import React, { useEffect, useState, useRef, useMemo } from "react";
import { BASE_URL } from "../../config/axios";
import axios from "axios";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { AttachmentIcon, handleErrorToast } from "../CustomFunctions";
import "jspdf-autotable";
import { DateRangePicker, CSSForSelect } from "../CustomFunctions";
import * as XLSX from "xlsx";
import Select, { components } from "react-select";
import { createPortal } from "react-dom";
import {
  AddwithWhiteCircle,
  DocumentIcon,
  DownloadIcon,
  Attachment,
  Eye,
  UpdatePencil,
  CrossRed,
  DOCIcon,
  AddwithBlueCircle,
  Notes,
  ArrowBulletHead,
  ArrowBullet,
  ArrowBulletReverse,
  Star,
  CancelCircle,
  DeleteDustbinbUTTON,
} from "../AllSvg";
import { useNavigate } from "react-router-dom";
import {
  formatDateDDMMYYYY,
  formattedDateLong,
  formatDateDDMMYYYYmonth,
  formatDateIndian,
  formatDateDDMMYYYYmonthNew,
} from "../Date";
import Pagination from "../Pagination/pagination.jsx";
import { use } from "react";
import { saveAudit } from "./Auditlogs";
import AimantraLoading from "../AimantraLoading/AimantraLoading";
import DownloadModal from "../Download Modal/DownloadModal";
import TenderResultSection from "../TenderResultSection/TenderResultSection.jsx";
import MultiWorkLogModal from "../TaskPlanner/MultiWorkLogModal";
import ViewWorkLogModal from "../TaskPlanner/ViewWorkLogModal";
import { fetchProjectsListSimple, saveDailyWorkLog, syncTenderToDetailDesign } from "../TaskPlanner/ddApi";
import { findProjectForTender, projectIdOf } from "../TaskPlanner/worklogHelpers";

// ─── CSS ──────────────────────────────────────────────────────────────────────
import "./bids.css";
import {
  CustomFieldsForm, fetchCustomFieldDefs, fetchTenderCustomFields,
  saveTenderCustomFields, fieldAppliesTo, formatCustomValue,
  CreateCustomFieldInline,
} from "../CustomFields/CustomFields.jsx";

// ─── All modal sub-components are UNCHANGED from original ─────────────────────
// (AddBidDetails, TenderViewBgModal, UpdateBidDetails, Addtocart, AssignTeamOnly,
//  TenderReject, TenderCancel, Tenderspecial, Tenderdiscuss, UploadSiteProject,
//  CorrigendumModal, CorrigendumModalScreening, TenderViewModal,
//  TenderViewAddDocumentModal, TenderAddPresentationfiles,
//  TenderViewModalPresnatation, TenderViewAddSingleNoteModal,
//  TenderViewSingleNote, TenderViewNotes, TenderViewAddNotes,
//  TenderViewAddBidders, EditTenderInfo, EditTenderInfoTab,
//  StatusBadge, getTenderStatus, StatsCard)
// All kept exactly as in the original file below.

const formatISTWithOffset = (localDateStr) => {
  const date = new Date(localDateStr);
  const pad = (n) => n.toString().padStart(2, "0");
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+05:30`;
};

const EMD_MULTISELECT_STYLES = `
.emd-multiselect-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 33vw;
  position: relative;
}
.emd-trigger {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-height: 50px;
  padding: 0px 10px;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  background: #f7f8fa;
  color: #4a4a4a;
  cursor: pointer;
  position: relative;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  user-select: none;
}
.emd-trigger:hover { border-color: #cfd4dc; }
.emd-trigger.open { border-color: #aab2bd; box-shadow: 0 0 0 3px rgba(0,0,0,0.04); }
.emd-trigger.error-border { border-color: #ef4444; }
.emd-placeholder { color: #9ca3af; font-size: 0.875rem; }
.emd-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #eef2f5;
  color: #4a4a4a;
  border-radius: 999px;
  padding: 2px 8px 2px 10px;
  font-size: 0.78rem;
  font-weight: 500;
  white-space: nowrap;
}
.emd-chip-remove {
  width: 16px; height: 16px;
  border-radius: 50%; border: none;
  background: #d1d5db; color: #4a4a4a;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.65rem;
}
.emd-chip-remove:hover { background: #bfc6cf; }
.emd-chevron {
  position: absolute; right: 10px; top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #6b7280; transition: transform 0.2s; font-size: 0.75rem;
}
.emd-trigger.open .emd-chevron { transform: translateY(-50%) rotate(180deg); }
.emd-dropdown {
  position: absolute; top: calc(100% + 6px); left: 0; right: 0;
  background: #fff; border: 1px solid #e3e3e3; border-radius: 10px;
  box-shadow: 0 6px 16px rgba(0,0,0,0.08); z-index: 9999; overflow: hidden;
}
.emd-option {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 14px; cursor: pointer;
  font-size: 0.875rem; color: #4a4a4a;
}
.emd-option:hover { background: #f0f2f5; }
.emd-option.selected { background: #eef2f5; }
.emd-option-check {
  width: 16px; height: 16px;
  border: 1px solid #cfd4dc; border-radius: 4px;
  display: flex; align-items: center; justify-content: center;
}
.emd-divider { height: 1px; background: #e9ecef; }
.emd-other-input {
  height: 40px; border: 1px solid #e3e3e3; border-radius: 10px;
  background: #f7f8fa; color: #4a4a4a; padding: 0 10px; font-size: 0.85rem;
}
.emd-other-input:focus { outline: none; border-color: #aab2bd; box-shadow: 0 0 0 3px rgba(0,0,0,0.04); }
.emd-other-add-btn {
  height: 40px; padding: 0 14px;
  background: #4a4a4a; color: #fff;
  border: none; border-radius: 10px; font-size: 0.82rem; cursor: pointer;
}
.emd-other-add-btn:hover { background: #333; }
.emd-other-add-btn:disabled { background: #c4c4c4; cursor: not-allowed; }
`;
const BLINK_DOT_STYLES = `
.amend-blink-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e11d48;
  margin-left: 4px;
  box-shadow: 0 0 0 rgba(225, 29, 72, 0.6);
  animation: amendBlinkPulse 1.4s infinite;
  vertical-align: middle;
}
@keyframes amendBlinkPulse {
  0%   { box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.6); opacity: 1; }
  70%  { box-shadow: 0 0 0 6px rgba(225, 29, 72, 0); opacity: 0.6; }
  100% { box-shadow: 0 0 0 0 rgba(225, 29, 72, 0); opacity: 1; }
}
.bg-exp-tab-dot-wrap { display: inline-flex; align-items: center; gap: 4px; }
`;

const TL_MEMBER_STYLES = `
.tl-summary-section { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 10px 14px; margin-bottom: 10px; }
.tl-summary-title { font-size: 11px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.6px; margin: 0 0 8px 0; }
.tl-filter-row { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.tl-select { height: 36px; min-width: 220px; flex: 1; padding: 0 10px; border: 1px solid #cbd5e1; border-radius: 6px; background: #ffffff; font-size: 13px; color: #334155; cursor: pointer; font-weight: 500; transition: border-color 0.15s ease; }
.tl-select:hover { border-color: #94a3b8; }
.tl-select:focus { outline: none; border-color: #2563eb; box-shadow: 0 0 0 2px rgba(37,99,235,.12); }
.tl-clear-btn { height: 36px; padding: 0 12px; font-size: 12px; border: 1px solid #cbd5e1; border-radius: 6px; background: #fff; color: #64748b; cursor: pointer; font-weight: 600; white-space: nowrap; transition: all 0.15s ease; display: inline-flex; align-items: center; gap: 4px; }
.tl-clear-btn:hover { border-color: #e74c3c; color: #e74c3c; background: #fff5f5; }
.tl-banner { display: flex; align-items: center; gap: 10px; padding: 8px 12px; background: linear-gradient(135deg,#dbeafe,#e0f2fe); border: 1px solid #7dd3fc; border-radius: 6px; margin-top: 8px; }
.tl-banner-avatar { width: 32px; height: 32px; border-radius: 50%; background: #0284c7; color: #fff; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 14px; flex-shrink: 0; }
.tl-banner-name { font-size: 13px; font-weight: 600; color: #0c4a6e; margin: 0; }
.tl-banner-role { font-size: 11px; color: #0369a1; margin: 2px 0 0; }
.tl-tender-badge { margin-left: auto; background: #0284c7; color: #fff; padding: 3px 10px; border-radius: 10px; font-size: 11px; font-weight: 700; white-space: nowrap; }
.member-chips-row { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }
.member-chip { display: inline-flex; align-items: center; gap: 5px; padding: 4px 10px; border: 1.5px solid #e2e8f0; border-radius: 20px; background: #fff; cursor: pointer; font-size: 12px; font-weight: 500; color: #334155; transition: all 0.15s ease; white-space: nowrap; }
.member-chip:hover { border-color: #2563eb; color: #2563eb; background: #eff6ff; }
.member-chip.member-chip-active { background: #0284c7; border-color: #0284c7; color: #fff; }
.member-chip-avatar { width: 20px; height: 20px; border-radius: 50%; background: #bfdbfe; color: #1e40af; font-size: 10px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.member-chip.member-chip-active .member-chip-avatar { background: rgba(255,255,255,0.3); color: #fff; }
.member-chip-count { background: #e0f2fe; color: #0284c7; border-radius: 8px; padding: 1px 6px; font-size: 11px; font-weight: 700; }
.member-chip.member-chip-active .member-chip-count { background: rgba(255,255,255,0.25); color: #fff; }
`;
const RESULT_BADGE_STYLES = `
.bg-result-badge { display:inline-block; font-size:9px; font-weight:700; line-height:1.4; padding:1px 6px; border-radius:8px; white-space:nowrap; border:1px solid transparent; }
.bg-result-badge--tech { background:#ecfdf3; color:#166534; border-color:#86efac; }
.bg-rows--tech-open > td { background:#f0fdf4 !important; }
`;

const DEFAULT_EMD_OPTIONS = [
  { key: "Bank_Gurantee", value: "Bank Gurantee" },
  { key: "neft", value: "NEFT" },
  { key: "demand_draft", value: "Demand Draft" },
  { key: "suretybond", value: "Surety Bond" },
  { key: "other", value: "Other" },
];

// ─── All original sub-components (unchanged) ─────────────────────────────────

const AddBidDetails = ({ getBidData, handleGetStats, filters }) => {
  const [show, setShow] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
  const uniqueStreamTypes = new Set();
  const [JvPartnerData, setJvPartnerData] = useState([]);
  const fileInputRefs = useRef([]);
  const [rfpFiles, setRfpFiles] = useState([]);
  const [rfpFilesother, setRfpFilesOther] = useState([]);
  const [emdDropdownOpen, setEmdDropdownOpen] = useState(false);
  const [emdOptions, setEmdOptions] = useState(DEFAULT_EMD_OPTIONS);
  const [cfDefs, setCfDefs] = useState([]);
  const [cfValues, setCfValues] = useState({});
  const [cfErrors, setCfErrors] = useState({});
  const [emdShowOtherInput, setEmdShowOtherInput] = useState(false);
  const [emdCustomInput, setEmdCustomInput] = useState("");
  const emdDropdownRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (emdDropdownRef.current && !emdDropdownRef.current.contains(e.target)) {
        setEmdDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleEmdToggleOption = (key) => {
    if (key === "other") { setEmdShowOtherInput((prev) => !prev); return; }
    setFormData((prev) => {
      const current = prev.emd_type_multi ?? [];
      const next = current.includes(key) ? current.filter((k) => k !== key) : [...current, key];
      return { ...prev, emd_type_multi: next };
    });
    setErrors((prev) => { const e = { ...prev }; delete e.emd_type_multi; return e; });
  };
  const handleEmdRemoveChip = (key, e) => {
    e.stopPropagation();
    setFormData((prev) => ({ ...prev, emd_type_multi: (prev.emd_type_multi ?? []).filter((k) => k !== key) }));
  };
  const handleEmdAddCustom = () => {
    const trimmed = emdCustomInput.trim();
    if (!trimmed) return;
    const key = trimmed.toLowerCase().replace(/\s+/g, "_");
    if (!emdOptions.find((o) => o.key === key)) {
      setEmdOptions((prev) => [...prev.filter((o) => o.key !== "other"), { key, value: trimmed }, { key: "other", value: "Other" }]);
    }
    setFormData((prev) => { const current = prev.emd_type_multi ?? []; if (current.includes(key)) return prev; return { ...prev, emd_type_multi: [...current, key] }; });
    setErrors((prev) => { const e = { ...prev }; delete e.emd_type_multi; return e; });
    setEmdCustomInput("");
    setEmdShowOtherInput(false);
  };
  const emdLabelFor = (key) => emdOptions.find((o) => o.key === key)?.value ?? key;

  const handleRfpFileChange = (e) => { if (e.target.files) { const newFiles = Array.from(e.target.files); setRfpFiles((prev) => [...prev, ...newFiles]); } };
  const handleRfpFileOtherChange = (e) => { if (e.target.files) { const newFiles = Array.from(e.target.files); setRfpFilesOther((prev) => [...prev, ...newFiles]); } };
  const handleRemove = (index) => { setRfpFiles((prev) => prev.filter((_, i) => i !== index)); };
  const handleRemoveOther = (index) => { setRfpFilesOther((prev) => prev.filter((_, i) => i !== index)); };

  const getJvPartner = async () => {
    setBuffering(true);
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/JVPartner/`);
      setJvPartnerData(sub.data);
    } catch (err) { handleErrorToast(err); } finally { setBuffering(false); }
  };

  const INITIAL_FORM = {
    is_residual_bid_capacity: false, sector: "", tender_type: "", client: "", tender_name: "",
    submission_date: "", lane: "", state: "", cost_of_consult: "", length: "",
    cost_of_construction: "", duration: { construction: "", dlp: "", onm: "" },
    status: "pending", lead_partner: "", is_special_tender: false, jv_partner_name: "",
    associate_with_version: "", emd: "", eligibity_criteria: "", remarks: "",
    type_of_project: "", km_cost: "", fee: "", bid_security: "", tender_id: "",
    e_published: "", consultancy_fees: "", GST_consultancy: "", construction_fees: "",
    special_structure_type: "", other_sector_type: "", other_tender_type: "",
    publish_date: "", ro: "", pbg_requried: "", pbg_details: "", tender_source: "",
    sent: "", recieve: "", is_emd_required: "", exmpted_emd: "", emd_amount: "",
    emd_type_multi: [], emd_submission_type: "", is_international: false, country_name: "", cost_of_rfp: "", infracon_id_cost: "", other_client: "",
  };

  const handleClose = () => {
    setFormData(INITIAL_FORM); setEmdOptions(DEFAULT_EMD_OPTIONS);
    setEmdShowOtherInput(false); setEmdCustomInput(""); setEmdDropdownOpen(false);
    setErrors({}); setShow(false); setDocNames(""); setRfpFiles([]); setCfValues({}); setCfErrors({});
  };
  const handleShow = () => {
    setShow(true); getJvPartner(); getSubCompany();
    clientList.forEach((entry) => { uniqueStreamTypes.add(entry.client_name); });
    fetchCustomFieldDefs().then(setCfDefs).catch(() => { });
  };

  const [empList, setEmpList] = useState([]);
  const [buffer, setBuffering] = useState(false);
  const [formData, setFormData] = useState(INITIAL_FORM);

  const getSubCompany = async () => {
    try { const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`); setSiteSubCompanyList(sub.data); } catch (error) { }
  };

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [docNames, setDocNames] = useState();

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "tender_id", "submission_date", "length", "tender_name", "sector", "tender_type", "client", "publish_date",
      formData.sector === "Highway" ? "lane" : null,
      formData.pbg_requried && formData.pbg_details === "" ? "pbg_details" : null,
      formData.is_special_tender && (formData.special_structure_type === null || formData.special_structure_type === "null" || formData.special_structure_type === "") ? "special_structure_type" : null,
      formData.is_emd_required === null || formData.is_emd_required === "" ? "is_emd_required" : null,
      formData.is_emd_required != null && formData.is_emd_required ? "emd_amount" : null,
      formData.is_emd_required != null && formData.is_emd_required && formData.exmpted_emd != "" ? "exmpted_emd" : null,
      formData.is_emd_required != null && formData.is_emd_required ? "emd_submission_type" : null,
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (formData[field] === null || formData[field] === undefined || formData[field] === "") {
        newErrors[field] = `${field.replace(/_/g, " ").charAt(0).toUpperCase() + field.replace(/_/g, " ").slice(1)} is required!`;
      }
    });

    if (formData.is_international) { if (!formData.country_name) { newErrors.country_name = "Country Name is required!"; } }
    else { if (!formData.state) { newErrors.state = "State is required!"; } }
    if (formData.client === "OTHER" && !formData.other_client.trim()) {
      newErrors.other_client = "Other Client name is required!";
    }

    const getValue = (path) => path.split(".").reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""), formData);
    requiredFields.forEach((field) => { const value = getValue(field); if (!value) { newErrors[field] = `${field.replace(/\./g, " ").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())} is required!`; } });

    if (formData.is_emd_required) {
      if (!formData.emd_type_multi || formData.emd_type_multi.length === 0) { newErrors["emd_type_multi"] = "Emd Type is required!"; }
    }
    const cfErr = {};
    cfVisible.forEach((f) => {
      if (f.is_required && (cfValues[f.key] === null || cfValues[f.key] === undefined || cfValues[f.key] === ""))
        cfErr[f.key] = `${f.name} is required!`;
    });
    setCfErrors(cfErr);
    if (Object.keys(cfErr).length) newErrors.custom_fields = "Custom fields";
    setErrors(newErrors); setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked, options, files } = e.target;
    let newValue;
    if (type === "select-multiple") { newValue = Array.from(options).filter((option) => option.selected).map((option) => option.value); }
    else if (type === "checkbox") { newValue = checked; }
    else if (type === "file") { newValue = files.length > 0 ? files[0] : null; }
    else { newValue = value; }
    const keys = name.split(".");
    const topKey = keys[0];
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData };
      if (keys.length === 2) { updatedFormData[topKey] = { ...updatedFormData[topKey], [keys[1]]: newValue }; }
      else { updatedFormData[name] = newValue; }
      return updatedFormData;
    });
    setInputState((prevState) => {
      if (keys.length === 2) { return { ...prevState, [topKey]: { ...prevState[topKey], [keys[1]]: newValue ? "green" : "" } }; }
      else { return { ...prevState, [name]: newValue ? "green" : "" }; }
    });
    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (keys.length === 2 && updatedErrors[topKey]) { updatedErrors[topKey] = { ...updatedErrors[topKey] }; delete updatedErrors[topKey][keys[1]]; if (Object.keys(updatedErrors[topKey]).length === 0) delete updatedErrors[topKey]; }
        else { delete updatedErrors[name]; }
        return updatedErrors;
      });
    }
  };

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");
      const formDataToSend = new FormData();
      const emdFields = ["emd_amount", "emd_submission_type"];
      Object.keys(formData).forEach((key) => {
        if (key === "country_name") return;
        if (key === "is_international") return;
        if (key === "other_client") return;
        if (key === "client") { formDataToSend.append("client", formData.client === "OTHER" ? formData.other_client.trim() : formData.client); return; }

        if (key === "state") { formDataToSend.append("state", formData.is_international ? formData.country_name : formData.state); }
        else if (key === "duration") { formDataToSend.append("duration", JSON.stringify(formData.duration)); }
        else if (key === "submission_date") { formDataToSend.append("submission_date", formatISTWithOffset(formData.submission_date)); }
        else if (key === "emd_type_multi") { formDataToSend.append("emd_type_multi", formData.is_emd_required ? JSON.stringify(formData.emd_type_multi) : "[]"); }
        else if (emdFields.includes(key)) { formDataToSend.append(key, formData.is_emd_required ? formData[key] : ""); }
        else { formDataToSend.append(key, formData[key]); }
      });
      try {
        let res = await axios.post(`${BASE_URL}/siteproject/BidTenders/`, formDataToSend, { headers: { "Content-Type": "multipart/form-data" } });
        if (res.status === 200 || res.status === 201) {
          if (res.data?.id) {
            const getJsonData = (data) => { if (data instanceof FormData) return Object.fromEntries(data.entries()); return data; };
            await saveAudit({ tenderId: res?.data?.id, updatedBy: sessionStorage.getItem("sitemanagement_emp_code"), tableName: "Tenderforbd", oldData: {}, newData: getJsonData(formData), action: "CREATE" });
            try {
              await syncTenderToDetailDesign({
                tender_id: res.data.id,
                created_by: sessionStorage.getItem("sitemanagement_emp_code"),
              });
            } catch (syncErr) {
              toast.warn("Tender saved, but detail-design sync failed.");
            }
            const cfPayload = Object.fromEntries(
              cfVisible.map((f) => [f.key, cfValues[f.key]]).filter(([, v]) => v !== null && v !== undefined && v !== "")
            );
            if (Object.keys(cfPayload).length) {
              try { await saveTenderCustomFields(res.data.id, cfPayload); }
              catch (cfErr) { toast.warn("Tender saved, but custom fields failed. Edit the tender to re-enter them."); }
            }
          }
          if (rfpFiles.length) {
            try {
              const fd = new FormData();
              rfpFiles.forEach((file) => { fd.append("rfp_tender", res?.data?.id); fd.append("document_name", file?.name); fd.append("document", file); });
              const uploadRes = await axios.post(`${BASE_URL}/siteproject/bulkrfp/`, fd, { headers: { "Content-Type": "multipart/form-data" } });
              if (uploadRes.status === 200 || uploadRes.status === 201) {
                const rfpFilesJson = rfpFiles.map((file) => ({ document_name: file.name, file_type: file.type, file_size: file.size }));
                await saveAudit({ tenderId: res?.data?.id, updatedBy: sessionStorage.getItem("sitemanagement_emp_code"), tableName: "Rfp", oldData: {}, newData: { rfp_documents: rfpFilesJson }, action: "CREATE" });
              }
            } catch (uploadErr) { setRfpFiles([]); } finally { setRfpFiles([]); }
          }
          if (rfpFilesother.length) {
            try {
              const fd = new FormData();
              rfpFilesother.forEach((file) => { fd.append("Rfpother_tender", res?.data?.id); fd.append("document_name", file?.name); fd.append("document", file); });
              await axios.post(`${BASE_URL}/siteproject/bulkother/`, fd, { headers: { "Content-Type": "multipart/form-data" } });
            } catch (uploadErr) { setRfpFiles([]); } finally { setRfpFiles([]); }
          }
          await getBidData(filters); await handleGetStats();
        }
        setShow(false); setLoading(false); toast.dismiss(loadingToastId); handleClose();
      } catch (err) { handleErrorToast(err); } finally { toast.dismiss(loadingToastId); }
    }
  };

  const addNewDocument = () => { setFormData((prevFormData) => [...prevFormData, { document_name: "", document_file: null }]); fileInputRefs.current.push(null); };
  const handleRemoveDocument = (index) => { setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index)); fileInputRefs.current.splice(index, 1); };
  const handleClear = (index) => { setFormData((prevFormData) => { const newDocuments = [...prevFormData]; newDocuments[index] = { ...newDocuments[index], document_file: null }; return newDocuments; }); if (fileInputRefs.current[index]) fileInputRefs.current[index].value = ""; setErrors((prevErrors) => { const newErrors = { ...prevErrors }; delete newErrors[`${index}-document_file`]; return newErrors; }); };
  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ["application/pdf", "application/zip", "application/x-zip-compressed", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
      if (!allowedTypes.includes(file.type) && !file.name.match(/\.(zip|pdf|xls|xlsx)$/)) { toast.error("Only ZIP, PDF, and Excel files are allowed!"); return; }
      setFormData((prevFormData) => { const newDocuments = [...prevFormData]; newDocuments[index] = { ...newDocuments[index], document_file: file }; return newDocuments; });
      setErrors((prevErrors) => { const newErrors = { ...prevErrors }; delete newErrors[`${index}-document_file`]; return newErrors; });
    }
  };
  const handleChangeAssignedTo = (selected) => { const com_operators = selected?.map((item) => item.value) || []; setFormData((prevState) => ({ ...prevState, com_operators })); };
  const options = empList?.sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))?.map((e) => ({ value: e.id, label: `${e.emp_code} - ${e.name}` }));

  const states = ["Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir", "Jharkhand", "Karnataka", "Kerala", "Ladakh", "Lakshadweep", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"];
  const cfVisible = cfDefs.filter((f) => fieldAppliesTo(f, formData.sector));
  const handleCfChange = (key, val) => {
    setCfValues((p) => ({ ...p, [key]: val }));
    setCfErrors((p) => { const n = { ...p }; delete n[key]; return n; });
  };
  return (
    <>
      <style>{EMD_MULTISELECT_STYLES}</style>
      <style>{RESULT_BADGE_STYLES}</style>
      <button title="Add Tender Details" className="bg-icon-btn" onClick={handleShow}>
        <AddwithWhiteCircle /> Add Tender
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Add Tender Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-form">

            <div className="checkbox-wrapper" style={{ marginTop: "8px" }}>
              <label className="custom-checkbox font-weight500 font-size-subheading">
                <input type="checkbox" name="is_residual_bid_capacity" checked={formData.is_residual_bid_capacity || false} onChange={handleInputChange} />
                <span className="checkmark"></span>Residual Bid Capacity
              </label>

            </div>
            <div className="form-flex-wrap">
              {["certificaionadminaccess", "CertificationAccess", "ScreeningTeam"].includes(
                sessionStorage.getItem("sitemanagement_role")
              ) && (
                  <div className="cf-container">
                    <CreateCustomFieldInline
                      defaultSector={formData.sector}
                      onCreated={async () =>
                        setCfDefs(await fetchCustomFieldDefs())
                      }
                    />
                  </div>
                )}

              <div className="flex-columns">
                <label className="form-labels">Tender ID <span className="required">*</span></label>
                <input type="text" name="tender_id" placeholder="Example - NHAI2025-RJ-011" value={formData.tender_id} onChange={handleInputChange} className={`form-input input-form ${errors.tender_id ? "error" : inputState.tender_id ? "success" : ""}`} />
                <br />{errors.tender_id && <span className="error-message">{errors.tender_id}</span>}
              </div>
              <div className="flex-columns">
                <div className="flex-row justify-between form-labels" style={{ height: "25px" }}>
                  <label htmlFor="tender_name" className="">Tender Name<span className="required">*</span></label>
                  <div className="checkbox-wrapper">
                    <label className="custom-checkbox font-weight500 font-size-subheading">
                      <input type="checkbox" name="is_special_tender" checked={formData.is_special_tender || false} onChange={handleInputChange} /><span className="checkmark"></span>Special Tender
                    </label>
                  </div>
                </div>
                <input type="text" name="tender_name" placeholder="Example - NH66 Highway Project" value={formData.tender_name} onChange={handleInputChange} className={`form-input input-form ${errors.tender_name ? "error" : inputState.tender_name ? "success" : ""}`} />
                <br />{errors.tender_name && <span className="error-message">{errors.tender_name}</span>}
              </div>
              {formData.is_special_tender && (
                <div className="flex-columns">
                  <label className="form-labels">Special Structure Type <span className="required">*</span></label><br />
                  <select name="special_structure_type" value={formData.special_structure_type} onChange={handleInputChange} className={`form-input input-form ${errors.special_structure_type ? "error" : inputState.special_structure_type ? "success" : ""}`}>
                    <option value="">Select structure type</option><option value="tunnel">Tunnel</option><option value="major_bridge">Major Bridge</option><option value="cable_stayed">Cable Stayed</option><option value="elevated">Elevated</option><option value="hilly">Hilly</option><option value="slope_protection">Slope Protection</option><option value="NEW_SEGMENT">New Segment</option>
                  </select>
                  {errors.special_structure_type && <span className="error-message">{errors.special_structure_type}</span>}
                </div>
              )}
              <div className="flex-columns">
                <label className="form-labels">Sector <span className="required">*</span></label><br />
                <select name="sector" value={formData.sector} onChange={handleInputChange} className={`form-input input-form ${errors.sector ? "error" : inputState.sector ? "success" : ""}`}>
                  <option value="">Select sector</option><option value="Highway">Highway</option><option value="Railway">Railway</option><option value="Metro">Metro</option><option value="Water">Water</option><option value="Ropeway">Ropeway</option><option value="Building">Building</option><option value="Other">Other</option>
                </select><br />{errors.sector && <span className="error-message">{errors.sector}</span>}
              </div>
              {cfVisible.length > 0 && (
                <CustomFieldsForm fields={cfVisible} values={cfValues} errors={cfErrors} onChange={handleCfChange} />
              )}
              {formData.sector === "Other" && (
                <div className="flex-columns">
                  <label className="form-labels">Other Sector Type</label>
                  <input type="text" name="other_sector_type" placeholder="Other Sector Type Name" value={formData.other_sector_type} onChange={handleInputChange} className={`form-input input-form ${errors.other_sector_type ? "error" : inputState.other_sector_type ? "success" : ""}`} />
                  {errors.other_sector_type && <span className="error-message">{errors.other_sector_type}</span>}
                </div>
              )}
              <div className="flex-columns">
                <label className="form-labels">Tender Type <span className="required">*</span></label>
                <select name="tender_type" value={formData.tender_type} onChange={handleInputChange} className={`form-input input-form ${errors.tender_type ? "error" : inputState.tender_type ? "success" : ""}`}>
                  <option value="">Select Tender Type</option><option value="Feasibility">Feasibility</option><option value="DPR">DPR</option><option value="FesibilityCumDPR">Feasibility Cum DPR</option><option value="Authority_Engineer">Authority Engineer</option><option value="Independent_Engineer">Independent Engineer</option><option value="PMC">PMC</option><option value="Supervision">Supervision</option><option value="eoi">EOI</option><option value="Empanelment">Empanelment</option><option value="O&M">O&amp;M</option><option value="IEO&M">IE O&amp;M</option><option value="AE_O&M">AE O&amp;M</option><option value="Supervision_O&M">Supervision O&amp;M</option><option value="Survey">Survey</option><option value="Technology">Technology</option><option value="machinery">Machinery</option><option value="slope_stability">Slope Stability</option><option value="slope_protection">Slope Protection</option><option value="Detailed_Design">Detailed Design</option><option value="Architecture">Architecture</option><option value="safety_consultant">SAFETY CONSULTANT</option><option value="pms">PMS</option><option value="geotechnical">Geotechnical</option><option value="Other">Other</option>
                  {formData.sector === "Railway" && (<><option value="PSSA">PSSA</option><option value="GC">GC</option><option value="Temping">Temping</option><option value="FLS">FLS</option><option value="Station_Redevelopment">Station Redevelopment</option></>)}
                </select><br />{errors.tender_type && <span className="error-message">{errors.tender_type}</span>}
              </div>
              {formData.tender_type === "Other" && (
                <div className="flex-columns">
                  <label className="form-labels">Other Tender Type</label>
                  <input type="text" name="other_tender_type" placeholder="Other Tender Type Name" value={formData.other_tender_type} onChange={handleInputChange} className={`form-input input-form ${errors.other_tender_type ? "error" : inputState.other_tender_type ? "success" : ""}`} />
                  {errors.other_tender_type && <span className="error-message">{errors.other_tender_type}</span>}
                </div>
              )}
              <div className="flex-columns">
                <label className="form-labels">Client <span className="required">*</span></label><br />
                <select name="client" value={formData.client} onChange={handleInputChange} className={`form-input input-form ${errors.client ? "error" : inputState.client ? "success" : ""}`}>
                  <option value="">Select Client</option>
                  {formData.sector === "Railway" ? (
                    <>
                      <option value="CENTRAL_RAILWAY">
                        Central Railway
                      </option>
                      <option value="EAST_CENTRAL_RAILWAY">
                        East Central Railway
                      </option>
                      <option value="EASTERN_RAILWAY">
                        Eastern Railway
                      </option>
                      <option value="MINISTRY_OF_RAILWAYS">
                        Ministry of Railways
                      </option>
                      <option value="MUMBAI_RAILWAY_VIKAS_CORPORATION">
                        Mumbai Railway Vikas Corporation
                      </option>
                      <option value="NORTH_CENTRAL_RAILWAY">
                        North Central Railway
                      </option>
                      <option value="NORTH_EASTERN_RAILWAYS">
                        North Eastern Railways
                      </option>
                      <option value="NORTHEST_FRONTIER_RAILWAYA">
                        Northest Frontier Railwaya
                      </option>
                      <option value="NORTHERN_RAILWAY">
                        Northern Railway
                      </option>
                      <option value="RAILWAY_ENERGY_MANAGEMENT_COMPANY_LIMITED">
                        Railway Energy Management Company Limited
                      </option>
                      <option value="SOUTH_CENTRAL_RAILWAY">
                        South Central Railway
                      </option>
                      <option value="SOUTH_EASTERN_RAILWAYS">
                        South Eastern Railways
                      </option>
                      <option value="SOUTH_COAST_RAILWAY">
                        South Coast Railway
                      </option>
                      <option value="SOUTHEST_FRONTIER_RAILWAY">
                        Southest Frontier Railway
                      </option>
                      <option value="SOUTHERN_RAILWAY">
                        Southern Railway
                      </option>
                      <option value="EAST_COAST_RAILWAY">
                        EAST COAST RAILWAY
                      </option>
                      <option value="South_West_Central_Railway">
                        South West Central Railway
                      </option>
                      <option value="West_Central_Railway ">
                        West Central Railway{" "}
                      </option>
                      <option value="South_Western_Railway">
                        {" "}
                        South Western Railway
                      </option>
                      <option value="Western_Railway">
                        Western Railway
                      </option>
                      <option value="North_Western_Railway">
                        {" "}
                        North Western Railway{" "}
                      </option>
                      <option value="South_East_Railway">
                        South East Railway
                      </option>
                      <option value="OTHER">Other</option>
                    </>
                  ) : (
                    <>
                      <option value="NHAI">NHAI</option>
                      <option value="MORTH">MoRTH</option>
                      <option value="NHIDCL">NHIDCL</option>
                      <option value="BRO">BRO</option>
                      <option value="PWDS">PWDs</option>
                      <option value="MPRDCL">MPRDCL</option>
                      <option value="MHRDCL">MHRDCL</option>
                      <option value="GJRDCL">GJRDCL</option>
                      <option value="SHAJ">SHAJ</option>
                      <option value="HSIIDC">HSIIDC</option>
                      <option value="BHRDCL">BHRDCL</option>
                      <option value="UPEIDA">UPEIDA</option>
                      <option value="UPHA&SP">UPHA&SP</option>
                      <option value="RITES">RITES</option>
                      <option value="HRBG">HRBG</option>
                      <option value="APCRDA">APCRDA</option>
                      <option value="RCDB">RCDB</option>
                      <option value="BSIL">BSIL</option>
                      <option value="BUIDCL">BUIDCL</option>
                      <option value="CMRL">CMRL</option>
                      <option value="DMRCL">DMRCL</option>
                      <option value="EPIL">EPIL</option>
                      <option value="HRSI&IDCL">HRSI&IDCL</option>
                      <option value="H&UDCL">H&UDCL</option>
                      <option value="J&KRRDA">J&KRRDA</option>
                      <option value="MHSIDC">MHSIDC</option>
                      <option value="MHMRCL">MHMRCL</option>
                      <option value="RJSRD&CCL">RJSRD&CCL</option>
                      <option value="KARDCL">KARDCL</option>
                      <option value="TNRDL">TNRDL</option>
                      <option value="APRDC">APRDC</option>
                      <option value="PBIDB">PBIDB</option>
                      <option value="R&BDT">R&BDT</option>
                      <option value="RCDJ">RCDJ</option>
                      <option value="JHSRDC">JHSRDC</option>
                      <option value="HPPWD">HPPWD</option>
                      <option value="UKPWD">UKPWD</option>
                      <option value="DSI&IDC">DSI&IDC</option>
                      <option value="GOAPWD">GOAPWD</option>
                      <option value="HRRIDC">HRRIDC</option>
                      <option value="RIDFOD">RIDFOD</option>
                      <option value="RJSID&IC">RJSID&IC</option>
                      <option value="KLRFB">KLRFB</option>
                      <option value="RSHA">RSHA</option>
                      <option value="BIDA">BIDA</option>
                      <option value="MIDFC">MIDFC</option>
                      <option value="SOI">SOI</option>
                      <option value="JNPT">JNPT</option>
                      <option value="BMRCL">BMRCL</option>
                      <option value="OBCCL">OBCCL</option>
                      <option value="NationalHighwaysLogisticsManagementLimited">
                        National Highways Logistics Management Limited
                      </option>
                      <option value="OTHER">Other</option>
                    </>
                  )}
                </select><br />{errors.client && <span className="error-message">{errors.client}</span>}
                {formData.client === "OTHER" && (
                  <div className="flex-columns">
                    <label className="form-labels">Other Client Name <span className="required">*</span></label>
                    <input
                      type="text"
                      name="other_client"
                      placeholder="Enter client name"
                      value={formData.other_client}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.other_client ? "error" : inputState.other_client ? "success" : ""}`}
                    />
                    {errors.other_client && <span className="error-message">{errors.other_client}</span>}
                  </div>
                )}
              </div>
              <div className="flex-columns"><label className="form-labels">Client Ro</label><input type="text" name="ro" value={formData?.ro} onChange={handleInputChange} className={`form-input input-form ${errors?.ro ? "error" : inputState?.ro ? "success" : ""}`} />{errors?.ro && <span className="error-message">{errors.ro}</span>}</div>
              <div className="flex-columns">
                <label className="form-labels">Publish Date <span className="required">*</span></label>
                <input type="date" name="publish_date" value={formData?.publish_date} onChange={handleInputChange} className={`form-input input-form ${errors?.publish_date ? "error" : inputState?.publish_date ? "success" : ""}`} max={new Date().toISOString().split("T")[0]} />
                <br />{errors?.publish_date && <span className="error-message">{errors?.publish_date}</span>}
              </div>
              <div className="flex-columns">
                <label className="form-labels">Submission Date <span className="required">*</span></label>
                <input type="datetime-local" name="submission_date" value={formData?.submission_date} onChange={handleInputChange} min={new Date().toISOString().slice(0, 16)} className={`form-input input-form ${errors?.submission_date ? "error" : inputState?.submission_date ? "success" : ""}`} />
                {errors?.submission_date && <span className="error-message">{errors?.submission_date}</span>}
              </div>
              {formData.sector !== "Railway" && (
                <div className="flex-columns">
                  <label className="form-labels">Lane <span className="required">*</span></label><br />
                  <select name="lane" value={formData.lane} onChange={handleInputChange} className={`form-input input-form ${errors.lane ? "error" : inputState.lane ? "success" : ""}`}>
                    <option value="">Select Lane</option><option value="intimident_lane">Single Track Lane</option><option value="2">2 Lane</option><option value="4">4 Lane</option><option value="6">6 Lane</option><option value="8">8 Lane</option><option value="nhsl">NHSL</option><option value="rfp_not_uploaded">Not Available</option><option value="not_required">Not Required</option>
                  </select><br />{errors.lane && <span className="error-message">{errors.lane}</span>}
                </div>
              )}
              <div className="flex-column">
                <div className="flex-row justify-between form-labels" style={{ height: "25px" }}>
                  <label className="">State {!formData.is_international && <span className="required">*</span>}</label>
                  <div className="checkbox-wrapper">
                    <label className="custom-checkbox font-weight500 font-size-subheading"><input type="checkbox" name="is_international" checked={formData.is_international || false} onChange={handleInputChange} /><span className="checkmark"></span>International</label>
                  </div>
                </div>
                <select name="state" value={formData.is_international ? "" : formData.state} onChange={handleInputChange} disabled={formData.is_international} className={`form-input input-form ${errors.state ? "error" : inputState.state ? "success" : ""}`} style={formData.is_international ? { opacity: 0.5, cursor: "not-allowed" } : {}}>
                  <option value="">Select State</option>{states.map((state) => (<option key={state} value={state}>{state}</option>))}
                </select>
                {errors.state && <span className="error-message">{errors.state}</span>}
              </div>
              {formData.is_international && (
                <div className="flex-column">
                  <label className="form-labels">Country Name <span className="required">*</span></label>
                  <input type="text" name="country_name" placeholder="e.g. United Arab Emirates" value={formData.country_name} onChange={handleInputChange} className={`form-input input-form ${errors.country_name ? "error" : inputState.country_name ? "success" : ""}`} />
                  {errors.country_name && <span className="error-message">{errors.country_name}</span>}
                </div>
              )}
              <div className="flex-columns">
                <label htmlFor="pbg_requried" className="form-labels">PBG Required</label>
                <select id="pbg_requried" name="pbg_requried" value={formData.pbg_requried} onChange={(e) => setFormData((prev) => ({ ...prev, pbg_requried: e.target.value === "true" ? true : e.target.value === "false" ? false : null }))} className="form-input input-form">
                  <option value="">PBG Required</option><option value="true">Yes</option><option value="false">No</option>
                </select>
                {errors.pbg_requried && <span className="error-message">{errors.pbg_requried}</span>}
              </div>
              {formData.pbg_requried && (
                <div className="flex-columns">
                  <label className="form-labels">Pbg Details <span className="required">*</span></label>
                  <input type="text" name="pbg_details" placeholder="Pbg Details" value={formData.pbg_details} onChange={handleInputChange} className={`form-input input-form ${errors.pbg_details ? "error" : inputState.pbg_details ? "success" : ""}`} />
                  <br />{errors.pbg_details && <span className="error-message">{errors.pbg_details}</span>}
                </div>
              )}
              <div className="flex-columns">
                <label className="form-labels">Consultancy Cost (in crores)</label>
                <input type="number" name="consultancy_fees" placeholder="e.g. 2.5 (in crores)" value={formData.consultancy_fees} onChange={handleInputChange} className={`form-input input-form ${errors.consultancy_fees ? "error" : inputState.consultancy_fees ? "success" : ""}`} />
                {errors.consultancy_fees && <span className="error-message">{errors.consultancy_fees}</span>}
              </div>
              <div className="flex-columns">
                <label className="form-labels">Construction Fees (in crores)</label>
                <input type="number" name="construction_fees" placeholder="e.g. 2.5 (in crores)" value={formData.construction_fees} onChange={handleInputChange} className={`form-input input-form ${errors.construction_fees ? "error" : inputState.construction_fees ? "success" : ""}`} />
                {errors.construction_fees && <span className="error-message">{errors.construction_fees}</span>}
              </div>
              <div className="flex-columns">
                <label className="form-labels">RFP Cost</label>
                <input
                  type="number"
                  name="cost_of_rfp"
                  placeholder="Enter full amount (e.g. 10000)"
                  value={formData.cost_of_rfp}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.cost_of_rfp ? "error" : inputState.cost_of_rfp ? "success" : ""}`}
                />
                {errors.cost_of_rfp && <span className="error-message">{errors.cost_of_rfp}</span>}
              </div>
              <div className="flex-columns">
                <label className="form-labels">Infracon ID Cost</label>
                <input
                  type="number"
                  name="infracon_id_cost"
                  placeholder="Enter full amount (e.g. 1000)"
                  value={formData.infracon_id_cost}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.infracon_id_cost ? "error" : inputState.infracon_id_cost ? "success" : ""}`}
                />
                {errors.infracon_id_cost && <span className="error-message">{errors.infracon_id_cost}</span>}
              </div>

              <div className="flex-columns">
                <label className="form-labels">GST</label><br />
                <select name="GST_consultancy" value={formData.GST_consultancy} onChange={handleInputChange} className={`form-input input-form ${errors.GST_consultancy ? "error" : inputState.GST_consultancy ? "success" : ""}`}>
                  <option value="">Select GST</option><option value="Including">Including</option><option value="Excluding">Excluding</option>
                </select>
                {errors.GST_consultancy && <span className="error-message">{errors.GST_consultancy}</span>}
              </div>
              <div className="flex-columns">
                <label className="form-labels">Tender Source</label><br />
                <select name="tender_source" value={formData.tender_source} onChange={handleInputChange} className={`form-input input-form ${errors.tender_source ? "error" : inputState.tender_source ? "success" : ""}`}>
                  <option value="">Select Tender Source</option><option value="internal">Internal</option><option value="sent">Sent</option><option value="recieve">Recieved</option>
                </select>
                {errors.tender_source && <span className="error-message">{errors.tender_source}</span>}
              </div>
              {formData.tender_source === "sent" && (<div className="flex-columns"><label className="form-labels">Sent to <span className="required">*</span></label><br /><input type="text" name="sent" placeholder="Sent to" value={formData.sent} onChange={handleInputChange} className={`form-input input-form ${errors.sent ? "error" : inputState.sent ? "success" : ""}`} /><br />{errors.sent && <span className="error-message">{errors.sent}</span>}</div>)}
              {formData.tender_source === "recieve" && (<div className="flex-columns"><label className="form-labels">Recieved From <span className="required">*</span></label><br /><input type="text" name="recieve" placeholder="Recieved From" value={formData.recieve} onChange={handleInputChange} className={`form-input input-form ${errors.recieve ? "error" : inputState.recieve ? "success" : ""}`} /><br />{errors.recieve && <span className="error-message">{errors.recieve}</span>}</div>)}
              <div className="flex-columns">
                <label className="form-labels">Length <span className="required">*</span></label><br />
                <input type="number" name="length" placeholder="Example - 125" value={formData.length} onChange={handleInputChange} className={`form-input input-form ${errors.length ? "error" : inputState.length ? "success" : ""}`} onWheel={(e) => e.target.blur()} min={0} />
                <br />{errors.length && <span className="error-message">{errors.length}</span>}
              </div>
              <div className="flex-columns"><label className="form-labels">{formData.tender_type === "DPR" ? "Construction Duration" : "Project Duration"}</label><input type="number" name="duration.construction" placeholder="Example - 24 months" value={formData.duration.construction} onChange={handleInputChange} className={`form-input input-form ${errors["duration.construction"] ? "error" : inputState?.duration?.construction ? "success" : ""}`} />{errors["duration.construction"] && <span className="error-message">{errors["duration.construction"]}</span>}</div>
              <div className="flex-columns"><label className="form-labels">DLP Duration</label><input type="number" name="duration.dlp" placeholder="Example - 24 months" value={formData.duration.dlp} onChange={handleInputChange} className={`form-input input-form ${errors["duration.dlp"] ? "error" : inputState?.duration?.dlp ? "success" : ""}`} />{errors["duration.dlp"] && <span className="error-message">{errors["duration.dlp"]}</span>}</div>
              <div className="flex-columns"><label className="form-labels">OnM Duration</label><input type="number" name="duration.onm" placeholder="Example - 24 months" value={formData.duration.onm} onChange={handleInputChange} className={`form-input input-form ${errors["duration.onm"] ? "error" : inputState?.duration?.onm ? "success" : ""}`} />{errors["duration.onm"] && <span className="error-message">{errors["duration.onm"]}</span>}</div>
              <div className="flex-columns"><label className="form-labels">Remarks</label><br /><textarea name="remarks" placeholder="Example - Project site visit completed and documents verified." value={formData.remarks} onChange={handleInputChange} className={`form-input input-form ${errors.remarks ? "error" : inputState.remarks ? "success" : ""}`} />{errors.remarks && <span className="error-message">{errors.remarks}</span>}</div>
              <div className="dropdown-wrapper flex justify-center">
                <label htmlFor="is_emd_required" className="form-labels font-weight500 font-size-subheading">Emd Required<span className="required">*</span></label><br />
                <select id="is_emd_required" name="is_emd_required" value={formData.is_emd_required} onChange={(e) => setFormData((prev) => ({ ...prev, is_emd_required: e.target.value === "true" ? true : e.target.value === "false" ? false : null }))} className="form-input font-size-subheading">
                  <option value="">Select Emd Required</option><option value="true">Yes</option><option value="false">No</option>
                </select>
              </div>
              {formData.is_emd_required && (
                <>
                  <div className="dropdown-wrapper flex justify-center" style={{ width: "39vw" }}>
                    <label htmlFor="exmpted_emd" className="form-labels font-weight500 font-size-subheading">Exmpted Emd<span className="required">*</span></label><br />
                    <select id="exmpted_emd" name="exmpted_emd" value={formData.exmpted_emd} onChange={(e) => setFormData((prev) => ({ ...prev, exmpted_emd: e.target.value === "true" ? true : e.target.value === "false" ? false : null }))} className="form-input font-size-subheading">
                      <option value="">Exmpted Emd</option><option value="true">Yes</option><option value="false">No</option>
                    </select>
                  </div>
                  <div className="dropdown-wrapper flex justify-center">
                    <label htmlFor="emd_amount" className="form-labels font-weight500 font-size-subheading">Emd Amount<span className="required">*</span></label><br />
                    <input type="text" name="emd_amount" placeholder="Enter full amount (e.g. 1 crore = 10000000)" value={formData.emd_amount} onChange={(e) => setFormData((prev) => ({ ...prev, emd_amount: e.target.value }))} className="form-input font-size-subheading" />
                  </div>
                  <div className="dropdown-wrapper flex justify-center" style={{ width: "39vw" }}>
                    <label className="form-labels font-weight500 font-size-subheading">Emd Type<span className="required">*</span></label><br />
                    <div className="emd-multiselect-wrapper" ref={emdDropdownRef}>
                      <div className={`emd-trigger ${emdDropdownOpen ? "open" : ""} ${errors.emd_type_multi ? "error-border" : ""}`} onClick={() => setEmdDropdownOpen((v) => !v)}>
                        {(formData.emd_type_multi ?? []).length === 0 ? (<span className="emd-placeholder">Select EMD types…</span>) : ((formData.emd_type_multi ?? []).map((key) => (<span key={key} className="emd-chip">{emdLabelFor(key)}<button type="button" className="emd-chip-remove" onClick={(e) => handleEmdRemoveChip(key, e)}>✕</button></span>)))}
                        <span className="emd-chevron">▼</span>
                      </div>
                      {emdDropdownOpen && (
                        <div className="emd-dropdown">
                          <div className="emd-options-list">
                            {emdOptions.filter((o) => o.key !== "other").map((emd) => (<div key={emd.key} className={`emd-option ${(formData.emd_type_multi ?? []).includes(emd.key) ? "selected" : ""}`} onClick={() => handleEmdToggleOption(emd.key)}><span className="emd-option-check">{(formData.emd_type_multi ?? []).includes(emd.key) && <span className="emd-option-check-icon">✓</span>}</span>{emd.value}</div>))}
                            <div className="emd-divider" />
                            <div className={`emd-option ${emdShowOtherInput ? "selected" : ""}`} onClick={() => handleEmdToggleOption("other")}><span className="emd-option-check">{emdShowOtherInput && <span className="emd-option-check-icon">✓</span>}</span>+ Add custom type…</div>
                          </div>
                          {emdShowOtherInput && (<div className="emd-other-area"><input className="emd-other-input" type="text" placeholder="e.g. Insurance Bond" value={emdCustomInput} onChange={(e) => setEmdCustomInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleEmdAddCustom()} autoFocus /><button type="button" className="emd-other-add-btn" onClick={handleEmdAddCustom} disabled={!emdCustomInput.trim()}>Add</button></div>)}
                        </div>
                      )}
                    </div>
                    {errors.emd_type_multi && <span className="error-message">{errors.emd_type_multi}</span>}
                  </div>
                  <div className="dropdown-wrapper flex justify-center">
                    <label htmlFor="emd_submission_type" className="form-labels font-weight500 font-size-subheading">Emd Submission Type<span className="required">*</span></label><br />
                    <select id="emd_submission_type" name="emd_submission_type" value={formData.emd_submission_type} onChange={(e) => setFormData((prev) => ({ ...prev, emd_submission_type: e.target.value }))} className="form-input font-size-subheading">
                      <option value="">EMD Submission Type</option><option value="online">Online</option><option value="physical">Physical</option><option value="both">Both</option>
                    </select>
                  </div>
                </>
              )}

              <div style={{ width: "100%" }}>
                <div style={{ width: "100%", maxWidth: 480, margin: "0", background: "#fff", borderRadius: 8, boxShadow: "0 2px 12px #eee", padding: 32 }}>
                  <label className="form-labels font-weight500 font-size-subheading" style={{ marginBottom: 12, display: "block", fontSize: 18, fontWeight: 600 }}>Upload Tender Document (File name should be max 400 character)</label>
                  <input type="file" multiple onChange={handleRfpFileChange} style={{ marginBottom: 24, width: "100%" }} className="form-control" />
                  <span style={{ fontSize: 11, color: "#888", marginTop: 4, display: "block" }}>
                    ↑ Select files, then click <strong>Add</strong> to upload
                  </span>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0, width: "100%", maxHeight: 180, overflowY: "auto", border: rfpFiles.length ? "1px solid #ececec" : "none", borderRadius: 6, background: rfpFiles.length ? "#fafafd" : "none" }}>
                    {rfpFiles.map((file, index) => (<li key={file.name} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 8px", borderBottom: index !== rfpFiles.length - 1 ? "1px solid #ececec" : "none" }}><span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><svg width="18" height="18" fill="#6c63ff" style={{ marginRight: 8, verticalAlign: "middle" }}><rect width="18" height="18" rx="3" /></svg>{file.name}</span><button onClick={() => handleRemove(index)} style={{ marginLeft: 16, padding: "4px 12px", backgroundColor: "#ff4e4e", color: "#fff", border: "none", borderRadius: 4, fontWeight: 500, cursor: "pointer", fontSize: 14 }}>Remove</button></li>))}
                    {!rfpFiles.length && <li style={{ color: "#999", textAlign: "center", padding: 20 }}>No files uploaded</li>}
                  </ul>
                </div>
                <div style={{ width: "100%", maxWidth: 480, margin: "0", background: "#fff", borderRadius: 8, boxShadow: "0 2px 12px #eee", padding: 32 }}>
                  <label className="form-labels font-weight500 font-size-subheading" style={{ marginBottom: 12, display: "block", fontSize: 18, fontWeight: 600 }}>Upload Tender Other Document (File name should be max 400 character)</label>
                  <input type="file" multiple onChange={handleRfpFileOtherChange} style={{ marginBottom: 24, width: "100%" }} className="form-control" />
                  <span style={{ fontSize: 11, color: "#888", marginTop: 4, display: "block" }}>
                    ↑ Select files, then click <strong>Add</strong> to upload
                  </span>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0, width: "100%", maxHeight: 180, overflowY: "auto", border: rfpFilesother.length ? "1px solid #ececec" : "none", borderRadius: 6, background: rfpFilesother.length ? "#fafafd" : "none" }}>
                    {rfpFilesother.map((file, index) => (<li key={file.name} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 8px", borderBottom: index !== rfpFilesother.length - 1 ? "1px solid #ececec" : "none" }}><span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><svg width="18" height="18" fill="#6c63ff" style={{ marginRight: 8, verticalAlign: "middle" }}><rect width="18" height="18" rx="3" /></svg>{file.name}</span><button onClick={() => handleRemoveOther(index)} style={{ marginLeft: 16, padding: "4px 12px", backgroundColor: "#ff4e4e", color: "#fff", border: "none", borderRadius: 4, fontWeight: 500, cursor: "pointer", fontSize: 14 }}>Remove</button></li>))}
                    {!rfpFilesother.length && <li style={{ color: "#999", textAlign: "center", padding: 20 }}>No files uploaded</li>}
                  </ul>
                </div>
              </div>
            </div>
            <div className="button-models"><button type="submit" onClick={handleSubmit} className="model-button model-button-submit">Submit</button></div>
            <p className="error-message font-size-text">{isSubmitted && Object.keys(errors).length > 0 && (Object.keys(errors).length > 5 ? (<h5 className="text-center">Please fill all mandatory fields!</h5>) : (<h6 className="text-center">{Object.keys(errors).map((field) => field.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())).join(", ") + " are required!"}</h6>))}</p>
          </form>
        </Modal.Body>
        {/* <ToastContainer position="top-center" autoClose={100000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover /> */}
      </Modal>
    </>
  );
};
const TenderViewBgModal = ({ i }) => {
  const [show, setShow] = useState(false);
  const [showModalBG, setShowModalBg] = useState(false);
  const [showModalBGLoader, setShowModalBgLoader] = useState(true);
  const [tenderidview, setTenderidView] = useState([]);
  const [tenderidviewdata, setTenderidViewData] = useState([]);
  const handleShowBG = (id) => {
    setShowModalBg(true);
    setTenderidView(id);
  };
  const handleCloseBg = () => {
    setShowModalBg(false);
    setTenderidView("");
  };

  const getBgDetailsFortender = async (id) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/gettenderwithbgdetails/${id}`,
      );

      if (response.status === 200) {
        setTenderidViewData(response?.data);
        setShowModalBgLoader(false);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
    }
  };

  useEffect(() => {
    if (showModalBG === true) {
      getBgDetailsFortender(i?.tender_id);
    }
    //   getBgDetailsFortender(i?.tender_id);
  }, [showModalBG]);
  const formatBoolean = (value) => {
    if (value === true || value === "true") return "Yes";
    if (value === false || value === "false") return "No";
    return value || "-";
  };
  const getDueDays = (expiryDate, transactionDate) => {
    const targetDate = expiryDate || transactionDate;

    if (!targetDate) return "-";

    const today = new Date();
    const target = new Date(targetDate);

    // remove time part for accurate day diff
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);

    const diffTime = target - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  return (
    <>
      <button
        title="Add Tender Documents"
        className="tender-card__action-outline"
        style={{ color: i?.bgcreatedfor_tender ? "#2576bc" : "red" }}
        onClick={() => handleShowBG(i?.tender_id)}
      >
        <Eye />{" "}
        {i?.bgcreatedfor_tender ? "EMD Created" : "EMD Yet to Create"}
      </button>

      <Modal
        show={showModalBG}
        onHide={handleCloseBg}
        dialogClassName="request-leave "
      // style={{ width: '100vw', maxWidth: '100%' }}
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Bg Created</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-container">
            {tenderidviewdata?.filter((item) => item?.is_in_created)?.length >
              0 ? (
              tenderidviewdata
                ?.filter((item) => item?.is_in_created)
                ?.map((item, index) => (
                  <div key={item.id} className="bg-card">
                    {/* Header */}
                    <div className="bg-card-header">
                      <span className="bg-card-title">
                        Tender ID: {item.tender_id}
                      </span>
                      <span className="bg-card-index">#{index + 1}</span>
                    </div>

                    {/* Body */}
                    <div className="bg-card-body">
                      <div className="bg-rows">
                        <span>EMD Created</span>
                        <span>{formatBoolean(item.bg_created)}</span>
                      </div>
                      <div className="bg-rows">
                        <span>Created By</span>
                        <span>{item.bg_created_by || "-"}</span>
                      </div>
                      <div className="bg-rows">
                        <span>On Behalf</span>
                        <span>{item.bg_created_on_behalf_of || "-"}</span>
                      </div>
                      <div className="bg-rows">
                        <span>Payer Bank</span>
                        <span>{item?.payer_bank?.toUpperCase() || "-"}</span>
                      </div>
                      <div className="bg-rows">
                        <span>Account No</span>
                        <span>{item.account_number || "-"}</span>
                      </div>
                      <div className="bg-rows">
                        <span>Account Holder</span>
                        <span>{item.name_of_account_holder || "-"}</span>
                      </div>
                      <div className="bg-rows">
                        <span>Creation Date</span>
                        <span>
                          {formatDateDDMMYYYYmonth(item.bg_creation_date)}
                        </span>
                      </div>
                      <div className="bg-rows">
                        <span>Expiry Date</span>
                        <span>
                          {formatDateDDMMYYYYmonth(item.bg_expiry_date)}
                        </span>
                      </div>
                      <div className="bg-rows">
                        <span>Transaction Date</span>
                        <span>
                          {formatDateDDMMYYYYmonth(item.bg_transcation_date)}
                        </span>
                      </div>
                      <div className="bg-rows">
                        <span>Ref No</span>
                        <span>{item.ref_no || "-"}</span>
                      </div>
                      <div className="bg-rows">
                        <span>NEFT ID</span>
                        <span>{item.neft_transaction_id || "-"}</span>
                      </div>
                      <div className="bg-rows">
                        <span>Transaction ID</span>
                        <span>{item.transcation_id || "-"}</span>
                      </div>

                      <div className="bg-rows">
                        <span>EMD Proof</span>
                        <span>
                          {item.emd_created_proof ? (
                            <a
                              href={item.emd_created_proof}
                              target="_blank"
                              rel="noreferrer"
                            >
                              View
                            </a>
                          ) : (
                            "-"
                          )}
                        </span>
                      </div>

                      <div className="bg-rows">
                        <span>Due Days</span>
                        <span
                          className={
                            getDueDays(
                              item.bg_expiry_date,
                              item.bg_transcation_date,
                            ) < 3
                              ? "due-alert"
                              : ""
                          }
                        >
                          {(() => {
                            const days = getDueDays(
                              item.bg_expiry_date,
                              item.bg_transcation_date,
                            );
                            return days === "-" ? "-" : `${days} days`;
                          })()}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <div className="Bg-not-created">
                Bg For This Tender Not Created Yet
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};


const KNOWN_CLIENT_VALUES = new Set([
  // Railway
  "CENTRAL_RAILWAY", "EAST_CENTRAL_RAILWAY", "EASTERN_RAILWAY", "MINISTRY_OF_RAILWAYS",
  "MUMBAI_RAILWAY_VIKAS_CORPORATION", "NORTH_CENTRAL_RAILWAY", "NORTH_EASTERN_RAILWAYS",
  "NORTHEST_FRONTIER_RAILWAYA", "NORTHERN_RAILWAY", "RAILWAY_ENERGY_MANAGEMENT_COMPANY_LIMITED",
  "SOUTH_CENTRAL_RAILWAY", "SOUTH_EASTERN_RAILWAYS", "SOUTH_COAST_RAILWAY", "SOUTHEST_FRONTIER_RAILWAY",
  "SOUTHERN_RAILWAY", "EAST_COAST_RAILWAY", "South_West_Central_Railway", "West_Central_Railway",
  "South_Western_Railway", "Western_Railway", "North_Western_Railway", "South_East_Railway",
  // Others
  "NHAI", "MORTH", "NHIDCL", "BRO", "PWDS", "MPRDCL", "MHRDCL", "GJRDCL", "SHAJ", "HSIIDC", "BHRDCL", "UPEIDA",
  "UPHA&SP", "RITES", "HRBG", "APCRDA", "RCDB", "BSIL", "BUIDCL", "CMRL", "DMRCL", "EPIL", "HRSI&IDCL", "H&UDCL",
  "J&KRRDA", "MHSIDC", "MHMRCL", "RJSRD&CCL", "KARDCL", "TNRDL", "APRDC", "PBIDB", "R&BDT", "RCDJ", "JHSRDC",
  "HPPWD", "UKPWD", "DSI&IDC", "GOAPWD", "HRRIDC", "RIDFOD", "RJSID&IC", "KLRFB", "RSHA", "BIDA", "MIDFC", "SOI",
  "JNPT", "BMRCL", "OBCCL", "NationalHighwaysLogisticsManagementLimited", "OTHER",
]);
const UpdateBidDetails = ({
  i,
  getBidData,
  toggleState,
  usedWhere,
  BidData,
  filters,
  onUpdateSuccess,
}) => {
  const [show, setShow] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
  const [lastUpdatedTenderId, setLastUpdatedTenderId] = useState(null);
  const uniqueStreamTypes = new Set();
  const [JvPartnerData, setJvPartnerData] = useState([]);
  const [docNames, setDocNames] = useState("");
  const fileInputRef = useRef("");
  const [oldData, setOldData] = useState({});
  const [prevEmdRequired, setPrevEmdRequired] = useState(null);

  const [emdDropdownOpen, setEmdDropdownOpen] = useState(false);
  const [emdOptions, setEmdOptions] = useState(DEFAULT_EMD_OPTIONS);
  const [emdShowOtherInput, setEmdShowOtherInput] = useState(false);
  const [emdCustomInput, setEmdCustomInput] = useState("");
  const emdDropdownRef = useRef(null);
  const [cfDefs, setCfDefs] = useState([]);
  const [cfValues, setCfValues] = useState({});
  const [cfErrors, setCfErrors] = useState({});
  const handleCfChange = (key, val) => {
    setCfValues((p) => ({ ...p, [key]: val }));
    setCfErrors((p) => { const n = { ...p }; delete n[key]; return n; });
  };
  // Close EMD dropdown on outside click
  // ✅ Track when user changes EMD Required from No to Yes

  useEffect(() => {
    const handler = (e) => {
      if (
        emdDropdownRef.current &&
        !emdDropdownRef.current.contains(e.target)
      ) {
        setEmdDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  const handleEmdToggleOption = (key) => {
    if (key === "other") {
      setEmdShowOtherInput((prev) => !prev);
      return;
    }
    setFormData((prev) => {
      const current = prev.emd_type_multi ?? [];
      const next = current.includes(key)
        ? current.filter((k) => k !== key)
        : [...current, key];
      return { ...prev, emd_type_multi: next };
    });
    // Clear error on selection
    setErrors((prev) => {
      const e = { ...prev };
      delete e.emd_type_multi;
      return e;
    });
  };

  const handleEmdRemoveChip = (key, e) => {
    e.stopPropagation();
    setFormData((prev) => ({
      ...prev,
      emd_type_multi: (prev.emd_type_multi ?? []).filter((k) => k !== key),
    }));
  };

  const handleEmdAddCustom = () => {
    const trimmed = emdCustomInput.trim();
    if (!trimmed) return;
    const key = trimmed.toLowerCase().replace(/\s+/g, "_");

    if (!emdOptions.find((o) => o.key === key)) {
      setEmdOptions((prev) => [
        ...prev.filter((o) => o.key !== "other"),
        { key, value: trimmed },
        { key: "other", value: "Other" },
      ]);
    }
    setFormData((prev) => {
      const current = prev.emd_type_multi ?? [];
      if (current.includes(key)) return prev;
      return { ...prev, emd_type_multi: [...current, key] };
    });
    setErrors((prev) => {
      const e = { ...prev };
      delete e.emd_type_multi;
      return e;
    });
    setEmdCustomInput("");
    setEmdShowOtherInput(false);
  };

  const emdLabelFor = (key) =>
    emdOptions.find((o) => o.key === key)?.value ?? key;

  const states = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  const getJvPartner = async () => {
    setBuffering(true);
    let url;
    try {
      url = `${BASE_URL}/siteproject/JVPartner/`;

      const sub = await axios.get(url);

      setJvPartnerData(sub.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  const handleClose = () => {
    setFormData({
      tender_id: "",
      tender_name: "",
      sector: "",
      tender_type: "",
      client: "",
      other_client: "",
      submission_date: "",
      publish_date: "",
      lane: "",
      state: "",
      consultancy_fees: "",
      construction_fees: "",
      GST_consultancy: "",
      length: "",
      duration: {
        construction: "",
        dlp: "",
        onm: "",
      },
      type_of_project: "",
      km_cost: "",
      remarks: "",
      pbg_requried: "",
      pbg_details: "",
    });
    setDocNames("");
    setErrors({});
    setShow(false);

    setWishData({
      associate_allowed: false,
      jv_partner_external: false,
      qualified: false,
      technical_marking: false,
      jv_partner_name: "",
      jv_partner_qualification_criteria: "",
      tenderIDD: null,
    });

    setFinalData({
      final_jv_name: "",
      lead_partner: "",
      assosiate_partner: "",
      external_jv: "",

      team_required: "",
      team_requirements_details: "",
      recipient_details: "",
      bg_amount: "",
      bg_type: "",

      tendersubmission: "",
      tenderIDD: "",
    });
    setCfDefs([]); setCfValues({}); setCfErrors({});
  };
  const handleShow = () => {
    setShow(true);
    getSubCompany();
    getJvPartner();

    clientList.forEach((entry) => {
      uniqueStreamTypes.add(entry.client_name);
    });
    const filteredData = { ...i };
    const toDatetimeLocal = (isoString) => {
      if (!isoString) return "";
      const date = new Date(isoString);
      const tzOffset = date.getTimezoneOffset() * 60000; // offset in ms
      const localISOTime = new Date(date - tzOffset).toISOString().slice(0, 16);
      return localISOTime; // "2025-09-18T05:22"
    };
    const extractRequiredFields = (data) => ({
      tender_id: data.tender_id || "",
      tender_name: data.tender_name || "",
      sector: data.sector || "",
      tender_type: data.tender_type || "",
      client:
        data.client && !KNOWN_CLIENT_VALUES.has(data.client.trim())
          ? "OTHER"
          : data.client || "",
      other_client:
        data.client && !KNOWN_CLIENT_VALUES.has(data.client.trim())
          ? data.client
          : "",
      submission_date: data.corrigendum_date
        ? toDatetimeLocal(data.corrigendum_date)
        : toDatetimeLocal(data?.submission_date) || "",
      publish_date: data.publish_date || "",
      lane: data.lane || "",
      // state: data.state || "",
      consultancy_fees: data.consultancy_fees || "",
      construction_fees: data.construction_fees || "",
      GST_consultancy: data.GST_consultancy || "",
      length: data.length || "",
      duration: {
        construction: data.duration?.construction || "",
        dlp: data.duration?.dlp || "",
        onm: data.duration?.onm || "",
      },
      type_of_project: data.type_of_project || "",
      km_cost: data.km_cost || "",
      remarks: data.remarks || "",
      ro: data.ro || "",
      tender_source: data.tender_source || "",
      sent: data.sent || "",
      recieve: data.recieve || "",
      is_emd_required: data.is_emd_required || false,
      exmpted_emd: data.exmpted_emd || false,
      emd_amount: data.emd_amount || "",
      // emd_unit: data.emd_unit || '',
      emd_type: data.emd_type === null || data.emd_type === undefined ? "" : data.emd_type,
      emd_type_multi: data.emd_type_multi || [],
      emd_submission_type: data.emd_submission_type || "",
      custom_emd_type: data.custom_emd_type || "",
      is_residual_bid_capacity: data.is_residual_bid_capacity || false,
      is_international: data.is_international || false,
      country_name: data.country_name || "",
      state: data.is_international ? "" : (data.state || ""),
      is_international: data.is_international || false,
      country_name: data.is_international ? (data.state || "") : "",
      cost_of_rfp: data.cost_of_rfp || "",
      infracon_id_cost: data.infracon_id_cost || "",
    });

    const cleanedData = extractRequiredFields(filteredData);
    setFormData(cleanedData);
    setOldData(cleanedData);
    setPrevEmdRequired(filteredData.is_emd_required);
    if (usedWhere === "downward") {
      Promise.all([fetchCustomFieldDefs(), fetchTenderCustomFields(i.id)])
        .then(([defs, vals]) => {
          const valMap = Object.fromEntries(vals.map((f) => [f.key, f.value]));
          setCfDefs(defs);          // all definitions, filtered by sector via cfVisible
          setCfValues(valMap);
        });
    }
  };

  const [buffer, setBuffering] = useState(false); //buffering logic

  const [formData, setFormData] = useState({
    tender_id: "",
    tender_name: "",
    sector: "",
    tender_type: "",
    client: "",
    other_client: "",
    submission_date: "",
    publish_date: "",
    lane: "",
    state: "",
    consultancy_fees: "",
    construction_fees: "",
    GST_consultancy: "",
    length: "",
    duration: {
      construction: "",
      dlp: "",
      onm: "",
    },
    type_of_project: "",
    km_cost: "",
    ro: "",
    remarks: "",
    pbg_requried: "",
    pbg_details: "",
    is_special_tender: "",
    special_structure_type: "",
    tender_source: "",
    sent: "",
    recieve: "",
    is_emd_required: "",
    exmpted_emd: "",
    emd_amount: "",
    // emd_unit: '',
    emd_type: "",
    emd_submission_type: "",
    custom_emd_type: "",
    is_residual_bid_capacity: false,
    is_international: false,
    country_name: "",
    cost_of_rfp: "",
    infracon_id_cost: "",
  });

  const cfVisible = cfDefs.filter((f) => fieldAppliesTo(f, formData.sector));
  const [wishListData, setWishData] = useState({
    associate_allowed: false,
    jv_partner_external: false,
    qualified: false,
    technical_marking: false,
    jv_partner_type: "",
    jv_partner_qualification_criteria: "",
    tenderIDD: null,
  });

  const [tenderId, setTenderId] = useState("null");

  useEffect(() => {
    setTenderId(wishListData.tenderIDD);
  }, [wishListData.tenderIDD]);
  const [wishlistinputState, setwishlistInputState] = useState({});
  const handleWishListInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    setwishlistInputState((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
            ? "green"
            : ""
          : newValue
            ? "green"
            : "",
    }));

    setWishData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,
      };

      return updatedFormData;
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const [finalData, setFinalData] = useState({
    final_jv_name: "",
    lead_partner: "",
    assosiate_partner: "",
    external_jv: "",
    emd_amount: "",
    // emd_unit: "",
    team_required: "",
    team_requirements_details: "",
    recipient_details: "",
    bg_amount: "",
    bg_type: "",
    emd_type: "",
    emd_submission_type: "",
    tendersubmission: "",
    tenderIDD: "",
  });
  useEffect(() => {
    setTenderId(finalData.tenderIDD);
  }, [finalData.tenderIDD]);
  const [finalinputState, setfinalInputState] = useState({});
  const handlefinalInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    setfinalInputState((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
            ? "green"
            : ""
          : newValue
            ? "green"
            : "",
    }));

    setFinalData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,
      };

      return updatedFormData;
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const getSubCompany = async () => {
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSiteSubCompanyList(sub.data);
    } catch (error) { }
  };

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  console.log("Tender row data:", i);


  const validateForm = () => {
    const newErrors = {};

    if (!formData.tender_id) {
      newErrors.tender_id = "Tender Id is required!";
    }
    if (!formData.submission_date) {
      newErrors.submission_date = "Submission Date is required!";
    }
    if (!formData.length) {
      newErrors.length = "Length is required!";
    }
    if (!formData.tender_name) {
      newErrors.tender_name = "Tender Name is required!";
    }
    if (!formData.sector) {
      newErrors.sector = "Sector is required!";
    }
    if (!formData.tender_type) {
      newErrors.tender_type = "Tender Type is required!";
    }
    if (!formData.client) {
      newErrors.client = "Client is required!";
    }
    if (formData.client === "OTHER" && !formData.other_client?.trim()) {
      newErrors.other_client = "Other Client name is required!";
    }
    if (formData.is_international) {
      if (!formData.country_name) {
        newErrors.country_name = "Country Name is required!";
      }
    } else {
      if (!formData.state) {
        newErrors.state = "State is required!";
      }
    }
    if (!formData.publish_date) {
      newErrors.publish_date = "Publish Date is required!";
    }


    if (formData.sector === "Highway") {
      if (!formData.lane) {
        newErrors.lane = "Lane is required!";
      }
    }

    if (formData.pbg_requried) {
      if (!formData.pbg_details) {
        newErrors.pbg_details = "PBG Details is required!";
      }
    }

    if (formData.is_special_tender) {
      if (!formData.special_structure_type || formData.special_structure_type === "null") {
        newErrors.special_structure_type = "Special Structure Type is required!";
      }
    }

    // ✅ EMD VALIDATION - Fixed logic
    if (formData.is_emd_required) {
      // Always required when EMD is Yes
      if (!formData.emd_amount) {
        newErrors.emd_amount = "EMD Amount is required!";
      }
      if (formData.exmpted_emd == null || formData.exmpted_emd === "") {
        newErrors.exmpted_emd = "Exmpted Emd is required!";
      }
      if (!formData.emd_submission_type) {
        newErrors.emd_submission_type = "EMD Submission Type is required!";
      }

      // Check if we're using the NEW multi-select approach (when emd_type is empty/null)
      const isUsingMultiSelect = !formData.emd_type || formData.emd_type === "";

      // For existing tenders with emd_type value, emd_type_multi is optional
      // For new tenders (isUsingMultiSelect true), emd_type_multi is required
      if (isUsingMultiSelect) {
        if (!formData.emd_type_multi || formData.emd_type_multi.length === 0) {
          newErrors.emd_type_multi = "EMD Type is required!";
        }
      }
      // If emd_type has a value (legacy data), we DON'T require emd_type_multi
    }
    const cfErr = {};
    cfVisible.forEach((f) => {
      if (f.is_required && (cfValues[f.key] === null || cfValues[f.key] === undefined || cfValues[f.key] === ""))
        cfErr[f.key] = `${f.name} is required!`;
    });
    setCfErrors(cfErr);
    if (Object.keys(cfErr).length) newErrors.custom_fields = "Custom fields";

    setErrors(newErrors);
    setIsSubmitted(true);

    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e) => {
    const { name, value, type, checked, options, files } = e.target;

    let newValue;
    if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files.length > 0 ? files[0] : null;
    } else {
      newValue = value;
    }

    const keys = name.split(".");
    const topKey = keys[0];

    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData };

      if (keys.length === 2) {
        updatedFormData[topKey] = {
          ...updatedFormData[topKey],
          [keys[1]]: newValue,
        };
      } else {
        updatedFormData[name] = newValue;
      }

      return updatedFormData;
    });

    setInputState((prevState) => {
      if (keys.length === 2) {
        return {
          ...prevState,
          [topKey]: {
            ...prevState[topKey],
            [keys[1]]: newValue ? "green" : "",
          },
        };
      } else {
        return {
          ...prevState,
          [name]: newValue ? "green" : "",
        };
      }
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (keys.length === 2 && updatedErrors[topKey]) {
          updatedErrors[topKey] = {
            ...updatedErrors[topKey],
          };
          delete updatedErrors[topKey][keys[1]];
          if (Object.keys(updatedErrors[topKey]).length === 0) {
            delete updatedErrors[topKey];
          }
        } else {
          delete updatedErrors[name];
        }
        return updatedErrors;
      });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-"); // Format: YYYY-MM-DD
      const time = now
        .toLocaleTimeString("en-GB", { hour12: false })
        .replace(/:/g, "-"); // Format: HH-MM-SS
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = "";
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        randomCode += allChars[randomIndex];
      }
      const customFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
      const customFile = new File([file], customFileName, { type: file.type });

      setFormData({
        ...formData,
        document: customFile,
      });
      setDocNames(customFileName);
    } else {
      setDocNames("");
    }
  };

  const handleClear = () => {
    setFormData((prevState) => ({
      ...prevState,
      document: null,
    }));
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    setDocNames("");
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      const formDataToSend = new FormData();
      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-");
      const time = now
        .toLocaleTimeString("en-GB", { hour12: false })
        .replace(/:/g, "-");
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = "";
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        randomCode += allChars[randomIndex];
      }

      const originalFile2 = formData?.document;
      const customFileName2 = `Aimantra ${date} ${time}_${randomCode} ${originalFile2?.name}`;
      const customFile2 = new File([originalFile2], customFileName2, {
        type: originalFile2?.type,
      });
      const emdFields = [
        "emd_amount",
        // 'emd_unit',
        "emd_type",
        "emd_submission_type",
        "custom_emd_type",
      ];

      Object.keys(formData).forEach((key) => {
        if (key === "document") return;

        if (key === "country_name") return; // UI-only
        if (key === "is_international") return; // UI-only
        if (key === "other_client") return; // UI-only
        if (key === "client") {
          formDataToSend.append(
            "client",
            formData.client === "OTHER" ? formData.other_client.trim() : formData.client,
          );
          return;
        }
        if (key === "state") {
          formDataToSend.append(
            "state",
            formData.is_international ? formData.country_name : formData.state
          );
        } else if (key === "duration") {
          formDataToSend.append("duration", JSON.stringify(formData.duration));
        } else if (key === "submission_date") {
          formDataToSend.append(
            "submission_date",
            formatISTWithOffset(formData.submission_date),
          );
        } else if (key === "emd_type_multi") {
          // Send as JSON array; empty array if EMD not required
          formDataToSend.append(
            "emd_type_multi",
            formData.is_emd_required
              ? JSON.stringify(formData.emd_type_multi)
              : "[]",
          );
        } else if (emdFields.includes(key)) {
          formDataToSend.append(
            key,
            formData.is_emd_required ? formData[key] : "",
          );
        } else {
          formDataToSend.append(key, formData[key]);
        }
      });
      if (formData.document) {
        formDataToSend.append("document", formData.document);
      }
      try {
        let data = null;
        let id = null;

        if (usedWhere === "downward") {
          setLastUpdatedTenderId(formData.tender_id);
          data = formData;
          id = i.id;
        } else if (usedWhere === "upward" && toggleState === 2) {
          setLastUpdatedTenderId(formData.tender_id);
          data = wishListData;
          id = tenderId;
        } else if (usedWhere === "upward" && toggleState === 4) {
          setLastUpdatedTenderId(formData.tender_id);
          data = finalData;
          id = tenderId;
        }

        let res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${id}/`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          const getJsonData = (data) => {
            if (data instanceof FormData) {
              return Object.fromEntries(data.entries());
            }
            return data; // already JSON
          };

          await saveAudit({
            tenderId: i?.id,
            updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
            tableName: "Tenderforbd",
            oldData: { ...oldData, client: i?.client || "" },
            newData: {
              ...getJsonData(formData),
              client: formData.client === "OTHER" ? formData.other_client.trim() : formData.client,
            },
            action: "UPDATE",
            tab_id: toggleState,
          });

          if (usedWhere === "downward" && cfVisible.length) {
            try {
              const cfPayload = Object.fromEntries(
                cfVisible.map((f) => [f.key, cfValues[f.key] ?? null])
              );
              await saveTenderCustomFields(id, cfPayload);
            } catch (cfErr) {
              if (cfErr.response?.status === 400) {
                setCfErrors(cfErr.response.data);
                toast.error("Tender updated, but some custom fields are invalid.");
                await getBidData(filters);   // ← add this
                return;
              }
              throw cfErr;
            }
          }

          // Set is_active based on updated submission_date
          if (usedWhere === "downward" && formData.submission_date) {
            const submissionDate = new Date(formData.submission_date);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            submissionDate.setHours(0, 0, 0, 0);
            const isActive = submissionDate >= today;

            await axios.put(
              `${BASE_URL}/siteproject/BidTenderUpdate/${id}/`,
              { is_active: isActive },
              { headers: { "Content-Type": "application/json" } },
            );
          }

          sessionStorage.setItem("scrollTenderId", i.tender_id);
          setShow(false);
          await getBidData(filters);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [tenderData, settenderData] = useState({});
  const getData = async () => {
    setBuffering(true); // Start Buffering
    let url;
    try {
      url = `${BASE_URL}/siteproject/tenderBDfilterbyid/${tenderId}/`;

      const sub = await axios.get(url);

      settenderData(sub.data);
    } catch (err) {
      handleErrorToast(err); // Toast Logic
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    if (toggleState === 4 && show === true && tenderId && tenderId !== "null") {
      getData();
    }
  }, [toggleState, show, tenderId]);
  const EmdType = [
    { key: "Bank_Gurantee", value: "Bank Gurantee" },
    { key: "neft", value: "NEFT" },
    { key: "demand_draft", value: "Demand Draft" },
    { key: "suretybond", value: "Surety Bond" },
    { key: "other", value: "Other" },
  ];
  useEffect(() => {
    // If EMD was previously NOT required and now IS required
    if (prevEmdRequired === false && formData.is_emd_required === true) {
      // You can optionally trigger any UI feedback here
    }
  }, [formData.is_emd_required, prevEmdRequired]);

  return (
    <>
      <button
        title="Edit Tender Details"

        onClick={handleShow}
      >
        {usedWhere === "downward" ? (
          <>
            <button className="bg-action-btn" title="Edit Tender" >✏️</button>{" "}
          </>
        ) : toggleState === 2 && usedWhere === "upward" ? (
          <>
            <AddwithWhiteCircle />
            Eligibility Cretria
          </>
        ) : toggleState === 9 && usedWhere === "upward" ? (
          <>
            <AddwithWhiteCircle />
            Final Details
          </>
        ) : (
          ""
        )}
      </button>

      <Modal
        Modal
        show={show}
        onHide={handleClose}
        dialogClassName={
          usedWhere === "downward" || toggleState === 9
            ? "ourcompany-model"
            : toggleState === 2 && usedWhere === "upward"
              ? "custom-modal"
              : ""
        }
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>
            {usedWhere === "downward" ? (
              <>Edit Tender Details</>
            ) : toggleState === 2 && usedWhere === "upward" ? (
              <>Add Eligibility Cretria</>
            ) : toggleState === 9 && usedWhere === "upward" ? (
              <>Add Final Details</>
            ) : (
              ""
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-form">
            <div className="checkbox-wrapper" style={{ marginTop: "8px" }}>
              <label className="custom-checkbox font-weight500 font-size-subheading">
                <input
                  type="checkbox"
                  name="is_residual_bid_capacity"
                  checked={formData.is_residual_bid_capacity || false}
                  onChange={handleInputChange}
                />
                <span className="checkmark"></span>
                Residual Bid Capacity
              </label>
            </div>
            {usedWhere === "downward" ? (
              <>
                <div className="form-flex-wrap">
                  {["certificaionadminaccess", "CertificationAccess", "ScreeningTeam"].includes(
                    sessionStorage.getItem("sitemanagement_role")
                  ) && (
                      <div className="cf-container">
                        <CreateCustomFieldInline
                          defaultSector={formData.sector}
                          onCreated={async () =>
                            setCfDefs(await fetchCustomFieldDefs())
                          }
                        />
                      </div>
                    )}


                  <div className="flex-column">

                    <label className="form-labels">
                      Tender ID <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="tender_id"
                      placeholder="Example - NHAI2025-RJ-011"
                      value={formData.tender_id}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.tender_id ? "error" : inputState.tender_id ? "success" : ""}`}
                    />
                    {errors.tender_id && (
                      <span className="error-message">{errors.tender_id}</span>
                    )}
                  </div>
                  <div className="flex-column">
                    <div
                      className="flex-row justify-between form-labels"
                      style={{ height: "25px" }}
                    >
                      <label htmlFor="tender_name" className="">
                        Tender Name
                        <span className="required">*</span>
                      </label>
                      <div className="checkbox-wrapper">
                        <label className="custom-checkbox  font-weight500 font-size-subheading">
                          <input
                            type="checkbox"
                            name="is_special_tender"
                            checked={formData.is_special_tender || false}
                            onChange={handleInputChange}
                          />
                          <span className="checkmark"></span>
                          Special Tender
                        </label>
                      </div>
                    </div>
                    <input
                      type="text"
                      name="tender_name"
                      placeholder="Example - NH66 Highway Project"
                      value={formData.tender_name}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.tender_name ? "error" : inputState.tender_name ? "success" : ""}`}
                    />
                    {errors.tender_name && (
                      <span className="error-message">
                        {errors.tender_name}
                      </span>
                    )}
                  </div>
                  {formData.is_special_tender && (
                    <div className="flex-columns">
                      <label className="form-labels">
                        Special Structure Type{" "}
                        <span className="required">*</span>{" "}
                      </label>
                      <br />
                      <select
                        name="special_structure_type"
                        placeholder="Special Structure"
                        value={formData.special_structure_type}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.special_structure_type ? "error" : inputState.special_structure_type ? "success" : ""}`}
                      >
                        <option value="">Select structure type</option>
                        <option value="tunnel">Tunnel</option>
                        <option value="major_bridge">Major Bridge</option>
                        <option value="cable_stayed">Cable Stayed</option>
                        <option value="elevated">Elevated</option><option value="hilly">Hilly</option><option value="slope_protection">Slope Protection</option><option value="NEW_SEGMENT">New Segment</option>
                      </select>
                      {errors.special_structure_type && (
                        <span className="error-message">
                          {errors.special_structure_type}
                        </span>
                      )}
                    </div>
                  )}
                  <div className="flex-column">
                    <label className="form-labels">
                      Sector <span className="required">*</span>{" "}
                    </label>
                    <select
                      name="sector"
                      value={formData.sector}
                      onChange={handleInputChange}
                      placeholder="Select Sector"
                      className={`form-input input-form ${errors.sector ? "error" : inputState.sector ? "success" : ""}`}
                    >
                      <option value="">Select sector</option>
                      <option value="Highway">Highway</option>
                      <option value="Railway">Railway</option>
                      <option value="Metro">Metro</option>
                      <option value="Water">Water</option>
                      <option value="Ropeway">Ropeway</option>
                      <option value="Building">Building</option>
                      <option value="Other">Other</option>
                    </select>
                    {errors.sector && (
                      <span className="error-message">{errors.sector}</span>
                    )}
                  </div>

                  {formData.sector === "Other" && (
                    <div className="flex-column">
                      <label className="form-labels">Other Sector Type </label>
                      <input
                        type="text"
                        name="other_sector_type"
                        placeholder="Other Sector Type Name"
                        value={formData.other_sector_type}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.other_sector_type ? "error" : inputState.other_sector_type ? "success" : ""}`}
                      />
                      {errors.other_sector_type && (
                        <span className="error-message">
                          {errors.other_sector_type}
                        </span>
                      )}
                    </div>
                  )}

                  {cfVisible.length > 0 && (
                    <CustomFieldsForm
                      className="flex-column"
                      fields={cfVisible}
                      values={cfValues}
                      errors={cfErrors}
                      onChange={handleCfChange}
                    />
                  )}

                  {/* Tender Type */}
                  <div className="flex-column">
                    <label className="form-labels">
                      Tender Type <span className="required">*</span>
                    </label>
                    <select
                      name="tender_type"
                      value={formData.tender_type}
                      onChange={handleInputChange}
                      placeholder="Select Tender Type"
                      className={`form-input input-form ${errors.tender_type
                        ? "error"
                        : inputState.tender_type
                          ? "success"
                          : ""
                        }`}
                    >
                      <option value="">Select Tender Type</option>

                      {/* Always visible */}
                      <option value="Feasibility">Feasibility</option>
                      <option value="DPR">DPR</option>
                      <option value="FesibilityCumDPR">
                        Feasibility Cum DPR
                      </option>
                      <option value="Authority_Engineer">
                        Authority Engineer
                      </option>
                      <option value="Independent_Engineer">
                        Independent Engineer
                      </option>
                      <option value="PMC">PMC</option>
                      <option value="Supervision">Supervision</option>
                      <option value="eoi">EOI</option>
                      <option value="Empanelment">Empanelment</option>
                      <option value="O&M">O&amp;M</option>
                      <option value="IEO&M">IE O&amp;M</option>
                      <option value="AE_O&M">AE O&amp;M</option>
                      <option value="Supervision_O&M">
                        Supervision O&amp;M
                      </option>
                      <option value="Survey">Survey</option>
                      <option value="Technology">Technology</option>
                      <option value="machinery">Machinery</option>
                      <option value="slope_stability">Slope Stability</option>
                      <option value="slope_protection">Slope Protection</option>
                      <option value="Detailed_Design">Detailed Design</option>
                      <option value="Architecture">Architecture</option>
                      <option value="safety_consultant">
                        SAFETY CONSULTANT
                      </option>
                      <option value="pms">PMS</option>
                      <option value="geotechnical">Geotechnical</option>
                      <option value="Other">Other</option>

                      {/* 👇 Show only if sector === "Railway" */}
                      {formData.sector === "Railway" && (
                        <>
                          <option value="PSSA">PSSA</option>
                          <option value="GC">GC</option>
                          <option value="Temping">Temping</option>
                          <option value="FLS">FLS</option>
                          <option value="Station_Redevelopment">
                            Station Redevelopment
                          </option>
                        </>
                      )}
                    </select>
                    <br />
                    {errors.tender_type && (
                      <span className="error-message">
                        {errors.tender_type}
                      </span>
                    )}
                  </div>

                  {formData.tender_type === "Other" && (
                    <div className="flex-column">
                      <label className="form-labels">Other Sector Type </label>
                      <input
                        type="text"
                        name="other_tender_type"
                        placeholder="Other Tender Type Name"
                        value={formData.other_tender_type}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.other_tender_type ? "error" : inputState.other_tender_type ? "success" : ""}`}
                      />
                      {errors.other_tender_type && (
                        <span className="error-message">
                          {errors.other_tender_type}
                        </span>
                      )}
                    </div>
                  )}

                  <div className="flex-column">
                    <label className="form-labels">
                      Client <span className="required">*</span>{" "}
                    </label>
                    <select
                      name="client"
                      value={formData.client}
                      onChange={handleInputChange}
                      placeholder="Select Client"
                      className={`form-input input-form ${errors.client ? "error" : inputState.client ? "success" : ""}`}
                    >
                      <option value="">Select Client</option>
                      {formData.sector === "Railway" ? (
                        <>
                          <option value="CENTRAL_RAILWAY">
                            Central Railway
                          </option>
                          <option value="EAST_CENTRAL_RAILWAY">
                            East Central Railway
                          </option>
                          <option value="EASTERN_RAILWAY">
                            Eastern Railway
                          </option>
                          <option value="MINISTRY_OF_RAILWAYS">
                            Ministry of Railways
                          </option>
                          <option value="MUMBAI_RAILWAY_VIKAS_CORPORATION">
                            Mumbai Railway Vikas Corporation
                          </option>
                          <option value="NORTH_CENTRAL_RAILWAY">
                            North Central Railway
                          </option>
                          <option value="NORTH_EASTERN_RAILWAYS">
                            North Eastern Railways
                          </option>
                          <option value="NORTHEST_FRONTIER_RAILWAYA">
                            Northest Frontier Railwaya
                          </option>
                          <option value="NORTHERN_RAILWAY">
                            Northern Railway
                          </option>
                          <option value="RAILWAY_ENERGY_MANAGEMENT_COMPANY_LIMITED">
                            Railway Energy Management Company Limited
                          </option>
                          <option value="SOUTH_CENTRAL_RAILWAY">
                            South Central Railway
                          </option>
                          <option value="SOUTH_EASTERN_RAILWAYS">
                            South Eastern Railways
                          </option>
                          <option value="SOUTH_COAST_RAILWAY">
                            South Coast Railway
                          </option>
                          <option value="SOUTHEST_FRONTIER_RAILWAY">
                            Southest Frontier Railway
                          </option>
                          <option value="SOUTHERN_RAILWAY">
                            Southern Railway
                          </option>
                          <option value="EAST_COAST_RAILWAY">
                            EAST COAST RAILWAY
                          </option>
                          <option value="South_West_Central_Railway">
                            South West Central Railway
                          </option>
                          <option value="West_Central_Railway ">
                            West Central Railway{" "}
                          </option>
                          <option value="South_Western_Railway">
                            {" "}
                            South Western Railway
                          </option>
                          <option value="Western_Railway">
                            Western Railway
                          </option>
                          <option value="North_Western_Railway">
                            {" "}
                            North Western Railway{" "}
                          </option>
                          <option value="South_East_Railway">
                            South East Railway
                          </option>
                          <option value="OTHER">Other</option>
                        </>
                      ) : (
                        <>
                          <option value="NHAI">NHAI</option>
                          <option value="MORTH">MoRTH</option>
                          <option value="NHIDCL">NHIDCL</option>
                          <option value="BRO">BRO</option>
                          <option value="PWDS">PWDs</option>
                          <option value="MPRDCL">MPRDCL</option>
                          <option value="MHRDCL">MHRDCL</option>
                          <option value="GJRDCL">GJRDCL</option>
                          <option value="SHAJ">SHAJ</option>
                          <option value="HSIIDC">HSIIDC</option>
                          <option value="BHRDCL">BHRDCL</option>
                          <option value="UPEIDA">UPEIDA</option>
                          <option value="UPHA&SP">UPHA&SP</option>
                          <option value="RITES">RITES</option>
                          <option value="HRBG">HRBG</option>
                          <option value="APCRDA">APCRDA</option>
                          <option value="RCDB">RCDB</option>
                          <option value="BSIL">BSIL</option>
                          <option value="BUIDCL">BUIDCL</option>
                          <option value="CMRL">CMRL</option>
                          <option value="DMRCL">DMRCL</option>
                          <option value="EPIL">EPIL</option>
                          <option value="HRSI&IDCL">HRSI&IDCL</option>
                          <option value="H&UDCL">H&UDCL</option>
                          <option value="J&KRRDA">J&KRRDA</option>
                          <option value="MHSIDC">MHSIDC</option>
                          <option value="MHMRCL">MHMRCL</option>
                          <option value="RJSRD&CCL">RJSRD&CCL</option>
                          <option value="KARDCL">KARDCL</option>
                          <option value="TNRDL">TNRDL</option>
                          <option value="APRDC">APRDC</option>
                          <option value="PBIDB">PBIDB</option>
                          <option value="R&BDT">R&BDT</option>
                          <option value="RCDJ">RCDJ</option>
                          <option value="JHSRDC">JHSRDC</option>
                          <option value="HPPWD">HPPWD</option>
                          <option value="UKPWD">UKPWD</option>
                          <option value="DSI&IDC">DSI&IDC</option>
                          <option value="GOAPWD">GOAPWD</option>
                          <option value="HRRIDC">HRRIDC</option>
                          <option value="RIDFOD">RIDFOD</option>
                          <option value="RJSID&IC">RJSID&IC</option>
                          <option value="KLRFB">KLRFB</option>
                          <option value="RSHA">RSHA</option>
                          <option value="BIDA">BIDA</option>
                          <option value="MIDFC">MIDFC</option>
                          <option value="SOI">SOI</option>
                          <option value="JNPT">JNPT</option>
                          <option value="BMRCL">BMRCL</option>
                          <option value="OBCCL">OBCCL</option>
                          <option value="NationalHighwaysLogisticsManagementLimited">
                            National Highways Logistics Management Limited
                          </option>
                          <option value="OTHER">Other</option>
                        </>
                      )}
                    </select>
                    {errors.client && (
                      <span className="error-message">{errors.client}</span>
                    )}
                  </div>
                  {formData.client === "OTHER" && (
                    <div className="flex-column">
                      <label className="form-labels">
                        Other Client Name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="other_client"
                        placeholder="Enter client name"
                        value={formData.other_client}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.other_client ? "error" : inputState.other_client ? "success" : ""}`}
                      />
                      {errors.other_client && (
                        <span className="error-message">{errors.other_client}</span>
                      )}
                    </div>
                  )}
                  <div className="flex-column">
                    <label className="form-labels">Client Ro</label>
                    <input
                      type="text"
                      name="ro"
                      value={formData?.ro}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors?.ro ? "error" : inputState?.ro ? "success" : ""}`}
                    />
                    {errors?.ro && (
                      <span className="error-message">{errors.ro}</span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">
                      Publish Date <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      name="publish_date"
                      value={formData?.publish_date}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors?.publish_date ? "error" : inputState?.publish_date ? "success" : ""}`}
                      max={new Date().toISOString().split("T")[0]}
                    />
                    {errors?.publish_date && (
                      <span className="error-message">
                        {errors?.publish_date}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">
                      Submission Date <span className="required">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      name="submission_date"
                      value={formData?.submission_date}
                      onChange={handleInputChange}
                      min={new Date().toISOString().slice(0, 16)}
                      className={`form-input input-form ${errors?.submission_date ? "error" : inputState?.submission_date ? "success" : ""}`}
                    />
                    {errors?.submission_date && (
                      <span className="error-message">
                        {errors?.submission_date}
                      </span>
                    )}
                  </div>

                  {formData.sector != "Railway" && (
                    <div className="flex-column">
                      <label className="form-labels">Lane</label>

                      <select
                        name="lane"
                        value={formData.lane}
                        onChange={handleInputChange}
                        placeholder="Select Lane"
                        className={`form-input input-form ${errors.lane
                          ? "error"
                          : inputState.lane
                            ? "success"
                            : ""
                          }`}
                      >
                        <option value="">Select Lane</option>
                        <option value="intimident_lane">Single Track Lane</option>
                        <option value="2">2 Lane</option>
                        <option value="4">4 Lane</option>
                        <option value="6">6 Lane</option>
                        <option value="8">8 Lane</option>
                        <option value="nhsl">NHSL</option>
                        <option value="rfp_not_uploaded">Not Available</option>
                        <option value="not_required">Not Required</option>
                      </select>

                      {errors.lane && (
                        <span className="error-message">{errors.lane}</span>
                      )}
                    </div>
                  )}

                  {/* <div className="flex-column">
                    <label className="form-labels">
                      State <span className="required">*</span>{" "}
                    </label>
                    <select
                      name="state"
                      value={formData.state}
                      onChange={handleInputChange}
                      placeholder="Select State"
                      className={`form-input input-form ${errors.state ? "error" : inputState.state ? "success" : ""}`}
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                    {errors.state && (
                      <span className="error-message">{errors.state}</span>
                    )}
                  </div> */}
                  <div className="flex-column">
                    {/* use flex-column in UpdateBidDetails */}
                    <div
                      className="flex-row justify-between form-labels"
                      style={{ height: "25px" }}
                    >
                      <label className="">
                        State {!formData.is_international && <span className="required">*</span>}
                      </label>
                      <div className="checkbox-wrapper" >
                        <label className="custom-checkbox font-weight500 font-size-subheading">
                          <input
                            type="checkbox"
                            name="is_international"
                            checked={formData.is_international || false}
                            onChange={handleInputChange}
                          />
                          <span className="checkmark"></span>
                          International
                        </label>
                      </div>
                    </div>
                    <select
                      name="state"
                      value={formData.is_international ? "" : formData.state}
                      onChange={handleInputChange}
                      disabled={formData.is_international}
                      className={`form-input input-form ${errors.state ? "error" : inputState.state ? "success" : ""
                        }`}
                      style={formData.is_international ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state} value={state}>{state}</option>
                      ))}
                    </select>
                    {errors.state && (
                      <span className="error-message">{errors.state}</span>
                    )}

                  </div>
                  {formData.is_international && (
                    <div className="flex-column"> {/* use flex-column in UpdateBidDetails */}
                      <label className="form-labels">
                        Country Name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="country_name"
                        placeholder="e.g. United Arab Emirates"
                        value={formData.country_name}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.country_name ? "error" : inputState.country_name ? "success" : ""
                          }`}
                      />
                      {errors.country_name && (
                        <span className="error-message">{errors.country_name}</span>
                      )}
                    </div>
                  )}
                  <div className="flex-column">
                    <label htmlFor="pbg_requried" className="form-labels">
                      PBG Required
                    </label>
                    <select
                      id="pbg_requried"
                      name="pbg_requried"
                      value={formData.pbg_requried}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          pbg_requried:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null,
                        }))
                      }
                      className="form-input input-form"
                    >
                      <option value="">PBG Required</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                    {errors.pbg_requried && (
                      <span className="error-message">
                        {errors.pbg_requried}
                      </span>
                    )}
                  </div>
                  {formData.pbg_requried && (
                    <div className="flex-column">
                      <label className="form-labels">Pbg Details</label>
                      <input
                        type="text"
                        name="pbg_details"
                        placeholder="Pbg Details"
                        value={formData.pbg_details}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.pbg_details ? "error" : inputState.pbg_details ? "success" : ""}`}
                      />
                      {errors.pbg_details && (
                        <span className="error-message">
                          {errors.pbg_details}
                        </span>
                      )}
                    </div>
                  )}

                  <div className="flex-column">
                    <label className="form-labels">
                      Consultancy Fees (in crores)
                    </label>
                    <input
                      type="number"
                      name="consultancy_fees"
                      Consultancy
                      Fees
                      value={formData.consultancy_fees}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.consultancy_fees ? "error" : inputState.consultancy_fees ? "success" : ""}`}
                    />
                    {errors.consultancy_fees && (
                      <span className="error-message">
                        {errors.consultancy_fees}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">
                      Construction Fees (in crores)
                    </label>
                    <input
                      type="number"
                      name="construction_fees"
                      placeholder="e.g. 2.5 (in crores)"
                      value={formData.construction_fees}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.construction_fees ? "error" : inputState.construction_fees ? "success" : ""}`}
                    />
                    {errors.construction_fees && (
                      <span className="error-message">
                        {errors.construction_fees}
                      </span>
                    )}
                  </div>
                  <div className="flex-column">
                    <label className="form-labels">RFP Cost</label>
                    <input
                      type="number"
                      name="cost_of_rfp"
                      placeholder="Enter full amount (e.g.10000)"
                      value={formData.cost_of_rfp}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.cost_of_rfp ? "error" : inputState.cost_of_rfp ? "success" : ""}`}
                    />
                    {errors.cost_of_rfp && <span className="error-message">{errors.cost_of_rfp}</span>}
                  </div>
                  <div className="flex-column">
                    <label className="form-labels">Infracon ID Cost</label>
                    <input
                      type="number"
                      name="infracon_id_cost"
                      placeholder="Enter full amount (e.g. 1000)"
                      value={formData.infracon_id_cost}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.infracon_id_cost ? "error" : inputState.infracon_id_cost ? "success" : ""}`}
                    />
                    {errors.infracon_id_cost && <span className="error-message">{errors.infracon_id_cost}</span>}
                  </div>
                  <div className="flex-column">
                    <label className="form-labels">GST</label>

                    <select
                      name="GST_consultancy"
                      value={formData.GST_consultancy}
                      onChange={handleInputChange}
                      placeholder="Select GST Consultancy"
                      className={`form-input input-form ${errors.GST_consultancy ? "error" : inputState.GST_consultancy ? "success" : ""}`}
                    >
                      <option value="">Select GST</option>
                      <option value="Including">Including</option>
                      <option value="Excluding">Excluding</option>
                    </select>
                    {errors.GST_consultancy && (
                      <span className="error-message">
                        {errors.GST_consultancy}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">Tender Source</label>

                    <select
                      name="tender_source"
                      value={formData.tender_source}
                      onChange={handleInputChange}
                      placeholder="Select Tender Source Consultancy"
                      className={`form-input input-form ${errors.tender_source ? "error" : inputState.tender_source ? "success" : ""}`}
                    >
                      <option value="">Select Tender Source</option>
                      <option value="internal">Internal</option>
                      <option value="sent">Sent</option>
                      <option value="recieve">Recieved</option>
                    </select>
                    {errors.tender_source && (
                      <span className="error-message">
                        {errors.tender_source}
                      </span>
                    )}
                  </div>
                  {formData.tender_source === "sent" && (
                    <div className="flex-column">
                      <label className="form-labels">
                        Sent to <span className="required">*</span>
                      </label>

                      <input
                        type="text"
                        name="sent"
                        placeholder="Sent to"
                        value={formData.sent}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.sent ? "error" : inputState.sent ? "success" : ""}`}
                      />
                      <br />
                      {errors.sent && (
                        <span className="error-message">{errors.sent}</span>
                      )}
                    </div>
                  )}
                  {formData.tender_source === "recieve" && (
                    <div className="flex-column">
                      <label className="form-labels">
                        Recieved From <span className="required">*</span>
                      </label>

                      <input
                        type="text"
                        name="recieve"
                        placeholder="Recieved From"
                        value={formData.recieve}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.recieve ? "error" : inputState.recieve ? "success" : ""}`}
                      />
                      <br />
                      {errors.recieve && (
                        <span className="error-message">{errors.recieve}</span>
                      )}
                    </div>
                  )}

                  <div className="flex-column">
                    <label className="form-labels">Length </label>
                    <input
                      type="number"
                      name="length"
                      placeholder="Example - 125"
                      value={formData.length}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.length ? "error" : inputState.length ? "success" : ""}`}
                      onWheel={(e) => e.target.blur()}
                      min={0}
                    />
                    {errors.length && (
                      <span className="error-message">{errors.length}</span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">
                      {formData.tender_type === "DPR"
                        ? "Construction Duration"
                        : "Project Duration"}{" "}
                    </label>
                    <input
                      type="number"
                      name="duration.construction"
                      placeholder="Example - 24 months"
                      value={formData.duration.construction}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors["duration.construction"] ? "error" : inputState.duration ? "success" : ""}`}
                    />
                    {errors["duration.construction"] && (
                      <span className="error-message">
                        {errors["duration.construction"]}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">DLP Duration </label>
                    <input
                      type="number"
                      name="duration.dlp"
                      placeholder="Example - 24 months"
                      value={formData.duration.dlp}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors["duration.dlp"] ? "error" : inputState.duration ? "success" : ""}`}
                    />
                    {errors["duration.dlp"] && (
                      <span className="error-message">
                        {errors["duration.dlp"]}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">OnM Duration</label>
                    <input
                      type="number"
                      name="duration.onm"
                      placeholder="Example - 24 months"
                      value={formData.duration.onm}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors["duration.onm"] ? "error" : inputState.duration ? "success" : ""}`}
                    />
                    {errors["duration.onm"] && (
                      <span className="error-message">
                        {errors["duration.onm"]}
                      </span>
                    )}
                  </div>

                  {/* <div className="flex-column">
                                        <label className="form-labels">KM Cost </label>
                                        <input
                                            type="number"
                                            name="km_cost"
                                            placeholder="Example - 150000"
                                            value={formData.km_cost}
                                            onChange={handleInputChange}
                                            className={`form-input input-form ${errors.km_cost ? 'error' : inputState.km_cost ? 'success' : ''}`}
                                        />
                                        {errors.km_cost && <span className="error-message">{errors.km_cost}</span>}
                                    </div> */}

                  <div className="flex-column">
                    <label className="form-labels">Remarks</label>
                    <textarea
                      name="remarks"
                      placeholder="Example - Project site visit completed and documents verified."
                      value={formData.remarks}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.remarks ? "error" : inputState.remarks ? "success" : ""}`}
                    />
                    {errors.remarks && (
                      <span className="error-message">{errors.remarks}</span>
                    )}
                  </div>

                  <div className="dropdown-wrapper flex justify-center ">
                    <label
                      htmlFor="is_emd_required"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Emd Required<span className="required">*</span>
                    </label>
                    <br />

                    <select
                      id="is_emd_required"
                      name="is_emd_required"
                      value={formData.is_emd_required}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          is_emd_required:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null, // handles "Select Team Required"
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Select Emd Required</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>

                  {formData.is_emd_required && (
                    <>
                      <div className="dropdown-wrapper flex justify-center ">
                        <label
                          htmlFor="exmpted_emd"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Exmpted Emd<span className="required">*</span>
                        </label>
                        <br />

                        <select
                          id="exmpted_emd"
                          name="exmpted_emd"
                          value={formData.exmpted_emd}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              exmpted_emd:
                                e.target.value === "true"
                                  ? true
                                  : e.target.value === "false"
                                    ? false
                                    : null, // handles "Select Team Required"
                            }))
                          }
                          className="form-input font-size-subheading"
                        >
                          <option value="">Exmpted Emd</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>{" "}
                      <div className="dropdown-wrapper flex justify-center ">
                        <label
                          htmlFor="emd_amount"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Emd Amount<span className="required">*</span>
                        </label>
                        <br />
                        <input
                          type="text"
                          name="emd_amount"
                          placeholder="Enter full amount (e.g. 1 crore = 10000000)"
                          value={formData.emd_amount}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              emd_amount: e.target.value,
                            }))
                          }
                          className={`form-input font-size-subheading`}
                        />
                      </div>
                      {/* <div className="dropdown-wrapper flex justify-center ">
                                            <label htmlFor="emd_unit" className="form-labels font-weight500 font-size-subheading">
                                                EMD Unit<span className="required">*</span>
                                            </label>
                                            <br />
                                            <select
                                                id="emd_unit"
                                                name="emd_unit"
                                                value={formData.emd_unit}
                                                onChange={(e) => setFormData((prev) => ({ ...prev, emd_unit: e.target.value }))}
                                                className="form-input font-size-subheading"
                                            >
                                                <option value="">Select EMD Unit</option>
                                                <option value="crore">Crore</option>
                                                <option value="lakhs">Lakhs</option>
                                                <option value="thousand">thousand</option>
                                                <option value="hundreds">hundreds</option>
                                            </select>
                                        </div> */}
                      {/* <div className="dropdown-wrapper flex justify-center " >
                                            <label htmlFor="emd_review" className="form-labels  font-weight500    font-size-subheading">
                                                Emd Review<span className="required">*</span>
                                            </label>
                                            <br />


                                            <select
                                                id="emd_review"
                                                name="emd_review"
                                                value={wishListData.emd_review}
                                                onChange={(e) =>
                                                    setWishListData((prev) => ({
                                                        ...prev,
                                                        emd_review:
                                                            e.target.value === "true"
                                                                ? true
                                                                : e.target.value === "false"
                                                                    ? false
                                                                    : null, // handles "Select Team Required"
                                                    }))
                                                }
                                                className="form-input font-size-subheading"
                                            >
                                                <option value="">Select Emd Review</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </select>

                                        </div> */}
                    </>
                  )}
                  {/* If emd_type is null, show only emd_type_multi multiselect. If not null, show both. */}
                  {formData.is_emd_required &&
                    (formData.emd_type === null ||
                      formData.emd_type === "") && (
                      <div
                        className="dropdown-wrapper flex justify-center"
                        style={{ width: "39vw" }}
                      >
                        <label className="form-labels font-weight500 font-size-subheading">
                          Emd Type<span className="required">*</span>
                        </label>
                        <br />

                        <div
                          className="emd-multiselect-wrapper"
                          ref={emdDropdownRef}
                        >
                          {/* Trigger box */}
                          <div
                            className={`emd-trigger ${emdDropdownOpen ? "open" : ""} ${errors.emd_type_multi ? "error-border" : ""}`}
                            onClick={() => setEmdDropdownOpen((v) => !v)}
                          >
                            {(formData.emd_type_multi ?? []).length === 0 ? (
                              <span className="emd-placeholder">
                                Select EMD types…
                              </span>
                            ) : (
                              (formData.emd_type_multi ?? []).map((key) => (
                                <span key={key} className="emd-chip">
                                  {emdLabelFor(key)}
                                  <button
                                    type="button"
                                    className="emd-chip-close"
                                    onClick={(e) => handleEmdRemoveChip(key, e)}
                                  >
                                    ✕
                                  </button>
                                </span>
                              ))
                            )}
                          </div>

                          {/* Dropdown */}
                          {emdDropdownOpen && (
                            <div className="emd-dropdown">
                              <div className="emd-options-list">
                                {emdOptions
                                  .filter((o) => o.key !== "other")
                                  .map((emd) => (
                                    <div
                                      key={emd.key}
                                      className={`emd-option ${(formData.emd_type_multi ?? []).includes(emd.key) ? "selected" : ""}`}
                                      onClick={() =>
                                        handleEmdToggleOption(emd.key)
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        checked={(
                                          formData.emd_type_multi ?? []
                                        ).includes(emd.key)}
                                        onChange={() => { }}
                                      />
                                      <span>{emd.value}</span>
                                    </div>
                                  ))}

                                {/* Other + custom input */}
                                <div
                                  className={`emd-option ${emdShowOtherInput ? "open-other" : ""}`}
                                  onClick={() => handleEmdToggleOption("other")}
                                >
                                  <input
                                    type="checkbox"
                                    checked={emdShowOtherInput}
                                    onChange={() => { }}
                                  />
                                  <span>Other</span>
                                </div>
                                {emdShowOtherInput && (
                                  <div className="emd-custom-input-row">
                                    <input
                                      type="text"
                                      placeholder="Type custom value"
                                      value={emdCustomInput}
                                      onChange={(e) =>
                                        setEmdCustomInput(e.target.value)
                                      }
                                      className="emd-custom-input"
                                    />
                                    <button
                                      type="button"
                                      onClick={handleEmdAddCustom}
                                      className="emd-add-btn"
                                    >
                                      Add
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                        {errors.emd_type_multi && (
                          <span className="error-message">
                            {errors.emd_type_multi}
                          </span>
                        )}
                      </div>
                    )}

                  {/* If emd_type is not null, show both emd_type and emd_type_multi */}
                  {formData.is_emd_required && formData.emd_type && formData.emd_type !== "" && (
                    <>
                      <div className="dropdown-wrapper flex justify-center ">
                        <label
                          htmlFor="emd_type"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Emd Type<span className="required">*</span>
                        </label>
                        <br />
                        <select
                          id="emd_type"
                          name="emd_type"
                          value={formData.emd_type}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              emd_type: e.target.value,
                            }))
                          }
                          className={`form-input font-size-subheading`}
                        // style={{ width: '80% !important' }}
                        >
                          <option value="">EMD Type</option>
                          {EmdType.map((emd) => (
                            <option value={emd.key}>{emd.value}</option>
                          ))}
                        </select>
                        {formData.emd_type === "other" &&
                          formData.emd_type !== "null" && (
                            <input
                              type="text"
                              name="emd_type"
                              placeholder="Enter custom emd type"
                              value={formData.custom_emd_type}
                              onChange={(e) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  custom_emd_type: e.target.value,
                                }))
                              }
                              className="form-input font-size-subheading"
                            />
                          )}
                      </div>

                      {/* Also show emd_type_multi for additional selection */}
                      <div
                        className="dropdown-wrapper flex justify-center"
                        style={{ width: "39vw" }}
                      >
                        <label className="form-labels font-weight500 font-size-subheading">
                          Additional Emd Types (Optional)
                        </label>
                        <br />

                        <div
                          className="emd-multiselect-wrapper"
                          ref={emdDropdownRef}
                        >
                          {/* Trigger box */}
                          <div
                            className={`emd-trigger ${emdDropdownOpen ? "open" : ""}`}
                            onClick={() => setEmdDropdownOpen((v) => !v)}
                          >
                            {(formData.emd_type_multi ?? []).length === 0 ? (
                              <span className="emd-placeholder">
                                Select additional EMD types…
                              </span>
                            ) : (
                              (formData.emd_type_multi ?? []).map((key) => (
                                <span key={key} className="emd-chip">
                                  {emdLabelFor(key)}
                                  <button
                                    type="button"
                                    className="emd-chip-close"
                                    onClick={(e) =>
                                      handleEmdRemoveChip(key, e)
                                    }
                                  >
                                    ✕
                                  </button>
                                </span>
                              ))
                            )}
                          </div>

                          {/* Dropdown */}
                          {emdDropdownOpen && (
                            <div className="emd-dropdown">
                              <div className="emd-options-list">
                                {emdOptions
                                  .filter((o) => o.key !== "other")
                                  .map((emd) => (
                                    <div
                                      key={emd.key}
                                      className={`emd-option ${(
                                        formData.emd_type_multi ?? []
                                      ).includes(emd.key)
                                        ? "selected"
                                        : ""
                                        }`}
                                      onClick={() =>
                                        handleEmdToggleOption(emd.key)
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        checked={(
                                          formData.emd_type_multi ?? []
                                        ).includes(emd.key)}
                                        onChange={() => { }}
                                      />
                                      <span>{emd.value}</span>
                                    </div>
                                  ))}

                                {/* Other + custom input */}
                                <div
                                  className={`emd-option ${emdShowOtherInput ? "open-other" : ""}`}
                                  onClick={() =>
                                    handleEmdToggleOption("other")
                                  }
                                >
                                  <input
                                    type="checkbox"
                                    checked={emdShowOtherInput}
                                    onChange={() => { }}
                                  />
                                  <span>Other</span>
                                </div>
                                {emdShowOtherInput && (
                                  <div className="emd-custom-input-row">
                                    <input
                                      type="text"
                                      placeholder="Type custom value"
                                      value={emdCustomInput}
                                      onChange={(e) =>
                                        setEmdCustomInput(e.target.value)
                                      }
                                      className="emd-custom-input"
                                    />
                                    <button
                                      type="button"
                                      onClick={handleEmdAddCustom}
                                      className="emd-add-btn"
                                    >
                                      Add
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {formData.is_emd_required && (
                    <div className="dropdown-wrapper flex justify-center ">
                      <label
                        htmlFor="emd_submission_type"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Emd Submission Type<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="emd_submission_type"
                        name="emd_submission_type"
                        value={formData.emd_submission_type}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            emd_submission_type: e.target.value,
                          }))
                        }
                        className={`form-input font-size-subheading`}
                      // style={{ width: '80% !important' }}
                      >
                        <option value="">EMD Submission Type</option>
                        <option value="online">Online</option>
                        <option value="physical">Physical</option>
                        <option value="both">Both</option>
                      </select>
                    </div>
                  )}
                  <div className="upload-button-field">
                    <div className="flex-column">
                      <label
                        htmlFor="document"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Upload Document (File name should be max 400 character)
                      </label>
                      <div className="flex-row justify-between">
                        <div>
                          <label htmlFor="document" className="svg-icon">
                            <div className="svg-field form-input align-center">
                              <Attachment />
                            </div>
                          </label>
                          <input
                            type="file"
                            id="document"
                            name="document_file"
                            accept=".zip, .pdf, .xls, .xlsx"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                            ref={fileInputRef}
                          />
                        </div>
                        <div style={{ width: docNames ? "6vw" : "35vw" }}>
                          {docNames ? (
                            <span className="file-name">{docNames}</span>
                          ) : i.document ? (
                            <a href={i.document} target="blank">
                              <div className="flex-row justify-center">
                                <DocumentIcon /> View
                              </div>
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                        {docNames !== "" && (
                          <div
                            className="flex-row justify-between"
                            style={{ width: "12vw" }}
                          >
                            <button
                              type="button"
                              title="Clear File"
                              onClick={handleClear}
                              className="file-clear clear-button"
                            >
                              Clear
                            </button>
                          </div>
                        )}
                      </div>
                      {errors.document && (
                        <span className="error-message font-size-text">
                          {errors.document}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : toggleState === 2 && usedWhere === "upward" ? (
              <>
                <div>
                  <div className="form-flex-wrap">
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="tenderIDD"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Select Tender<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="tenderIDD"
                        name="tenderIDD"
                        value={wishListData.tenderIDD}
                        onChange={handleWishListInputChange}
                        className={`form-input form-group-selection ${errors.tenderIDD
                          ? "error"
                          : wishlistinputState.tenderIDD
                            ? "success"
                            : ""
                          }`}
                      >
                        <option value="">Select Tender</option>
                        {BidData.filter(
                          (item) => item.is_in_bidlist === true,
                        ).map((item) => (
                          <option value={item.id}>{item.tender_name}</option>
                        ))}
                      </select>
                      <div>
                        {errors.tenderIDD && (
                          <span className="error-message font-size-text ">
                            {errors.tenderIDD}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="checkbox-wrapper">
                      <label className="custom-checkbox  font-weight500 font-size-subheading">
                        <input
                          type="checkbox"
                          name="qualified"
                          checked={wishListData.qualified || false}
                          onChange={handleWishListInputChange}
                        />
                        <span className="checkmark"></span>
                        Qualified
                      </label>
                    </div>
                    <div className="checkbox-wrapper">
                      <label className="custom-checkbox  font-weight500 font-size-subheading">
                        <input
                          type="checkbox"
                          name="jv_partner_external"
                          checked={wishListData.jv_partner_external || false}
                          onChange={handleWishListInputChange}
                        />
                        <span className="checkmark"></span>
                        Is External JV Partner
                      </label>
                    </div>
                    <div className="checkbox-wrapper">
                      <label className="custom-checkbox  font-weight500 font-size-subheading">
                        <input
                          type="checkbox"
                          name="technical_marking"
                          checked={wishListData.technical_marking || false}
                          onChange={handleWishListInputChange}
                        />
                        <span className="checkmark"></span>
                        Technical Marking
                      </label>
                    </div>
                    <div className="checkbox-wrapper">
                      <label className="custom-checkbox  font-weight500 font-size-subheading">
                        <input
                          type="checkbox"
                          name="associate_allowed"
                          checked={wishListData.associate_allowed || false}
                          onChange={handleWishListInputChange}
                        />
                        <span className="checkmark"></span>
                        Associate Allowed
                      </label>
                    </div>
                  </div>
                  <div className="form-flex-wrap">
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="jv_partner_qualification_criteria"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        JV Partner Qualification Criteria
                        <span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="jv_partner_qualification_criteria"
                        name="jv_partner_qualification_criteria"
                        value={wishListData.jv_partner_qualification_criteria}
                        onChange={handleWishListInputChange}
                        className={`form-input form-input-time form-group-selection ${errors.jv_partner_qualification_criteria
                          ? "error"
                          : wishlistinputState.jv_partner_qualification_criteria
                            ? "success"
                            : ""
                          }`}
                      >
                        <option value="null">
                          Select Qualification Criteria{" "}
                        </option>
                        <option value="As_Whole">As Per Whole</option>
                        <option value="As_per_technicalshare">
                          As Per Technical Share
                        </option>
                        <option value="As_per_technicalshare_financeshare">
                          Techincal and Finance Share
                        </option>
                      </select>

                      <div>
                        {errors.jv_partner_qualification_criteria && (
                          <span className="error-message font-size-text ">
                            {errors.jv_partner_qualification_criteria}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="jv_partner_type"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        JV Partner<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="jv_partner_type"
                        name="jv_partner_type"
                        value={wishListData.jv_partner_type}
                        onChange={handleWishListInputChange}
                        className={`form-input form-input-time form-group-selection ${errors.jv_partner_type
                          ? "error"
                          : wishlistinputState.jv_partner_type
                            ? "success"
                            : ""
                          }`}
                      >
                        <option value="null">Select JV Partner </option>
                        <option value="sapl">SAPL</option>
                        <option value="cipl">CIPL</option>
                        <option value="joint">Joint</option>
                      </select>

                      <div>
                        {errors.jv_partner_type && (
                          <span className="error-message font-size-text ">
                            {errors.jv_partner_type}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : toggleState === 9 && usedWhere === "upward" ? (
              <>
                <div className="form-flex-wrap">
                  <div className="form-flex-wrap">
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="tenderIDD"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Select Tender<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="tenderIDD"
                        name="tenderIDD"
                        value={finalData.tenderIDD}
                        onChange={handlefinalInputChange}
                        className={`form-input form-group-selection ${errors.tenderIDD
                          ? "error"
                          : finalinputState.tenderIDD
                            ? "success"
                            : ""
                          }`}
                      >
                        <option value="">Select Tender</option>
                        {BidData.filter(
                          (item) => item.is_finalize === true,
                        ).map((item) => (
                          <option value={item.id}>{item.tender_name}</option>
                        ))}
                      </select>
                      <div>
                        {errors.tenderIDD && (
                          <span className="error-message font-size-text ">
                            {errors.tenderIDD}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="flex-column">
                      <label
                        htmlFor="lead_partner"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Lead Partner Name
                      </label>
                      <input
                        maxLength={50}
                        type="text"
                        id="lead_partner"
                        name="lead_partner"
                        placeholder="Lead Partner Name"
                        onChange={handlefinalInputChange}
                        value={finalData.lead_partner}
                        className={`form-input ${errors.lead_partner
                          ? "error"
                          : finalinputState.lead_partner
                            ? "success"
                            : ""
                          }`}
                      />
                      {errors.lead_partner && (
                        <span className="error-message font-size-text ">
                          {errors.lead_partner}
                        </span>
                      )}
                    </div>
                    <div className="flex-column">
                      <label
                        htmlFor="final_jv_name"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        JV Partner Name
                      </label>
                      <input
                        maxLength={50}
                        type="text"
                        id="final_jv_name"
                        name="final_jv_name"
                        placeholder="JV Partner Name"
                        onChange={handlefinalInputChange}
                        value={finalData.final_jv_name}
                        className={`form-input ${errors.final_jv_name
                          ? "error"
                          : finalinputState.final_jv_name
                            ? "success"
                            : ""
                          }`}
                      />
                      {errors.final_jv_name && (
                        <span className="error-message font-size-text ">
                          {errors.final_jv_name}
                        </span>
                      )}
                    </div>
                    {tenderData.associate_allowed && (
                      <div className="flex-column">
                        <label
                          htmlFor="assosiate_partner"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Associate Partner Name
                        </label>
                        <input
                          maxLength={50}
                          type="text"
                          id="assosiate_partner"
                          name="assosiate_partner"
                          placeholder="Associate Partner Name"
                          onChange={handlefinalInputChange}
                          value={finalData.assosiate_partner}
                          className={`form-input ${errors.assosiate_partner
                            ? "error"
                            : finalinputState.assosiate_partner
                              ? "success"
                              : ""
                            }`}
                        />
                        {errors.assosiate_partner && (
                          <span className="error-message font-size-text ">
                            {errors.assosiate_partner}
                          </span>
                        )}
                      </div>
                    )}
                    {tenderData.jv_partner_external && (
                      <div className="flex-column">
                        <label
                          htmlFor="external_jv"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          External JV Partner Name
                        </label>
                        <input
                          maxLength={50}
                          type="text"
                          id="external_jv"
                          name="external_jv"
                          placeholder="External JV Partner Name"
                          onChange={handlefinalInputChange}
                          value={finalData.external_jv}
                          className={`form-input ${errors.external_jv
                            ? "error"
                            : finalinputState.external_jv
                              ? "success"
                              : ""
                            }`}
                        />
                        {errors.external_jv && (
                          <span className="error-message font-size-text ">
                            {errors.external_jv}
                          </span>
                        )}
                      </div>
                    )}

                    <div className="flex-column">
                      <label
                        htmlFor="emd_amount"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        EMD Amount
                      </label>
                      <input
                        maxLength={50}
                        type="number"
                        id="emd_amount"
                        name="emd_amount"
                        placeholder="Enter full amount (e.g. 1 crore = 10000000)"
                        onChange={handlefinalInputChange}
                        value={finalData.emd_amount}
                        className={`form-input ${errors.emd_amount
                          ? "error"
                          : finalinputState.emd_amount
                            ? "success"
                            : ""
                          }`}
                      />
                      {errors.emd_amount && (
                        <span className="error-message font-size-text ">
                          {errors.emd_amount}
                        </span>
                      )}
                    </div>

                    {/* <div className="dropdown-wrapper flex justify-center ">
                                                    <label htmlFor="emd_unit" className="form-labels font-weight500 font-size-subheading">
                                                        EMD Unit<span className="required">*</span>
                                                    </label>
                                                    <br />
                                                    <select
                                                        id="emd_unit"
                                                        name="emd_unit"
                                                        value={finalData.emd_unit}
                                                        onChange={handlefinalInputChange}
                                                        className="form-input font-size-subheading"
                                                    >
                                                        <option value="">Select EMD Unit</option>
                                                        <option value="crore">Crore</option>
                                                        <option value="lakhs">Lakhs</option>
                                                        <option value="thousand">thousand</option>
                                                        <option value="hundreds">hundreds</option>
                                                    </select>
                                                </div> */}

                    <div className="flex-column">
                      <label
                        htmlFor="team_requirements_details"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Team Requirements Details
                      </label>
                      <input
                        maxLength={50}
                        type="number"
                        id="team_requirements_details"
                        name="team_requirements_details"
                        placeholder="Team Requirements Details"
                        onChange={handlefinalInputChange}
                        value={finalData.team_requirements_details}
                        className={`form-input ${errors.team_requirements_details
                          ? "error"
                          : finalinputState.team_requirements_details
                            ? "success"
                            : ""
                          }`}
                      />
                      {errors.team_requirements_details && (
                        <span className="error-message font-size-text ">
                          {errors.team_requirements_details}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex-column">
                    <label
                      htmlFor="recipient_details"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Recipient Details
                    </label>
                    <input
                      maxLength={50}
                      type="text"
                      id="recipient_details"
                      name="recipient_details"
                      placeholder="Recipient Details"
                      onChange={handlefinalInputChange}
                      value={finalData.recipient_details}
                      className={`form-input ${errors.recipient_details
                        ? "error"
                        : finalinputState.recipient_details
                          ? "success"
                          : ""
                        }`}
                    />
                    {errors.recipient_details && (
                      <span className="error-message font-size-text ">
                        {errors.recipient_details}
                      </span>
                    )}
                  </div>
                  <div className="form-flex-wrap " style={{ width: "100%" }}>
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="emd_submission_type"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        EMD Submisssion Type<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="emd_submission_type"
                        name="emd_submission_type"
                        value={finalData.emd_submission_type}
                        onChange={handlefinalInputChange}
                        className={`form-input form-input-time form-group-selection ${errors.emd_submission_type
                          ? "error"
                          : finalinputState.emd_submission_type
                            ? "success"
                            : ""
                          }`}
                      >
                        <option value="null">EMD Submisssion Type</option>
                        <option value="Online">Online</option>
                        <option value="HardCopy">HardCopy</option>
                        <option value="Both">Both</option>
                      </select>

                      <div>
                        {errors.emd_submission_type && (
                          <span className="error-message font-size-text ">
                            {errors.emd_submission_type}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="tendersubmission"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Tender Submission Type
                        <span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="tendersubmission"
                        name="tendersubmission"
                        value={finalData.tendersubmission}
                        onChange={handlefinalInputChange}
                        className={`form-input form-input-time form-group-selection ${errors.tendersubmission
                          ? "error"
                          : finalinputState.tendersubmission
                            ? "success"
                            : ""
                          }`}
                      >
                        <option value="null">Tender Submission Type</option>
                        <option value="Online">Online</option>
                        <option value="HardCopy">HardCopy</option>
                        <option value="Both">Both</option>
                      </select>

                      <div>
                        {errors.tendersubmission && (
                          <span className="error-message font-size-text ">
                            {errors.tendersubmission}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            <div className="button-models">
              <button
                type="submit"
                onClick={handleSubmit}
                className="model-button model-button-submit"
              >
                {toggleState === 1 ? "Update" : "Submit"}
              </button>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted &&
                Object.keys(errors).length > 0 &&
                (Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">
                    Please fill all mandatory fields!
                  </h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors)
                      .map((field) =>
                        field
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (char) => char.toUpperCase()),
                      )
                      .join(", ") + " are required!"}
                  </h6>
                ))}
            </p>
          </form>
        </Modal.Body>
        {/* <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}
      </Modal>
    </>
  );
};
const Addtocart = ({
  i,
  getBid,
  toggleState,
  filters,
  setToggleState,
  getDaysLeftNumber,
  bgData,
}) => {
  const [show, setShow] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [toggleEmployeeCode, settoggleEmployeeCode] = useState([]);
  const [docTeamLead, setDocTeamLead] = useState(null);
  const [docTeamMembers, setDocTeamMembers] = useState([]);
  const [resultChoice, setResultChoice] = useState("tech");


  const defaultCvTLs = ["BD37", "BD05", "BD42"];
  const [cvTeamLead, setCvTeamLead] = useState(defaultCvTLs);
  // const [cvTeamMembers, setCvTeamMembers] = useState(defaultCvTLs);
  const [financeTeamLead, setFinanceTeamLead] = useState("BD52");
  const [financeTeamMembers, setFinanceTeamMembers] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [cvTeammainLead, setCvTeammainLead] = useState([]);

  // ✅ NEW: tender-discussed confirmation + qualification status (toggleState === 1, i.e. move from Tab 1 -> Tab 2 / WishList)
  const [tenderDiscussed, setTenderDiscussed] = useState(false);
  const [qualificationStatus, setQualificationStatus] = useState(""); // "qualified" | "do_not_qualified"
  const [ifQualified, setIfQualified] = useState("");                 // solo_only | jv_only | lead_only | associate_only | sent_to_partner
  const [qualificationRemark, setQualificationRemark] = useState("");

  const handleClose = () => { setShow(false); setResultChoice("tech"); };
  const handleShow = () => setShow(true);

  // -------------------------
  // VALIDATE USING UPDATED DATA ONLY
  // -------------------------
  const validateUpdatedData = (data) => {
    const newErrors = {};
    let requiredFields = [];

    // 🟦 WISH LIST (toggleState = 1) — tender-discussed + qualification check
    if (toggleState === 1) {
      requiredFields = [
        "is_discussed",
        "qualification_status",
        data.qualification_status === "qualified" ? "if_qualified" : null,
      ].filter(Boolean);
    }

    else if (toggleState === 2) {
      requiredFields = [
        data.is_jv_allowed == null ? "is_jv_allowed" : null,
        "tech_score",
        "company_score",
        "company_name",
        "eligibity_criteria",
        data.eligibity_criteria === "Special"
          ? "eligibity_criteria_special"
          : null,
        data.soil_quality == null ? "soil_quality" : null,
        data.participating_as == null ? "participating_as" : null,
        data.is_jv_consorium_association_allowed == null
          ? "jv_consorium_association_allowed"
          : null,
        data.site_apprisate_required == null ? "site_apprisate_required" : null,
        data.site_apprisate_required != null ? "site_apprisate_marking" : null,
        data.work_methodology_required == null
          ? "work_methodology_required"
          : null,
        data.work_methodology_required != null && data?.work_methodology_marking
          ? "work_methodology_marking"
          : null,
        data.presentation_required == null ? "presentation_required" : null,
        data.presentation_required ? "presentation_required_marking" : null,
        data.presentation_required ? "presentation_type" : null,
      ].filter(Boolean);
    }

    // 🟦 FINAL TENDER (toggleState = 3)
    else if (toggleState === 3) {
      requiredFields = [
        data.tender_submission_type == null ? "tender_submission_type" : null,
        data.bid_prepare_by == null ? "bid_prepare_by" : null,
        data.bg_prepare_by == null ? "bg_prepare_by" : null,
        "lead_partner_share",
        data.jv_partner_name !== "Not Required" ? "jv_partner_share" : null,
        data.assosiate_partner !== "Not Required"
          ? "associate_partner_share"
          : null,
        // data.is_emd_required == null ? "is_emd_required" : null,
        // data.is_emd_required ? "emd_amount" : null,
        // data.is_emd_required ? "emd_unit" : null,
        // data.is_emd_required ? "emd_review" : null,
        // data.is_emd_required && (data?.exmpted_emd != "" || data?.exmpted_emd != null) ? "exmpted_emd" : null,
        // data.is_emd_required ? "emd_type" : null,
        // data.is_emd_required ? "emd_submission_type" : null,
      ].filter(Boolean);
    }

    // 🟦 SUBMITTED (toggleState = 9)
    else if (toggleState === 9) {
      requiredFields = [
        data.checklist == null ? "checklist" : null,
        // data.team_required == null ? "team_required" : null,
        // data.team_required ? "team_prepare_by" : null,
        // data.team_required ? "team_prepare_by_remarks" : null,
        // data.team_required ? "team_requirements_details" : null,

        data.all_docs_done == null ? "all_docs_done" : null,
      ].filter(Boolean);
    }

    // 🟦 BID PREPARE IN PROGRESS (toggleState = 4)
    else if (toggleState === 4) {
      requiredFields = [
        // data.assigned_to?.length === 0 ? "assigned_to" : null,
      ].filter(Boolean);
    }

    // -------------------------
    // GENERAL VALIDATION
    // -------------------------
    const missingFieldsList = [];

    requiredFields.forEach((field) => {
      if (!data[field]) {
        newErrors[field] = `${field} is required`;
        missingFieldsList.push(field.replace(/_/g, " ").toUpperCase());
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);

    // ⛔ SHOW ONE TOAST FOR ALL MISSING FIELDS
    if (missingFieldsList.length > 0) {
      toast.error(`These fields are missing: ${missingFieldsList.join(", ")}`);
      return false;
    }

    return true;
  };

  const normalizeArray = (arr) => {
    if (!Array.isArray(arr)) return [];

    return Array.from(
      new Set(
        arr
          .flatMap((item) => {
            try {
              const parsed = JSON.parse(item);
              return Array.isArray(parsed) ? parsed : [parsed];
            } catch {
              return [item];
            }
          })
          .map((x) => x.toUpperCase()),
      ),
    );
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Processing...");

    const updatedData = { ...i, document: null };




    if (toggleState === 1) {
      updatedData.is_in_bidlist = true;
      updatedData.date_aa = new Date().toISOString();

      updatedData.is_discussed = tenderDiscussed;
      updatedData.is_discussed_by = sessionStorage.getItem("sitemanagement_emp_code");
      updatedData.qualification_status = qualificationStatus;
      updatedData.if_qualified = qualificationStatus === "qualified" ? ifQualified : null;
      updatedData.qualification_remarks = qualificationRemark;
    }

    if (toggleState === 2) {
      updatedData.is_in_targetlist = true;
      updatedData.date_bb = new Date().toISOString();
    }

    if (toggleState === 3) {
      updatedData.is_finalize = true;
      updatedData.date_cc = new Date().toISOString();
      updatedData.tat_duration = getDaysLeftNumber(
        i.corrigendum_date ? i.corrigendum_date : i.submission_date,
      );
    }

    if (toggleState === 9) {
      updatedData.is_submitted = true;
      updatedData.date_ee = new Date().toISOString();
    }

    // =====================================================
    // Bid Prepare In Progress
    // =====================================================
    if (toggleState === 4) {
      updatedData.is_bid_prepare_in_progress = true;
      updatedData.date_ff = new Date().toISOString();

      const emp = sessionStorage.getItem("sitemanagement_emp_code");

      // ✅ MEMBERS (assigned_to)
      const allMembers = [...docTeamMembers, ...financeTeamMembers];
      const existingAssignedTo = Array.isArray(i.assigned_to) ? i.assigned_to : [];
      updatedData.assigned_to = normalizeArray([...existingAssignedTo, ...allMembers]);

      // ✅ TLs — doc + cv + finance
      const tls = [
        docTeamLead,
        financeTeamLead,
        ...cvTeamLead,
      ].filter(Boolean);
      const existingTls = Array.isArray(i.assigned_tls) ? i.assigned_tls : [];
      updatedData.assigned_tls = normalizeArray([...existingTls, ...tls]);

      const existingmaincvteamlead = Array.isArray(i.cvTeammainLead) ? i.cvTeammainLead : [];
      updatedData.main_tl = cvTeammainLead;
      // ✅ assigned_at
      const assignedAt = {};
      allMembers.forEach((code) => { assignedAt[code] = new Date().toISOString(); });
      updatedData.assigned_at = assignedAt;

      const existingAssignedBy = Array.isArray(i.assigned_by) ? i.assigned_by : [];
      updatedData.assigned_by = normalizeArray([...existingAssignedBy, emp]);
    }
    if (toggleState === 5) {
      updatedData.is_in_tech_tab = true;
      updatedData.date_ff = new Date().toISOString();
      updatedData.tech_open = true;

      if (resultChoice === "financial") {
        // carry the same fields previously sent for the separate Tech Open (11) -> Financial Open (12) move
        updatedData.is_in_financial_tab = true;
        updatedData.date_gg = new Date().toISOString();
      }
    }

    // =============================
    // FINANCIAL OPEN
    // =============================
    if (toggleState === 11) {
      updatedData.is_in_financial_tab = true;
      updatedData.date_gg = new Date().toISOString();
    }

    // =====================================================
    // Validate
    // =====================================================
    if (!validateUpdatedData(updatedData)) {
      toast.dismiss(loadingToastId);
      return;
    }

    // =====================================================
    // Build FormData safely
    // =====================================================
    const formData = new FormData();
    Object.entries(updatedData).forEach(([key, value]) => {
      if (value == null) return;
      if (Array.isArray(value) || typeof value === "object") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });

    try {
      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (res.status === 200) {
        toast.success(
          toggleState === 1
            ? "Added to WishList"
            : toggleState === 2
              ? "Added to Target List"
              : toggleState === 3
                ? "Marked as Final"
                : toggleState === 9
                  ? "Marked as Submitted"
                  : toggleState === 5
                    ? "Marked as Tech Open"
                    : toggleState === 11
                      ? "Marked as Financial Open"
                      : "Moved to Bid Prepare In Progress",
        );
        const getJsonData = (data) => {
          if (data instanceof FormData) {
            return Object.fromEntries(data.entries());
          }
          return data; // already JSON
        };

        await saveAudit({
          tenderId: i?.id,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "Tenderforbd",
          oldData: getJsonData(i),
          newData: getJsonData(updatedData),
          action: "UPDATE",
          tab_id: toggleState,
        });
        if (toggleState === 9) {

          const matchedBg = bgData?.find((bg) => bg.tender_id === i.tender_id);

          if (matchedBg && matchedBg.is_in_created === true) {
            await axios.put(
              `${BASE_URL}/siteproject/bgdetailsforbdput/${matchedBg.id}/`,
              { is_submitted: true },
              { headers: { "Content-Type": "application/json" } },
            );
          }
        }
        if (toggleState === 5) {
          const matchedBg = bgData?.find((bg) => bg.tender_id === i.tender_id);
          if (matchedBg) {
            await axios.put(
              `${BASE_URL}/siteproject/bgdetailsforbdput/${matchedBg.id}/`,
              {
                is_matured: true,
                tech_open: updatedData.tech_open,
                date_ff: updatedData.date_ff,
              },
              { headers: { "Content-Type": "application/json" } },
            );
          }
        }

        await getBid(filters);
        setShow(false);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  // -------------------------
  // LOAD EMPLOYEES (FOR TOGGLE 4)
  // -------------------------
  const getEmployeeData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/employeebyfilterss/null/null/null/134b633a-89b3-4173-a51e-d030c5b562f5/null/null/d11b2d36-9a36-47df-98c4-4e23923c0abb/`,
      );
      setEmployeeList(response.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    if (show && toggleState === 4) getEmployeeData();
  }, [show, toggleState]);


  const financeOptions = employeeList
    .filter((emp) => emp.emp_role === "BdDashbaordAccount")
    .map((emp) => ({ value: emp.emp_code, label: `${emp.emp_code} - ${emp.name}` }));

  const financeLeadValue = financeTeamLead
    ? {
      value: financeTeamLead,
      label: employeeList.find((e) => e.emp_code === financeTeamLead)
        ? `${financeTeamLead} - ${employeeList.find((e) => e.emp_code === financeTeamLead)?.name}`
        : financeTeamLead,
    }
    : null;

  return (
    <>
      <button
        title="Move To Next"
        onClick={handleShow}
        className="bg-exp-btn"
      >
        Next →
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {toggleState === 5
              ? "Move to Tender Result"
              : toggleState === 11
                ? "Financial Open Confirmation"
                : toggleState === 1
                  ? "Move Tender To Wish List"
                  : toggleState === 2
                    ? "Move Tender To Target List"
                    : toggleState === 3
                      ? "Move Tender To Final List"
                      : toggleState === 9
                        ? "Move Tender To Submitted List"
                        : toggleState === 4
                          ? "Move Tender To Bid Prepare In Progress"
                          : "Move Tender"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="parent-div">
            {toggleState === 5 ? (
              <div className="flex-column form-group-selectt" style={{ display: "block" }}>
                <p style={{ marginBottom: "0.75rem" }}>
                  Move tender (<b>{i.tender_name}</b>) to Tender Result. Is this tender <b>Tech Open</b> or <b>Financial Open</b>?
                </p>
                <label className="form-labels font-weight500 font-size-subheading" style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                  <input type="radio" name="resultChoice" value="tech" checked={resultChoice === "tech"} onChange={() => setResultChoice("tech")} />
                  Tech Open
                </label>
                <label className="form-labels font-weight500 font-size-subheading" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <input type="radio" name="resultChoice" value="financial" checked={resultChoice === "financial"} onChange={() => setResultChoice("financial")} />
                  Financial Open
                </label>
              </div>
            ) : toggleState === 11 ? (
              <>Are you sure this tender is <b>Financial Open</b>?<br />Tender: ({i.tender_name})</>
            ) : (
              <>Are you sure you want to move this tender ({i.tender_name})?</>
            )}

            {/* ✅ NEW: Tender-discussed confirmation + qualification status (toggleState === 1) */}
            {toggleState === 1 && (
              <div
                className="flex-column form-group-selectt"
                style={{ display: "block", marginTop: "1rem" }}
              >
                <div
                  style={{
                    background: "#fff3cd",
                    border: "1px solid #ffe69c",
                    color: "#664d03",
                    borderRadius: "6px",
                    padding: "10px 14px",
                    marginBottom: "1rem",
                    fontSize: "14px",
                  }}
                >
                  ⚠️ Please confirm this tender has been discussed internally before moving it forward.
                </div>
                <label
                  className="form-labels font-weight500 font-size-subheading"
                  style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
                >
                  <input
                    type="checkbox"
                    checked={tenderDiscussed}
                    onChange={(e) => setTenderDiscussed(e.target.checked)}
                  />
                  This tender has been discussed <span className="required">*</span>
                </label>

                <label
                  className="form-labels font-weight500 font-size-subheading"
                  style={{ marginTop: "0.75rem", display: "block" }}
                >
                  Qualification Status <span className="required">*</span>
                </label>
                <select
                  className="form-controls"
                  value={qualificationStatus}
                  onChange={(e) => {
                    setQualificationStatus(e.target.value);
                    if (e.target.value !== "qualified") setIfQualified("");
                  }}
                >
                  <option value="">Select Qualification Status</option>
                  <option value="qualified">Qualified</option>
                  <option value="do_not_qualified">Do Not Qualified</option>
                </select>

                {qualificationStatus === "qualified" && (
                  <>
                    <label
                      className="form-labels font-weight500 font-size-subheading"
                      style={{ marginTop: "0.75rem", display: "block" }}
                    >
                      If Qualified <span className="required">*</span>
                    </label>
                    <select
                      className="form-controls"
                      value={ifQualified}
                      onChange={(e) => setIfQualified(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="solo_only">Solo Only</option>
                      <option value="jv_only">JV Only</option>
                      <option value="lead_only">Lead Only</option>
                      <option value="associate_only">Associate Only</option>
                      <option value="sent_to_partner">Sent To Partner</option>
                    </select>
                  </>
                )}

                <label
                  className="form-labels font-weight500 font-size-subheading"
                  style={{ marginTop: "0.75rem", display: "block" }}
                >
                  Remarks
                </label>
                <textarea
                  className="form-controls"
                  rows={3}
                  placeholder="Enter remarks"
                  value={qualificationRemark}
                  onChange={(e) => setQualificationRemark(e.target.value)}
                />
              </div>
            )}

            {/* MULTI-EMPLOYEE SELECT FOR TOGGLE 4 */}
            {toggleState === 4 && (
              <div
                className="flex-column form-group-selectt"
                style={{ display: "block" }}
              >
                <label className="form-labels font-weight500 font-size-subheading">
                  Assign Team Fo Tender  <span className="required">*</span>
                </label>
                <br />



                {/* ================= DOCUMENT TEAM ================= */}
                <label>Document Team - TL</label>
                <Select
                  options={employeeList
                    .filter(
                      (emp) =>
                        emp.emp_role ===
                        "CertificationAccessDocumentTeamHead"
                    )
                    .map((emp) => ({
                      value: emp.emp_code,
                      label: `${emp.emp_code} - ${emp.name}`,
                    }))}
                  onChange={(val) =>
                    setDocTeamLead(val?.value || null)
                  }
                />

                <label>Document Team Members</label>
                <Select
                  isMulti
                  options={employeeList
                    .filter(
                      (emp) =>
                        emp.emp_role ===
                        "CertificationAccessDocumentTeam"
                    )
                    .map((emp) => ({
                      value: emp.emp_code,
                      label: `${emp.emp_code} - ${emp.name}`,
                    }))}
                  onChange={(val) =>
                    setDocTeamMembers(
                      val ? val.map((x) => x.value) : []
                    )
                  }
                />
                <div style={{ display: 'none' }}>
                  {/* ================= CV TEAM ================= */}
                  <label >CV Team - TL</label>

                  <Select
                    isMulti
                    style={{ display: 'none' }}
                    options={employeeList
                      .filter(
                        (emp) =>
                          emp.emp_role === "CertificationAccessCvTeamHead"
                      )
                      .map((emp) => ({
                        value: emp.emp_code.toUpperCase(),
                        label: `${emp.emp_code} - ${emp.name}`,
                      }))}

                    value={cvTeamLead.map((code) => {
                      const emp = employeeList.find(
                        (e) => e.emp_code.toUpperCase() === code.toUpperCase()
                      );

                      return {
                        value: code.toUpperCase(),
                        label: emp
                          ? `${emp.emp_code} - ${emp.name}`
                          : code,
                      };
                    })}

                    onChange={(val) =>
                      setCvTeamLead(
                        val ? val.map((x) => x.value.toUpperCase()) : []
                      )
                    }

                  />
                </div>

                {/* ================= CV TEAM ================= */}
                <label >CV Team Responsible Person</label>

                <Select
                  isMulti

                  options={employeeList
                    .filter(
                      (emp) =>
                        emp.emp_role === "CertificationAccessCvTeamHead"
                    )
                    .map((emp) => ({
                      value: emp.emp_code.toUpperCase(),
                      label: `${emp.emp_code} - ${emp.name}`,
                    }))}

                  value={cvTeammainLead.map((code) => {
                    const emp = employeeList.find(
                      (e) => e.emp_code.toUpperCase() === code.toUpperCase()
                    );

                    return {
                      value: code.toUpperCase(),
                      label: emp
                        ? `${emp.emp_code} - ${emp.name}`
                        : code,
                    };
                  })}

                  onChange={(val) =>
                    setCvTeammainLead(
                      val ? val.map((x) => x.value.toUpperCase()) : []
                    )
                  }

                />

                {/* <label>CV Team Members</label>
                <Select
                  isMulti
                  options={employeeList
                    .filter(
                      (emp) =>
                        emp.emp_role === "CertificationAccessCvTeam"
                    )
                    .map((emp) => ({
                      value: emp.emp_code,
                      label: `${emp.emp_code} - ${emp.name}`,
                    }))}
                  onChange={(val) =>
                    setCvTeamMembers(
                      val ? val.map((x) => x.value) : []
                    )
                  }
                /> */}

                <label style={{ marginTop: "0.75rem" }}>Finance Team - TL</label>
                <Select
                  options={financeOptions}
                  value={financeLeadValue}
                  onChange={(val) => setFinanceTeamLead(val?.value || null)}
                  placeholder="Select Finance TL"
                  isSearchable
                  isClearable
                />


              </div>
            )}
            <div className="button-models">
              <button
                className="model-button model-button-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmit}
                className="model-button model-button-delete"
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal.Body>

        {/* <ToastContainer position="top-center" autoClose={1000} /> */}
      </Modal>
    </>
  );
};

const AssignTeamOnly = ({ i, getBid, filters, toggleState }) => {
  const [show, setShow] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [docTeamLead, setDocTeamLead] = useState(null);
  const [docTeamMembers, setDocTeamMembers] = useState([]);
  const defaultCvTLs = ["BD37", "BD05", "BD42"];

  const [cvTeamLead, setCvTeamLead] = useState(defaultCvTLs);
  const [cvTeamMembers, setCvTeamMembers] = useState([]);
  const [financeTeamLead, setFinanceTeamLead] = useState(null);
  const [financeTeamMembers, setFinanceTeamMembers] = useState([]);

  const handleClose = () => {
    setShow(false);
    // Reset selections on close
    setDocTeamLead(null);
    setDocTeamMembers([]);
    setCvTeamLead(defaultCvTLs);
    setCvTeamMembers([]);
    setFinanceTeamLead(null);
    setFinanceTeamMembers([]);
  };
  const handleShow = () => setShow(true);

  const normalizeArray = (arr) => {
    if (!Array.isArray(arr)) return [];

    return Array.from(
      new Set(
        arr
          .flatMap((item) => {
            try {
              const parsed = JSON.parse(item);
              return Array.isArray(parsed) ? parsed : [parsed];
            } catch {
              return [item];
            }
          })
          .map((x) => x.toUpperCase()),
      ),
    );
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Assigning team...");

    try {
      const emp = sessionStorage.getItem("sitemanagement_emp_code");

      const allMembers = [...docTeamMembers, ...cvTeamMembers, ...financeTeamMembers];
      const existingAssignedTo = Array.isArray(i.assigned_to) ? i.assigned_to : [];
      const finalAssignedTo = normalizeArray([...existingAssignedTo, ...allMembers]);

      // ✅ TLs — doc + cv + finance
      const tls = [
        docTeamLead,
        financeTeamLead,
        ...cvTeamLead,
      ].filter(Boolean);
      const existingTls = Array.isArray(i.assigned_tls) ? i.assigned_tls : [];
      const finalAssignedTls = normalizeArray([...existingTls, ...tls]);

      // ✅ assigned_at — timestamp per member
      const assignedAt = {};
      allMembers.forEach((code) => { assignedAt[code] = new Date().toISOString(); });

      const existingAssignedBy = Array.isArray(i.assigned_by) ? i.assigned_by : [];
      const finalAssignedBy = normalizeArray([...existingAssignedBy, emp]);

      const updatedData = {
        ...i,
        document: null,
        assigned_to: finalAssignedTo,
        assigned_tls: finalAssignedTls,
        assigned_at: assignedAt,
        assigned_by: finalAssignedBy,
        date_team_assigned: new Date().toISOString(),
      };

      // Build FormData safely
      const formData = new FormData();
      Object.entries(updatedData).forEach(([key, value]) => {
        if (value == null) return;
        if (Array.isArray(value) || typeof value === "object") {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });

      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (res.status === 200) {
        const getJsonData = (data) => {
          if (data instanceof FormData) {
            return Object.fromEntries(data.entries());
          }
          return data;
        };

        await saveAudit({
          tenderId: i?.id,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "Tenderforbd",
          oldData: {},
          newData: getJsonData(formData),
          action: "CREATE",
          tab_id: toggleState,
        });

        await getBid(filters);
        handleClose();
        toast.success("Team Assigned Successfully");
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  // Fetch Employees
  const getEmployeeData = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/employeebyfilterss/null/null/null/134b633a-89b3-4173-a51e-d030c5b562f5/null/null/d11b2d36-9a36-47df-98c4-4e23923c0abb/`,
      );
      setEmployeeList(res.data);
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };

  useEffect(() => {
    if (show) getEmployeeData();
  }, [show]);

  // ─── Pre-populate selects from existing data ──────────────────────────────
  useEffect(() => {
    if (!show || employeeList.length === 0) return;

    // Pre-fill TLs (first match from assigned_tls)
    const existingTls = normalizeArray(
      Array.isArray(i.assigned_tls) ? i.assigned_tls : [],
    );

    const docTlMatch = existingTls.find((code) =>
      employeeList.some(
        (e) =>
          e.emp_code === code &&
          e.emp_role === "CertificationAccessDocumentTeamHead",
      ),
    );
    // const cvTlMatch = existingTls.find((code) =>
    //   employeeList.some(
    //     (e) =>
    //       e.emp_code === code &&
    //       e.emp_role === "CertificationAccessCvTeamHead",
    //   ),
    // );

    if (docTlMatch) setDocTeamLead(docTlMatch);
    // if (cvTlMatch) setCvTeamLead(cvTlMatch);

    // Pre-fill members from assigned_to
    const existingMembers = normalizeArray(
      Array.isArray(i.assigned_to) ? i.assigned_to : [],
    );

    const docMembers = existingMembers.filter((code) =>
      employeeList.some(
        (e) =>
          e.emp_code === code &&
          e.emp_role === "CertificationAccessDocumentTeam",
      ),
    );
    const cvMembers = existingMembers.filter((code) =>
      employeeList.some(
        (e) =>
          e.emp_code === code && e.emp_role === "CertificationAccessCvTeam",
      ),
    );
    const finTlMatch = existingTls.find((code) =>
      employeeList.some((e) => e.emp_code === code && e.emp_role === "BdDashbaordAccount"),
    );
    setFinanceTeamLead(finTlMatch ?? "BD52");

    // ✅ Pre-populate finance members
    const finMembers = existingMembers.filter((code) =>
      employeeList.some((e) => e.emp_code === code && e.emp_role === "BdDashbaordAccount"),
    );
    setFinanceTeamMembers(finMembers);
  }, [show, employeeList]);
  const financeOptions = employeeList
    .filter((emp) => emp.emp_role === "BdDashbaordAccount")
    .map((emp) => ({ value: emp.emp_code, label: `${emp.emp_code} - ${emp.name}` }));

  const financeLeadValue = financeTeamLead
    ? {
      value: financeTeamLead,
      label: employeeList.find((e) => e.emp_code === financeTeamLead)
        ? `${financeTeamLead} - ${employeeList.find((e) => e.emp_code === financeTeamLead)?.name}`
        : financeTeamLead,
    }
    : null;


  return (
    <>
      <button
        title="Assign Team"
        onClick={handleShow}
        style={{
          cursor: "pointer",
          padding: "0px 10px",
          backgroundColor: "#2576bc",
          color: "white",
          borderRadius: "6px",
          fontSize: "11px",
          height: "28px",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="white"
        >
          <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V20h14v-3.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V20h6v-3.5c0-2.33-4.67-3.5-7-3.5z" />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Assign Tender to Team</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="parent-div">
            Assign team for tender: <b>{i.tender_name}</b>

            <div
              className="flex-column form-group-selectt"
              style={{ display: "block", marginTop: "1rem" }}
            >
              <label className="form-labels font-weight500 font-size-subheading">
                Assign Team For Tender <span className="required">*</span>
              </label>
              <br />

              {/* ── Document Team TL ── */}
              <label>Document Team - TL</label>
              <Select
                options={employeeList
                  .filter(
                    (emp) =>
                      emp.emp_role === "CertificationAccessDocumentTeamHead",
                  )
                  .map((emp) => ({
                    value: emp.emp_code,
                    label: `${emp.emp_code} - ${emp.name}`,
                  }))}
                value={
                  docTeamLead
                    ? {
                      value: docTeamLead,
                      label:
                        employeeList.find((e) => e.emp_code === docTeamLead)
                          ? `${docTeamLead} - ${employeeList.find((e) => e.emp_code === docTeamLead)?.name}`
                          : docTeamLead,
                    }
                    : null
                }
                onChange={(val) => setDocTeamLead(val?.value || null)}
                placeholder="Select Document TL"
                isSearchable
                isClearable
              />

              {/* ── Document Team Members ── */}
              <label style={{ marginTop: "0.75rem" }}>
                Document Team Members
              </label>
              <Select
                isMulti
                options={employeeList
                  .filter(
                    (emp) => emp.emp_role === "CertificationAccessDocumentTeam",
                  )
                  .map((emp) => ({
                    value: emp.emp_code,
                    label: `${emp.emp_code} - ${emp.name}`,
                  }))}
                value={docTeamMembers.map((code) => ({
                  value: code,
                  label: employeeList.find((e) => e.emp_code === code)
                    ? `${code} - ${employeeList.find((e) => e.emp_code === code)?.name}`
                    : code,
                }))}
                onChange={(val) =>
                  setDocTeamMembers(val ? val.map((x) => x.value) : [])
                }
                placeholder="Select Document Team Members"
                isSearchable
                isClearable
                noOptionsMessage={() => "No employees available"}
              />

              {/* ── CV Team TL ── */}
              <label style={{ marginTop: "0.75rem", display: 'none' }}>CV Team - TL</label>

              <Select
                isMulti
                options={employeeList
                  .filter(
                    (emp) => emp.emp_role === "CertificationAccessCvTeamHead",
                  )
                  .map((emp) => ({
                    value: emp.emp_code.toUpperCase(),
                    label: `${emp.emp_code} - ${emp.name}`,
                  }))}

                value={cvTeamLead.map((code) => {
                  const emp = employeeList.find(
                    (e) => e.emp_code.toUpperCase() === code.toUpperCase()
                  );

                  return {
                    value: code.toUpperCase(),
                    label: emp
                      ? `${emp.emp_code} - ${emp.name}`
                      : code,
                  };
                })}

                onChange={(val) =>
                  setCvTeamLead(
                    val ? val.map((x) => x.value.toUpperCase()) : []
                  )
                }

                placeholder="Select CV TL"
                isSearchable
                isClearable
                style={{ display: 'none' }}
              />

              {/* ── CV Team Members ── */}
              <label style={{ marginTop: "0.75rem" }}>CV Team Members</label>
              <Select
                isMulti
                options={employeeList
                  .filter(
                    (emp) => emp.emp_role === "CertificationAccessCvTeam",
                  )
                  .map((emp) => ({
                    value: emp.emp_code,
                    label: `${emp.emp_code} - ${emp.name}`,
                  }))}
                value={cvTeamMembers.map((code) => ({
                  value: code,
                  label: employeeList.find((e) => e.emp_code === code)
                    ? `${code} - ${employeeList.find((e) => e.emp_code === code)?.name}`
                    : code,
                }))}
                onChange={(val) =>
                  setCvTeamMembers(val ? val.map((x) => x.value) : [])
                }
                placeholder="Select CV Team Members"
                isSearchable
                isClearable
                noOptionsMessage={() => "No employees available"}
              />
              <label style={{ marginTop: "0.75rem" }}>Finance Team - TL</label>
              <Select
                options={financeOptions}
                value={financeLeadValue}
                onChange={(val) => setFinanceTeamLead(val?.value || null)}
                placeholder="Select Finance TL"
                isSearchable
                isClearable
              />
            </div>

            <div className="button-models">
              <button
                className="model-button model-button-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="model-button model-button-delete"
                onClick={handleFormSubmit}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal.Body>

        {/* <ToastContainer position="top-center" autoClose={1000} /> */}
      </Modal>
    </>
  );
};

const TenderReject = ({ i, getBidData, filters, bgData, toggleState }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [formData, setFormData] = useState({
    rejected_reason: "",
    rejected_reason_other: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "rejected_reason",
      formData.rejected_reason === "other" ? "rejected_reason_other" : null,
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      const updatedData = {
        is_rejected: true,
        rejected_reason: formData.rejected_reason,
        rejected_reason_other: formData.rejected_reason_other,
      };
      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
          {
            ...updatedData,
          },
        );

        if (res.status === 200) {
          const matchedBg = bgData?.find((bg) => bg.tender_id === i.tender_id);
          if (matchedBg) {
            await axios.put(
              `${BASE_URL}/siteproject/bgdetailsforbdput/${matchedBg.id}/`,
              {
                is_rejected: true,

              },
              { headers: { "Content-Type": "application/json" } },
            );
          }
          const getJsonData = (data) => {
            if (data instanceof FormData) {
              return Object.fromEntries(data.entries());
            }
            return data; // already JSON
          };

          await saveAudit({
            tenderId: i?.id,
            updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
            tableName: "Tenderforbd",
            oldData: {},
            newData: getJsonData(updatedData),
            action: "UPDATE",
            tab_id: toggleState,
          });

          await getBidData(filters);
          // setShow(false);
        } else {
          // alert(res);
        }
      } catch (err) {
        //toast Logic
        if (err.response) {
          toast.dismiss(loadingToastId);
          const errorData = err.response.data;

          if (typeof errorData.error === "string") {
            // Single error message
            toast.error(`Error: ${errorData.error}`);
          } else if (typeof errorData === "object" && errorData !== null) {
            // Multiple error messages
            Object.entries(errorData).forEach(([field, messages]) => {
              messages.forEach((message) =>
                toast.error(`"${field}": ${message}`),
              );
            });
          } else {
            toast.error("Error:- Failed to Process!");
          }
        } else {
          toast.error("Error processing your request.");
        }
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  const handleDropdownChange = (e) => {
    const selectedValue = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      rejected_reason_dropdown: selectedValue,
      rejected_reason:
        selectedValue === "other" ? prevData.rejected_reason : "",
    }));
  };

  return (
    <>
      {/* <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover /> */}

      <button className="tender-card__action-danger" onClick={handleShow}
      // TenderReject is a modal component rendered separately in the full list
      >Reject</button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Reject Tender</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="flex-column">
                <label
                  htmlFor="rejected_reason"
                  className="form-labels font-weight500 font-size-heading"
                >
                  Select Rejection Reason<span className="required">*</span>
                </label>
                <select
                  id="rejected_reason"
                  name="rejected_reason"
                  value={formData.rejected_reason}
                  onChange={handleInputChange}
                  className="form-input input-form form-group-selection font-weight400 font-size-subheading"
                >
                  <option value="">-- Select Reason --</option>
                  <option value="do_not_qualify">Do Not Qualify</option>
                  <option value="partner_not_found">Partner Not Found</option>
                  <option value="due_to_tendor_document">
                    Due To Tender Document
                  </option>
                  <option value="due_to_cv_not_found">
                    Due To CV Not Found
                  </option>
                  <option value="other">Other</option>
                </select>

                {errors.rejected_reason && (
                  <span className="error-message font-size-text ">
                    {errors.rejected_reason}
                  </span>
                )}
                {formData.rejected_reason === "other" && (
                  <>
                    <label
                      htmlFor="rejected_reason"
                      className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                    >
                      Tender Rejection Reason<span className="required">*</span>
                    </label>
                    <textarea
                      id="rejected_reason_other"
                      type="text"
                      name="rejected_reason_other"
                      placeholder=" Please write the Reject Reason Other"
                      onChange={handleInputChange}
                      maxLength={100}
                      value={formData.rejected_reason_other}
                      className={`form-input-textarea font-weight400 font-size-subheading ${errors.rejected_reason_other
                        ? "error"
                        : inputState.rejected_reason_other
                          ? "success"
                          : ""
                        }`}
                    />
                    {errors.rejected_reason_other && (
                      <span className="error-message font-size-text ">
                        {errors.rejected_reason_other}
                      </span>
                    )}
                  </>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button model-button-cancel   font-weight500"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button   font-weight500    model-button-delete    font-size-heading"
                  onClick={handleFormSubmitPut}
                >
                  Reject
                </button>
              </div>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted &&
                Object.keys(errors).length > 0 &&
                (Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">
                    Please fill all mandatory fields!
                  </h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors)
                      .map((field) =>
                        field
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (char) => char.toUpperCase()),
                      )
                      .join(", ") + " are required!"}
                  </h6>
                ))}
            </p>
          </div>
        </Modal.Body>
        {/* <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}
      </Modal>
    </>
  );
};
const TenderCancel = ({ i, getBidData, filters, bgData }) => {
  const [show, setShow] = useState(false);
  const [reason, setReason] = useState("");
  const [proofFile, setProofFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const fileInputRef = useRef(null);

  const handleClose = () => {
    setShow(false);
    setReason("");
    setProofFile(null);
    setErrors({});
    if (fileInputRef.current) fileInputRef.current.value = "";
  };
  const handleShow = () => setShow(true);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0] || null;
    setProofFile(file);
    if (file) setErrors((prev) => ({ ...prev, cancellation_proof: undefined }));
  };

  const handleClearFile = () => {
    setProofFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const validate = () => {
    const newErrors = {};
    if (!reason.trim()) {
      newErrors.reason_remark_cancellation = "Reason for cancellation is required!";
    }
    // To make the document mandatory too, uncomment:
    // if (!proofFile) newErrors.cancellation_proof = "Cancellation proof is required!";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setSubmitting(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    // multipart, because cancellation_proof is a file
    const formData = new FormData();
    formData.append("is_cancelled", true);
    formData.append("reason_remark_cancellation", reason.trim());
    if (proofFile) {
      formData.append("cancellation_proof", proofFile);
    }

    try {
      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (res.status === 200 || res.status === 201) {
        const matchedBg = bgData?.find((bg) => bg.tender_id === i.tender_id);
        if (matchedBg) {
          await axios.put(
            `${BASE_URL}/siteproject/bgdetailsforbdput/${matchedBg.id}/`,
            { is_cancelled: true },
            { headers: { "Content-Type": "application/json" } },
          );
        }

        await saveAudit({
          tenderId: i?.id,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "Tenderforbd",
          oldData: {},
          newData: {
            is_cancelled: true,
            reason_remark_cancellation: reason.trim(),
            cancellation_proof: proofFile ? proofFile.name : null,
          },
          action: "UPDATE",
        });

        toast.success("Tender cancelled");
        handleClose();
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setSubmitting(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="tender-card__action-danger" onClick={handleShow}>
        Cancel
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Cancel Tender</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <p style={{ marginBottom: 16 }}>
              Are you sure you want to cancel this tender <b>{i?.tender_name}</b>?
            </p>

            {/* Reason */}
            <div className="flex-column" style={{ marginBottom: 16 }}>
              <label className="form-labels font-weight500 font-size-subheading">
                Reason for Cancellation <span className="required">*</span>
              </label>
              <textarea
                rows={4}
                placeholder="Please write the reason for cancelling this tender"
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value);
                  if (e.target.value.trim()) {
                    setErrors((prev) => ({ ...prev, reason_remark_cancellation: undefined }));
                  }
                }}
                className={`form-input-textarea font-weight400 font-size-subheading ${errors.reason_remark_cancellation ? "error" : reason.trim() ? "success" : ""
                  }`}
              />
              {errors.reason_remark_cancellation && (
                <span className="error-message font-size-text">
                  {errors.reason_remark_cancellation}
                </span>
              )}
            </div>

            {/* Document upload */}
            <div className="flex-column" style={{ marginBottom: 16 }}>
              <label className="form-labels font-weight500 font-size-subheading">
                Cancellation Document
              </label>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <input
                  type="file"
                  ref={fileInputRef}
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.zip,.jpg,.jpeg,.png"
                  onChange={handleFileChange}
                  className="form-control"
                  style={{ flex: 1, minWidth: 0 }}
                />
                {proofFile && (
                  <button
                    type="button"
                    onClick={handleClearFile}
                    style={{
                      padding: "4px 12px",
                      backgroundColor: "#ff4e4e",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                      fontWeight: 500,
                      cursor: "pointer",
                      fontSize: 14,
                    }}
                  >
                    Clear
                  </button>
                )}
              </div>
              {proofFile && (
                <span style={{ fontSize: 12, color: "#57606a", marginTop: 4 }}>
                  Selected: {proofFile.name}
                </span>
              )}
              {errors.cancellation_proof && (
                <span className="error-message font-size-text">
                  {errors.cancellation_proof}
                </span>
              )}
            </div>

            <div className="button-models">
              <button
                type="button"
                className="model-button font-weight500 model-button-cancel"
                onClick={handleClose}
                disabled={submitting}
              >
                Close
              </button>
              <button
                type="button"
                onClick={handleFormSubmitPut}
                className="model-button font-weight500 model-button-delete"
                disabled={submitting}
              >
                {submitting ? "Cancelling..." : "Confirm Cancel"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const Tenderspecial = ({ i, getBidData, filters }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    const updatedData = {
      is_special_tender: true,
    };
    try {
      let res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        {
          ...updatedData,
        },
      );

      if (res.status === 200) {
        await getBidData(filters);
        // setShow(false);
      } else {
        // alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const handleFormSubmitRemovePut = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    const updatedData = {
      is_special_tender: false,
    };
    try {
      let res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        {
          ...updatedData,
        },
      );

      if (res.status === 200) {
        await getBidData(filters);
        // setShow(false);
      } else {
        // alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      {!i?.is_special_tender ? (
        <button
          className="view_button"
          title="Mark as special"
          onClick={handleShow}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
        >
          <Star />
        </button>
      ) : (
        <button
          className="view_button"
          title="Remove From special"
          onClick={handleShow}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <circle cx="12" cy="12" r="12" fill="rgb(37,118,188)" />
            <path
              d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
              fill="#fff"
            />
          </svg>
        </button>
      )}

      {!i?.is_special_tender ? (
        <>
          {" "}
          <Modal
            show={show}
            onHide={handleClose}
            dialogClassName="request-leave width-40vw"
          >
            <Modal.Header closeButton>
              <Modal.Title>Mark Tender as Special</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="parent-div">
                <div className="bdy-div">
                  <div className="button-models">
                    <button
                      className="model-button model-button-cancel   font-weight500"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="model-button   font-weight500    model-button-delete    font-size-heading"
                      onClick={handleFormSubmitPut}
                    >
                      Mark special
                    </button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </>
      ) : (
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="request-leave width-40vw"
        >
          <Modal.Header closeButton>
            <Modal.Title>Remove Tender From Special Tender</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="parent-div">
              <div className="bdy-div">
                <div className="button-models">
                  <button
                    className="model-button model-button-cancel   font-weight500"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                    onClick={handleFormSubmitRemovePut}
                  >
                    Remove Tender
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
          {/* <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          /> */}
        </Modal>
      )}
    </>
  );
};

const Tenderdiscuss = ({ i, getBidData, filters }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Marking as discussed...");

    try {
      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        {
          is_discussed: true,
          is_discussed_by: sessionStorage.getItem("sitemanagement_emp_code"),
        },
      );
      if (res.status === 200) {
        await getBidData(filters);
        toast.success("Tender marked as discussed!");
        handleClose();
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const handleFormSubmitRemovePut = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Removing from discussed...");

    try {
      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        {
          is_discussed: false,
        },
      );
      if (res.status === 200) {
        await getBidData(filters);
        toast.success("Tender removed from discussed!");
        handleClose();
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      {/* Discuss Button */}
      {!i?.is_discussed && (
        <button
          className={`tender-card__action-secondary `}
          onClick={(e) => {
            e.stopPropagation();
            handleShow(i?.id);
          }}
        >
          {i?.is_discussed ? "Discussed" : "Discuss"}
        </button>
      )}

      {/* Modal for marking discussed */}
      {!i?.is_discussed ? (
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="request-leave width-40vw"
        >
          <Modal.Header closeButton>
            <Modal.Title>Mark Tender as Discussed</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="parent-div">
              <div className="bdy-div">
                <div className="button-models">
                  <button
                    className="model-button model-button-cancel font-weight500"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="model-button font-weight500 model-button-delete font-size-heading"
                    onClick={handleFormSubmitPut}
                  >
                    Mark Discussed
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : (
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="request-leave width-40vw"
        >
          <Modal.Header closeButton>
            <Modal.Title>Remove Tender from Discussed</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="parent-div">
              <div className="bdy-div">
                <div className="button-models">
                  <button
                    className="model-button model-button-cancel font-weight500"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="model-button font-weight500 model-button-delete font-size-heading"
                    onClick={handleFormSubmitRemovePut}
                  >
                    Remove Tender
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
      {/* 
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
    </>
  );
};


const UploadSiteProject = ({ getBidData, filters }) => {
  // ==========================================================
  // STATE
  // ==========================================================

  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null);
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});
  const [validationErrors, setValidationErrors] = useState([]);

  const bulktableRef = useRef(null);

  // ==========================================================
  // ALLOWED LEADING PARTNERS
  //
  // Backend:
  //
  // We = "We"
  // Client = "Client"
  // ==========================================================

  const allowedLeadingPartners = ["We", "Client"];

  // ==========================================================
  // ALLOWED STATES
  // ==========================================================

  const states = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  // ==========================================================
  // ALLOWED TENDER TYPES
  // ==========================================================

  const allowedTenderTypes = [
    "Feasibility",
    "DPR",
    "FeasibilityCumDPR",
    "Authority_Engineer",
    "Independent_Engineer",
    "PSSA",
    "PMC",
    "GC",
    "Other",
  ];

  // ==========================================================
  // ALLOWED SECTORS
  // ==========================================================

  const allowedSectors = [
    "Highway",
    "Railway",
    "Metro",
    "Water",
    "Ropeway",
    "Building",
    "Other",
  ];

  // ==========================================================
  // ALLOWED LANES
  // ==========================================================

  const allowedLanes = ["1", "2", "4", "8"];

  // ==========================================================
  // ALLOWED GST
  // ==========================================================

  const allowedGST = ["Including", "Excluding"];

  // ==========================================================
  // EXCEL / MODEL FIELDS
  //
  // These are writable model fields.
  //
  // Serializer-only read-only fields such as:
  // tender_bidders
  // tender_participants
  // notes_tender
  // assigned_to_detail
  // etc.
  //
  // are intentionally NOT sent in POST because they are
  // SerializerMethodField / read-only fields.
  // ==========================================================

  const fields = [
    // --------------------------------------------------------
    // MAIN
    // --------------------------------------------------------

    "sector",
    "tender_type",
    "client",
    "tender_name",
    "submission_date",
    "lane",
    "state",
    "cost_of_consult",
    "length",
    "cost_of_construction",
    "duration",

    "lead_partner",
    "jv_partner",
    "associate_with_version",

    "document",
    "emd",

    "eligibity_criteria",
    "eligibity_criteria_special",

    "remarks",
    "type_of_project",

    "km_cost",
    "fee",
    "bid_security",

    "tender_id",

    "e_published",

    // --------------------------------------------------------
    // MAIN STATUS
    // --------------------------------------------------------

    "status",

    "is_in_bidlist",
    "is_in_targetlist",
    "is_finalize",

    "is_special_tender",

    "qualified",

    // --------------------------------------------------------
    // JV
    // --------------------------------------------------------

    "jv_partner_type",
    "external_jv_required",
    "jv_partner_qualification_criteria",

    "assosiate_partner",

    "emd_amount",
    "bg_amount",

    "emd_type",
    "emd_submission",
    "tendersubmission",

    "is_submitted",

    "final_jv_name",

    "associate_allowed",
    "jv_partner_external",

    "technical_marking",

    "external_jv",

    "bg_type",

    "special_structure",

    "special_structure_type",

    "other_sector_type",
    "other_tender_type",

    "consultancy_fees",
    "GST_consultancy",

    "construction_fees",
    "GST_construction",

    "company_type",

    "soil_quality",
    "soil_type",

    "lead_partner_share",
    "jv_partner_share",
    "associate_partner_share",

    "bg_requried",
    "is_emd_required",

    "bg_submission",

    "tech_score",
    "company_score",

    "site_apprisate_required",
    "site_apprisate",

    "technical_status",
    "financial_status",
    "responsive_status",

    "are_we_l1",

    "work_methodology_required",
    "work_methodology_marking",

    "presentation_required",
    "presentation_required_marking",
    "presentation_type",

    "document_submission_date",

    "bg_sharing",
    "emd_sharing",

    "bg_pending",
    "pending_details_bg",

    "is_rejected",

    "rejected_reason",
    "rejected_reason_other",

    "leading_partner",

    "publish_date",

    "corrigendum_date",

    "jv_partner_name",
    "company_name",

    "lead_qualify",
    "jv_qualify",
    "associate_qualify",

    "is_jv_allowed",
    "is_jv_consorium_association_allowed",

    "terms_of_jv",

    "site_apprisate_marking",

    "associate_partner",

    "tender_submission_type",

    "checklist",

    "all_docs_done",

    "cv_score",
    "all_cvs_done",

    "tech_open",
    "tech_responsive",

    "emd_submission_type",

    "bid_prepare_by",
    "bid_prepare_by_remarks",

    "team_prepare_by",
    "team_prepare_by_remarks",

    "ro",

    "date_aa",
    "date_bb",
    "date_cc",
    "date_ee",

    "team_required",
    "team_requirements_details",

    "recipient_details",

    "emd_assumpter",

    "team_review",
    "emd_review",

    "emd_unit",

    "bg_scan_copy",

    "team_reviewer",

    "exmpted_emd",

    "pbg_requried",
    "pbg_details",

    "participating_as",

    "is_cancelled",
    "reason_remark_cancellation",

    "is_bid_prepare_in_progress",

    "is_discussed",

    "tat_duration",

    "mark_as_cv",
    "mark_as_document",

    "bg_prepare_by",

    "screening_date",

    "assigned_at",
    "assigned_by",
    "assigned_to",

    "tender_source",

    "sent",
    "recieve",

    "is_active",

    "bgcreatedfor_tender",

    "presentation_submitted",

    "emd_type_multi",

    "tender_fee",

    "is_residual_bid_capacity",

    "assigned_tls",
    "main_tl",

    "is_in_tech_tab",
    "is_in_financial_tab",

    "date_ff",

    "tech_summary_doc",

    "company_project_code_bd",

    "cost_of_rfp",
    "cost_of_rfp_mode",

    "qualification_status",

    "if_qualified",
    "qualification_remarks",

    "is_matured",

    "date_gg",

    "infracon_id_cost",
  ];

  // ==========================================================
  // DATE FIELDS
  // ==========================================================

  const dateFields = [
    "submission_date",
    "e_published",
    "emd_submission",
    "publish_date",
    "corrigendum_date",
    "document_submission_date",
    "screening_date",
  ];

  // ==========================================================
  // BOOLEAN FIELDS
  // ==========================================================

  const booleanFields = [
    "is_in_bidlist",
    "is_in_targetlist",
    "is_finalize",
    "is_special_tender",
    "qualified",

    "external_jv_required",
    "associate_allowed",
    "jv_partner_external",

    "technical_marking",

    "special_structure",

    "soil_quality",

    "bg_requried",
    "is_emd_required",

    "site_apprisate_required",

    "financial_status",

    "are_we_l1",

    "work_methodology_required",

    "presentation_required",

    "bg_pending",

    "is_rejected",

    "lead_qualify",
    "jv_qualify",
    "associate_qualify",

    "is_jv_allowed",
    "is_jv_consorium_association_allowed",

    "checklist",
    "all_docs_done",
    "all_cvs_done",

    "tech_open",
    "tech_responsive",

    "team_required",
    "emd_assumpter",

    "exmpted_emd",

    "pbg_requried",

    "is_cancelled",

    "is_bid_prepare_in_progress",

    "is_discussed",

    "mark_as_cv",
    "mark_as_document",

    "is_active",

    "bgcreatedfor_tender",

    "presentation_submitted",

    "is_residual_bid_capacity",

    "is_in_tech_tab",
    "is_in_financial_tab",

    "is_matured",

    "is_submitted",
  ];

  // ==========================================================
  // BOOLEAN CONVERTER
  // ==========================================================

  const convertToBoolean = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return null;
    }

    if (typeof value === "boolean") {
      return value;
    }

    if (typeof value === "number") {
      if (value === 1) {
        return true;
      }

      if (value === 0) {
        return false;
      }
    }

    if (typeof value === "string") {
      const normalized =
        value.trim().toLowerCase();

      if (
        normalized === "true" ||
        normalized === "yes" ||
        normalized === "y" ||
        normalized === "1"
      ) {
        return true;
      }

      if (
        normalized === "false" ||
        normalized === "no" ||
        normalized === "n" ||
        normalized === "0"
      ) {
        return false;
      }
    }

    return value;
  };

  // ==========================================================
  // LEADING PARTNER NORMALIZATION
  //
  // Backend accepts ONLY:
  //
  // We
  // Client
  //
  // Old Excel values:
  //
  // CIPL
  // cipl
  // SAPL
  // sapl
  //
  // are mapped to We.
  // ==========================================================

  const normalizeLeadingPartner = (
    value
  ) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return null;
    }

    const normalized =
      String(value)
        .trim()
        .toLowerCase();

    if (
      normalized === "we" ||
      normalized === "cipl" ||
      normalized === "sapl"
    ) {
      return "We";
    }

    if (
      normalized === "client"
    ) {
      return "Client";
    }

    return null;
  };

  // ==========================================================
  // DATE CONVERTER
  // ==========================================================

  const convertToYYYYMMDD = (
    input
  ) => {
    try {
      if (
        input === null ||
        input === undefined ||
        input === ""
      ) {
        return null;
      }

      let date;

      // Excel serial
      if (
        typeof input === "number"
      ) {
        const excelEpoch =
          new Date(
            1899,
            11,
            30
          );

        date = new Date(
          excelEpoch.getTime() +
          input *
          86400000
        );
      }

      // Text
      else if (
        typeof input === "string"
      ) {
        const value =
          input.trim();

        if (!value) {
          return null;
        }

        const normalized =
          value.replace(
            /[./\s]+/g,
            "-"
          );

        // DD-MM-YYYY

        if (
          /^\d{1,2}-\d{1,2}-\d{4}$/.test(
            normalized
          )
        ) {
          const [
            d,
            m,
            y,
          ] =
            normalized.split(
              "-"
            );

          date = new Date(
            Number(y),
            Number(m) - 1,
            Number(d)
          );
        }

        // YYYY-MM-DD

        else if (
          /^\d{4}-\d{1,2}-\d{1,2}$/.test(
            normalized
          )
        ) {
          const [
            y,
            m,
            d,
          ] =
            normalized.split(
              "-"
            );

          date = new Date(
            Number(y),
            Number(m) - 1,
            Number(d)
          );
        }

        // ISO datetime or other valid date

        else {
          date =
            new Date(value);
        }
      }

      else {
        date =
          new Date(input);
      }

      if (
        isNaN(
          date.getTime()
        )
      ) {
        return null;
      }

      return [
        date.getFullYear(),
        String(
          date.getMonth() + 1
        ).padStart(2, "0"),
        String(
          date.getDate()
        ).padStart(2, "0"),
      ].join("-");
    } catch (error) {
      console.error(
        "Date conversion error:",
        error
      );

      return null;
    }
  };

  // ==========================================================
  // JSON ARRAY CONVERTER
  // ==========================================================

  const convertToJsonArray = (
    value
  ) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    if (
      typeof value === "string"
    ) {
      const trimmed =
        value.trim();

      if (!trimmed) {
        return [];
      }

      try {
        const parsed =
          JSON.parse(trimmed);

        return Array.isArray(
          parsed
        )
          ? parsed
          : [];
      } catch {
        // Support comma-separated employee codes
        return trimmed
          .split(",")
          .map((x) => x.trim())
          .filter(Boolean);
      }
    }

    return [];
  };

  // ==========================================================
  // JSON OBJECT CONVERTER
  // ==========================================================

  const convertToJsonObject = (
    value
  ) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return {};
    }

    if (
      typeof value === "object" &&
      !Array.isArray(value)
    ) {
      return value;
    }

    if (
      typeof value === "string"
    ) {
      try {
        const parsed =
          JSON.parse(
            value.trim()
          );

        if (
          parsed &&
          typeof parsed ===
          "object" &&
          !Array.isArray(
            parsed
          )
        ) {
          return parsed;
        }
      } catch {
        return {};
      }
    }

    return {};
  };

  // ==========================================================
  // CLEAN CHOICE FIELDS
  //
  // We don't know the exact values of every backend enum.
  // For optional choice fields, invalid legacy text is sent
  // as null so it doesn't fail the serializer.
  // ==========================================================

  const cleanOptionalChoice =
    (value) => {
      if (
        value === null ||
        value === undefined
      ) {
        return null;
      }

      const text =
        String(value).trim();

      if (!text) {
        return null;
      }

      return text;
    };

  // ==========================================================
  // NORMALIZE HEADER
  // ==========================================================

  const normalizeHeader = (
    value
  ) => {
    if (
      value === null ||
      value === undefined
    ) {
      return "";
    }

    return String(value).trim();
  };

  // ==========================================================
  // DISPLAY DATE
  // ==========================================================

  const formatDisplayDate = (
    dateStr
  ) => {
    if (!dateStr) {
      return "";
    }

    const parts =
      String(dateStr).split("-");

    if (
      parts.length === 3
    ) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }

    return dateStr;
  };

  // ==========================================================
  // FIND DUPLICATES
  // ==========================================================

  const checkForDuplicates = (
    data
  ) => {
    const tenderIds =
      new Map();

    const duplicates = [];

    data.forEach(
      (item, index) => {
        if (!item.tender_id) {
          return;
        }

        const tenderId =
          String(
            item.tender_id
          )
            .trim()
            .toLowerCase();

        if (
          tenderIds.has(
            tenderId
          )
        ) {
          tenderIds
            .get(tenderId)
            .push(index + 2);
        } else {
          tenderIds.set(
            tenderId,
            [index + 2]
          );
        }
      }
    );

    tenderIds.forEach(
      (
        positions,
        tenderId
      ) => {
        if (
          positions.length > 1
        ) {
          duplicates.push(
            `Tender ID "${tenderId}" is duplicated in rows ${positions.join(
              ", "
            )}`
          );
        }
      }
    );

    return duplicates;
  };

  // ==========================================================
  // READ EXCEL
  // ==========================================================

  const readExcel = (
    file
  ) => {
    const reader =
      new FileReader();

    reader.onload = (
      e
    ) => {
      try {
        const data =
          new Uint8Array(
            e.target.result
          );

        const workbook =
          XLSX.read(
            data,
            {
              type: "array",
              cellDates: false,
              raw: true,
            }
          );

        if (
          !workbook.SheetNames.length
        ) {
          toast.error(
            "Excel workbook does not contain any sheet."
          );

          return;
        }

        // ====================================================
        // FIRST SHEET
        // ====================================================

        const sheetName =
          workbook.SheetNames[0];

        const worksheet =
          workbook.Sheets[
          sheetName
          ];

        const sheetData =
          XLSX.utils.sheet_to_json(
            worksheet,
            {
              header: 1,
              defval: null,
              raw: true,
            }
          );

        if (
          !sheetData.length
        ) {
          toast.error(
            "The Excel sheet is empty."
          );

          return;
        }

        // ====================================================
        // REQUIRED HEADERS
        // ====================================================

        const requiredHeaders = [
          "sector",
          "tender_type",
          "tender_name",
          "client",
          "publish_date",
          "submission_date",
          "tender_id",
        ];

        // ====================================================
        // FIND HEADER ROW
        // ====================================================

        const headerRowIndex =
          sheetData.findIndex(
            (row) => {
              if (
                !Array.isArray(
                  row
                )
              ) {
                return false;
              }

              const rowHeaders =
                row.map(
                  normalizeHeader
                );

              return requiredHeaders.every(
                (header) =>
                  rowHeaders.includes(
                    header
                  )
              );
            }
          );

        if (
          headerRowIndex === -1
        ) {
          toast.error(
            "❌ Correct header row not found in Excel sheet."
          );

          return;
        }

        // ====================================================
        // HEADERS
        // ====================================================

        const headers =
          sheetData[
            headerRowIndex
          ].map(
            normalizeHeader
          );

        // ====================================================
        // DATA ROWS
        // ====================================================

        const dataRows =
          sheetData.slice(
            headerRowIndex + 1
          );

        // ====================================================
        // CONVERT ROWS
        // ====================================================

        const formattedJson =
          dataRows.map(
            (row) => {
              const obj = {};

              headers.forEach(
                (
                  header,
                  index
                ) => {
                  if (
                    !header ||
                    !fields.includes(
                      header
                    )
                  ) {
                    return;
                  }

                  let value =
                    row[index];

                  // Date
                  if (
                    dateFields.includes(
                      header
                    )
                  ) {
                    value =
                      convertToYYYYMMDD(
                        value
                      );
                  }

                  // Boolean
                  else if (
                    booleanFields.includes(
                      header
                    )
                  ) {
                    value =
                      convertToBoolean(
                        value
                      );
                  }

                  // Leading partner
                  else if (header === "leading_partner") {
                    value = normalizeLeadingPartner(value);
                  }


                  // assigned arrays
                  else if (
                    [
                      "assigned_to",
                      "assigned_by",
                      "assigned_tls",
                      "main_tl",
                      "emd_type_multi",
                    ].includes(
                      header
                    )
                  ) {
                    value =
                      convertToJsonArray(
                        value
                      );
                  }

                  // assigned_at
                  else if (
                    header ===
                    "assigned_at"
                  ) {
                    value =
                      convertToJsonObject(
                        value
                      );
                  }

                  // String
                  else if (
                    typeof value ===
                    "string"
                  ) {
                    value =
                      value.trim();
                  }

                  if (
                    value ===
                    undefined
                  ) {
                    value = null;
                  }

                  obj[header] =
                    value;
                }
              );

              return obj;
            }
          );

        // ====================================================
        // REMOVE EMPTY ROWS
        // ====================================================

        const nonEmptyRows =
          formattedJson.filter(
            (row) =>
              Object.values(
                row
              ).some(
                (value) =>
                  value !==
                  null &&
                  value !==
                  undefined &&
                  value !== ""
              )
          );

        // ====================================================
        // DUPLICATES
        // ====================================================

        const duplicates =
          checkForDuplicates(
            nonEmptyRows
          );

        if (
          duplicates.length
        ) {
          setValidationErrors(
            duplicates
          );
        } else {
          setValidationErrors(
            []
          );
        }

        // ====================================================
        // DATE VALIDATION
        // ====================================================

        const invalidDates =
          nonEmptyRows.filter(
            (item) => {
              if (
                !item.publish_date ||
                !item.submission_date
              ) {
                return false;
              }

              return (
                new Date(
                  item.publish_date
                ) >
                new Date(
                  item.submission_date
                )
              );
            }
          );

        if (
          invalidDates.length
        ) {
          toast.error(
            "❌ Publish date cannot be after submission date.",
            {
              autoClose: 5000,
            }
          );

          return;
        }

        // ====================================================
        // SET DATA
        // ====================================================

        setExcelJson(
          nonEmptyRows
        );

        setDocInputState({
          document_file: true,
        });
      } catch (error) {
        console.error(
          "Excel parsing error:",
          error
        );

        toast.error(
          "Unable to read Excel file. Please check the format."
        );
      }
    };

    reader.readAsArrayBuffer(
      file
    );
  };

  // ==========================================================
  // HANDLE FILE
  // ==========================================================

  const handleFileChange = (
    e
  ) => {
    const file =
      e.target.files?.[0];

    setDocErrors({});
    setValidationErrors([]);

    if (!file) {
      setFileName("");
      setExcelJson(null);

      return;
    }

    const validFileTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];

    const validExtension =
      /\.(xlsx|xls)$/i.test(
        file.name
      );

    if (
      !validFileTypes.includes(
        file.type
      ) &&
      !validExtension
    ) {
      setDocErrors({
        document_file:
          "Please upload a valid Excel file (.xlsx or .xls).",
      });

      setFileName("");
      setExcelJson(null);

      return;
    }

    setFileName(
      file.name
    );

    readExcel(file);
  };

  // ==========================================================
  // UPLOAD
  // ==========================================================

  const handleUpload = async () => {
    if (!excelJson || !excelJson.length) {
      setDocErrors({
        document_file:
          "Please upload a valid Excel file containing tender data.",
      });
      return;
    }

    // ==========================================================
    // IMPORTANT:
    // NORMALIZE THE EXCEL DATA FIRST
    //
    // cipl -> We
    // sapl -> We
    // we   -> We
    // client -> Client
    // ==========================================================

    const normalizedExcelJson = excelJson.map((row) => ({
      ...row,

      leading_partner: normalizeLeadingPartner(
        row.leading_partner
      ),

      // Backend status cannot be null
      status: row.status || "pending",

      // Backend BooleanField
      technical_marking:
        typeof row.technical_marking === "boolean"
          ? row.technical_marking
          : false,

      // Backend BooleanField
      financial_status:
        typeof row.financial_status === "boolean"
          ? row.financial_status
          : false,

      // Submitted tab flags
      is_in_bidlist: true,
      is_in_targetlist: true,
      is_finalize: true,
      is_bid_prepare_in_progress: true,
      is_submitted: true,
      is_rejected: false,
      is_cancelled: false,
    }));

    console.log(
      "NORMALIZED LEADING PARTNERS:",
      normalizedExcelJson.map((item) => ({
        tender_id: item.tender_id,
        original: excelJson.find(
          (x) => x.tender_id === item.tender_id
        )?.leading_partner,
        normalized: item.leading_partner,
      }))
    );

    const errors = [];
    const seenTenderIds = new Map();

    // ==========================================================
    // VALIDATION
    // ==========================================================

    normalizedExcelJson.forEach((row, index) => {
      const rowNum = index + 2;

      // --------------------------------------------------------
      // TENDER ID
      // --------------------------------------------------------

      const tenderId = row.tender_id
        ? String(row.tender_id)
          .trim()
          .toLowerCase()
        : null;

      if (!tenderId) {
        errors.push(
          `Row ${rowNum}: Missing Tender ID`
        );
      } else if (seenTenderIds.has(tenderId)) {
        errors.push(
          `Row ${rowNum}: Duplicate Tender ID "${row.tender_id}" (also at Row ${seenTenderIds.get(
            tenderId
          )})`
        );
      } else {
        seenTenderIds.set(tenderId, rowNum);
      }

      // --------------------------------------------------------
      // TENDER TYPE
      // --------------------------------------------------------

      if (
        row.tender_type &&
        !allowedTenderTypes.includes(
          String(row.tender_type).trim()
        )
      ) {
        errors.push(
          `Row ${rowNum}: Invalid Tender Type "${row.tender_type}"`
        );
      }

      // --------------------------------------------------------
      // SECTOR
      // --------------------------------------------------------

      if (
        row.sector &&
        !allowedSectors.includes(
          String(row.sector).trim()
        )
      ) {
        errors.push(
          `Row ${rowNum}: Invalid Sector "${row.sector}"`
        );
      }

      // --------------------------------------------------------
      // LEADING PARTNER
      //
      // At this point the value should already be:
      //
      // We
      // Client
      // --------------------------------------------------------

      if (
        row.leading_partner !== null &&
        row.leading_partner !== undefined &&
        row.leading_partner !== "" &&
        !allowedLeadingPartners.includes(
          row.leading_partner
        )
      ) {
        errors.push(
          `Row ${rowNum}: Invalid Leading Partner "${row.leading_partner}". Allowed values: We, Client`
        );
      }

      // --------------------------------------------------------
      // STATE
      // --------------------------------------------------------

      if (
        row.state &&
        !states.includes(
          String(row.state).trim()
        )
      ) {
        errors.push(
          `Row ${rowNum}: Invalid State "${row.state}"`
        );
      }

      // --------------------------------------------------------
      // LANE
      // --------------------------------------------------------

      if (
        row.lane !== null &&
        row.lane !== undefined &&
        row.lane !== ""
      ) {
        const lane = String(row.lane).trim();

        if (!allowedLanes.includes(lane)) {
          errors.push(
            `Row ${rowNum}: Invalid Lane "${row.lane}". Allowed values: 1, 2, 4, 8`
          );
        }
      }

      // --------------------------------------------------------
      // GST CONSULTANCY
      // --------------------------------------------------------

      if (
        row.GST_consultancy &&
        !allowedGST.includes(
          String(row.GST_consultancy).trim()
        )
      ) {
        errors.push(
          `Row ${rowNum}: Invalid GST_consultancy "${row.GST_consultancy}"`
        );
      }

      // --------------------------------------------------------
      // GST CONSTRUCTION
      // --------------------------------------------------------

      if (
        row.GST_construction &&
        !allowedGST.includes(
          String(row.GST_construction).trim()
        )
      ) {
        errors.push(
          `Row ${rowNum}: Invalid GST_construction "${row.GST_construction}"`
        );
      }

      // --------------------------------------------------------
      // PUBLISH / SUBMISSION DATE
      // --------------------------------------------------------

      if (
        row.publish_date &&
        row.submission_date
      ) {
        if (
          new Date(row.publish_date) >
          new Date(row.submission_date)
        ) {
          errors.push(
            `Row ${rowNum}: Publish date cannot be after Submission date`
          );
        }
      }
    });

    // ==========================================================
    // STOP IF ERRORS
    // ==========================================================

    if (errors.length > 0) {
      setValidationErrors(errors);
      return;
    }

    setValidationErrors([]);

    // ==========================================================
    // FINAL API PAYLOAD
    // ==========================================================

    const enrichedExcelJson =
      normalizedExcelJson.map(
        ({
          duration_construction,
          duration_dlp,
          duration_onm,
          ...rest
        }) => {
          const existingDuration =
            rest.duration &&
              typeof rest.duration === "object" &&
              !Array.isArray(rest.duration)
              ? rest.duration
              : {};

          const finalData = {
            ...rest,

            // ==================================================
            // GUARANTEE VALID LEADING PARTNER
            // ==================================================

            leading_partner:
              normalizeLeadingPartner(
                rest.leading_partner
              ),

            // ==================================================
            // REQUIRED STATUS
            // ==================================================

            status:
              rest.status || "pending",

            // ==================================================
            // REQUIRED BOOLEAN
            // ==================================================

            technical_marking:
              typeof rest.technical_marking ===
                "boolean"
                ? rest.technical_marking
                : false,

            // financial_status is BooleanField
            financial_status:
              typeof rest.financial_status ===
                "boolean"
                ? rest.financial_status
                : false,

            // ==================================================
            // SUBMITTED TAB
            // ==================================================

            is_in_bidlist: true,
            is_in_targetlist: true,
            is_finalize: true,
            is_bid_prepare_in_progress: true,
            is_submitted: true,

            is_rejected: false,
            is_cancelled: false,

            // ==================================================
            // DURATION
            // ==================================================

            duration: {
              ...existingDuration,

              construction:
                duration_construction ??
                existingDuration.construction ??
                "",

              dlp:
                duration_dlp ??
                existingDuration.dlp ??
                "",

              onm:
                duration_onm ??
                existingDuration.onm ??
                "",
            },

            // ==================================================
            // JSON ARRAY FIELDS
            // ==================================================

            assigned_to:
              convertToJsonArray(
                rest.assigned_to
              ),

            assigned_by:
              convertToJsonArray(
                rest.assigned_by
              ),

            assigned_tls:
              convertToJsonArray(
                rest.assigned_tls
              ),

            main_tl:
              convertToJsonArray(
                rest.main_tl
              ),

            emd_type_multi:
              convertToJsonArray(
                rest.emd_type_multi
              ),

            // ==================================================
            // JSON OBJECT
            // ==================================================

            assigned_at:
              convertToJsonObject(
                rest.assigned_at
              ),
          };

          // These duration Excel columns are converted into
          // the duration object.
          delete finalData.duration_construction;
          delete finalData.duration_dlp;
          delete finalData.duration_onm;

          // Serializer-only computed fields.
          delete finalData.assigned_to_detail;
          delete finalData.assigned_to_tls_detail;
          delete finalData.main_tl_summary;

          return finalData;
        }
      );

    // ==========================================================
    // FINAL SAFETY CHECK
    // ==========================================================

    const invalidLeadingPartners =
      enrichedExcelJson.filter(
        (item) =>
          item.leading_partner !== null &&
          item.leading_partner !== "" &&
          !["We", "Client"].includes(
            item.leading_partner
          )
      );

    if (invalidLeadingPartners.length > 0) {
      console.error(
        "INVALID LEADING PARTNER VALUES:",
        invalidLeadingPartners.map(
          (item) => ({
            tender_id: item.tender_id,
            leading_partner:
              item.leading_partner,
          })
        )
      );

      setValidationErrors([
        "Invalid leading_partner values remain after normalization.",
      ]);

      return;
    }

    // ==========================================================
    // DEBUG
    // ==========================================================

    console.log(
      "=========================================="
    );

    console.log(
      "FINAL BULK UPLOAD PAYLOAD"
    );

    console.log(
      "Number of tenders:",
      enrichedExcelJson.length
    );

    console.log(
      "First tender:",
      enrichedExcelJson[0]
    );

    console.log(
      "Leading Partner values:",
      [
        ...new Set(
          enrichedExcelJson.map(
            (item) =>
              item.leading_partner
          )
        ),
      ]
    );

    console.log(
      "Submitted flags:",
      {
        is_in_bidlist:
          enrichedExcelJson[0]
            ?.is_in_bidlist,

        is_in_targetlist:
          enrichedExcelJson[0]
            ?.is_in_targetlist,

        is_finalize:
          enrichedExcelJson[0]
            ?.is_finalize,

        is_bid_prepare_in_progress:
          enrichedExcelJson[0]
            ?.is_bid_prepare_in_progress,

        is_submitted:
          enrichedExcelJson[0]
            ?.is_submitted,

        is_rejected:
          enrichedExcelJson[0]
            ?.is_rejected,

        is_cancelled:
          enrichedExcelJson[0]
            ?.is_cancelled,
      }
    );

    console.log(
      "=========================================="
    );

    // ==========================================================
    // API CALL
    // ==========================================================

    const loadingToastId =
      toast.loading(
        "Uploading: Please wait..."
      );

    try {
      const res = await axios.post(
        `${BASE_URL}/siteproject/bidtenderbulk/`,
        enrichedExcelJson
      );

      console.log(
        "Bulk upload response:",
        res
      );

      if (
        res.status === 200 ||
        res.status === 201
      ) {
        await getBidData(filters);

        handleClose();

        toast.dismiss(
          loadingToastId
        );

        toast.success(
          "Projects uploaded successfully and moved to Submitted tab."
        );
      } else {
        toast.dismiss(
          loadingToastId
        );

        toast.error(
          "Failed to add data!"
        );
      }
    } catch (error) {
      console.error(
        "Bulk upload error:",
        error
      );

      console.error(
        "API RESPONSE:",
        error?.response?.data
      );

      toast.dismiss(
        loadingToastId
      );

      if (
        typeof handleErrorToast ===
        "function"
      ) {
        handleErrorToast(
          error
        );
      } else {
        toast.error(
          error?.response?.data
            ?.detail ||
          "Bulk upload failed."
        );
      }
    } finally {
      toast.dismiss(
        loadingToastId
      );
    }
  };

  // ==========================================================
  // CLOSE MODAL
  // ==========================================================

  const handleClose = () => {
    setFileName("");
    setExcelJson(null);
    setDocErrors({});
    setDocInputState({});
    setValidationErrors([]);

    setShow(false);
  };

  // ==========================================================
  // OPEN MODAL
  // ==========================================================

  const handleShow = () => {
    setShow(true);
  };

  // ==========================================================
  // DOWNLOAD EXCEL FORMAT
  // ==========================================================

  const handleDownload = () => {
    const link =
      document.createElement(
        "a"
      );

    link.href =
      "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/bid/tender/b4b6eb36-4b8b-495d-b18e-f3b40dc33a79/Aimantra_2025-10-13_13-37-51_SbL2Ba_bid_Tender+(4).xlsx";

    link.download =
      "Bid_Tender.xlsx";

    link.target =
      "_blank";

    link.click();
  };

  // ==========================================================
  // TITLE CASE
  // ==========================================================

  const toTitleCase = (
    value
  ) => {
    return String(value)
      .replace(
        /_/g,
        " "
      )
      .replace(
        /\b\w/g,
        (char) =>
          char.toUpperCase()
      );
  };

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <>
      {/* =====================================================
          UPLOAD BUTTON
      ====================================================== */}

      <button
        title="Upload"
        className="bg-icon-btn"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 20 22"
          fill="none"
        >
          <g
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14" />
          </g>
        </svg>

        Upload
      </button>

      {/* =====================================================
          MODAL
      ====================================================== */}

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        {/* ===================================================
            HEADER
        ==================================================== */}

        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>
            Upload Bulk Tender Data in format :
          </Modal.Title>
        </Modal.Header>

        {/* ===================================================
            BODY
        ==================================================== */}

        <Modal.Body>
          {/* =================================================
              FORMAT DOWNLOAD
          ================================================== */}

          <div className="flex-row align-center">
            <button
              onClick={
                handleDownload
              }
              className="model-button-download model-button font-weight500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                viewBox="0 0 20 22"
                fill="#fff"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14" />
                </g>
              </svg>

              {"  "}
              Format
            </button>
          </div>

          {/* =================================================
              PREVIEW TABLE
          ================================================== */}

          <div
            className="table-css-white-background scroll-container"
            style={{
              marginTop:
                "20px",
            }}
          >
            <div
              className="table-container scrollbar"
              style={{
                width: "100%",
              }}
            >
              <table
                ref={
                  bulktableRef
                }
                className="nested-table-lightblue"
                style={{
                  margin: "0px",
                  minWidth:
                    "3000px",
                }}
              >
                <thead className="table-heading">
                  <tr className="custom-table-head-tr">
                    {fields.map(
                      (
                        field,
                        index
                      ) => (
                        <th
                          key={
                            index
                          }
                          className="table-heading-text"
                        >
                          {toTitleCase(
                            field
                          )}
                        </th>
                      )
                    )}
                  </tr>
                </thead>

                <tbody>
                  {excelJson?.map(
                    (
                      project,
                      rowIndex
                    ) => (
                      <tr
                        key={
                          rowIndex
                        }
                        className="modal-padding-heading"
                      >
                        {fields.map(
                          (
                            field,
                            colIndex
                          ) => {
                            const value =
                              project[
                              field
                              ];

                            return (
                              <td
                                key={
                                  colIndex
                                }
                                className="table-heading-text"
                              >
                                {typeof value ===
                                  "boolean"
                                  ? value
                                    ? "Yes"
                                    : "No"
                                  : dateFields.includes(
                                    field
                                  ) &&
                                    value
                                    ? formatDisplayDate(
                                      value
                                    )
                                    : Array.isArray(
                                      value
                                    )
                                      ? JSON.stringify(
                                        value
                                      )
                                      : value ??
                                      ""}
                              </td>
                            );
                          }
                        )}
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* =================================================
              FILE UPLOAD
          ================================================== */}

          <div className="flex-column field-cont-div">
            <label
              htmlFor="document_file"
              className="form-labels announce-date font-weight500 font-size-heading"
            >
              Upload File
            </label>

            <label
              htmlFor="document_file"
              className={`align-center form-inputss custom-file-upload ${docErrors.document_file
                ? "error"
                : docInputState.document_file
                  ? "success"
                  : ""
                }`}
            >
              <svg
                className="pdf-input"
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                  stroke="#707070"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </label>

            <input
              id="document_file"
              name="document_file"
              type="file"
              accept=".xlsx,.xls"
              onChange={
                handleFileChange
              }
              className="file-inputs align-center"
              style={{
                display:
                  "none",
                position:
                  "relative",
              }}
            />

            {fileName && (
              <p className="file-name align-center">
                {fileName}
              </p>
            )}

            <br />

            {docErrors.document_file && (
              <span className="file-name error-message font-size-text">
                {
                  docErrors
                    .document_file
                }
              </span>
            )}
          </div>

          {/* =================================================
              BUTTONS
          ================================================== */}

          <div className="button-models">
            <button
              className="model-button-cancel model-button font-weight500"
              onClick={
                handleClose
              }
            >
              Cancel
            </button>

            <button
              className="model-button-download model-button font-weight500"
              onClick={
                handleUpload
              }
              disabled={
                !excelJson ||
                excelJson.length ===
                0
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                id="upload"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14" />
                </g>
              </svg>

              {"  "}
              Upload
            </button>
          </div>

          {/* =================================================
              VALIDATION ERRORS
          ================================================== */}

          {validationErrors.length >
            0 && (
              <div
                style={{
                  background:
                    "#ffecec",
                  border:
                    "1px solid #f5c2c7",
                  color:
                    "#842029",
                  borderRadius:
                    "6px",
                  padding:
                    "10px",
                  marginTop:
                    "15px",
                  fontSize:
                    "14px",
                  maxHeight:
                    "250px",
                  overflowY:
                    "auto",
                }}
              >
                <strong>
                  Validation Errors:
                </strong>

                <ul
                  style={{
                    marginTop:
                      "5px",
                    paddingLeft:
                      "20px",
                  }}
                >
                  {validationErrors.map(
                    (
                      error,
                      index
                    ) => (
                      <li
                        key={
                          index
                        }
                      >
                        {error}
                      </li>
                    )
                  )}
                </ul>
              </div>
            )}

          {/* =================================================
              REFERENCES
          ================================================== */}

          <h4
            style={{
              marginBottom:
                "1rem",
              marginTop:
                "1rem",
            }}
          >
            References:
          </h4>

          <div
            style={{
              padding:
                "0.5rem",
              lineHeight:
                "1.4",
              borderRadius:
                "8px",
            }}
          >
            <div
              style={{
                display:
                  "flex",
                flexWrap:
                  "wrap",
                gap:
                  "1rem",
              }}
            >
              {/* GENERAL */}

              <div
                style={{
                  flex:
                    "1 1 250px",
                  fontSize:
                    "14px",
                }}
              >
                <p
                  style={{
                    fontWeight:
                      "bold",
                    margin:
                      "0 0 0.3rem 0",
                  }}
                >
                  General:
                </p>

                <ul
                  className="arrow-list"
                  style={{
                    paddingLeft:
                      "1rem",
                    margin: 0,
                  }}
                >
                  <li>
                    Tender ID must be unique
                  </li>

                  <li>
                    Dates: DD-MM-YYYY
                  </li>

                  <li>
                    Length in km
                  </li>

                  <li>
                    Lane: 1, 2, 4, 8
                  </li>

                  <li>
                    Duration: months
                  </li>

                  <li>
                    Publish &lt; Submission Date
                  </li>

                  <li>
                    Amount data should be in crores
                  </li>
                </ul>
              </div>

              {/* SECTOR */}

              <div
                style={{
                  flex:
                    "1 1 200px",
                  fontSize:
                    "14px",
                }}
              >
                <p
                  style={{
                    fontWeight:
                      "bold",
                    margin:
                      "0 0 0.3rem 0",
                  }}
                >
                  Sector Types:
                </p>

                <ul
                  className="arrow-list"
                  style={{
                    columnCount:
                      2,
                    paddingLeft:
                      "1rem",
                    margin: 0,
                  }}
                >
                  {allowedSectors.map(
                    (
                      sector
                    ) => (
                      <li
                        key={
                          sector
                        }
                      >
                        {
                          sector
                        }
                      </li>
                    )
                  )}
                </ul>
              </div>

              {/* TENDER TYPES */}

              <div
                style={{
                  flex:
                    "1 1 300px",
                  fontSize:
                    "14px",
                }}
              >
                <p
                  style={{
                    fontWeight:
                      "bold",
                    margin:
                      "0 0 0.3rem 0",
                  }}
                >
                  Tender Types:
                </p>

                <ul
                  className="arrow-list"
                  style={{
                    columnCount:
                      2,
                    paddingLeft:
                      "1rem",
                    margin: 0,
                  }}
                >
                  {allowedTenderTypes.map(
                    (
                      tenderType
                    ) => (
                      <li
                        key={
                          tenderType
                        }
                      >
                        {
                          tenderType
                        }
                      </li>
                    )
                  )}
                </ul>
              </div>

              {/* GST */}

              <div
                style={{
                  flex:
                    "1 1 150px",
                  fontSize:
                    "14px",
                }}
              >
                <p
                  style={{
                    fontWeight:
                      "bold",
                    margin:
                      "0 0 0.3rem 0",
                  }}
                >
                  GST:
                </p>

                <ul
                  className="arrow-list"
                  style={{
                    paddingLeft:
                      "1rem",
                    margin: 0,
                  }}
                >
                  {allowedGST.map(
                    (
                      gst
                    ) => (
                      <li
                        key={gst}
                      >
                        {gst}
                      </li>
                    )
                  )}
                </ul>
              </div>

              {/* LEADING PARTNER */}

              <div
                style={{
                  flex:
                    "1 1 200px",
                  fontSize:
                    "14px",
                }}
              >
                <p
                  style={{
                    fontWeight:
                      "bold",
                    margin:
                      "0 0 0.3rem 0",
                  }}
                >
                  Leading Partner:
                </p>

                <ul
                  className="arrow-list"
                  style={{
                    paddingLeft:
                      "1rem",
                    margin: 0,
                  }}
                >
                  {allowedLeadingPartners.map(
                    (
                      partner
                    ) => (
                      <li
                        key={
                          partner
                        }
                      >
                        {
                          partner
                        }
                      </li>
                    )
                  )}
                </ul>
              </div>

              {/* STATES */}

              <div
                style={{
                  flex:
                    "1 1 500px",
                  fontSize:
                    "14px",
                }}
              >
                <p
                  style={{
                    fontWeight:
                      "bold",
                    margin:
                      "0 0 0.3rem 0",
                  }}
                >
                  States:
                </p>

                <ul
                  className="arrow-list"
                  style={{
                    columnCount:
                      3,
                    paddingLeft:
                      "1rem",
                    margin: 0,
                  }}
                >
                  {states.map(
                    (
                      state
                    ) => (
                      <li
                        key={
                          state
                        }
                      >
                        {
                          state
                        }
                      </li>
                    )
                  )}
                </ul>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const tooltipContainerStyle = {
  position: "absolute",
  bottom: "120%",
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 10,
  animation: "fadeInStausBadge 0.25s ease",
};

const tooltipArrowStyle = {
  position: "absolute",
  bottom: "-6px",
  left: "50%",
  transform: "translateX(-50%) rotate(45deg)",
  width: "12px",
  height: "12px",
  backgroundColor: "#fff",
  borderLeft: "1px solid #ccc",
  borderTop: "1px solid #ccc",
  boxShadow: "0 2px 3px rgba(0,0,0,0.08)",
  zIndex: 1,
};

const tooltipCardStyle = {
  position: "relative",
  backgroundColor: "#fff",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  border: "1px solid #ddd",
  padding: "10px 12px",
  minWidth: "200px",
};

const StatusBadge = ({ Tenderstatus }) => {
  const [showPopup, setShowPopup] = useState(false);
  const { status, missingFields = [] } = Tenderstatus || {};

  const getStatusColor = () => {
    switch (status) {
      case "Incomplete":
        return "#e74c3c"; // red
      case "Partially Filled":
        return "#f1c40f"; // yellow
      case "Complete":
      default:
        return "#27ae60"; // green
    }
  };

  const statusColor = getStatusColor();

  // light background + border (soft tone)
  const getLightColor = (color, opacity = 0.1) => {
    return `${color}${Math.floor(opacity * 255)
      .toString(16)
      .padStart(2, "0")}`;
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {/* Status Badge */}
      <div
        onMouseEnter={() => setShowPopup(true)}
        onMouseLeave={() => setShowPopup(false)}
        style={{
          padding: "0px 10px",
          height: "28px",
          background: getLightColor(statusColor, 0.12),
          border: `1px solid ${getLightColor(statusColor, 0.35)}`,
          color: statusColor,
          borderRadius: "8px", // or var(--radius-md)
          cursor: "pointer",
          fontSize: "11px",
          fontWeight: 600,
          transition: "all 0.25s ease", // or var(--transition)
          whiteSpace: "nowrap",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <div
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: statusColor,
          }}
        />
        <span>{status || "Unknown"}</span>
      </div>

      {/* Tooltip */}
      {showPopup && missingFields.length > 0 && (
        <div style={tooltipContainerStyle}>
          <div style={tooltipArrowStyle}></div>
          <div style={tooltipCardStyle}>
            <strong style={{ color: "#2576BC", fontSize: "0.8rem" }}>
              Missing Fields:
            </strong>
            <ul style={{ margin: "6px 0 0 0", paddingLeft: "18px" }}>
              {missingFields.map((field) => (
                <li key={field} style={{ fontSize: "0.75rem" }}>
                  {field}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

function getTenderStatus(toggleState, tender) {
  let requiredFields = [];
  let totalChecks = 0;
  let filledChecks = 0;
  let missingFields = [];

  if (toggleState === 2) {
    requiredFields = [
      tender.is_jv_allowed === null ? "is_jv_allowed" : null,
      "tech_score",
      "company_score",
      "company_name",
      "eligibity_criteria",
      tender.soil_quality === null ? "soil_quality" : null,
      tender.participating_as === null ? "participating_as" : null,
      tender.is_jv_consorium_association_allowed === null
        ? "jv_consorium_association_allowed"
        : null,
      tender.is_jv_consorium_association_allowed != null &&
        tender.is_jv_consorium_association_allowed
        ? "terms_of_jv"
        : null,
      tender.site_apprisate_required === null
        ? "site_apprisate_required"
        : null,
      tender.site_apprisate_required !== null ? "site_apprisate_marking" : null,
      tender.work_methodology_required === null
        ? "work_methodology_required"
        : null,
      tender.work_methodology_required != null
        ? "work_methodology_marking"
        : null,
      tender.presentation_required === null ? "presentation_required" : null,
      tender.presentation_required !== null && tender.presentation_required
        ? "presentation_required_marking"
        : null,
      tender.presentation_required !== null && tender.presentation_required
        ? "presentation_type"
        : null,
    ].filter(Boolean);

    totalChecks = requiredFields.length;

    requiredFields.forEach((field) => {
      if (
        tender[field] !== undefined &&
        tender[field] !== null &&
        tender[field] !== ""
      ) {
        filledChecks++;
      } else {
        missingFields.push(field);
      }
    });

    // if (tender.is_jv_consorium_association_allowed) {
    //     totalChecks++;
    //     if (tender.terms_of_jv) filledChecks++;
    //     else missingFields.push("terms_of_jv");
    // }

    // if (tender.site_apprisate_required) {
    //     totalChecks++;
    //     if (tender.site_apprisate_marking) filledChecks++;
    //     else missingFields.push("site_apprisate_marking");
    // }

    // if (tender.work_methodology_required) {
    //     totalChecks++;
    //     if (tender.work_methodology_marking) filledChecks++;
    //     else missingFields.push("work_methodology_marking");
    // }

    // if (tender.presentation_required) {
    //     totalChecks++;
    //     if (tender.presentation_required_marking) filledChecks++;
    //     else missingFields.push("presentation_required_marking");
    // }
  } else if (toggleState === 3) {
    requiredFields = [
      tender.tender_submission_type === null ? "tender_submission_type" : null,

      tender.bid_prepare_by === null ? "bid_prepare_by" : null,
      tender.bg_prepare_by === null ? "bg_prepare_by" : null,
      "lead_partner_share",
      tender.jv_partner_name != "Not Required" ? "jv_partner_share" : null,
      tender.assosiate_partner != "Not Required"
        ? "associate_partner_share"
        : null,
      "jv_partner_share",
    ].filter(Boolean);

    totalChecks = requiredFields.length;

    requiredFields.forEach((field) => {
      if (
        tender[field] !== undefined &&
        tender[field] !== null &&
        tender[field] !== ""
      ) {
        filledChecks++;
      } else {
        missingFields.push(field);
      }
    });
  } else if (toggleState === 9) {
    requiredFields = [
      tender.all_docs_done === null ? "all_docs_done" : null,
      tender.all_cvs_done === null ? "all_cvs_done" : null,
      tender.checklist === null ? "checklist" : null,
      "tech_score",
      "cv_score",
      tender.team_required === null ? "team_required" : null,
      tender.team_required !== null && tender.team_required
        ? "team_prepare_by"
        : null,
      tender.team_required !== null && tender.team_required
        ? "team_prepare_by_remarks"
        : null,
      tender.team_required !== null && tender.team_required
        ? "team_requirements_details"
        : null,
    ].filter(Boolean);
    totalChecks = requiredFields.length;

    requiredFields.forEach((field) => {
      if (
        tender[field] !== undefined &&
        tender[field] !== null &&
        tender[field] !== ""
      ) {
        filledChecks++;
      } else missingFields.push(field);
    });
  } else {
    return { status: "Unknown", missingFields: [] };
  }

  let status =
    filledChecks === 0
      ? "Incomplete"
      : filledChecks < totalChecks
        ? "Partially Filled"
        : "Completed";

  return { status, missingFields };
}

const StatsCard = ({
  stat,
  index,
  activeCard,
  setActiveCard,
  handleStatClick,
  handleFilterTenderType,
  handleSpecialClick,
  handleTodayClick,
  handleDiscussClick,
}) => {
  const isOpen = activeCard === index;

  const toggleOpen = () => {
    if (isOpen) {
      setActiveCard(null);
      handleStatClick("");
      handleFilterTenderType("");
    } else {
      setActiveCard(index);
      handleFilterTenderType("");

      if (
        stat.sector !== "Special Tender" &&
        stat.sector !== "Today Tender" &&
        stat.sector !== "Discussion Tender"
      ) {
        handleStatClick(
          stat.sector.charAt(0).toUpperCase() +
          stat.sector.slice(1).toLowerCase(),
        );
      } else if (stat.sector === "Special Tender") {
        handleSpecialClick(true);
      } else if (stat.sector === "Discussion Tender") {
        handleDiscussClick(true);
      } else if (stat.sector === "Today Tender") {
        handleTodayClick(true);
      }
    }
  };

  const handleTenderTypeClick = (e, type) => {
    e.stopPropagation();

    const tenderType =
      type === "FEASIBILITY"
        ? "Feasibility"
        : type === "FESIBILITYCUMDPR"
          ? "FesibilityCumDPR"
          : type === "AUTHORITY_ENGINEER"
            ? "Authority_Engineer"
            : type === "INDEPENDENT_ENGINEER"
              ? "Independent_Engineer"
              : type === "OTHER"
                ? "Other"
                : type === "SUPERVISION"
                  ? "Supervision"
                  : type;

    handleFilterTenderType(tenderType);
  };

  return (
    <div
      onClick={toggleOpen}
      style={{
        minWidth: isOpen ? "260px" : "140px",
        maxWidth: isOpen ? "260px" : "140px",
        background: "#fff",
        borderRadius: "10px",
        padding: "10px 12px",
        cursor: "pointer",
        transition: "all 0.3s ease",
        border: isOpen ? "1px solid #0b85d8" : "1px solid #eee",
        boxShadow: isOpen
          ? "0 6px 18px rgba(0,0,0,0.12)"
          : "0 2px 6px rgba(0,0,0,0.06)",
        flexShrink: 0,
      }}
    >
      {/* TOP */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span
          style={{
            fontSize: "13px",
            fontWeight: 500,
            color: "#555",
          }}
        >
          {stat.sector}
        </span>

        <span
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "0.3s",
            display: "flex",
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24">
            <path
              d="M6 9L12 15L18 9"
              stroke="#0b85d8"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>

      {/* COUNT */}
      <div
        style={{
          fontSize: "18px",
          fontWeight: 600,
          marginTop: "4px",
        }}
      >
        {stat.count}
      </div>

      {/* EXPAND */}
      <div
        style={{
          maxHeight: isOpen ? "140px" : "0px",
          overflow: "hidden",
          transition: "all 0.3s ease",
          marginTop: isOpen ? "8px" : "0px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "6px",
          }}
        >
          {Object.entries(stat.tender_type || {}).map(([type, count]) => (
            <div
              key={type}
              onClick={(e) => handleTenderTypeClick(e, type)}
              style={{
                background: "#f5f7fa",
                padding: "4px 6px",
                borderRadius: "5px",
                fontSize: "11px",
                cursor: "pointer",
                display: "flex",
                gap: "4px",
              }}
            >
              <span>{type}</span>
              <span style={{ fontWeight: 600 }}>{count}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const CorrigendumModal = ({
  corriendumModal,
  setCorriendumModal,
  handleHideUpdateModal,
  tenderId,
  getBidData,
  toggleState,
  tenders,
  filters,
  onUpdateSuccess,
  setScrollToTender,
  scrollToTender,
  bgData,
}) => {
  const [selected, setSelected] = useState("date");
  const [corrigendumDate, setCorrigendumDate] = useState(null);
  const currTender = tenders?.find((t) => t.id === tenderId);

  const fieldMeta = {
    tender_id: {
      label: "Tender Id",
      type: "text",
      default: currTender?.tender_id,
    },
    tender_name: {
      label: "Tender Name",
      type: "text",
      default: currTender?.tender_name,
    },
    sector: {
      label: "Sector",
      type: "select",
      options: [
        "Highway",
        "Railway",
        "Metro",
        "Water",
        "Ropeway",
        "Building",
        "Other",
      ],
      default: currTender?.sector,
    },
    tender_type: {
      label: "Tender Type",
      type: "select",
      options: [
        "Feasibility",
        "DPR",
        "FesibilityCumDPR",
        "Authority_Engineer",
        "Independent_Engineer",
        "PSSA",
        "PMC",
        "GC",
        "Other",
      ],
      default: currTender?.tender_type,
    },
    client: { label: "Client", type: "text", default: currTender?.client },
    submission_date: {
      label: "Submission Date",
      type: "date",
      default: currTender?.submission_date,
    },
    publish_date: {
      label: "Publish Date",
      type: "date",
      default: currTender?.publish_date,
    },
    lane: { label: "Lane", type: "char", default: currTender?.lane },
    state: {
      label: "State",
      type: "select",
      options: [
        "Andaman and Nicobar Islands",
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chandigarh",
        "Chhattisgarh",
        "Dadra and Nagar Haveli and Daman and Diu",
        "Delhi",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Ladakh",
        "Lakshadweep",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Puducherry",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
      ],
      default: currTender?.state,
    },
    consultancy_fees: {
      label: "Consultancy Fees ",
      type: "number",
      default: currTender?.consultancy_fees,
    },
    construction_fees: {
      label: "Construction Fees",
      type: "number",
      default: currTender?.construction_fees,
    },
    GST_consultancy: {
      label: "GST on Construction",
      type: "select",
      options: ["Including", "Excluding"],
      default: currTender?.GST_consultancy,
    },
    length: {
      label: "Length (km)",
      type: "number",
      default: currTender?.length,
    },
    duration: {
      label: "Duration (days)",
      type: "char",
      default: currTender?.duration,
    },
    type_of_project: {
      label: "Type of Project",
      type: "text",
      default: currTender?.type_of_project,
    },
    km_cost: {
      label: "Cost per KM",
      type: "number",
      default: currTender?.km_cost,
    },
    remarks: { label: "Remarks", type: "text", default: currTender?.remarks },
  };

  const handleCheckboxChange = (value) => {
    setSelected((prev) => (prev === value ? null : value));
  };

  const [corrigendumFiles, setCorrigendumFiles] = useState([]);

  const handleCorrigendumFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setCorrigendumFiles((prev) => [...prev, ...newFiles]);
    }
  };

  const handleCorrigendumFileRemove = (index) => {
    setCorrigendumFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const [fieldEntries, setFieldEntries] = useState([]);

  const handleAddField = () => {
    const unusedFields = availableFields.filter((f) => !usedKeys.includes(f));
    if (unusedFields.length === 0) return;

    const newField = unusedFields[0];
    const defaultValue = fieldMeta[newField]?.default ?? "";

    setFieldEntries((prev) => [
      ...prev,
      { key: newField, value: defaultValue },
    ]);
  };

  const handleFieldKeyChange = (index, newKey) => {
    const defaultValue = fieldMeta[newKey]?.default ?? "";
    setFieldEntries((prev) => {
      const updated = [...prev];
      updated[index] = { key: newKey, value: defaultValue };
      return updated;
    });
  };

  const handleValueChange = (index, newValue) => {
    const updated = [...fieldEntries];
    updated[index].value = newValue;
    setFieldEntries(updated);
  };

  const handleRemoveField = (index) => {
    const updated = [...fieldEntries];
    updated.splice(index, 1);
    setFieldEntries(updated);
  };

  const usedKeys = fieldEntries.map((f) => f.key);

  const handleCloseModal = () => {
    setFieldEntries([]);
    setCorrigendumFiles([]);
    setCorrigendumDate(null);
    setSelected("date");
    handleHideUpdateModal();
  };

  // ── BG sync helper ──────────────────────────────────────────────────
  // NOTE: `bgData` is a prop populated by the parent, but the parent only
  // fetches it for certain tabs (toggleState 9/5/11/12). If this modal is
  // opened from another tab, `bgData` can be empty/stale and the match
  // below would silently fail. As a safety net, if no match is found in
  // the prop, we fetch BG data directly here before giving up.
  const updateMatchedBgSubmissionDate = async (newDateValue) => {
    if (!currTender?.tender_id) return;
    console.log(bgData)
    let matchedBg = bgData?.find(
      (bg) => bg.tender_id === currTender?.tender_id,
    );

    console.log(matchedBg, "matchedBg", currTender?.tender_id);



    // if (!matchedBg) {
    //   try {
    //     const bgRes = await axios.get(
    //       `${BASE_URL}/siteproject/bgdetailsforbdpost/`,
    //     );
    //     matchedBg = bgRes?.data?.find(
    //       (bg) => bg.tender_id === currTender?.tender_id,
    //     );
    //   } catch (err) {
    //     console.error("Failed to fetch fallback BG data:", err);
    //   }
    // }

    if (!matchedBg) {
      console.warn(
        `No matching BG record found for tender_id: ${currTender?.tender_id}. Skipping BG submission_date sync.`,
      );
      return;
    }

    try {
      await axios.put(
        `${BASE_URL}/siteproject/bgdetailsforbdput/${matchedBg.id}/`,
        { submission_date: formatISTWithOffset(newDateValue) },
        { headers: { "Content-Type": "application/json" } },
      );
    } catch (err) {
      console.error("Failed to update matched BG submission date:", err);
    }
  };

  const handleUpdateDate = async () => {
    if (!selected || (selected.includes("date") && !corrigendumDate)) return;

    try {
      const formData = new FormData();
      formData.append("corrigendum_tender", tenderId);

      corrigendumFiles.forEach((file) => {
        formData.append("document", file);
      });

      const fileNames = corrigendumFiles.map((f) => f.name);
      formData.append("document_name", JSON.stringify(fileNames));

      const otherDetails = [];

      if (selected === "date" || selected === "both") {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const selectedDate = new Date(corrigendumDate);
        selectedDate.setHours(0, 0, 0, 0);

        const isActive = selectedDate >= today;

        otherDetails.push({
          corrigendum_type: selected,
          other_name: "corrigendum_date",
          other_value: formatISTWithOffset(corrigendumDate),
          is_active: isActive,
        });
      }

      if (selected === "other" || selected === "both") {
        fieldEntries.forEach((entry) => {
          otherDetails.push({
            corrigendum_type: selected,
            other_name: entry.key,
            other_value: entry.value,
          });
        });
      }

      formData.append("other_details", JSON.stringify(otherDetails));

      // Step 1: Post corrigendum
      const res = await axios.post(
        `${BASE_URL}/siteproject/bulkcorrengdum/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        const getJsonData = (data) => {
          if (data instanceof FormData) {
            return Object.fromEntries(data.entries());
          }
          return data; // already JSON
        };

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "CorrigendumDocument",
          oldData: {},
          newData: getJsonData(formData),
          action: "CREATE",
          tab_id: toggleState,
        });

        // Step 2: Check if corrigendum response is not null and date is today or future
        const corrigendumResponse = res.data;

        // Tracks whether we've already synced the BG submission_date via one
        // of the response-parsing branches below, so the final fallback
        // (using the raw `corrigendumDate` from local state) only runs when
        // it's actually still needed — instead of being skipped entirely
        // just because we landed in an earlier `else if` branch.
        let bgUpdated = false;

        if (
          corrigendumResponse &&
          Array.isArray(corrigendumResponse) &&
          corrigendumResponse.length > 0
        ) {
          // Find date type corrigendum entries
          const dateCorrigendums = corrigendumResponse.filter(
            (item) =>
              (item.corrigendum_type === "date" ||
                item.corrigendum_type === "both") &&
              item.other_name === "corrigendum_date" &&
              item.other_value,
          );

          for (const dateItem of dateCorrigendums) {
            const corrigendumDateValue = new Date(dateItem.other_value);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            corrigendumDateValue.setHours(0, 0, 0, 0);

            // If corrigendum date is today or in the future, update tender submission_date
            if (corrigendumDateValue >= today) {
              const tenderUpdateData = new FormData();
              tenderUpdateData.append(
                "submission_date",
                formatISTWithOffset(dateItem.other_value),
              );
              tenderUpdateData.append(
                "corrigendum_date",
                dateItem.other_value.slice(0, 10), // YYYY-MM-DD
              );

              await axios.put(
                `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
                tenderUpdateData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                },
              );
              await updateMatchedBgSubmissionDate(dateItem.other_value);
              bgUpdated = true;
              break;
            }
          }
        }

        // If response is a single object (not array)
        else if (
          corrigendumResponse &&
          !Array.isArray(corrigendumResponse) &&
          typeof corrigendumResponse === "object"
        ) {
          const items = corrigendumResponse.other_details || [];

          const dateItem = items.find(
            (item) =>
              (item.corrigendum_type === "date" ||
                item.corrigendum_type === "both") &&
              item.other_name === "corrigendum_date" &&
              item.other_value,
          );

          if (dateItem) {
            const corrigendumDateValue = new Date(dateItem.other_value);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            corrigendumDateValue.setHours(0, 0, 0, 0);

            if (corrigendumDateValue >= today) {
              const tenderUpdateData = new FormData();
              tenderUpdateData.append(
                "submission_date",
                formatISTWithOffset(dateItem.other_value),
              );
              tenderUpdateData.append(
                "corrigendum_date",
                dateItem.other_value.slice(0, 10),
              );

              await axios.put(
                `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
                tenderUpdateData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                },
              );
              await updateMatchedBgSubmissionDate(dateItem.other_value);
              bgUpdated = true;
            }
          }
        }

        // Fallback: use the locally-held corrigendumDate if none of the
        // response-parsing branches above already synced the BG record.
        // This is now an unconditional check (not an `else if`), so it
        // still fires even if we landed in the array/object branch above
        // but that branch didn't find a valid future-dated entry.
        if (
          !bgUpdated &&
          corrigendumDate &&
          (selected === "date" || selected === "both")
        ) {
          const selectedDate = new Date(corrigendumDate);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          selectedDate.setHours(0, 0, 0, 0);

          if (selectedDate >= today) {
            const tenderUpdateData = new FormData();
            tenderUpdateData.append(
              "submission_date",
              formatISTWithOffset(corrigendumDate),
            );
            tenderUpdateData.append(
              "corrigendum_date",
              new Date(corrigendumDate).toISOString().slice(0, 10),
            );

            await axios.put(
              `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
              tenderUpdateData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              },
            );
            await updateMatchedBgSubmissionDate(corrigendumDate);
            bgUpdated = true;
          }
        }

        sessionStorage.setItem("scrollTenderId", currTender?.tender_id);
        await getBidData(filters);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to update corrigendum");
    } finally {
      setCorrigendumDate(null);
      setCorrigendumFiles([]);
      setFieldEntries([]);
      setCorriendumModal(false);
      getBidData(filters);
    }
  };

  const availableFields = Object.keys(fieldMeta);
  const fieldLabels = Object.fromEntries(
    Object.entries(fieldMeta).map(([key, { label }]) => [key, label]),
  );

  return (
    <>
      <Modal
        show={corriendumModal}
        onHide={handleCloseModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Corrigendum</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex-column">
            <div style={{ display: "flex", gap: "20px", marginBottom: "2rem" }}>
              {["date", "other", "both"].map((type) => (
                <label
                  key={type}
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <input
                    type="checkbox"
                    checked={selected === type}
                    onChange={() => handleCheckboxChange(type)}
                  />
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </label>
              ))}
            </div>
            {(selected === "date" || selected === "both") && (
              <>
                <label className="form-labels">
                  Corrigendum Date <span className="required">*</span>
                </label>
                <input
                  type="datetime-local"
                  name="corrigendum_date"
                  value={corrigendumDate}
                  min={new Date().toISOString().slice(0, 16)}
                  onChange={(e) => setCorrigendumDate(e.target.value)}
                  className={`form-input input-form`}
                  style={{ width: "80%" }}
                />
              </>
            )}
            {(selected === "other" || selected === "both") && (
              <div
                style={{
                  padding: "16px",
                  maxWidth: "28rem",
                  margin: "0 auto",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                <h2
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    marginBottom: "1rem",
                  }}
                >
                  Add Other Fields
                </h2>

                {fieldEntries.map((entry, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <select
                      value={entry.key}
                      onChange={(e) =>
                        handleFieldKeyChange(index, e.target.value)
                      }
                      style={{
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                    >
                      <option value="">Select Field</option>
                      {availableFields
                        .filter(
                          (field) =>
                            field === entry.key || !usedKeys.includes(field),
                        )
                        .map((field) => (
                          <option key={field} value={field}>
                            {fieldLabels[field] || field}
                          </option>
                        ))}
                    </select>

                    {(() => {
                      const meta = fieldMeta[entry.key];
                      if (!meta) return null;

                      if (meta.type === "select") {
                        return (
                          <select
                            value={entry.value}
                            onChange={(e) =>
                              handleValueChange(index, e.target.value)
                            }
                            style={{
                              padding: "8px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              flex: 1,
                            }}
                          >
                            <option value="">Select {meta.label}</option>
                            {meta.options.map((opt) => (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </select>
                        );
                      }

                      return (
                        <input
                          type={meta.type}
                          placeholder={`Enter ${meta.label}`}
                          value={entry.value}
                          onChange={(e) =>
                            handleValueChange(index, e.target.value)
                          }
                          style={{
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            flex: 1,
                          }}
                        />
                      );
                    })()}

                    <button
                      onClick={() => handleRemoveField(index)}
                      style={{
                        color: "red",
                        background: "none",
                        border: "none",
                        fontSize: "1.2rem",
                        cursor: "pointer",
                      }}
                    >
                      <CrossRed />
                    </button>
                  </div>
                ))}

                <button
                  onClick={handleAddField}
                  disabled={usedKeys.length >= availableFields.length}
                  style={{
                    backgroundColor: "#3B82F6",
                    color: "white",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <AddwithWhiteCircle /> Add Field
                </button>
              </div>
            )}
          </div>

          <div
            style={{
              width: "100%",
              maxWidth: 480,
              margin: "0",
              background: "#fff",
              borderRadius: 8,
              boxShadow: "0 2px 12px #eee",
              padding: 32,
            }}
          >
            <label
              className="form-labels font-weight500 font-size-subheading"
              style={{
                marginBottom: 12,
                display: "block",
                fontSize: 18,
                fontWeight: 600,
              }}
            >
              Upload Tender Document (File name should be max 400 character)
            </label>
            <input
              type="file"
              multiple
              onChange={handleCorrigendumFileChange}
              style={{ marginBottom: 24, width: "100%" }}
              className="form-control"
            />

            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                width: "100%",
                maxHeight: 180,
                overflowY: "auto",
                border: corrigendumFiles.length ? "1px solid #ececec" : "none",
                borderRadius: 6,
                background: corrigendumFiles.length ? "#fafafd" : "none",
              }}
            >
              {corrigendumFiles.map((file, index) => (
                <li
                  key={file.name}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 8px",
                    borderBottom:
                      index !== corrigendumFiles.length - 1
                        ? "1px solid #ececec"
                        : "none",
                  }}
                >
                  <span
                    style={{
                      flex: 1,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      fill="#6c63ff"
                      style={{ marginRight: 8, verticalAlign: "middle" }}
                    >
                      <rect width="18" height="18" rx="3" />
                    </svg>
                    {file.name}
                  </span>
                  <button
                    onClick={() => handleCorrigendumFileRemove(index)}
                    style={{
                      marginLeft: 16,
                      padding: "4px 12px",
                      backgroundColor: "#ff4e4e",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                      fontWeight: 500,
                      cursor: "pointer",
                      fontSize: 14,
                    }}
                  >
                    Remove
                  </button>
                </li>
              ))}
              {!corrigendumFiles.length && (
                <li style={{ color: "#999", textAlign: "center", padding: 20 }}>
                  No files uploaded
                </li>
              )}
            </ul>
          </div>

          <button
            className="model-button-download model-button font-weight500"
            style={{ marginTop: "20px" }}
            onClick={handleUpdateDate}
            disabled={
              selected === null ||
              (selected.includes("date") && !corrigendumDate) ||
              (selected.includes("other") && fieldEntries.length === 0)
            }
          >
            Update
          </button>

          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              gap: "1rem",
              flexDirection: "column",
            }}
          >
            <label>Logs</label>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontFamily: "Arial, sans-serif",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f2f2f2", textAlign: "left" }}>
                  <th
                    style={{ padding: "12px", borderBottom: "2px solid #ccc" }}
                  >
                    Corrigendum Type
                  </th>
                  <th
                    style={{ padding: "12px", borderBottom: "2px solid #ccc" }}
                  >
                    Changed On
                  </th>
                  <th
                    style={{ padding: "12px", borderBottom: "2px solid #ccc" }}
                  >
                    Name
                  </th>
                  <th
                    style={{ padding: "12px", borderBottom: "2px solid #ccc" }}
                  >
                    Value
                  </th>
                </tr>
              </thead>
              <tbody>
                {currTender?.correigendum_types?.map((entry) => (
                  <tr key={entry.id} style={{ borderBottom: "1px solid #ddd" }}>
                    <td style={{ padding: "10px" }}>
                      {entry.corrigendum_type}
                    </td>
                    <td style={{ padding: "10px" }}>
                      {entry.created_at?.slice(0, 10)}
                    </td>
                    <td style={{ padding: "10px" }}>{entry.other_name}</td>
                    <td style={{ padding: "10px" }}>{entry.other_value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        {/* <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}
      </Modal>
    </>
  );
};

const CorrigendumModalScreening = ({
  corriendumModal,
  setCorriendumModal,
  handleHideUpdateModal,
  tenderId,
  getBidData,
  toggleState,
  tenders,
  filters,
  onUpdateSuccess,
  setScrollToTender,
  scrollToTender,
}) => {
  const [selected, setSelected] = useState("date");
  const [corrigendumDate, setCorrigendumDate] = useState(null);
  const currTender = tenders?.find((t) => t.id === tenderId);

  const fieldMeta = {
    tender_id: {
      label: "Tender Id",
      type: "text",
      default: currTender?.tender_id,
    },
    tender_name: {
      label: "Tender Name",
      type: "text",
      default: currTender?.tender_name,
    },
    sector: {
      label: "Sector",
      type: "select",
      options: [
        "Highway",
        "Railway",
        "Metro",
        "Water",
        "Ropeway",
        "Building",
        "Other",
      ],
      default: currTender?.sector,
    },
    tender_type: {
      label: "Tender Type",
      type: "select",
      options: [
        "Feasibility",
        "DPR",
        "FesibilityCumDPR",
        "Authority_Engineer",
        "Independent_Engineer",
        "PSSA",
        "PMC",
        "GC",
        "Other",
      ],
      default: currTender?.tender_type,
    },
    client: { label: "Client", type: "text", default: currTender?.client },
    submission_date: {
      label: "Submission Date",
      type: "date",
      default: currTender?.submission_date,
    },
    publish_date: {
      label: "Publish Date",
      type: "date",
      default: currTender?.publish_date,
    },
    lane: { label: "Lane", type: "char", default: currTender?.lane },
    state: {
      label: "State",
      type: "select",
      options: [
        "Andaman and Nicobar Islands",
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chandigarh",
        "Chhattisgarh",
        "Dadra and Nagar Haveli and Daman and Diu",
        "Delhi",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Ladakh",
        "Lakshadweep",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Puducherry",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
      ],
      default: currTender?.state,
    },
    consultancy_fees: {
      label: "Consultancy Fees ",
      type: "number",
      default: currTender?.consultancy_fees,
    },
    construction_fees: {
      label: "Construction Fees",
      type: "number",
      default: currTender?.construction_fees,
    },
    GST_consultancy: {
      label: "GST on Construction",
      type: "select",
      options: ["Including", "Excluding"],
      default: currTender?.GST_consultancy,
    },
    length: {
      label: "Length (km)",
      type: "number",
      default: currTender?.length,
    },
    duration: {
      label: "Duration (days)",
      type: "char",
      default: currTender?.duration,
    },
    type_of_project: {
      label: "Type of Project",
      type: "text",
      default: currTender?.type_of_project,
    },
    km_cost: {
      label: "Cost per KM",
      type: "number",
      default: currTender?.km_cost,
    },
    remarks: { label: "Remarks", type: "text", default: currTender?.remarks },
  };

  const handleCheckboxChange = (value) => {
    setSelected((prev) => (prev === value ? null : value));
  };

  const [corrigendumFiles, setCorrigendumFiles] = useState([]);

  const handleCorrigendumFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setCorrigendumFiles((prev) => [...prev, ...newFiles]);
    }
  };

  const handleCorrigendumFileRemove = (index) => {
    setCorrigendumFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const [fieldEntries, setFieldEntries] = useState([]);

  const handleAddField = () => {
    const unusedFields = availableFields.filter((f) => !usedKeys.includes(f));
    if (unusedFields.length === 0) return;

    const newField = unusedFields[0];
    const defaultValue = fieldMeta[newField]?.default ?? "";

    setFieldEntries((prev) => [
      ...prev,
      { key: newField, value: defaultValue },
    ]);
  };

  const handleFieldKeyChange = (index, newKey) => {
    const defaultValue = fieldMeta[newKey]?.default ?? "";
    setFieldEntries((prev) => {
      const updated = [...prev];
      updated[index] = { key: newKey, value: defaultValue };
      return updated;
    });
  };

  const handleValueChange = (index, newValue) => {
    const updated = [...fieldEntries];
    updated[index].value = newValue;
    setFieldEntries(updated);
  };

  const handleRemoveField = (index) => {
    const updated = [...fieldEntries];
    updated.splice(index, 1);
    setFieldEntries(updated);
  };

  const usedKeys = fieldEntries.map((f) => f.key);

  const handleCloseModal = () => {
    setCorrigendumDate(null);

    handleHideUpdateModal();
  };

  const handleUpdateDate = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Removing from discussed...");

    try {
      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
        {
          screening_date: corrigendumDate,
        },
      );
      if (res.status === 200) {
        await getBidData(filters);
        toast.success("Screening Date updated");
        handleHideUpdateModal();
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };
  const availableFields = Object.keys(fieldMeta);
  const fieldLabels = Object.fromEntries(
    Object.entries(fieldMeta).map(([key, { label }]) => [key, label]),
  );

  return (
    <>
      <Modal
        show={corriendumModal}
        onHide={handleCloseModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Screening Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex-column">
            <label className="form-labels">
              Screening Date <span className="required">*</span>
            </label>
            <input
              type="date"
              name="corrigendum_date"
              value={corrigendumDate}
              min={new Date().toISOString().slice(0, 16)}
              onChange={(e) => setCorrigendumDate(e.target.value)}
              className={`form-input input-form`}
              style={{ width: "80%" }}
            />
          </div>

          <button
            className="model-button-download model-button font-weight500"
            style={{ marginTop: "20px" }}
            onClick={handleUpdateDate}
            disabled={
              selected === null ||
              (selected.includes("date") && !corrigendumDate)
            }
          >
            Update
          </button>
        </Modal.Body>
        {/* <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}
      </Modal>
    </>
  );
};

const TenderViewModal = ({
  rpfDocumentList,
  techDocumentList,
  cvDocumentList,
  BidDocumentList,
  financialDocumentList,
  toggleState,
  getBidData,
  filters,
}) => {
  const [show, SetShow] = useState(false);
  const [showfinancial, SetShowfinancial] = useState(false);
  const [showCV, SetShowCv] = useState(false);
  const [showRfp, SetShowRfp] = useState(false);
  const [showBid, SetShowBid] = useState(false);
  const handleShow = () => {
    SetShow(true);
  };

  const handleShowFinancial = () => {
    SetShowfinancial(true);
  };

  const handleShowCv = () => {
    SetShowCv(true);
  };

  const handleShowRfp = () => {
    SetShowRfp(true);
  };

  const handleShowBid = () => {
    SetShowBid(true);
  };

  const handleCloseModal = () => {
    SetShow(false);
  };

  const handleCloseFinancialModal = () => {
    SetShowfinancial(false);
  };

  const handleCloseCvModal = () => {
    SetShowCv(false);
  };

  const handleCloseRfpModal = () => {
    SetShowRfp(false);
  };

  const handleCloseBidModal = () => {
    SetShowBid(false);
  };

  const handleDeleterfp = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/siteproject/rfpdelete/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        SetShow(false);
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // toast.dismiss(loadingToastId);
    }
  };

  const handleDeleteTech = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/siteproject/techdelete/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        SetShow(false);
        // sessionStorage.setItem('scrollTenderId', tenderId);
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // toast.dismiss(loadingToastId);
    }
  };

  const handleDeleteFinancial = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/siteproject/financialdelete/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        SetShow(false);
        // sessionStorage.setItem('scrollTenderId', tenderId);
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // toast.dismiss(loadingToastId);
    }
  };

  const handleDeleteCv = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/siteproject/cvdelete/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        SetShow(false);
        // sessionStorage.setItem('scrollTenderId', tenderId);
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // toast.dismiss(loadingToastId);
    }
  };

  const handleDeleteBid = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/siteproject/biddelete/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        SetShow(false);
        // sessionStorage.setItem('scrollTenderId', tenderId);
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // toast.dismiss(loadingToastId);
    }
  };

  const roleemp = sessionStorage.getItem("sitemanagement_role");

  const allowedRoles = [
    "certificaionadminaccess",
    "CertificationAccess",
    "CertificationAccessDocumentTeamHead",
    "CertificationAccessCvTeamHead",
    "CertificationAccessBd",
    "BdDashboardPrebid",
    "ScreeningTeam",
  ];

  const hasAccess = allowedRoles.includes(roleemp);

  return (
    <>
      <div class="tender-buttons">
        {toggleState === 5 && hasAccess && techDocumentList.length > 0 && (
          <button onClick={handleShow} title="View Tech Tender Documents">
            <DOCIcon size={"27"} />
            <small className="tender-detail-doc-name">Tech</small>
          </button>
        )}

        {toggleState === 5 && hasAccess && financialDocumentList.length > 0 && (
          <button
            onClick={handleShowFinancial}
            title="View Financial Tender Documents"
          >
            <DOCIcon size={"27"} />
            <small className="tender-detail-doc-name">Financial</small>
          </button>
        )}

        {(toggleState === 5 || toggleState === 9) &&
          hasAccess &&
          cvDocumentList.length > 0 && (
            <button onClick={handleShowCv} title="View CV Tender Documents">
              <DOCIcon size={"27"} />
              <small className="tender-detail-doc-name">Cv</small>
            </button>
          )}

        {rpfDocumentList.length === 0 ? (
          ""
        ) : (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="tooltip-rfp" className="rfp-tooltip">
                <div>
                  <b>RFP Documents:</b>
                  <br />
                  {rpfDocumentList.map((doc, index) => (
                    <div key={index}>
                      {index + 1}. {doc.document_name}
                    </div>
                  ))}
                </div>
              </Tooltip>
            }
          >
            <button
              onClick={handleShowRfp}
              className="align-center justify-center"
            >
              <DOCIcon size={"27"} />
              <small className="tender-detail-doc-name">Rfp</small>
            </button>
          </OverlayTrigger>
        )}

        {toggleState === 5 &&
          (BidDocumentList.length === 0 ? (
            ""
          ) : (
            <button onClick={handleShowBid} title="View Bid Tender Documents">
              <DOCIcon size={"27"} />
              <small className="tender-detail-doc-name">Bid</small>
            </button>
          ))}
      </div>

      <Modal
        show={show}
        onHide={handleCloseModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title> Technical Tender Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-overflow" style={{ marginTop: "2rem" }}>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr ">
                  <th className="table-heading-text">S.No.</th>
                  <th className="table-heading-text">Document Name</th>

                  <th className="table-heading-text text-center">Document</th>
                  <th className="table-heading-text text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {techDocumentList.map((doc, docIndex) => (
                  <tr className="custom-table-head-td" key={docIndex}>
                    <td className="table-body">{docIndex + 1}.</td>

                    <td className="table-body">{doc?.document_name}</td>
                    <td className="table-body">
                      {doc.document ? (
                        <a
                          href={doc.document}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="flex-row justify-center">
                            <AttachmentIcon source={doc.document} />
                          </div>
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>

                    <td className="table-body">
                      <button
                        onClick={() => {
                          handleDeleteTech(doc.id);
                        }}
                      >
                        <DeleteDustbinbUTTON />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showfinancial}
        onHide={handleCloseFinancialModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Financial Tender Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-overflow" style={{ marginTop: "2rem" }}>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr ">
                  <th className="table-heading-text">S.No.</th>
                  <th className="table-heading-text">Document Name</th>

                  <th className="table-heading-text text-center">Document</th>
                  <th className="table-heading-text text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {financialDocumentList.map((doc, docIndex) => (
                  <tr className="custom-table-head-td" key={docIndex}>
                    <td className="table-body">{docIndex + 1}.</td>

                    <td className="table-body">{doc?.document_name}</td>
                    <td className="table-body">
                      {doc.document ? (
                        <a
                          href={doc.document}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="flex-row justify-center">
                            <AttachmentIcon source={doc.document} />
                          </div>
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>
                    <td className="table-body">
                      <button
                        onClick={() => {
                          handleDeleteFinancial(doc.id);
                        }}
                      >
                        <DeleteDustbinbUTTON />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCV}
        onHide={handleCloseCvModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Cv Tender Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-overflow" style={{ marginTop: "2rem" }}>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr ">
                  <th className="table-heading-text">S.No.</th>
                  <th className="table-heading-text">Document Name</th>

                  <th className="table-heading-text text-center">Document</th>

                  <th className="table-heading-text text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {cvDocumentList.map((doc, docIndex) => (
                  <tr className="custom-table-head-td" key={docIndex}>
                    <td className="table-body">{docIndex + 1}.</td>

                    <td className="table-body">{doc?.document_name}</td>
                    <td className="table-body">
                      {doc.document ? (
                        <a
                          href={doc.document}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="flex-row justify-center">
                            <AttachmentIcon source={doc.document} />
                          </div>
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>
                    <td className="table-body">
                      <button
                        onClick={() => {
                          handleDeleteCv(doc.id);
                        }}
                      >
                        <DeleteDustbinbUTTON />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showRfp}
        onHide={handleCloseRfpModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Rfp Tender Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-overflow" style={{ marginTop: "2rem" }}>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr ">
                  <th className="table-heading-text">S.No.</th>
                  <th className="table-heading-text">Document Name</th>

                  <th className="table-heading-text text-center">Document</th>

                  <th className="table-heading-text text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {rpfDocumentList.map((doc, docIndex) => (
                  <tr className="custom-table-head-td" key={docIndex}>
                    <td className="table-body">{docIndex + 1}.</td>

                    <td className="table-body">{doc?.document_name}</td>
                    <td className="table-body">
                      {doc.document ? (
                        <a
                          href={doc.document}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="flex-row justify-center">
                            <AttachmentIcon source={doc.document} />
                          </div>
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>
                    <td className="table-body text-center">
                      <button
                        onClick={() => {
                          handleDeleterfp(doc.id);
                        }}
                      >
                        <DeleteDustbinbUTTON />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showBid}
        onHide={handleCloseBidModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Bid Tender Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-overflow" style={{ marginTop: "2rem" }}>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr ">
                  <th className="table-heading-text">S.No.</th>
                  <th className="table-heading-text">Document Name</th>

                  <th className="table-heading-text text-center">Document</th>

                  <th className="table-heading-text text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {BidDocumentList.map((doc, docIndex) => (
                  <tr className="custom-table-head-td" key={docIndex}>
                    <td className="table-body">{docIndex + 1}.</td>

                    <td className="table-body">{doc?.document_name}</td>
                    <td className="table-body">
                      {doc.document ? (
                        <a
                          href={doc.document}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="flex-row justify-center">
                            <AttachmentIcon source={doc.document} />
                          </div>
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>
                    <td className="table-body">
                      <button
                        onClick={() => {
                          handleDeleteBid(doc.id);
                        }}
                      >
                        <DeleteDustbinbUTTON />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        {/* <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}
      </Modal>
    </>
  );
};

const TenderViewAddDocumentModal = ({
  tenderID,
  getBidData,
  toogleState,
  filters,
  i,
}) => {
  const [tenderidscroll, SetTenderIdscroll] = useState("");
  const [rfpFiles, setRfpFiles] = useState([]);
  const [show, setShow] = useState(false);
  const handleRfpFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setRfpFiles((prev) => [...prev, ...newFiles]);
    }
  };

  const handleRemove = (index) => {
    setRfpFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClose = () => {
    setShow(false);
    setDocNames("");
    setRfpFiles([]);
  };

  const handleShow = () => {
    setShow(true);
    SetTenderIdscroll(i.tender_id);
  };

  const [docNames, setDocNames] = useState();

  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      if (rfpFiles.length) {
        try {
          const formData = new FormData();

          rfpFiles.forEach((file) => {
            formData.append("rfp_tender", tenderID);
            formData.append("document_name", file?.name);
            formData.append("document", file);
          });

          const uploadRes = await axios.post(
            `${BASE_URL}/siteproject/bulkrfp/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
          if (uploadRes.status === 200 || uploadRes.status === 201) {
            const rfpFilesJson = rfpFiles.map((file) => ({
              document_name: file.name,
              file_type: file.type,
              file_size: file.size,
            }));

            await saveAudit({
              tenderId: tenderID,
              updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
              tableName: "Rfp",
              oldData: {},
              newData: {
                rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
              },
              action: "CREATE",
            });
          }
        } catch (uploadErr) {
          setRfpFiles([]);
        } finally {
          setRfpFiles([]);
          getBidData(filters);
          sessionStorage.setItem("scrollTenderId", tenderidscroll);
        }
      }

      setShow(false);
      setLoading(false);
      toast.dismiss(loadingToastId);
      handleClose();
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const [cvsDocs, setCvsDocs] = useState([]);
  const [techDocs, setTechDocs] = useState([]);
  const [finacialDocs, setFinancialDocs] = useState([]);
  const [BidDocs, setBidDocs] = useState([]);
  const handleCvsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setCvsDocs(newFiles);
    }
  };

  const handleCvsRemove = (index) => {
    setCvsDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddCvDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      cvsDocs.forEach((file) => {
        formData.append("cv_tender", tenderID);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkcv/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = cvsDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderID,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "Cv",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
          tab_id: toogleState,
        });
      }
    } catch (uploadErr) {
      setCvsDocs([]);
    } finally {
      setCvsDocs([]);
      getBidData(filters);
      sessionStorage.setItem("scrollTenderId", tenderidscroll);
    }
  };

  const handleTechFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setTechDocs(newFiles);
    }
  };

  const handleTechRemove = (index) => {
    setTechDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddTechDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      techDocs.forEach((file) => {
        formData.append("tech_tender", tenderID);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulktech/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = techDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderID,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "TechDocumentBd",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
        });
      }
    } catch (uploadErr) {
      setTechDocs([]);
    } finally {
      setTechDocs([]);
      getBidData(filters);
      sessionStorage.setItem("scrollTenderId", tenderidscroll);
    }
  };

  const handleFinancialFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setFinancialDocs(newFiles);
    }
  };

  const handleFinancialRemove = (index) => {
    setFinancialDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddFinancialDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      finacialDocs.forEach((file) => {
        formData.append("financial_tender", tenderID);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkfinancial/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = finacialDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderID,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "FinancialDocument",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
        });
      }
    } catch (uploadErr) {
      setFinancialDocs([]);
    } finally {
      setFinancialDocs([]);
      getBidData(filters);
      sessionStorage.setItem("scrollTenderId", tenderidscroll);
    }
  };

  const handleBidsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setBidDocs(newFiles);
    }
  };

  const handleBidsRemove = (index) => {
    setBidDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddBidDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      BidDocs.forEach((file) => {
        formData.append("bid_tender", tenderID);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkbbid/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = BidDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderID,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "BidTenderDocument",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
        });
      }
    } catch (uploadErr) {
      setBidDocs([]);
    } finally {
      setBidDocs([]);
      getBidData(filters);
      sessionStorage.setItem("scrollTenderId", tenderidscroll);
    }
  };

  return (
    <>
      <button
        title="Add Tender Documents"
        className="tender-card__action-secondary"

        onClick={handleShow}
      >
        <svg
          className="doc-btn__icon"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7l-6-4zm-7 14h-2v-3H7v-2h3V9h2v3h3v2h-3v3z" />
        </svg> Document
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Add Tender Documents </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Rfp Document (File name should be max 400 character)
              </label>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleRfpFileChange}
                  style={{ marginBottom: 24, width: "100%" }}
                  className="form-control"
                />
                <button
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!rfpFiles.length}
                  onClick={handleSubmit}
                  className="model-button model-button-submit"
                >
                  Add
                </button>
              </div>
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: rfpFiles.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: rfpFiles.length ? "#fafafd" : "none",
                }}
              >
                {rfpFiles.map((file, index) => (
                  <li
                    key={file.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== rfpFiles.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#2576BC"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!rfpFiles.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            {toogleState === 4 && (
              <>
                <div
                  style={{
                    width: "100%",
                    maxWidth: 480,
                    margin: "0 auto",
                    background: "#fff",
                    borderRadius: 8,
                    boxShadow: "0 2px 12px #eee",
                    padding: 32,
                    marginTop: 24,
                  }}
                >
                  <label
                    className="form-labels font-weight500 font-size-subheading"
                    style={{
                      marginBottom: 12,
                      display: "block",
                      fontSize: 18,
                      fontWeight: 600,
                    }}
                  >
                    Upload Tech Proposal (File name should be max 400 character)
                  </label>

                  {/* File Input and Add Button */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 24,
                    }}
                  >
                    <input
                      type="file"
                      multiple
                      onChange={handleTechFileChange}
                      style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                      className="form-control"
                    />
                    <button
                      onClick={handleAddTechDoc}
                      style={{
                        padding: "8px 20px",
                        backgroundColor: "#6c63ff",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: "pointer",
                      }}
                      disabled={!techDocs.length}
                    >
                      Add
                    </button>
                  </div>

                  {/* List of uploaded tech docs */}
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      width: "100%",
                      maxHeight: 180,
                      overflowY: "auto",
                      border: techDocs?.length ? "1px solid #ececec" : "none",
                      borderRadius: 6,
                      background: techDocs?.length ? "#fafafd" : "none",
                    }}
                  >
                    {techDocs?.map((file, index) => (
                      <li
                        key={file.name + index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 8px",
                          borderBottom:
                            index !== techDocs.length - 1
                              ? "1px solid #ececec"
                              : "none",
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            fill="#6c63ff"
                            style={{ marginRight: 8, verticalAlign: "middle" }}
                          >
                            <rect width="18" height="18" rx="3" />
                          </svg>
                          {file.name}
                        </span>
                        <button
                          onClick={() => handleTechRemove(index)}
                          style={{
                            marginLeft: 16,
                            padding: "4px 12px",
                            backgroundColor: "#ff4e4e",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            fontWeight: 500,
                            cursor: "pointer",
                            fontSize: 14,
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                    {!techDocs?.length && (
                      <li
                        style={{
                          color: "#999",
                          textAlign: "center",
                          padding: 20,
                        }}
                      >
                        No files uploaded
                      </li>
                    )}
                  </ul>
                </div>
                <div
                  style={{
                    width: "100%",
                    maxWidth: 480,
                    margin: "0 auto",
                    background: "#fff",
                    borderRadius: 8,
                    boxShadow: "0 2px 12px #eee",
                    padding: 32,
                    marginTop: 24,
                  }}
                >
                  <label
                    className="form-labels font-weight500 font-size-subheading"
                    style={{
                      marginBottom: 12,
                      display: "block",
                      fontSize: 18,
                      fontWeight: 600,
                    }}
                  >
                    Upload Financial Proposal (File name should be max 400
                    character)
                  </label>

                  {/* File Input and Add Button */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 24,
                    }}
                  >
                    <input
                      type="file"
                      multiple
                      onChange={handleFinancialFileChange}
                      style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                      className="form-control"
                    />
                    <button
                      onClick={handleAddFinancialDoc}
                      style={{
                        padding: "8px 20px",
                        backgroundColor: "#6c63ff",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: "pointer",
                      }}
                      disabled={!finacialDocs.length}
                    >
                      Add
                    </button>
                  </div>

                  {/* List of uploaded tech docs */}
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      width: "100%",
                      maxHeight: 180,
                      overflowY: "auto",
                      border: finacialDocs?.length
                        ? "1px solid #ececec"
                        : "none",
                      borderRadius: 6,
                      background: finacialDocs?.length ? "#fafafd" : "none",
                    }}
                  >
                    {finacialDocs?.map((file, index) => (
                      <li
                        key={file.name + index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 8px",
                          borderBottom:
                            index !== finacialDocs.length - 1
                              ? "1px solid #ececec"
                              : "none",
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            fill="#6c63ff"
                            style={{ marginRight: 8, verticalAlign: "middle" }}
                          >
                            <rect width="18" height="18" rx="3" />
                          </svg>
                          {file.name}
                        </span>
                        <button
                          onClick={() => handleFinancialRemove(index)}
                          style={{
                            marginLeft: 16,
                            padding: "4px 12px",
                            backgroundColor: "#ff4e4e",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            fontWeight: 500,
                            cursor: "pointer",
                            fontSize: 14,
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                    {!finacialDocs?.length && (
                      <li
                        style={{
                          color: "#999",
                          textAlign: "center",
                          padding: 20,
                        }}
                      >
                        No files uploaded
                      </li>
                    )}
                  </ul>
                </div>
                <div
                  style={{
                    width: "100%",
                    maxWidth: 480,
                    margin: "0 auto",
                    background: "#fff",
                    borderRadius: 8,
                    boxShadow: "0 2px 12px #eee",
                    padding: 32,
                    marginTop: 24,
                  }}
                >
                  <label
                    className="form-labels font-weight500 font-size-subheading"
                    style={{
                      marginBottom: 12,
                      display: "block",
                      fontSize: 18,
                      fontWeight: 600,
                    }}
                  >
                    Upload CV's (File name should be max 400 character)
                  </label>

                  {/* File Input and Add Button */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 24,
                    }}
                  >
                    <input
                      type="file"
                      multiple
                      onChange={handleCvsFileChange}
                      style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                      className="form-control"
                    />
                    <button
                      onClick={handleAddCvDoc}
                      style={{
                        padding: "8px 20px",
                        backgroundColor: "#6c63ff",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: "pointer",
                      }}
                      disabled={!cvsDocs.length}
                    >
                      Add
                    </button>
                  </div>

                  {/* List of uploaded tech docs */}
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      width: "100%",
                      maxHeight: 180,
                      overflowY: "auto",
                      border: cvsDocs?.length ? "1px solid #ececec" : "none",
                      borderRadius: 6,
                      background: cvsDocs?.length ? "#fafafd" : "none",
                    }}
                  >
                    {cvsDocs?.map((file, index) => (
                      <li
                        key={file.name + index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 8px",
                          borderBottom:
                            index !== cvsDocs.length - 1
                              ? "1px solid #ececec"
                              : "none",
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            fill="#6c63ff"
                            style={{ marginRight: 8, verticalAlign: "middle" }}
                          >
                            <rect width="18" height="18" rx="3" />
                          </svg>
                          {file.name}
                        </span>
                        <button
                          onClick={() => handleCvsRemove(index)}
                          style={{
                            marginLeft: 16,
                            padding: "4px 12px",
                            backgroundColor: "#ff4e4e",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            fontWeight: 500,
                            cursor: "pointer",
                            fontSize: 14,
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                    {!cvsDocs?.length && (
                      <li
                        style={{
                          color: "#999",
                          textAlign: "center",
                          padding: 20,
                        }}
                      >
                        No files uploaded
                      </li>
                    )}
                  </ul>
                </div>
              </>
            )}
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Bid Acknowledgemnet (File name should be max 400
                character)
              </label>

              {/* File Input and Add Button */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleBidsFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddBidDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!BidDocs.length}
                >
                  Add
                </button>
              </div>

              {/* List of uploaded tech docs */}
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: BidDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: BidDocs?.length ? "#fafafd" : "none",
                }}
              >
                {BidDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== cvsDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleBidsRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!BidDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
          </div>

          {/* <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          /> */}
        </Modal.Body>
      </Modal>
    </>
  );
};

const TenderAddPresentationfiles = ({
  tenderID,
  getBidData,
  toogleState,
  filters,
  i,
}) => {
  const [tenderidscroll, SetTenderIdscroll] = useState("");
  const [presntation, setPresnatationFiles] = useState([]);
  const [show, setShow] = useState(false);
  const handleRfpFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setPresnatationFiles((prev) => [...prev, ...newFiles]);
    }
  };

  const handleRemove = (index) => {
    setPresnatationFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClose = () => {
    setShow(false);
    setDocNames("");
    setPresnatationFiles([]);
  };

  const handleShow = () => {
    setShow(true);
    SetTenderIdscroll(i.tender_id);
  };

  const [docNames, setDocNames] = useState();

  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      if (presntation.length) {
        try {
          const formData = new FormData();

          presntation.forEach((file) => {
            formData.append("rfp_tender", tenderID);
            formData.append("document_name", file?.name);
            formData.append("document", file);
          });

          const uploadRes = await axios.post(
            `${BASE_URL}/siteproject/bulkpresentation/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
          // formData.append("presentation_submitted", true);
          if (uploadRes.status === 200 || uploadRes.status === 201) {
            const rfpFilesJson = presntation.map((file) => ({
              document_name: file.name,
              file_type: file.type,
              file_size: file.size,
            }));

            await saveAudit({
              tenderId: tenderID,
              updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
              tableName: "Presentation",
              oldData: {},
              newData: {
                presntation_documents: rfpFilesJson, // ✅ clean JSON for audit
              },
              action: "CREATE",
              tab_id: toogleState,
            });
          }
        } catch (uploadErr) {
          setPresnatationFiles([]);
        } finally {
          setPresnatationFiles([]);
          getBidData(filters);
          sessionStorage.setItem("scrollTenderId", tenderidscroll);
        }
      }

      setShow(false);
      setLoading(false);
      toast.dismiss(loadingToastId);
      handleClose();
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Add Tender Documents"
        // className="jd-heading-bottom-bold "
        style={{ color: "#2576bc" }}
        onClick={handleShow}
      >
        <AddwithBlueCircle /> <u>Submit Presentation</u>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>
            Add Presntation Documents and Submit Presentation{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Presentation Document (File name should be max 400
                character)
              </label>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleRfpFileChange}
                  style={{ marginBottom: 24, width: "100%" }}
                  className="form-control"
                />
                <button
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!presntation.length}
                  onClick={handleSubmit}
                  className="model-button model-button-submit"
                >
                  Add
                </button>
              </div>
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: presntation.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: presntation.length ? "#fafafd" : "none",
                }}
              >
                {presntation.map((file, index) => (
                  <li
                    key={file.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== presntation.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#2576BC"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!presntation.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
          </div>

          {/* <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          /> */}
        </Modal.Body>
      </Modal>
    </>
  );
};

const TenderViewModalPresnatation = ({
  presentationDocumentList,

  toggleState,
  getBidData,
  filters,
}) => {
  const [show, SetShow] = useState(false);

  const [showPresenation, SetShowPresentation] = useState(false);

  const handleShow = () => {
    SetShow(true);
  };

  const handleShowPresentation = () => {
    SetShowPresentation(true);
  };

  const handleClosePresentationModal = () => {
    SetShowPresentation(false);
  };

  const handleDeletePresenation = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/siteproject/presentationdelete/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        SetShow(false);
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // toast.dismiss(loadingToastId);
    }
  };

  const roleemp = sessionStorage.getItem("sitemanagement_role");
  return (
    <>
      <div class="tender-buttons">
        {presentationDocumentList != undefined ? (
          presentationDocumentList.length === 0 ? (
            ""
          ) : (
            <button
              onClick={handleShowPresentation}
              title="View Tech Tender Documents"
            >
              <DOCIcon size={"27"} />
              <small className="tender-detail-doc-name">Presentation</small>
            </button>
          )
        ) : (
          ""
        )}
        {/* {
                    (presentationDocumentList != undefined && presentationDocumentList.length === 0 ? (
                        ""
                    ) : (
                        <button onClick={handleShowPresentation} title="View Tech Tender Documents">
                            <DOCIcon size={"27"} />
                            <small className="tender-detail-doc-name">Presentation</small>
                        </button>
                    ))} */}
      </div>

      <Modal
        show={showPresenation}
        onHide={handleClosePresentationModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title> Presentation Tender Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-overflow" style={{ marginTop: "2rem" }}>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr ">
                  <th className="table-heading-text">S.No.</th>
                  <th className="table-heading-text">Document Name</th>

                  <th className="table-heading-text text-center">Document</th>
                  <th className="table-heading-text text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {presentationDocumentList?.map((doc, docIndex) => (
                  <tr className="custom-table-head-td" key={docIndex}>
                    <td className="table-body">{docIndex + 1}.</td>

                    <td className="table-body">{doc?.document_name}</td>
                    <td className="table-body">
                      {doc.document ? (
                        <a
                          href={doc.document}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="flex-row justify-center">
                            <AttachmentIcon source={doc.document} />
                          </div>
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>

                    <td className="table-body">
                      <button
                        onClick={() => {
                          handleDeletePresenation(doc.id);
                        }}
                      >
                        <DeleteDustbinbUTTON />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const TenderViewAddSingleNoteModal = ({ i, tenderID, getBidData, filters }) => {
  const [show, setShow] = useState(false);
  const [tenderidscroll, SetTenderIdscroll] = useState("");
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState({ title: "", detail: "" });
  const [buffering, setBuffering] = useState(false);

  const handleClose = () => {
    setShow(false);
    setNewNote({ title: "", detail: "" });
  };

  const handleShow = () => {
    setShow(true);
    SetTenderIdscroll(i?.tender_id);
  };

  const handleAddNote = async () => {
    if (!newNote.title.trim() || !newNote.detail.trim()) {
      toast.error("Please fill both Title and Detail!");
      return;
    }

    const payload = {
      tender_id: tenderID,
      employee_id: sessionStorage.getItem("sitemanagement_emp_id"),
      emp_code: sessionStorage.getItem("sitemanagement_emp_code"),
      description: newNote,
    };

    const loadingToastId = toast.loading("Saving note...");

    try {
      await axios.post(`${BASE_URL}/siteproject/notes/`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success("Note saved successfully!");
      setNewNote({ title: "", detail: "" });
      sessionStorage.setItem("scrollTenderId", tenderidscroll);
      getBidData(filters);
      handleClose();
    } catch (err) {
      toast.error("Failed to save note!");
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const getNotesData = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/notesfilterbytender/${tenderID}/`,
      );
      if (res?.data) {
        setNotes(res.data);
      } else {
        setNotes([]);
      }
    } catch (err) {
      console.error("Error fetching notes:", err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (show) {
      getNotesData();
    }
  }, [show]);

  return (
    <>
      <button
        title="Add Note"
        className="tender-card__action-secondary"
        onClick={handleShow}
      >
        <svg
          className="doc-btn__icon"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7l-6-4zm-7 14h-2v-3H7v-2h3V9h2v3h3v2h-3v3z" />
        </svg> Note
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Add Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {/* Note Title Input */}
            <div className="flex-column">
              <label className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                Title<span className="required">*</span>
              </label>
              <input
                type="text"
                value={newNote.title}
                onChange={(e) =>
                  setNewNote((prev) => ({ ...prev, title: e.target.value }))
                }
                placeholder="Enter note title"
                className="form-input"
              />
            </div>

            {/* Note Detail Input */}
            <div className="flex-column">
              <label className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                Detail<span className="required">*</span>
              </label>
              <textarea
                rows="4"
                value={newNote.detail}
                onChange={(e) =>
                  setNewNote((prev) => ({ ...prev, detail: e.target.value }))
                }
                placeholder="Enter note details"
                className="form-input-textarea"
              />
            </div>

            {/* Add Button */}
            {/* <div style={{ display: "flex", justifyContent: "flex-end" }}> */}
            <div className="button-models">
              <button
                onClick={handleAddNote}
                disabled={!newNote.title.trim() || !newNote.detail.trim()}
                className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                style={{
                  //     padding: '10px 24px',
                  backgroundColor:
                    !newNote.title.trim() || !newNote.detail.trim()
                      ? "#ccc"
                      : "#2576bc",
                  //     color: "#fff",
                  //     border: "none",
                  //     borderRadius: "6px",
                  //     fontWeight: 600,
                  //     fontSize: "15px",
                  cursor:
                    !newNote.title.trim() || !newNote.detail.trim()
                      ? "not-allowed"
                      : "pointer",
                  //     transition: "background-color 0.2s"
                }}
              >
                Add Note
              </button>
            </div>
          </div>

          {/* Existing Notes Section */}
          {notes.length > 0 && (
            <div
              style={{
                width: "100%",
                // maxWidth: 480,
                // margin: '32px auto 0',
                // background: '#fff',
                // borderRadius: 8,
                // boxShadow: '0 2px 12px #eee',
                // padding: 32
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 16,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Existing Notes ({notes.length})
              </label>

              <ol
                style={{
                  maxHeight: 300,
                  overflowY: "auto",
                  border: "1px solid #ececec",
                  borderRadius: 6,
                  background: "#fafafd",
                }}
              >
                {notes.map((note, index) => (
                  <li
                    key={index}
                    style={{
                      padding: "16px",
                      borderBottom:
                        index !== notes.length - 1
                          ? "1px solid #ececec"
                          : "none",
                      background: "#fff",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginBottom: 8,
                      }}
                    >
                      <strong
                        style={{
                          color: "#333",
                          fontSize: "15px",
                          flex: 1,
                        }}
                      >
                        {note?.description?.title}
                      </strong>
                    </div>
                    <p
                      style={{
                        margin: 0,
                        color: "#666",
                        fontSize: "14px",
                        lineHeight: "1.4",
                      }}
                    >
                      {note?.description?.detail}
                    </p>
                  </li>
                ))}
              </ol>
            </div>
          )}
        </Modal.Body>
        {/* <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}
      </Modal>
    </>
  );
};

const TenderViewSingleNote = ({
  noteIndex,
  noteData,
  tenderID,
  onNotesUpdated,
  getBidData,
  filters,
  notesId,
}) => {
  const [show, setShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [buffering, setBuffering] = useState(false);
  const [editedNote, setEditedNote] = useState({
    title: noteData?.title || "",
    detail: noteData?.detail || "",
  });

  const handleClose = () => {
    setShow(false);
    setEditMode(false);
  };
  const handleShow = () => setShow(true);

  const handleEdit = () => setEditMode(true);

  const handleDelete = async () => {
    try {
      setBuffering(true);
      const res = await axios.delete(
        `${BASE_URL}/siteproject/notesupdate/${notesId}/`,
      );
      if (res.status === 204 || res.status === 200) {
        toast.success("Note deleted successfully!");
        handleClose();
        await getBidData(filters);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setBuffering(false);
    }
  };

  const handleSaveEdit = async () => {
    try {
      setBuffering(true);
      const payload = {
        description: {
          title: editedNote.title,
          detail: editedNote.detail,
        },
      };
      const res = await axios.put(
        `${BASE_URL}/siteproject/notesupdate/${notesId}/`,
        payload,
      );
      if (res.status === 200) {
        toast.success("Note updated successfully!");
        setEditMode(false);
        setEditedNote({
          title: "",
          detail: "",
        });
        await getBidData(filters);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setBuffering(false);
    }
  };

  return (
    <>
      {/* ============================
                NOTE BUTTON WITH HOVER TOOLTIP
            ============================= */}
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`note-tooltip-${noteIndex}`} className="note-tooltip">
            <div style={{ textAlign: "left" }}>
              <b>Title:</b> {noteData?.title || "No Title"} <br />
              <b>Details:</b> {noteData?.detail || "No Details"}
            </div>
          </Tooltip>
        }
      >
        <button
          title="View Note"
          style={{ color: "#2576bc" }}
          onClick={handleShow}
          className="align-center justify-center"
        >
          <Notes />
          <small className="tender-detail-doc-name">Note {noteIndex}</small>
        </button>
      </OverlayTrigger>

      {/* ============================
                MODAL
            ============================= */}
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>{editMode ? "Edit Note" : "Note Details"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {editMode ? (
            <form>
              <div className="mb-3">
                <label>
                  <b>Title</b>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter note title"
                  value={editedNote.title}
                  onChange={(e) =>
                    setEditedNote({ ...editedNote, title: e.target.value })
                  }
                />
              </div>
              <div className="mb-3">
                <label>
                  <b>Details</b>
                </label>
                <textarea
                  rows="4"
                  className="form-control"
                  placeholder="Enter note details"
                  value={editedNote.detail}
                  onChange={(e) =>
                    setEditedNote({ ...editedNote, detail: e.target.value })
                  }
                />
              </div>
            </form>
          ) : (
            <div style={{ padding: "10px" }}>
              <p>
                <b>Title:</b> {noteData?.title}
              </p>
              <p>
                <b>Details:</b> {noteData?.detail}
              </p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          {editMode ? (
            <>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setEditMode(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSaveEdit}
                disabled={buffering}
              >
                {buffering ? "Saving..." : "Save"}
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDelete}
                disabled={buffering}
              >
                {buffering ? "Deleting..." : "Delete"}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleEdit}
              >
                Edit
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>
            </>
          )}
        </Modal.Footer>

        {/* <ToastContainer
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}
      </Modal>
    </>
  );
};

const TenderViewNotes = ({ tenderID, existingNotes }) => {
  const [show, setShow] = useState(false);
  const [notes, setNotes] = useState([]);
  const [buffering, setBuffering] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getNotesData = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/notesfilterbytender/${tenderID}/`,
      );
      if (res?.data) {
        setNotes(res.data);
      } else {
        setNotes([]);
      }
    } catch (err) {
      console.error("Error fetching notes:", err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (show) {
      getNotesData();
    }
  }, [show]);

  return (
    <>
      <button
        title="View All Note"
        style={{ color: "#2576bc" }}
        onClick={handleShow}
        className="flex-row justify-between"
      >
        <div>
          <u>View All</u>
        </div>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title className="flex-row">
            Tender Notes ({notes.length})
            {buffering ? (
              <div className="align-center justify-center">
                <div className="spinner-vsmall"></div>
              </div>
            ) : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // notes.length > 0 && (
            <div>
              <ol
                style={{
                  maxHeight: 300,
                  overflowY: "auto",
                  border: "1px solid #ececec",
                  borderRadius: 6,
                  background: "#fafafd",
                }}
              >
                {notes.map((note, index) => (
                  <li
                    key={index}
                    style={{
                      padding: "16px",
                      borderBottom:
                        index !== notes.length - 1
                          ? "1px solid #ececec"
                          : "none",
                      background: "#fff",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginBottom: 8,
                      }}
                    >
                      <strong
                        style={{
                          color: "#333",
                          fontSize: "15px",
                          flex: 1,
                        }}
                      >
                        {note?.description?.title}
                      </strong>
                    </div>
                    <p
                      style={{
                        margin: 0,
                        color: "#666",
                        fontSize: "14px",
                        lineHeight: "1.4",
                      }}
                    >
                      {note?.description?.detail}
                    </p>
                  </li>
                ))}
              </ol>
            </div>
            // )
          }
        </Modal.Body>

        {/* <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}
      </Modal>
    </>
  );
};
const TenderViewAddNotes = ({ tenderID }) => {
  const [show, setShow] = useState(false);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState({ title: "", detail: "" });
  const [showInput, setShowInput] = useState(false);

  const handleClose = () => {
    setShow(false);
    setNotes([]);
    setNewNote({ title: "", detail: "" });
    setShowInput(false);
  };
  const [buffering, setBuffering] = useState(false);

  const handleShow = () => setShow(true);

  const handleAddNote = () => {
    if (newNote.title.trim() && newNote.detail.trim()) {
      setNotes((prev) => [...prev, newNote]);
      setNewNote({ title: "", detail: "" });
      setShowInput(false);
    } else {
      toast.error("Please fill both Title and Detail!");
    }
  };

  const handleRemoveNote = (index) => {
    setNotes((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    if (!notes.length) {
      toast.error("Please add at least one note!");
      return;
    }

    const payload = {
      tender_id: tenderID,
      employee_id: sessionStorage.getItem("sitemanagement_emp_id"),
      description: notes,
    };

    const loadingToastId = toast.loading("Saving notes...");

    try {
      await axios.post(`${BASE_URL}/siteproject/notes/`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success("Notes saved successfully!");

      handleClose();
    } catch (err) {
      toast.error("Failed to save notes!");
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const getNotesdata = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/notesfilterbytender/${tenderID}/`,
      );

      if (res?.data[0]?.description) {
        setNotes(res?.data[0].description);
      } else {
        setNotes([]);
      }
    } catch (err) {
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (show) {
      getNotesdata();
    }
  }, [show]);

  return (
    <>
      {/* <button
                onClick={show ? handleClose : handleShow}

                title="Add Notes"
                style={{ fontSize: '38px' }}
            >
                📝
            </button> */}
      <button
        onClick={show ? handleClose : handleShow}
        title="Add Notes"
        className="flex-column "
      >
        <Notes />
        <small className="tender-detail-doc-name">Note</small>
      </button>

      {show && (
        <div
          style={{
            position: "fixed",
            bottom: "100px",
            right: "20px",
            width: "340px",
            background: "#fffbea",
            border: "1px solid #f1c40f",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
            zIndex: 999,
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {" "}
            <h4
              style={{ marginBottom: "12px", fontSize: "18px", color: "#444" }}
            >
              Add Notes
            </h4>
            <button onClick={handleClose} title="Add Notes">
              ✖
            </button>
          </div>

          {!showInput && (
            <button
              onClick={() => setShowInput(true)}
              style={{
                width: "100%",
                marginTop: "10px",
                background: "#f1c40f",
                border: "none",
                borderRadius: "6px",
                padding: "8px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              ➕ Add Note
            </button>
          )}

          {showInput && (
            <div style={{ marginTop: "10px" }}>
              <input
                type="text"
                value={newNote.title}
                onChange={(e) =>
                  setNewNote((prev) => ({ ...prev, title: e.target.value }))
                }
                placeholder="Note Title"
                style={{
                  width: "100%",
                  marginBottom: "8px",
                  padding: "6px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />
              <textarea
                rows="2"
                value={newNote.detail}
                onChange={(e) =>
                  setNewNote((prev) => ({ ...prev, detail: e.target.value }))
                }
                placeholder="Note Detail"
                style={{
                  width: "100%",
                  marginBottom: "8px",
                  padding: "6px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  resize: "none",
                }}
              />
              <div style={{ display: "flex", gap: "8px" }}>
                <button
                  onClick={handleAddNote}
                  style={{
                    flex: 1,
                    background: "#2ecc71",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    padding: "6px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Save
                </button>
                <button
                  onClick={() => {
                    setNewNote({ title: "", detail: "" });
                    setShowInput(false);
                  }}
                  style={{
                    flex: 1,
                    background: "#e74c3c",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    padding: "6px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}

          <ul style={{ listStyle: "none", padding: 0, margin: "10px 0" }}>
            {notes.map((note, index) => (
              <li
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  background: "#fff9c4",
                  padding: "8px",
                  marginBottom: "6px",
                  borderRadius: "6px",
                  fontSize: "13px",
                }}
              >
                <div>
                  <strong>{note.title}</strong>
                  <p style={{ margin: "4px 0 0", fontSize: "12px" }}>
                    {note.detail}
                  </p>
                </div>
                {/* <button
                                    onClick={() => handleRemoveNote(index)}
                                    style={{
                                        marginLeft: 8,
                                        padding: "2px 6px",
                                        background: "#ff4e4e",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        fontSize: "12px",
                                    }}
                                >
                                    ✖
                                </button> */}
              </li>
            ))}
          </ul>

          <button
            onClick={handleSubmit}
            style={{
              marginTop: "12px",
              width: "100%",
              background: "#f39c12",
              border: "none",
              borderRadius: "6px",
              padding: "8px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Submit
          </button>
        </div>
      )}
      {/* <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
    </>
  );
};

const TenderViewAddBidders = ({ bidders }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => setShow(true);

  useEffect(() => {
    if (show) {
    }
  }, [show]);

  return (
    <>
      <button
        onClick={show ? handleClose : handleShow}
        title="View Bidders"
        className="flex-column "
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          role="img"
          aria-label="Bidder"
        >
          <path
            fill="rgb(37,118,188)"
            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zM4 20v-1c0-2.21 3.58-4 8-4s8 1.79 8 4v1H4z"
          />
        </svg>
        <small className="tender-detail-doc-name">Bidders</small>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Bidders List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table
            className="modern-table"
            style={{ borderRadius: "15px", overflow: "hidden", width: "100%" }}
          >
            <thead>
              <tr>
                <th style={{ width: "80px" }}>S.No</th>
                <th>Bidder Name</th>
              </tr>
            </thead>
            <tbody>
              {bidders?.map((bidder, index) => (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td>{bidder.bidder_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
      </Modal>
    </>
  );
};


const EditTenderInfo = ({
  showEditModal,
  handleCloseEditModal,
  toggleState,
  tenders,
  tenderId,
  getBidData,
  editTenderData,
  showModal,
  filters,
  roleemp,
  bgData,
  initialTab,
}) => {
  const TABS = [
    { key: "eligibility", label: "Eligibility Criteria", minToggle: 3 },
    { key: "partners", label: "Finalize Partners", minToggle: 4 },
    { key: "documents", label: "Attach Tender Documents", minToggle: 5 },
  ];

  const tender = useMemo(() => {
    return tenders?.find((t) => t.id === tenderId) ?? {};
  }, [tenders, tenderId]);

  const filteredTabs = useMemo(() => {
    return TABS.filter(
      (tab) =>
        toggleState >= tab.minToggle &&
        !(toggleState === 9 && tab.key === "documents"),
    );
  }, [toggleState]);
  const [activeTab, setActiveTab] = useState(() => {
    if (initialTab && filteredTabs.find((tab) => tab.key === initialTab)) {
      return initialTab;
    }
    return filteredTabs.length > 0 ? filteredTabs[0].key : null;
  });
  useEffect(() => {
    if (showEditModal) {
      if (initialTab && filteredTabs.find((tab) => tab.key === initialTab)) {
        setActiveTab(initialTab);
      } else if (filteredTabs.length > 0) {
        setActiveTab(filteredTabs[0].key);
      }
    }
  }, [showEditModal, initialTab]);

  useEffect(() => {
    const tabExists = filteredTabs.find((tab) => tab.key === activeTab);
    if (!tabExists) {
      const newActive = filteredTabs.length > 0 ? filteredTabs[0].key : null;
      if (newActive !== activeTab) {
        setActiveTab(newActive);
      }
    }
  }, [toggleState, activeTab, filteredTabs]);

  const [tenderDocumentsData, setTenderDocumentsData] = useState({
    checklist: tender.checklist ?? false,
    all_docs_done: tender.all_docs_done ?? false,
    tech_score: tender.tech_score ?? "",
    cv_score: tender.cv_score ?? "",
    tech_doc: tender.tech_doc ?? [],
    financial_doc: tender.financial_doc ?? [],
    cvs_files: tender.cv_doc ?? [],
    bid_doc: tender.bid_doc ?? [],
    bidder_doc: tender.bidder_doc ?? [],
    all_cvs_done: tender.all_cvs_done ?? false,
    bidders: tender.tender_bidders ?? [],
    bidder_name: {
      value: "",
      laoding: false,
    },
  });

  const [finalizePartnersData, setFinalizePartnersData] = useState({
    lead_partner: tender.lead_partner
      ? tender.lead_partner
      : tender.lead_qualify
        ? tender.company_name
        : "",
    lead_partner_share: tender.lead_partner_share ?? "",
    partner_share_sum: 0,
    jv_partner_share: tender.jv_partner_share ?? "",
    jv_partner_name:
      tender.soil_quality === true
        ? "Not Required"
        : tender.jv_partner_name
          ? tender.jv_partner_name
          : tender.jv_qualify
            ? tender.company_name
            : "",
    assosiate_partner:
      tender.soil_quality === true
        ? "Not Required"
        : tender.assosiate_partner
          ? tender.assosiate_partner
          : tender.associate_qualify
            ? tender.company_name
            : "",
    associate_partner_share: tender.associate_partner_share ?? "",
    bg_requried: tender.bg_requried,
    bg_amount: tender.bg_amount ?? 0,
    bg_prepare_by: tender.bg_prepare_by ?? "",
    bid_prepare_by: tender.bid_prepare_by ?? "",
    bid_prepare_by_remarks: tender.bid_prepare_by_remarks ?? "",
    // emd_assumpter: tender.emd_assumpter,

    bg_type: tender.bg_type ?? "",

    tender_submission_type: tender.tender_submission_type ?? "",

    team_required: tender.team_required,
    team_requirements_details: tender.team_requirements_details ?? "",
    team_prepare_by: tender.team_prepare_by,
    team_prepare_by_remarks: tender.team_prepare_by_remarks,
  });

  const [eligibilityCriteriaData, setEligibilityCriteriaData] = useState({
    eligibity_criteria: tender?.eligibity_criteria ?? "",
    eligibity_criteria_special: tender?.eligibity_criteria_special ?? "",
    is_jv_allowed: tender?.is_jv_allowed ?? false,
    is_jv_consorium_association_allowed:
      tender?.is_jv_consorium_association_allowed ?? false,
    company_name: tender?.company_name ?? "",
    company_dist_lead: tender?.company_dist_lead,
    company_dist_jv: tender?.company_dist_jv,
    soil_quality: tender?.soil_quality ?? false,
    participating_as: tender?.participating_as ?? "",
    terms_of_jv: tender?.terms_of_jv ?? "",
    tech_score: tender?.tech_score ?? "",
    company_score: tender?.company_score ?? "",
    site_apprisate_required: tender?.site_apprisate_required ?? false,
    site_apprisate_marking: tender?.site_apprisate_marking ?? "",
    work_methodology_required: tender?.work_methodology_required ?? false,
    work_methodology_marking: tender?.work_methodology_marking ?? "",
    presentation_required: tender?.presentation_required ?? false,
    presentation_type: tender?.presentation_type ?? "",
    presentation_required_marking: tender?.presentation_required_marking ?? "",
  });

  useEffect(() => {
    if (tender) {
      setEligibilityCriteriaData({
        eligibity_criteria: tender?.eligibity_criteria ?? "",
        eligibity_criteria_special: tender?.eligibity_criteria_special ?? "",
        is_jv_allowed: tender?.is_jv_allowed ?? false,
        is_jv_consorium_association_allowed:
          tender?.is_jv_consorium_association_allowed ?? false,
        company_name: tender?.company_name ?? "",
        company_dist_lead: tender?.company_dist_lead,
        company_dist_jv: tender?.company_dist_jv,
        soil_quality: tender?.soil_quality ?? false,
        participating_as: tender?.participating_as ?? "",
        terms_of_jv: tender?.terms_of_jv ?? "",
        tech_score: tender?.tech_score ?? "",
        company_score: tender?.company_score ?? "",
        site_apprisate_required: tender?.site_apprisate_required ?? false,
        site_apprisate_marking: tender?.site_apprisate_marking ?? "",
        work_methodology_required: tender?.work_methodology_required ?? false,
        work_methodology_marking: tender?.work_methodology_marking ?? "",
        presentation_required: tender?.presentation_required ?? false,
        presentation_type: tender?.presentation_type ?? "",
        presentation_required_marking:
          tender?.presentation_required_marking ?? "",
      });
      setFinalizePartnersData({
        lead_partner: tender.lead_partner
          ? tender.lead_partner
          : tender.lead_qualify
            ? tender.company_name
            : "",
        lead_partner_share: tender.lead_partner_share ?? "",
        partner_share_sum: 0,
        jv_partner_share: tender.jv_partner_share ?? "",
        jv_partner_name: tender.jv_partner_name
          ? tender.jv_partner_name
          : tender.jv_qualify
            ? tender.company_name
            : "",
        assosiate_partner: tender.assosiate_partner
          ? tender.assosiate_partner
          : tender.associate_qualify
            ? tender.company_name
            : "",
        associate_partner_share: tender.associate_partner_share ?? "",
        bg_requried: tender.bg_requried,
        bg_amount: tender.bg_amount ?? 0,
        bg_prepare_by: tender.bg_prepare_by ?? "",
        bid_prepare_by: tender.bid_prepare_by ?? "",
        bid_prepare_by_remarks: tender.bid_prepare_by_remarks ?? "",
        // emd_assumpter: tender.emd_assumpter,

        bg_type: tender.bg_type ?? "",

        tender_submission_type: tender.tender_submission_type ?? "",

        team_required: tender.team_required,
        team_requirements_details: tender.team_requirements_details ?? "",
        team_prepare_by: tender.team_prepare_by,
        team_prepare_by_remarks: tender.team_prepare_by_remarks,
      });
      setTenderDocumentsData({
        checklist: tender.checklist ?? false,
        all_docs_done: tender.all_docs_done ?? false,
        tech_score: tender.tech_score ?? "",
        cv_score: tender.cv_score ?? "",
        tech_doc: tender.tech_doc ?? [],
        financial_doc: tender.financial_doc ?? [],
        cvs_files: tender.cv_doc ?? [],
        bid_doc: tender.bid_doc ?? [],
        bidder_doc: tender.bidder_doc ?? [],
        all_cvs_done: tender.all_cvs_done ?? false,
        bidders: tender.tender_bidders ?? [],
        bidder_name: {
          value: "",
          laoding: false,
        },
      });
    }
    const updatedSum =
      parseInt(tender.lead_partner_share) +
      parseInt(tender.associate_partner_share) +
      parseInt(tender.jv_partner_share);
    setFinalizePartnersData((prev) => ({
      ...prev,
      partner_share_sum: updatedSum,
    }));
  }, [tender]);

  useEffect(() => {
    const updatedSum =
      (parseInt(finalizePartnersData.lead_partner_share) || 0) +
      (parseInt(finalizePartnersData.associate_partner_share) || 0) +
      (parseInt(finalizePartnersData.jv_partner_share) || 0);

    if (finalizePartnersData.partner_share_sum !== updatedSum) {
      setFinalizePartnersData((prev) => ({
        ...prev,
        partner_share_sum: updatedSum,
      }));
    }
  }, [
    finalizePartnersData.lead_partner_share,
    finalizePartnersData.associate_partner_share,
    finalizePartnersData.jv_partner_share,
  ]);
  const [errorsdoc, setErrorsDoc] = useState({});
  const [isSubmitteddoc, setIsSubmittedDoc] = useState(false);
  const validateFormTenderdocument = () => {
    const newErrors = {};
    let requiredFields = [];

    requiredFields = [
      tenderDocumentsData.all_docs_done === null ? "all_docs_done" : null,
      tenderDocumentsData.all_cvs_done === null ? "all_cvs_done" : null,
      tenderDocumentsData.checklist === null ? "checklist" : null,

      "tech_score",
      "cv_score",
    ].filter(Boolean);

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          tenderDocumentsData,
        );
    };

    requiredFields.forEach((field) => {
      if (!tenderDocumentsData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrorsDoc(newErrors);
    setIsSubmittedDoc(true);
    return Object.keys(newErrors).length === 0;
  };
  const handleTenderDocumentUpdate = async (e) => {
    if (validateFormTenderdocument()) {
      e.preventDefault();
      const loadingToastId = toast.loading("Loading: Please wait...");
      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          tenderDocumentsData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          const getJsonData = (data) => {
            if (data instanceof FormData) {
              return Object.fromEntries(data.entries());
            }
            return data; // already JSON
          };

          await saveAudit({
            tenderId: tenderId,
            updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
            tableName: "Tenderforbd",
            oldData: getJsonData(tender),
            newData: getJsonData(tenderDocumentsData),
            action: "UPDATE",
            tab_id: toggleState,
          });
          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  const [errorseligiblity, setErrorsEligibilty] = useState({});
  const [isSubmittedeligiblity, setIsSubmittedEligibility] = useState(false);
  const validateFormEligibility = () => {
    const newErrors = {};
    let requiredFields = [];

    requiredFields = [
      eligibilityCriteriaData.is_jv_allowed === null ? "is_jv_allowed" : null,
      "tech_score",
      "company_score",
      "company_name",
      "eligibity_criteria",
      eligibilityCriteriaData.eligibity_criteria != "" &&
        eligibilityCriteriaData.eligibity_criteria === "Special"
        ? "eligibity_criteria_special"
        : null,
      eligibilityCriteriaData.soil_quality === null ? "soil_quality" : null,
      eligibilityCriteriaData.participating_as === null
        ? "participating_as"
        : null,
      eligibilityCriteriaData.is_jv_consorium_association_allowed === null
        ? "jv_consorium_association_allowed"
        : null,

      eligibilityCriteriaData.site_apprisate_required === null
        ? "site_apprisate_required"
        : null,
      eligibilityCriteriaData.site_apprisate_required !== null
        ? "site_apprisate_marking"
        : null,
      eligibilityCriteriaData.work_methodology_required === null
        ? "work_methodology_required"
        : null,
      eligibilityCriteriaData.work_methodology_required != null &&
        eligibilityCriteriaData.work_methodology_required
        ? "work_methodology_marking"
        : null,
      eligibilityCriteriaData.presentation_required === null
        ? "presentation_required"
        : null,
      eligibilityCriteriaData.presentation_required !== null &&
        eligibilityCriteriaData.presentation_required
        ? "presentation_required_marking"
        : null,
      eligibilityCriteriaData.presentation_required !== null &&
        eligibilityCriteriaData.presentation_required
        ? "presentation_type"
        : null,
    ].filter(Boolean);

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          eligibilityCriteriaData,
        );
    };

    requiredFields.forEach((field) => {
      if (!eligibilityCriteriaData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrorsEligibilty(newErrors);
    setIsSubmittedEligibility(true);
    return Object.keys(newErrors).length === 0;
  };

  // const handleEligibilityCriteriaUpdate = async (e) => {
  //     if (validateFormEligibility()) {
  //         e.preventDefault();
  //         const loadingToastId = toast.loading("Loading: Please wait...");
  //         try {
  //             const res = await axios.put(
  //                 `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
  //                 eligibilityCriteriaData,
  //                 {
  //                     headers: {
  //                         "Content-Type": "multipart/form-data",
  //                     },
  //                 },
  //             );

  //             if (res.status === 200 || res.status === 201) {
  //                 const getJsonData = (data) => {
  //                     if (data instanceof FormData) {
  //                         return Object.fromEntries(data.entries());
  //                     }
  //                     return data; // already JSON
  //                 };

  //                 await saveAudit({
  //                     tenderId: tenderId,
  //                     updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
  //                     tableName: "Tenderforbd",
  //                     oldData: getJsonData(tender),
  //                     newData: getJsonData(eligibilityCriteriaData),
  //                     action: "UPDATE"
  //                 });
  //                 handleCloseEditModal();
  //                 sessionStorage.setItem("scrollTenderId", tenderId);
  //                 await getBidData(filters);
  //             }
  //         } catch (err) {
  //             handleErrorToast(err);
  //         } finally {
  //             toast.dismiss(loadingToastId);
  //         }
  //     }
  // };
  const handleEligibilityCriteriaUpdate = async (e) => {
    if (validateFormEligibility()) {
      e.preventDefault();

      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        // ✅ Clone data (important)
        let updatedData = { ...eligibilityCriteriaData };

        // ✅ 1. If not Special → blank it
        if (updatedData.eligibity_criteria !== "Special") {
          updatedData.eligibity_criteria_special = "";
        }

        // ✅ 2. Site Appraisal
        if (!updatedData.site_apprisate_required) {
          updatedData.site_apprisate_marking = 0;
        }

        // ✅ 3. Work Methodology
        if (!updatedData.work_methodology_required) {
          updatedData.work_methodology_marking = 0;
        }

        // ✅ 4. Presentation
        if (!updatedData.presentation_required) {
          updatedData.presentation_required_marking = 0;
          updatedData.presentation_type = "";
        }

        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          updatedData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          const getJsonData = (data) => {
            if (data instanceof FormData) {
              return Object.fromEntries(data.entries());
            }
            return data;
          };

          await saveAudit({
            tenderId: tenderId,
            updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
            tableName: "Tenderforbd",
            oldData: getJsonData(tender),
            newData: getJsonData(updatedData),
            action: "UPDATE",
            tab_id: toggleState,
          });

          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  const [errorspartner, setErrorsPartner] = useState({});
  const [isSubmittedpartner, setIsSubmittedPartner] = useState(false);
  const validateFormPartner = () => {
    const newErrors = {};
    let requiredFields = [];
    const partnerShareSum =
      (parseInt(finalizePartnersData.lead_partner_share) || 0) +
      (finalizePartnersData.jv_partner_name !== "Not Required"
        ? parseInt(finalizePartnersData.jv_partner_share) || 0
        : 0) +
      (finalizePartnersData.assosiate_partner !== "Not Required"
        ? parseInt(finalizePartnersData.associate_partner_share) || 0
        : 0);

    if (partnerShareSum !== 100) {
      newErrors["partner_share_sum"] =
        partnerShareSum > 100
          ? "Sum of all partner shares must not be more than 100"
          : "Sum of all partner shares must not be less than 100";
    }

    requiredFields = [
      finalizePartnersData.tender_submission_type === null
        ? "tender_submission_type"
        : null,

      finalizePartnersData.bid_prepare_by === null ? "bid_prepare_by" : null,
      finalizePartnersData.bg_prepare_by === null ? "bg_prepare_by" : null,
      "lead_partner_share",
      finalizePartnersData.jv_partner_name != "Not Required"
        ? "jv_partner_share"
        : null,
      finalizePartnersData.assosiate_partner != "Not Required"
        ? "associate_partner_share"
        : null,
      finalizePartnersData.team_required === null ? "team_required" : null,
      finalizePartnersData.team_required !== null &&
        finalizePartnersData.team_required
        ? "team_prepare_by"
        : null,
      finalizePartnersData.team_required !== null &&
        finalizePartnersData.team_required
        ? "team_prepare_by_remarks"
        : null,
      finalizePartnersData.team_required !== null &&
        finalizePartnersData.team_required
        ? "team_requirements_details"
        : null,
    ].filter(Boolean);

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          finalizePartnersData,
        );
    };

    requiredFields.forEach((field) => {
      if (!finalizePartnersData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrorsPartner(newErrors);
    setIsSubmittedPartner(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleFinalizePartnerUpdate = async (e) => {
    e.preventDefault();
    if (validateFormPartner()) {
      let data = { ...finalizePartnersData };
      const loadingToastId = toast.loading("Loading: Please wait...");
      if (finalizePartnersData.lead_partner === "Not Required") {
        data.lead_partner_share = 0;
      }

      if (finalizePartnersData.jv_partner_name === "Not Required") {
        data.jv_partner_share = 0;
      }

      if (finalizePartnersData.assosiate_partner === "Not Required") {
        data.associate_partner_share = 0;
      }
      if (!finalizePartnersData.team_required) {
        data.team_prepare_by = "";
        data.team_prepare_by_remarks = "";
        data.team_requirements_details = "";
      }
      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          const getJsonData = (data) => {
            if (data instanceof FormData) {
              return Object.fromEntries(data.entries());
            }
            return data; // already JSON
          };

          await saveAudit({
            tenderId: tenderId,
            updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
            tableName: "FinancialParticipants",
            oldData: getJsonData(tender),
            newData: getJsonData(finalizePartnersData),
            action: "UPDATE",
            tab_id: toggleState,
          });
          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [cvsDocs, setCvsDocs] = useState([]);
  const [techDocs, setTechDocs] = useState([]);
  const [finacialDocs, setFinancialDocs] = useState([]);
  const [BidDocs, setBidDocs] = useState([]);
  const handleCvsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setCvsDocs(newFiles);
    }
  };

  const handleCvsRemove = (index) => {
    setCvsDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddCvDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      cvsDocs.forEach((file) => {
        formData.append("cv_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkcv/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = cvsDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "Cv",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
        });
      }
    } catch (uploadErr) {
      setCvsDocs([]);
    } finally {
      setCvsDocs([]);
      getBidData();
    }
  };

  const handleTechFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setTechDocs(newFiles);
    }
  };

  const handleTechRemove = (index) => {
    setTechDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddTechDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      techDocs.forEach((file) => {
        formData.append("tech_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulktech/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = techDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "TechDocumentBd",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
        });
      }
    } catch (uploadErr) {
      setTechDocs([]);
    } finally {
      setTechDocs([]);
      getBidData();
    }
  };

  const handleFinancialFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setFinancialDocs(newFiles);
    }
  };

  const handleFinancialRemove = (index) => {
    setFinancialDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddFinancialDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      finacialDocs.forEach((file) => {
        formData.append("financial_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkfinancial/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = finacialDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "FinancialDocument",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
        });
      }
    } catch (uploadErr) {
      setFinancialDocs([]);
    } finally {
      setFinancialDocs([]);
      getBidData();
    }
  };

  const handleBidsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setBidDocs(newFiles);
    }
  };

  const handleBidsRemove = (index) => {
    setBidDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddBidDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      BidDocs.forEach((file) => {
        formData.append("bid_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkbbid/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = BidDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "BidTenderDocument",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
          tab_id: toggleState,
        });
      }
    } catch (uploadErr) {
      setBidDocs([]);
    } finally {
      setBidDocs([]);
      getBidData();
    }
  };
  const [stop, SetStop] = useState(false);
  const handleBidderSubmit = async (name, id) => {
    const data = {
      bidder_name: name ? name : tenderDocumentsData.bidder_name.value,
      TenderforBD: tenderId ? tenderId : id,
      number_of_bidder: 1,
    };
    try {
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidder_name: { ...prev.bidder_name, loading: true },
      }));
      const res = await axios.post(`${BASE_URL}/siteproject/bidder/`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidders: [...prev.bidders, res.data],
        bidder_name: { ...prev.bidder_name, value: "" },
      }));
      SetStop(true);
    } catch (err) {
    } finally {
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidder_name: { ...prev.bidder_name, loading: false },
      }));
    }
  };
  useEffect(() => {
    if (
      showModal &&
      editTenderData != undefined &&
      editTenderData?.lead_partner != null &&
      !stop &&
      editTenderData?.tender_bidders?.length == 0
    ) {
      SetStop(true);
    }
  }, [editTenderData, showModal, tenderDocumentsData, stop]);

  const EmdType = [
    { key: "Bank_Gurantee", value: "Bank Gurantee" },
    { key: "neft", value: "NEFT" },
    { key: "demand_draft", value: "Demand Draft" },
    { key: "suretybond", value: "Surety Bond" },
    { key: "other", value: "Other" },
  ];
  const Partners = [
    {
      key: "Saptagon Asia Private Limited",
      value: "Saptagon Asia Private Limited",
    },
    {
      key: "Civilmantra Infracon Limited",
      value: "Civilmantra Infracon Limited",
    },
    {
      key: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED",
      value: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED",
    },
    { key: "ISAN CORPORATION", value: "ISAN CORPORATION" },
    { key: "MARC TECHNOCRATS LIMITED", value: "MARC TECHNOCRATS LIMITED" },
    {
      key: "ALOMNDS GLOBAL INFRASTRUCTURE",
      value: "ALOMNDS GLOBAL INFRASTRUCTURE",
    },
    { key: "VOYANTS SOLUTIONS PVT LTD", value: "VOYANTS SOLUTIONS PVT LTD" },
    {
      key: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED",
      value: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED",
    },
    { key: "MSV INTERNATIONAL", value: "MSV INTERNATIONAL" },
    { key: "YONGMA ENGINEERING CO LTD", value: "YONGMA ENGINEERING CO LTD" },
    { key: "TECH-4", value: "TECH-4" },
    {
      key: "AECOM INDIA PRIVATE LIMITED",
      value: "AECOM INDIA PRIVATE LIMITED",
    },
    { key: "SMEC INDIA PVT LTD", value: "SMEC INDIA PVT LTD" },
    { key: "SPECTRUM", value: "SPECTRUM" },
    { key: "INSTUTIUTE GIPROSTROYMOST", value: "INSTUTIUTE GIPROSTROYMOST" },
    {
      key: "RODIC CONSULTANT PRIVATE LIMITED",
      value: "RODIC CONSULTANT PRIVATE LIMITED",
    },
    {
      key: "CHAITANYA PROJECT CONSULTANCY LTD",
      value: "CHAITANYA PROJECT CONSULTANCY LTD",
    },
    {
      key: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)",
      value: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)",
    },
    {
      key: "TPF ENGINEERING PRIVATE LIMITED",
      value: "TPF ENGINEERING PRIVATE LIMITED",
    },
    {
      key: "INFRAPLUS CONSULTANCY PVT LTD",
      value: "INFRAPLUS CONSULTANCY PVT LTD",
    },
    { key: "RITES LIMITED", value: "RITES LIMITED" },
    { key: "TPF GETINSAEUROESTUDIOS SL", value: "TPF GETINSAEUROESTUDIOS SL" },
    {
      key: "SA INFRASTURCTURE CONSULTING PRIVATE",
      value: "SA INFRASTURCTURE CONSULTING PRIVATE",
    },
    { key: "CEG LIMITED", value: "CEG LIMITED" },
    {
      key: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD",
      value: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD",
    },
    { key: "Egis", value: "Egis" },
    { key: "OPEN SOLUTION", value: "OPEN SOLUTION" },
    { key: "SUMAD ENTERPRISE", value: "SUMAD ENTERPRISE" },
    {
      key: "Earl Techno Consultant Pvt. Ltd.",
      value: "Earl Techno Consultant Pvt. Ltd.",
    },
    { key: "Pentagon", value: "Pentagon" },
    { key: "Ropes", value: "Ropes" },
    { key: "WPKK", value: "WPKK" },
    { key: "sapl", value: "SAPL" },
    { key: "cipl", value: "CIPL" },
    { key: "DESIGN LINE CONSULTANCY", value: "DESIGN LINE CONSULTANCY" },
    { key: "GIPRO", value: "GIPRO" },
    { key: "joint", value: "Joint" },
    { key: "Other", value: "Other" },
    { key: "Not Required", value: "Not Required" },
  ];

  const [scoreError, setScoreError] = useState("");

  const renderTabContent = () => {
    switch (activeTab) {
      case "eligibility":
        return (
          <section
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div className="dropdown-wrapper flex-column justify-center  ">
              <label
                htmlFor="eligibity_criteria"
                className="form-label font-weight500 font-size-subheading"
              >
                Eligibilty Criteria<span className="required">*</span>
              </label>
              <select
                name="eligibity_criteria"
                placeholder="Please write a eligibility creteria. "
                value={eligibilityCriteriaData.eligibity_criteria}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    eligibity_criteria: e.target.value,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Eligibilty Criteria</option>
                <option value="Normal">Normal</option>
                <option value="Special">Special</option>
              </select>
            </div>
            {eligibilityCriteriaData.eligibity_criteria === "Special" && (
              <div className="dropdown-wrapper flex-column justify-center ">
                <label className="form-labels">
                  Eligibility Criteria Special
                  <span className="required">*</span>
                </label>
                <textarea
                  name="eligibity_criteria_special Eligibity Criteria"
                  placeholder="Please write Special Eligibilty Criteria "
                  value={eligibilityCriteriaData.eligibity_criteria_special}
                  className={`form-input input-form`}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      eligibity_criteria_special: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="is_jv_allowed"
                className="font-weight500 font-size-subheading"
              >
                Is Jv allowed<span className="required">*</span>
              </label>
              <select
                id="is_jv_allowed"
                name="is_jv_allowed"
                value={eligibilityCriteriaData.is_jv_allowed}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    is_jv_allowed:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Is Jv Allowed</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="is_jv_consorium_association_allowed"
                className="font-weight500 font-size-subheading"
              >
                Is Consorium/Association allowed
                <span className="required">*</span>
              </label>
              <select
                id="is_jv_consorium_association_allowed"
                name="is_jv_consorium_association_allowed"
                value={
                  eligibilityCriteriaData.is_jv_consorium_association_allowed
                }
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    is_jv_consorium_association_allowed:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Checklist</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {eligibilityCriteriaData.is_jv_consorium_association_allowed && (
              <div className="flex-column">
                <label className="form-labels">Terms of JV </label>
                <textarea
                  name="terms_of_jv"
                  placeholder="terms"
                  value={eligibilityCriteriaData.terms_of_jv}
                  className={`form-input input-form`}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      terms_of_jv: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            <div className="flex-column form-group-selectt">
              <label
                htmlFor="company_name"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Company Name<span className="required">*</span>
              </label>
              <br />
              <select
                id="company_name"
                name="company_name"
                value={eligibilityCriteriaData.company_name}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    company_name: e.target.value,
                  }))
                }
                className={`form-input input-form  form-group-selection`}
              >
                <option value="null">Select Company Name</option>
                <option value="sapl">SAPL</option>
                <option value="cipl">CIPL</option>
              </select>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="soil_quality"
                className="font-weight500 font-size-subheading"
              >
                Sole Qualify<span className="required">*</span>
              </label>
              <select
                id="soil_quality"
                name="soil_quality"
                value={eligibilityCriteriaData.soil_quality}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    soil_quality:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Sole Qualify</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="participating_as "
                className="  font-weight500    font-size-subheading"
              >
                Participating As<span className="required">*</span>
              </label>
              <br />
              <select
                id="participating_as"
                name="participating_as"
                value={eligibilityCriteriaData.participating_as}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    participating_as: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
              //style={{ width: '80% !important' }}
              >
                <option value="">Select Participating As</option>

                <option value="lead">Lead</option>
                <option value="jv">JV</option>
                <option value="associate">Associate</option>
                {eligibilityCriteriaData?.soil_quality ? (
                  <option value="sole">Sole</option>
                ) : (
                  ""
                )}
              </select>
            </div>

            <div
              className="joint-columns"
              style={{ display: "flex", gap: "20px", marginTop: "10px" }}
            >
              <div className="flex-column form-group-selectt widths50">
                <label
                  htmlFor="tech_score"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Total Tech Score<span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="tech_score"
                  placeholder="tech Score"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.tech_score}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      tech_score: e.target.value,
                    }))
                  }
                  style={{ width: "80%" }}
                />
              </div>

              <div className="flex-column form-group-selectt widths50">
                <label
                  htmlFor="company_score"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  {eligibilityCriteriaData.company_name === null ||
                    eligibilityCriteriaData.company_name === "null"
                    ? "Our Company"
                    : eligibilityCriteriaData.company_name?.toUpperCase()}{" "}
                  Technical Score<span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="company_score"
                  placeholder="Company Score"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.company_score}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (
                      Number(value) > Number(eligibilityCriteriaData.tech_score)
                    ) {
                      setScoreError(
                        "Company score cannot be greater than Total Tech Score",
                      );
                    } else {
                      setScoreError("");
                      setEligibilityCriteriaData((prev) => ({
                        ...prev,
                        company_score: value,
                      }));
                    }
                  }}
                  style={{ width: "80%" }}
                />
                <br />
                {scoreError && (
                  <p
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {scoreError}
                  </p>
                )}
              </div>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="site_apprisate_required"
                className="font-weight500 font-size-subheading"
              >
                Site Appreciate Required <span className="required">*</span>
              </label>
              <select
                id="site_apprisate_required"
                name="site_apprisate_required"
                value={eligibilityCriteriaData.site_apprisate_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    site_apprisate_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Site Appreciate Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            {eligibilityCriteriaData.site_apprisate_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="site_apprisate_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Site Appreciate Marking <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="site_apprisate_marking"
                  placeholder="site_apprisate_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.site_apprisate_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      site_apprisate_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="work_methodology_required"
                className="font-weight500 font-size-subheading"
              >
                Work Methodology Required <span className="required">*</span>
              </label>
              <select
                id="work_methodology_required"
                name="work_methodology_required"
                value={eligibilityCriteriaData.work_methodology_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    work_methodology_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Work Methodology Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            {eligibilityCriteriaData.work_methodology_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="work_methodology_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Work Methodology Marking <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="work_methodology_marking"
                  placeholder="work_methodology_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.work_methodology_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      work_methodology_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="presentation_required"
                className="font-weight500 font-size-subheading"
              >
                Presentation Required <span className="required">*</span>
              </label>
              <select
                id="presentation_required"
                name="presentation_required"
                value={eligibilityCriteriaData.presentation_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    presentation_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Presentation Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {eligibilityCriteriaData.presentation_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="presentation_required_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Presentation Required Marking{" "}
                  <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="presentation_required_marking"
                  placeholder="presentation_required_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.presentation_required_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      presentation_required_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            {eligibilityCriteriaData.presentation_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="presentation_type"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Presentation Type <span className="required">*</span>
                </label>
                <br />
                <select
                  id="presentation_type"
                  name="presentation_type"
                  className={`form-input input-form  form-group-selection `}
                  value={eligibilityCriteriaData.presentation_type}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      presentation_type: e.target.value,
                    }))
                  }
                >
                  <option value="null">Select Presentation Type</option>
                  <option value="Online">Online</option>
                  <option value="physical">Physical</option>
                  <option value="both">Both</option>
                </select>
              </div>
            )}
            <p className="error-message font-size-text">
              {" "}
              {isSubmittedeligiblity &&
                Object.keys(errorseligiblity).length > 0 && (
                  <h6 className="text-center">
                    {"Error in: " +
                      Object.keys(errorseligiblity)
                        .map((field) => {
                          // Convert field names to readable format
                          const formatted = field
                            .replace(/_/g, " ") // replace underscores with spaces
                            .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letters
                          return `${formatted}`; // include the actual error message
                        })
                        .join(", ")}
                  </h6>
                )}
            </p>

            <button
              onClick={handleEligibilityCriteriaUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      case "partners":
        return (
          <section
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div className="flex-column form-group-selectt ">
              <label
                htmlFor="lead_partner"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Lead Partner<span className="required">*</span>
              </label>
              <br />
              {finalizePartnersData.lead_qualify ? (
                <input
                  type="text"
                  name="lead_partner"
                  placeholder="lead partner"
                  value={finalizePartnersData.lead_partner}
                  disabled={finalizePartnersData.lead_qualify}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      lead_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              ) : (
                <select
                  id="lead_partner"
                  name="lead_partner"
                  value={finalizePartnersData.lead_partner}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      lead_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form  form-group-selection`}
                >
                  {Partners.map((partner) => (
                    <option value={partner.key}>{partner.value}</option>
                  ))}
                </select>
              )}
            </div>
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="lead_partner_share"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Lead Partner Share %<span className="required">*</span>
              </label>
              <br />
              <input
                type="number"
                name="lead_partner_share"
                placeholder="lead partner share"
                value={finalizePartnersData.lead_partner_share}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    lead_partner_share: e.target.value,
                  }))
                }
                className={`form-input input-form`}
              />
              {finalizePartnersData.partner_share_sum > 100 && (
                <label style={{ color: "red" }}>
                  Sum of all partner should not be more than 100
                </label>
              )}
              {finalizePartnersData.partner_share_sum < 100 && (
                <label style={{ color: "red" }}>
                  Sum of all lead partner should not be less than 100
                </label>
              )}
            </div>
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="jv_partner_name"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Jv Partner<span className="required">*</span>
              </label>
              <br />
              {finalizePartnersData.jv_qualify ? (
                <input
                  type="text"
                  name="jv_partner_name"
                  placeholder="Jv Partner"
                  value={finalizePartnersData.jv_partner_name}
                  disabled={finalizePartnersData.jv_qualify}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      jv_partner_name: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              ) : (
                <select
                  id="jv_partner_name"
                  name="jv_partner_name"
                  value={finalizePartnersData.jv_partner_name}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      jv_partner_name: e.target.value,
                    }))
                  }
                  className={`form-input input-form  form-group-selection`}
                >
                  {Partners.map((partner) => (
                    <option value={partner.key}>{partner.value}</option>
                  ))}
                </select>
              )}
            </div>

            {finalizePartnersData.jv_partner_name != "Not Required" && (
              <>
                {" "}
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="jv_partner_share"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Jv Partner Share %<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="number"
                    name="jv_partner_share"
                    placeholder="Jv Partner Share"
                    value={finalizePartnersData.jv_partner_share}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        jv_partner_share: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
                {finalizePartnersData.partner_share_sum > 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all partner should not be more than 100
                  </label>
                )}
                {finalizePartnersData.partner_share_sum < 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all lead partner should not be less than 100
                  </label>
                )}
              </>
            )}
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="assosiate_partner"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Assosiate Partner<span className="required">*</span>
              </label>
              <br />
              {finalizePartnersData.associate_qualify ? (
                <input
                  type="text"
                  name="assosiate_partner"
                  placeholder="Assosiate Partner"
                  value={finalizePartnersData.assosiate_partner}
                  disabled={finalizePartnersData.associate_qualify}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      assosiate_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              ) : (
                <select
                  id="assosiate_partner"
                  name="assosiate_partner"
                  value={finalizePartnersData.assosiate_partner}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      assosiate_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form  form-group-selection`}
                >
                  {Partners.map((partner) => (
                    <option value={partner.key}>{partner.value}</option>
                  ))}
                </select>
              )}
            </div>
            {finalizePartnersData.assosiate_partner != "Not Required" && (
              <>
                {" "}
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="associate_partner_share"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Associate Partner Share %<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="number"
                    name="associate_partner_share"
                    placeholder="Associate Partner Share"
                    value={finalizePartnersData.associate_partner_share}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        associate_partner_share: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
                {finalizePartnersData.partner_share_sum > 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all partner should not be more than 100
                  </label>
                )}
                {finalizePartnersData.partner_share_sum < 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all lead partner should not be less than 100
                  </label>
                )}
              </>
            )}

            <div className="dropdown-wrapper flex justify-center ">
              <label
                htmlFor="bid_prepare_by"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Bid Prepare By<span className="required">*</span>
              </label>
              <br />
              <select
                id="bid_prepare_by"
                name="bid_prepare_by"
                value={finalizePartnersData.bid_prepare_by}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    bid_prepare_by: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
              >
                <option value="">Select</option>
                <option
                  value={
                    finalizePartnersData.lead_partner
                      ? finalizePartnersData.lead_partner
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.lead_partner ||
                    finalizePartnersData.lead_partner != "null"
                    ? finalizePartnersData.lead_partner
                    : ""}
                </option>
                <option
                  value={
                    finalizePartnersData.jv_partner_name
                      ? finalizePartnersData.jv_partner_name
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.jv_partner_name ||
                    finalizePartnersData.jv_partner_name != "null"
                    ? finalizePartnersData.jv_partner_name
                    : ""}
                </option>
                <option
                  value={
                    finalizePartnersData.assosiate_partner
                      ? finalizePartnersData.assosiate_partner
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.assosiate_partner ||
                    finalizePartnersData.assosiate_partner != "null"
                    ? finalizePartnersData.assosiate_partner
                    : ""}
                </option>
              </select>
            </div>
            <div className="dropdown-wrapper flex justify-center ">
              <label className="form-labels font-weight500 font-size-subheading">
                Bid Prepare By Remarks
              </label>
              <br />
              <textarea
                name="bid_prepare_by_remarks"
                placeholder="Remarks for bid prepared by"
                value={finalizePartnersData.bid_prepare_by_remarks}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    bid_prepare_by_remarks: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
              />
            </div>

            <div className="dropdown-wrapper flex justify-center ">
              <label
                htmlFor="bg_prepare_by"
                className="form-labels  font-weight500    font-size-subheading"
              >
                BG Prepare By<span className="required">*</span>
              </label>
              <br />
              <select
                id="bg_prepare_by"
                name="bg_prepare_by"
                value={finalizePartnersData.bg_prepare_by}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    bg_prepare_by: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
              >
                <option value="">Select</option>
                <option
                  value={
                    finalizePartnersData.lead_partner
                      ? finalizePartnersData.lead_partner
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.lead_partner ||
                    finalizePartnersData.lead_partner != "null"
                    ? finalizePartnersData.lead_partner
                    : ""}
                </option>
                <option
                  value={
                    finalizePartnersData.jv_partner_name
                      ? finalizePartnersData.jv_partner_name
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.jv_partner_name ||
                    finalizePartnersData.jv_partner_name != "null"
                    ? finalizePartnersData.jv_partner_name
                    : ""}
                </option>
                <option
                  value={
                    finalizePartnersData.assosiate_partner
                      ? finalizePartnersData.assosiate_partner
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.assosiate_partner ||
                    finalizePartnersData.assosiate_partner != "null"
                    ? finalizePartnersData.assosiate_partner
                    : ""}
                </option>
              </select>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="team_required"
                className="font-weight500 font-size-subheading"
              >
                Team Required <span className="required">*</span>
              </label>
              <select
                id="team_required"
                name="team_required"
                value={finalizePartnersData.team_required}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    team_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Team Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {finalizePartnersData.team_required && (
              <>
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="team_prepare_by"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Team Prepare By<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="team_prepare_by"
                    name="team_prepare_by"
                    value={finalizePartnersData.team_prepare_by}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        team_prepare_by: e.target.value,
                      }))
                    }
                    className={`form-input input-form  form-group-selection`}
                  >
                    <option value="">Select</option>
                    <option
                      value={
                        finalizePartnersData.lead_partner
                          ? finalizePartnersData.lead_partner
                          : ""
                      }
                    >
                      {finalizePartnersData.lead_partner}
                    </option>
                    <option
                      value={
                        finalizePartnersData.jv_partner_name
                          ? finalizePartnersData.jv_partner_name
                          : ""
                      }
                    >
                      {" "}
                      {finalizePartnersData.jv_partner_name}
                    </option>
                    <option
                      value={
                        finalizePartnersData.assosiate_partner
                          ? finalizePartnersData.assosiate_partner
                          : ""
                      }
                    >
                      {" "}
                      {finalizePartnersData.assosiate_partner}
                    </option>
                  </select>
                </div>
                <div className="flex-column">
                  <label className="form-labels">
                    Team Prepare By Remarks <span className="required">*</span>
                  </label>
                  <textarea
                    name="team_prepare_by_remarks"
                    placeholder="Remarks for Team prepared by"
                    value={finalizePartnersData.team_prepare_by_remarks}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        team_prepare_by_remarks: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>{" "}
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="team_requirements_details"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Team Requirements Details<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="team_requirements_details"
                    placeholder="Team Requirements Deatils"
                    value={finalizePartnersData.team_requirements_details}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        team_requirements_details: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
              </>
            )}
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="tender_submission_type"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Tender Submission Type<span className="required">*</span>
              </label>
              <br />
              <select
                id="tender_submission_type"
                name="tender_submission_type"
                value={finalizePartnersData.tender_submission_type}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    tender_submission_type: e.target.value,
                  }))
                }
                className={`form-input input-form  form-group-selection`}
              >
                <option value="null">Select Tender Submission Type</option>
                <option value="Online">Online</option>
                <option value="physical">Physical</option>
                <option value="both">Both</option>
              </select>
            </div>
            <br />
            <p className="error-message font-size-text">
              {isSubmittedpartner && Object.keys(errorspartner).length > 0 && (
                <h6 className="text-center">
                  {"Error in: " +
                    Object.keys(errorspartner)
                      .map((field) => {
                        if (field === "partner_share_sum") {
                          return errorspartner[field]; // show the actual message directly
                        }
                        const formatted = field
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase());
                        return formatted;
                      })
                      .join(", ")}
                </h6>
              )}
            </p>
            <button
              onClick={handleFinalizePartnerUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      case "documents":
        return (
          <section>
            {roleemp != "CertificationAccessCvTeamHead" &&
              roleemp != "CertificationAccessCvTeam" && (
                <>
                  <div className="dropdown-wrapper flex-column justify-center ">
                    <label
                      htmlFor="checklist"
                      className="font-weight500 font-size-subheading"
                    >
                      Checklist <span className="required">*</span>
                    </label>
                    <select
                      id="checklist"
                      name="checklist"
                      value={tenderDocumentsData.checklist}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          checklist:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null,
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Checklist</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                  <div className="dropdown-wrapper flex-column justify-center ">
                    <label
                      htmlFor="all_docs_done"
                      className="font-weight500 font-size-subheading"
                    >
                      All Docs Done <span className="required">*</span>
                    </label>
                    <select
                      id="all_docs_done"
                      name="all_docs_done"
                      value={tenderDocumentsData.all_docs_done}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          all_docs_done:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null,
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">All Docs Done</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>

                  <div className="flex-column form-group-selectt">
                    <label
                      htmlFor="tech_score"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Total Technical Score <span className="required">*</span>
                    </label>
                    <br />
                    <input
                      type="text"
                      name="tech_score"
                      placeholder="tech Score"
                      value={tenderDocumentsData.tech_score}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          tech_score: e.target.value,
                        }))
                      }
                      className={`form-input input-form`}
                    />
                  </div>
                </>
              )}
            {(roleemp === "CertificationAccessCvTeamHead" ||
              roleemp === "CertificationAccessCvTeam" ||
              roleemp === "CertificationAccess" ||
              roleemp === "CertificateAccessBd" ||
              roleemp === "certificaionadminaccess") && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="cv_score"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    CV Score <span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="cv_score"
                    placeholder="CV Score"
                    value={tenderDocumentsData.cv_score}
                    onChange={(e) =>
                      setTenderDocumentsData((prev) => ({
                        ...prev,
                        cv_score: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
              )}
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Tech Proposal (File name should be max 400 character)
              </label>

              {tenderDocumentsData?.tech_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.tech_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleTechFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddTechDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!techDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: techDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: techDocs?.length ? "#fafafd" : "none",
                }}
              >
                {techDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== techDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleTechRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!techDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Financial Proposal (File name should be max 400
                character)
              </label>

              {tenderDocumentsData?.financial_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.financial_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleFinancialFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddFinancialDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!finacialDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: finacialDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: finacialDocs?.length ? "#fafafd" : "none",
                }}
              >
                {finacialDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== finacialDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleFinancialRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!finacialDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload CV's (File name should be max 400 character)
              </label>

              {tenderDocumentsData?.cvs_files?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.cvs_files.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleCvsFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddCvDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!cvsDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: cvsDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: cvsDocs?.length ? "#fafafd" : "none",
                }}
              >
                {cvsDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== cvsDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleCvsRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!cvsDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="all_cvs_done"
                className="font-weight500 font-size-subheading"
              >
                All Cvs Done
              </label>
              <select
                id="all_cvs_done"
                name="all_cvs_done"
                value={tenderDocumentsData.all_cvs_done}
                onChange={(e) =>
                  setTenderDocumentsData((prev) => ({
                    ...prev,
                    all_cvs_done:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">All Cvs Done</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Bid Acknowledgemnet (File name should be max 400
                character)
              </label>

              {tenderDocumentsData?.bid_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.bid_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleBidsFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddBidDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!BidDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: BidDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: BidDocs?.length ? "#fafafd" : "none",
                }}
              >
                {BidDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== BidDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleBidsRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!BidDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            {roleemp != "CertificationAccessCvTeamHead" &&
              roleemp != "CertificationAccessCvTeam" && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <label style={{ fontSize: "16px", fontWeight: 500 }}>
                    Bidder
                  </label>

                  <table
                    className="table-css table-border"
                    style={{ borderRadius: "15px" }}
                  >
                    <thead className="table-heading">
                      <tr className="custom-table-head-tr">
                        <th
                          className="table-heading-text text-center table-border"
                          style={{ padding: "8px 10px" }}
                        >
                          S.No
                        </th>
                        <th
                          className="table-heading-text text-center table-border"
                          style={{ padding: "8px 10px" }}
                        >
                          Bidder Name
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {tenderDocumentsData?.bidders?.map((bidder, index) => (
                        <tr>
                          <td
                            className="text-center table-border"
                            style={{ fontSize: "14px" }}
                          >
                            {index + 1}
                          </td>
                          <td
                            className="text-center table-border"
                            style={{ fontSize: "14px" }}
                          >
                            {bidder.bidder_name}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="flex-column form-group-selectt">
                    <label
                      htmlFor="bidder_name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Bidder Name<span className="required">*</span>
                    </label>
                    <br />
                    <input
                      type="text"
                      name="bidder_name"
                      placeholder="bidder_name"
                      value={tenderDocumentsData.bidder_name.value}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          bidder_name: {
                            ...prev.bidder_name,
                            value: e.target.value,
                          },
                        }))
                      }
                      className={`form-input input-form`}
                    />
                  </div>

                  <button
                    className="upload-svg"
                    style={{
                      display: "flex",
                      gap: "10px",
                      width: "fit-content",
                      marginLeft: "auto",
                    }}
                    disabled={
                      tenderDocumentsData.bidder_name.loading ||
                      tenderDocumentsData.bidder_name.value === ""
                    }
                    onClick={handleBidderSubmit}
                  >
                    <AddwithWhiteCircle />
                    Add
                  </button>
                </div>
              )}

            <p className="error-message font-size-text">
              {isSubmitteddoc && Object.keys(errorsdoc).length > 0 && (
                <h6 className="text-center">
                  {"Error in: " +
                    Object.keys(errorsdoc)
                      .map((field) => {
                        // Convert field names to readable format
                        const formatted = field
                          .replace(/_/g, " ") // replace underscores with spaces
                          .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letters
                        return `${formatted}`; // include the actual error message
                      })
                      .join(", ")}
                </h6>
              )}
            </p>

            <button
              onClick={handleTenderDocumentUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        dialogClassName="edit-tender-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Tender Information </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              borderBottom: "1px solid #e0e0e0",
              marginBottom: 20,
              gap: 16,
            }}
            role="tablist"
          >
            {filteredTabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                type="button"
                style={{
                  padding: "10px 20px",
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: 16,
                  color: "#495057",
                  background: "none",
                  border: "none",
                  borderBottom: "2px solid transparent",
                  outline: "none",
                  transition: "color 0.18s, border-bottom 0.18s",
                  ...(activeTab === tab.key
                    ? {
                      color: "#0d6efd",
                      borderBottom: "2px solid #0d6efd",
                      fontWeight: 700,
                    }
                    : {}),
                }}
                tabIndex={0}
                aria-selected={activeTab === tab.key}
                role="tab"
                aria-controls={`tab-panel-${tab.key}`}
                id={`tab-${tab.key}`}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <div
            id={`tab-panel-${activeTab}`}
            role="tabpanel"
            aria-labelledby={`tab-${activeTab}`}
            style={{
              background: "#fafbfc",
              borderRadius: 8,
              padding: 20,
              minHeight: 180,
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            }}
          >
            {renderTabContent()}
          </div>
        </Modal.Body>
        {/* <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}
      </Modal>
    </>
  );
};
function EditTenderInfoTab({
  showEditModal,
  handleCloseEditModal,
  toggleState,
  tenders,
  tenderId,
  getBidData,
  editTenderData,
  showModal,
  filters,
  roleemp,
}) {
  const TABS = [
    { key: "eligibility", label: "Eligibility Criteria" },
    { key: "partners", label: "Finalize Partners" },
    { key: "documents", label: "Attach Tender Documents" },
  ];

  const tender = useMemo(() => {
    return tenders?.find((t) => t.id === tenderId) ?? {};
  }, [tenders, tenderId]);

  // State for selected stage
  const [selectedStage, setSelectedStage] = useState("wishlist");

  // Filter tabs based on selected stage
  const filteredTabs = useMemo(() => {
    switch (selectedStage) {
      case "wishlist":
        return TABS.filter((tab) => tab.key === "eligibility");
      case "target":
        return TABS.filter(
          (tab) => tab.key === "eligibility" || tab.key === "partners",
        );
      case "final":
        return TABS; // Show all tabs
      default:
        return TABS.filter((tab) => tab.key === "eligibility");
    }
  }, [selectedStage]);

  const getInitialTab = () => {
    return filteredTabs.length > 0 ? filteredTabs[0].key : null;
  };

  const [activeTab, setActiveTab] = useState(getInitialTab());

  useEffect(() => {
    const tabExists = filteredTabs.find((tab) => tab.key === activeTab);
    if (!tabExists) {
      const newActive = filteredTabs.length > 0 ? filteredTabs[0].key : null;
      if (newActive !== activeTab) {
        setActiveTab(newActive);
      }
    }
  }, [selectedStage, activeTab, filteredTabs]);

  // Handle stage change
  const handleStageChange = (e) => {
    const stage = e.target.value;
    setSelectedStage(stage);

    // Reset to first available tab when stage changes
    switch (stage) {
      case "wishlist":
        setActiveTab("eligibility");
        break;
      case "target":
        setActiveTab("eligibility");
        break;
      case "final":
        setActiveTab("eligibility");
        break;
      default:
        setActiveTab("eligibility");
    }
  };

  // Get toggle state based on selected stage
  const getToggleState = () => {
    switch (selectedStage) {
      case "wishlist":
        return 1; // is_in_bidlist
      case "target":
        return 2; // is_in_targetlist
      case "final":
        return 3; // is_finalize
      default:
        return 1;
    }
  };

  // Form data states
  const [tenderDocumentsData, setTenderDocumentsData] = useState({
    checklist: tender.checklist ?? false,
    all_docs_done: tender.all_docs_done ?? false,
    tech_score: tender.tech_score ?? "",
    cv_score: tender.cv_score ?? "",
    tech_doc: tender.tech_doc ?? [],
    financial_doc: tender.financial_doc ?? [],
    cvs_files: tender.cv_doc ?? [],
    bid_doc: tender.bid_doc ?? [],
    bidder_doc: tender.bidder_doc ?? [],
    all_cvs_done: tender.all_cvs_done ?? false,
    bidders: tender.tender_bidders ?? [],
    bidder_name: {
      value: "",
      laoding: false,
    },
  });

  const [finalizePartnersData, setFinalizePartnersData] = useState({
    lead_partner: tender.lead_partner
      ? tender.lead_partner
      : tender.lead_qualify
        ? tender.company_name
        : "",
    lead_partner_share: tender.lead_partner_share ?? "",
    partner_share_sum: 0,
    jv_partner_share: tender.jv_partner_share ?? "",
    jv_partner_name:
      tender.soil_quality === true
        ? "Not Required"
        : tender.jv_partner_name
          ? tender.jv_partner_name
          : tender.jv_qualify
            ? tender.company_name
            : "",
    assosiate_partner:
      tender.soil_quality === true
        ? "Not Required"
        : tender.assosiate_partner
          ? tender.assosiate_partner
          : tender.associate_qualify
            ? tender.company_name
            : "",
    associate_partner_share: tender.associate_partner_share ?? "",
    bg_requried: tender.bg_requried,
    bg_amount: tender.bg_amount ?? 0,
    bg_prepare_by: tender.bg_prepare_by ?? "",
    bid_prepare_by: tender.bid_prepare_by ?? "",
    bid_prepare_by_remarks: tender.bid_prepare_by_remarks ?? "",
    // emd_assumpter: tender.emd_assumpter,

    bg_type: tender.bg_type ?? "",

    tender_submission_type: tender.tender_submission_type ?? "",

    team_required: tender.team_required,
    team_requirements_details: tender.team_requirements_details ?? "",
    team_prepare_by: tender.team_prepare_by,
    team_prepare_by_remarks: tender.team_prepare_by_remarks,
  });

  const [eligibilityCriteriaData, setEligibilityCriteriaData] = useState({
    eligibity_criteria: tender?.eligibity_criteria ?? "",
    eligibity_criteria_special: tender?.eligibity_criteria_special ?? "",
    is_jv_allowed: tender?.is_jv_allowed ?? false,
    is_jv_consorium_association_allowed:
      tender?.is_jv_consorium_association_allowed ?? false,
    company_name: tender?.company_name ?? "",
    company_dist_lead: tender?.company_dist_lead,
    company_dist_jv: tender?.company_dist_jv,
    soil_quality: tender?.soil_quality ?? false,
    participating_as: tender?.participating_as ?? "",
    terms_of_jv: tender?.terms_of_jv ?? "",
    tech_score: tender?.tech_score ?? "",
    company_score: tender?.company_score ?? "",
    site_apprisate_required: tender?.site_apprisate_required ?? false,
    site_apprisate_marking: tender?.site_apprisate_marking ?? "",
    work_methodology_required: tender?.work_methodology_required ?? false,
    work_methodology_marking: tender?.work_methodology_marking ?? "",
    presentation_required: tender?.presentation_required ?? false,
    presentation_type: tender?.presentation_type ?? "",
    presentation_required_marking: tender?.presentation_required_marking ?? "",
  });

  useEffect(() => {
    if (tender) {
      setEligibilityCriteriaData({
        eligibity_criteria: tender?.eligibity_criteria ?? "",
        eligibity_criteria_special: tender?.eligibity_criteria_special ?? "",
        is_jv_allowed: tender?.is_jv_allowed ?? false,
        is_jv_consorium_association_allowed:
          tender?.is_jv_consorium_association_allowed ?? false,
        company_name: tender?.company_name ?? "",
        company_dist_lead: tender?.company_dist_lead,
        company_dist_jv: tender?.company_dist_jv,
        soil_quality: tender?.soil_quality ?? false,
        participating_as: tender?.participating_as ?? "",
        terms_of_jv: tender?.terms_of_jv ?? "",
        tech_score: tender?.tech_score ?? "",
        company_score: tender?.company_score ?? "",
        site_apprisate_required: tender?.site_apprisate_required ?? false,
        site_apprisate_marking: tender?.site_apprisate_marking ?? "",
        work_methodology_required: tender?.work_methodology_required ?? false,
        work_methodology_marking: tender?.work_methodology_marking ?? "",
        presentation_required: tender?.presentation_required ?? false,
        presentation_type: tender?.presentation_type ?? "",
        presentation_required_marking:
          tender?.presentation_required_marking ?? "",
      });
      setFinalizePartnersData({
        lead_partner: tender.lead_partner
          ? tender.lead_partner
          : tender.lead_qualify
            ? tender.company_name
            : "",
        lead_partner_share: tender.lead_partner_share ?? "",
        partner_share_sum: 0,
        jv_partner_share: tender.jv_partner_share ?? "",
        jv_partner_name: tender.jv_partner_name
          ? tender.jv_partner_name
          : tender.jv_qualify
            ? tender.company_name
            : "",
        assosiate_partner: tender.assosiate_partner
          ? tender.assosiate_partner
          : tender.associate_qualify
            ? tender.company_name
            : "",
        associate_partner_share: tender.associate_partner_share ?? "",
        bg_requried: tender.bg_requried,
        bg_amount: tender.bg_amount ?? 0,
        bg_prepare_by: tender.bg_prepare_by ?? "",
        bid_prepare_by: tender.bid_prepare_by ?? "",
        bid_prepare_by_remarks: tender.bid_prepare_by_remarks ?? "",
        // emd_assumpter: tender.emd_assumpter,

        bg_type: tender.bg_type ?? "",

        tender_submission_type: tender.tender_submission_type ?? "",

        team_required: tender.team_required,
        team_requirements_details: tender.team_requirements_details ?? "",
        team_prepare_by: tender.team_prepare_by,
        team_prepare_by_remarks: tender.team_prepare_by_remarks,
      });
      setTenderDocumentsData({
        checklist: tender.checklist ?? false,
        all_docs_done: tender.all_docs_done ?? false,
        tech_score: tender.tech_score ?? "",
        cv_score: tender.cv_score ?? "",
        tech_doc: tender.tech_doc ?? [],
        financial_doc: tender.financial_doc ?? [],
        cvs_files: tender.cv_doc ?? [],
        bid_doc: tender.bid_doc ?? [],
        bidder_doc: tender.bidder_doc ?? [],
        all_cvs_done: tender.all_cvs_done ?? false,
        bidders: tender.tender_bidders ?? [],
        bidder_name: {
          value: "",
          laoding: false,
        },
      });
    }
    const updatedSum =
      parseInt(tender.lead_partner_share) +
      parseInt(tender.associate_partner_share) +
      parseInt(tender.jv_partner_share);
    setFinalizePartnersData((prev) => ({
      ...prev,
      partner_share_sum: updatedSum,
    }));
  }, [tender]);

  useEffect(() => {
    const updatedSum =
      (parseInt(finalizePartnersData.lead_partner_share) || 0) +
      (parseInt(finalizePartnersData.associate_partner_share) || 0) +
      (parseInt(finalizePartnersData.jv_partner_share) || 0);

    if (finalizePartnersData.partner_share_sum !== updatedSum) {
      setFinalizePartnersData((prev) => ({
        ...prev,
        partner_share_sum: updatedSum,
      }));
    }
  }, [
    finalizePartnersData.lead_partner_share,
    finalizePartnersData.associate_partner_share,
    finalizePartnersData.jv_partner_share,
  ]);
  const [errorsdoc, setErrorsDoc] = useState({});
  const [isSubmitteddoc, setIsSubmittedDoc] = useState(false);
  const addToggleStateFlags = (data) => {
    const toggleState = getToggleState();
    const updatedData = { ...data };

    if (toggleState === 1) {
      updatedData.is_in_bidlist = true;
      updatedData.is_in_targetlist = false;
      updatedData.is_finalize = false;
      updatedData.is_bid_prepare_in_progress = false;
      updatedData.is_submitted = false;
      updatedData.is_cancelled = false;
      updatedData.is_rejected = false;
      updatedData.date_aa = new Date().toISOString();
    } else if (toggleState === 2) {
      updatedData.is_in_targetlist = true;
      updatedData.is_in_bidlist = true;
      updatedData.is_finalize = false;
      updatedData.is_bid_prepare_in_progress = false;
      updatedData.is_submitted = false;
      updatedData.is_cancelled = false;
      updatedData.is_rejected = false;
      updatedData.date_bb = new Date().toISOString();
    } else if (toggleState === 3) {
      updatedData.is_in_bidlist = true;
      updatedData.is_in_targetlist = true;
      updatedData.is_bid_prepare_in_progress = false;
      updatedData.is_submitted = false;
      updatedData.is_finalize = true;
      updatedData.is_cancelled = false;
      updatedData.is_rejected = false;
      updatedData.date_cc = new Date().toISOString();
    } else if (toggleState === 9) {
      updatedData.is_in_bidlist = true;
      updatedData.is_in_targetlist = true;
      updatedData.is_bid_prepare_in_progress = true;

      updatedData.is_finalize = true;
      updatedData.is_submitted = false;
      updatedData.is_cancelled = false;
      updatedData.is_rejected = false;
      updatedData.date_ee = new Date().toISOString();
    } else if (toggleState === 4) {
      updatedData.is_in_bidlist = true;
      updatedData.is_in_targetlist = true;

      updatedData.is_submitted = false;
      updatedData.is_finalize = true;

      updatedData.is_bid_prepare_in_progress = true;
      updatedData.is_cancelled = false;
      updatedData.is_rejected = false;
      updatedData.date_ff = new Date().toISOString();
    }

    return updatedData;
  };
  const validateFormTenderdocument = () => {
    const newErrors = {};
    let requiredFields = [];

    requiredFields = [
      tenderDocumentsData.all_docs_done === null ? "all_docs_done" : null,
      tenderDocumentsData.all_cvs_done === null ? "all_cvs_done" : null,
      tenderDocumentsData.checklist === null ? "checklist" : null,

      "tech_score",
      "cv_score",
    ].filter(Boolean);

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          tenderDocumentsData,
        );
    };

    requiredFields.forEach((field) => {
      if (!tenderDocumentsData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrorsDoc(newErrors);
    setIsSubmittedDoc(true);
    return Object.keys(newErrors).length === 0;
  };
  const handleTenderDocumentUpdate = async (e) => {
    if (validateFormTenderdocument()) {
      e.preventDefault();
      const loadingToastId = toast.loading("Loading: Please wait...");
      const dataWithToggleState = addToggleStateFlags(tenderDocumentsData);
      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          dataWithToggleState,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          const getJsonData = (data) => {
            if (data instanceof FormData) {
              return Object.fromEntries(data.entries());
            }
            return data; // already JSON
          };

          await saveAudit({
            tenderId: tenderId,
            updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
            tableName: "Tenderforbd",
            oldData: getJsonData(tender),
            newData: getJsonData(tenderDocumentsData),
            action: "UPDATE",
            tab_id: toggleState,
          });
          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  const [errorseligiblity, setErrorsEligibilty] = useState({});
  const [isSubmittedeligiblity, setIsSubmittedEligibility] = useState(false);
  const validateFormEligibility = () => {
    const newErrors = {};
    let requiredFields = [];

    requiredFields = [
      eligibilityCriteriaData.is_jv_allowed === null ? "is_jv_allowed" : null,
      "tech_score",
      "company_score",
      "company_name",
      "eligibity_criteria",
      eligibilityCriteriaData.eligibity_criteria != "" &&
        eligibilityCriteriaData.eligibity_criteria === "Special"
        ? "eligibity_criteria_special"
        : null,
      eligibilityCriteriaData.soil_quality === null ? "soil_quality" : null,
      eligibilityCriteriaData.participating_as === null
        ? "participating_as"
        : null,
      eligibilityCriteriaData.is_jv_consorium_association_allowed === null
        ? "jv_consorium_association_allowed"
        : null,

      eligibilityCriteriaData.site_apprisate_required === null
        ? "site_apprisate_required"
        : null,
      eligibilityCriteriaData.site_apprisate_required !== null
        ? "site_apprisate_marking"
        : null,
      eligibilityCriteriaData.work_methodology_required === null
        ? "work_methodology_required"
        : null,
      eligibilityCriteriaData.work_methodology_required != null &&
        eligibilityCriteriaData.work_methodology_required
        ? "work_methodology_marking"
        : null,
      eligibilityCriteriaData.presentation_required === null
        ? "presentation_required"
        : null,
      eligibilityCriteriaData.presentation_required !== null &&
        eligibilityCriteriaData.presentation_required
        ? "presentation_required_marking"
        : null,
      eligibilityCriteriaData.presentation_required !== null &&
        eligibilityCriteriaData.presentation_required
        ? "presentation_type"
        : null,
    ].filter(Boolean);

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          eligibilityCriteriaData,
        );
    };

    requiredFields.forEach((field) => {
      if (!eligibilityCriteriaData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrorsEligibilty(newErrors);
    setIsSubmittedEligibility(true);
    return Object.keys(newErrors).length === 0;
  };

  // const handleEligibilityCriteriaUpdate = async (e) => {
  //     if (validateFormEligibility()) {
  //         e.preventDefault();
  //         const loadingToastId = toast.loading("Loading: Please wait...");
  //         try {
  //             const res = await axios.put(
  //                 `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
  //                 eligibilityCriteriaData,
  //                 {
  //                     headers: {
  //                         "Content-Type": "multipart/form-data",
  //                     },
  //                 },
  //             );

  //             if (res.status === 200 || res.status === 201) {
  //                 const getJsonData = (data) => {
  //                     if (data instanceof FormData) {
  //                         return Object.fromEntries(data.entries());
  //                     }
  //                     return data; // already JSON
  //                 };

  //                 await saveAudit({
  //                     tenderId: tenderId,
  //                     updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
  //                     tableName: "Tenderforbd",
  //                     oldData: getJsonData(tender),
  //                     newData: getJsonData(eligibilityCriteriaData),
  //                     action: "UPDATE"
  //                 });
  //                 handleCloseEditModal();
  //                 sessionStorage.setItem("scrollTenderId", tenderId);
  //                 await getBidData(filters);
  //             }
  //         } catch (err) {
  //             handleErrorToast(err);
  //         } finally {
  //             toast.dismiss(loadingToastId);
  //         }
  //     }
  // };
  const handleEligibilityCriteriaUpdate = async (e) => {
    if (validateFormEligibility()) {
      e.preventDefault();

      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        // ✅ Clone data (important)
        let updatedData = { ...eligibilityCriteriaData };

        // ✅ 1. If not Special → blank it
        if (updatedData.eligibity_criteria !== "Special") {
          updatedData.eligibity_criteria_special = "";
        }

        // ✅ 2. Site Appraisal
        if (!updatedData.site_apprisate_required) {
          updatedData.site_apprisate_marking = 0;
        }

        // ✅ 3. Work Methodology
        if (!updatedData.work_methodology_required) {
          updatedData.work_methodology_marking = 0;
        }

        // ✅ 4. Presentation
        if (!updatedData.presentation_required) {
          updatedData.presentation_required_marking = 0;
          updatedData.presentation_type = "";
        }
        const finalData = addToggleStateFlags(updatedData);
        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          finalData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          const getJsonData = (data) => {
            if (data instanceof FormData) {
              return Object.fromEntries(data.entries());
            }
            return data;
          };

          await saveAudit({
            tenderId: tenderId,
            updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
            tableName: "Tenderforbd",
            oldData: getJsonData(tender),
            newData: getJsonData(updatedData),
            action: "UPDATE",
            tab_id: getToggleState(),
          });

          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  const [errorspartner, setErrorsPartner] = useState({});
  const [isSubmittedpartner, setIsSubmittedPartner] = useState(false);
  const validateFormPartner = () => {
    const newErrors = {};
    let requiredFields = [];
    const partnerShareSum =
      (parseInt(finalizePartnersData.lead_partner_share) || 0) +
      (finalizePartnersData.jv_partner_name !== "Not Required"
        ? parseInt(finalizePartnersData.jv_partner_share) || 0
        : 0) +
      (finalizePartnersData.assosiate_partner !== "Not Required"
        ? parseInt(finalizePartnersData.associate_partner_share) || 0
        : 0);

    if (partnerShareSum !== 100) {
      newErrors["partner_share_sum"] =
        partnerShareSum > 100
          ? "Sum of all partner shares must not be more than 100"
          : "Sum of all partner shares must not be less than 100";
    }

    requiredFields = [
      finalizePartnersData.tender_submission_type === null
        ? "tender_submission_type"
        : null,

      finalizePartnersData.bid_prepare_by === null ? "bid_prepare_by" : null,
      finalizePartnersData.bg_prepare_by === null ? "bg_prepare_by" : null,
      "lead_partner_share",
      finalizePartnersData.jv_partner_name != "Not Required"
        ? "jv_partner_share"
        : null,
      finalizePartnersData.assosiate_partner != "Not Required"
        ? "associate_partner_share"
        : null,
      finalizePartnersData.team_required === null ? "team_required" : null,
      finalizePartnersData.team_required !== null &&
        finalizePartnersData.team_required
        ? "team_prepare_by"
        : null,
      finalizePartnersData.team_required !== null &&
        finalizePartnersData.team_required
        ? "team_prepare_by_remarks"
        : null,
      finalizePartnersData.team_required !== null &&
        finalizePartnersData.team_required
        ? "team_requirements_details"
        : null,
    ].filter(Boolean);

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          finalizePartnersData,
        );
    };

    requiredFields.forEach((field) => {
      if (!finalizePartnersData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrorsPartner(newErrors);
    setIsSubmittedPartner(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleFinalizePartnerUpdate = async (e) => {
    if (validateFormPartner()) {
      e.preventDefault();
      let data = { ...finalizePartnersData };
      const loadingToastId = toast.loading("Loading: Please wait...");
      if (finalizePartnersData.lead_partner === "Not Required") {
        data.lead_partner_share = 0;
      }

      if (finalizePartnersData.jv_partner_name === "Not Required") {
        data.jv_partner_share = 0;
      }

      if (finalizePartnersData.assosiate_partner === "Not Required") {
        data.associate_partner_share = 0;
      }
      if (!finalizePartnersData.team_required) {
        data.team_prepare_by = "";
        data.team_prepare_by_remarks = "";
        data.team_requirements_details = "";
      }
      const finalData = addToggleStateFlags(data);
      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          finalData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          const getJsonData = (data) => {
            if (data instanceof FormData) {
              return Object.fromEntries(data.entries());
            }
            return data; // already JSON
          };

          await saveAudit({
            tenderId: tenderId,
            updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
            tableName: "FinancialParticipants",
            oldData: getJsonData(tender),
            newData: getJsonData(finalizePartnersData),
            action: "UPDATE",
            tab_id: getToggleState(),
          });
          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  const [cvsDocs, setCvsDocs] = useState([]);
  const [techDocs, setTechDocs] = useState([]);
  const [finacialDocs, setFinancialDocs] = useState([]);
  const [BidDocs, setBidDocs] = useState([]);
  const handleCvsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setCvsDocs(newFiles);
    }
  };

  const handleCvsRemove = (index) => {
    setCvsDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddCvDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      cvsDocs.forEach((file) => {
        formData.append("cv_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkcv/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = cvsDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "Cv",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
          tab_id: getToggleState(),
        });
      }
    } catch (uploadErr) {
      setCvsDocs([]);
    } finally {
      setCvsDocs([]);
      getBidData();
    }
  };

  const handleTechFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setTechDocs(newFiles);
    }
  };

  const handleTechRemove = (index) => {
    setTechDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddTechDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      techDocs.forEach((file) => {
        formData.append("tech_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulktech/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = techDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "TechDocumentBd",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
        });
      }
    } catch (uploadErr) {
      setTechDocs([]);
    } finally {
      setTechDocs([]);
      getBidData();
    }
  };

  const handleFinancialFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setFinancialDocs(newFiles);
    }
  };

  const handleFinancialRemove = (index) => {
    setFinancialDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddFinancialDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      finacialDocs.forEach((file) => {
        formData.append("financial_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkfinancial/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = finacialDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "FinancialDocument",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
        });
      }
    } catch (uploadErr) {
      setFinancialDocs([]);
    } finally {
      setFinancialDocs([]);
      getBidData();
    }
  };

  const handleBidsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setBidDocs(newFiles);
    }
  };

  const handleBidsRemove = (index) => {
    setBidDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddBidDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      BidDocs.forEach((file) => {
        formData.append("bid_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkbbid/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = BidDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "BidTenderDocument",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
        });
      }
    } catch (uploadErr) {
      setBidDocs([]);
    } finally {
      setBidDocs([]);
      getBidData();
    }
  };
  const [stop, SetStop] = useState(false);
  const handleBidderSubmit = async (name, id) => {
    const data = {
      bidder_name: name ? name : tenderDocumentsData.bidder_name.value,
      TenderforBD: tenderId ? tenderId : id,
      number_of_bidder: 1,
    };
    try {
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidder_name: { ...prev.bidder_name, loading: true },
      }));
      const res = await axios.post(`${BASE_URL}/siteproject/bidder/`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidders: [...prev.bidders, res.data],
        bidder_name: { ...prev.bidder_name, value: "" },
      }));
      SetStop(true);
    } catch (err) {
    } finally {
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidder_name: { ...prev.bidder_name, loading: false },
      }));
    }
  };
  useEffect(() => {
    if (
      showModal &&
      editTenderData != undefined &&
      editTenderData?.lead_partner != null &&
      !stop &&
      editTenderData?.tender_bidders?.length == 0
    ) {
      SetStop(true);
    }
  }, [editTenderData, showModal, tenderDocumentsData, stop]);

  const EmdType = [
    { key: "Bank_Gurantee", value: "Bank Gurantee" },
    { key: "neft", value: "NEFT" },
    { key: "demand_draft", value: "Demand Draft" },
    { key: "suretybond", value: "Surety Bond" },
    { key: "other", value: "Other" },
  ];
  const Partners = [
    {
      key: "Saptagon Asia Private Limited",
      value: "Saptagon Asia Private Limited",
    },
    {
      key: "Civilmantra Infracon Limited",
      value: "Civilmantra Infracon Limited",
    },
    {
      key: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED",
      value: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED",
    },
    { key: "ISAN CORPORATION", value: "ISAN CORPORATION" },
    { key: "MARC TECHNOCRATS LIMITED", value: "MARC TECHNOCRATS LIMITED" },
    {
      key: "ALOMNDS GLOBAL INFRASTRUCTURE",
      value: "ALOMNDS GLOBAL INFRASTRUCTURE",
    },
    { key: "VOYANTS SOLUTIONS PVT LTD", value: "VOYANTS SOLUTIONS PVT LTD" },
    {
      key: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED",
      value: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED",
    },
    { key: "MSV INTERNATIONAL", value: "MSV INTERNATIONAL" },
    { key: "YONGMA ENGINEERING CO LTD", value: "YONGMA ENGINEERING CO LTD" },
    { key: "TECH-4", value: "TECH-4" },
    {
      key: "AECOM INDIA PRIVATE LIMITED",
      value: "AECOM INDIA PRIVATE LIMITED",
    },
    { key: "SMEC INDIA PVT LTD", value: "SMEC INDIA PVT LTD" },
    { key: "SPECTRUM", value: "SPECTRUM" },
    { key: "INSTUTIUTE GIPROSTROYMOST", value: "INSTUTIUTE GIPROSTROYMOST" },
    {
      key: "RODIC CONSULTANT PRIVATE LIMITED",
      value: "RODIC CONSULTANT PRIVATE LIMITED",
    },
    {
      key: "CHAITANYA PROJECT CONSULTANCY LTD",
      value: "CHAITANYA PROJECT CONSULTANCY LTD",
    },
    {
      key: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)",
      value: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)",
    },
    {
      key: "TPF ENGINEERING PRIVATE LIMITED",
      value: "TPF ENGINEERING PRIVATE LIMITED",
    },
    {
      key: "INFRAPLUS CONSULTANCY PVT LTD",
      value: "INFRAPLUS CONSULTANCY PVT LTD",
    },
    { key: "RITES LIMITED", value: "RITES LIMITED" },
    { key: "TPF GETINSAEUROESTUDIOS SL", value: "TPF GETINSAEUROESTUDIOS SL" },
    {
      key: "SA INFRASTURCTURE CONSULTING PRIVATE",
      value: "SA INFRASTURCTURE CONSULTING PRIVATE",
    },
    { key: "CEG LIMITED", value: "CEG LIMITED" },
    {
      key: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD",
      value: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD",
    },
    { key: "Egis", value: "Egis" },
    { key: "OPEN SOLUTION", value: "OPEN SOLUTION" },
    { key: "SUMAD ENTERPRISE", value: "SUMAD ENTERPRISE" },
    {
      key: "Earl Techno Consultant Pvt. Ltd.",
      value: "Earl Techno Consultant Pvt. Ltd.",
    },
    { key: "Pentagon", value: "Pentagon" },
    { key: "Ropes", value: "Ropes" },
    { key: "WPKK", value: "WPKK" },
    { key: "sapl", value: "SAPL" },
    { key: "cipl", value: "CIPL" },
    { key: "DESIGN LINE CONSULTANCY", value: "DESIGN LINE CONSULTANCY" },
    { key: "GIPRO", value: "GIPRO" },
    { key: "joint", value: "Joint" },
    { key: "Other", value: "Other" },
    { key: "Not Required", value: "Not Required" },
  ];

  const [scoreError, setScoreError] = useState("");

  const renderTabContent = () => {
    switch (activeTab) {
      case "eligibility":
        return (
          <section
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div className="dropdown-wrapper flex-column justify-center  ">
              <label
                htmlFor="eligibity_criteria"
                className="form-label font-weight500 font-size-subheading"
              >
                Eligibilty Criteria<span className="required">*</span>
              </label>
              <select
                name="eligibity_criteria"
                placeholder="Please write a eligibility creteria. "
                value={eligibilityCriteriaData.eligibity_criteria}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    eligibity_criteria: e.target.value,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Eligibilty Criteria</option>
                <option value="Normal">Normal</option>
                <option value="Special">Special</option>
              </select>
            </div>
            {eligibilityCriteriaData.eligibity_criteria === "Special" && (
              <div className="dropdown-wrapper flex-column justify-center ">
                <label className="form-labels">
                  Eligibility Criteria Special
                  <span className="required">*</span>
                </label>
                <textarea
                  name="eligibity_criteria_special Eligibity Criteria"
                  placeholder="Please write Special Eligibilty Criteria "
                  value={eligibilityCriteriaData.eligibity_criteria_special}
                  className={`form-input input-form`}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      eligibity_criteria_special: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="is_jv_allowed"
                className="font-weight500 font-size-subheading"
              >
                Is Jv allowed<span className="required">*</span>
              </label>
              <select
                id="is_jv_allowed"
                name="is_jv_allowed"
                value={eligibilityCriteriaData.is_jv_allowed}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    is_jv_allowed:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Is Jv Allowed</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="is_jv_consorium_association_allowed"
                className="font-weight500 font-size-subheading"
              >
                Is Consorium/Association allowed
                <span className="required">*</span>
              </label>
              <select
                id="is_jv_consorium_association_allowed"
                name="is_jv_consorium_association_allowed"
                value={
                  eligibilityCriteriaData.is_jv_consorium_association_allowed
                }
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    is_jv_consorium_association_allowed:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Checklist</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {eligibilityCriteriaData.is_jv_consorium_association_allowed && (
              <div className="flex-column">
                <label className="form-labels">Terms of JV </label>
                <textarea
                  name="terms_of_jv"
                  placeholder="terms"
                  value={eligibilityCriteriaData.terms_of_jv}
                  className={`form-input input-form`}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      terms_of_jv: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            <div className="flex-column form-group-selectt">
              <label
                htmlFor="company_name"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Company Name<span className="required">*</span>
              </label>
              <br />
              <select
                id="company_name"
                name="company_name"
                value={eligibilityCriteriaData.company_name}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    company_name: e.target.value,
                  }))
                }
                className={`form-input input-form  form-group-selection`}
              >
                <option value="null">Select Company Name</option>
                <option value="sapl">SAPL</option>
                <option value="cipl">CIPL</option>
              </select>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="soil_quality"
                className="font-weight500 font-size-subheading"
              >
                Sole Qualify<span className="required">*</span>
              </label>
              <select
                id="soil_quality"
                name="soil_quality"
                value={eligibilityCriteriaData.soil_quality}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    soil_quality:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Sole Qualify</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="participating_as "
                className="  font-weight500    font-size-subheading"
              >
                Participating As<span className="required">*</span>
              </label>
              <br />
              <select
                id="participating_as"
                name="participating_as"
                value={eligibilityCriteriaData.participating_as}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    participating_as: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
              //style={{ width: '80% !important' }}
              >
                <option value="">Select Participating As</option>

                <option value="lead">Lead</option>
                <option value="jv">JV</option>
                <option value="associate">Associate</option>
                {eligibilityCriteriaData?.soil_quality ? (
                  <option value="sole">Sole</option>
                ) : (
                  ""
                )}
              </select>
            </div>

            <div
              className="joint-columns"
              style={{ display: "flex", gap: "20px", marginTop: "10px" }}
            >
              <div className="flex-column form-group-selectt widths50">
                <label
                  htmlFor="tech_score"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Total Tech Score<span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="tech_score"
                  placeholder="tech Score"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.tech_score}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      tech_score: e.target.value,
                    }))
                  }
                  style={{ width: "80%" }}
                />
              </div>

              <div className="flex-column form-group-selectt widths50">
                <label
                  htmlFor="company_score"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  {eligibilityCriteriaData.company_name === null ||
                    eligibilityCriteriaData.company_name === "null"
                    ? "Our Company"
                    : eligibilityCriteriaData.company_name?.toUpperCase()}{" "}
                  Technical Score<span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="company_score"
                  placeholder="Company Score"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.company_score}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (
                      Number(value) > Number(eligibilityCriteriaData.tech_score)
                    ) {
                      setScoreError(
                        "Company score cannot be greater than Total Tech Score",
                      );
                    } else {
                      setScoreError("");
                      setEligibilityCriteriaData((prev) => ({
                        ...prev,
                        company_score: value,
                      }));
                    }
                  }}
                  style={{ width: "80%" }}
                />
                <br />
                {scoreError && (
                  <p
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {scoreError}
                  </p>
                )}
              </div>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="site_apprisate_required"
                className="font-weight500 font-size-subheading"
              >
                Site Appreciate Required <span className="required">*</span>
              </label>
              <select
                id="site_apprisate_required"
                name="site_apprisate_required"
                value={eligibilityCriteriaData.site_apprisate_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    site_apprisate_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Site Appreciate Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            {eligibilityCriteriaData.site_apprisate_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="site_apprisate_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Site Appreciate Marking <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="site_apprisate_marking"
                  placeholder="site_apprisate_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.site_apprisate_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      site_apprisate_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="work_methodology_required"
                className="font-weight500 font-size-subheading"
              >
                Work Methodology Required <span className="required">*</span>
              </label>
              <select
                id="work_methodology_required"
                name="work_methodology_required"
                value={eligibilityCriteriaData.work_methodology_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    work_methodology_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Work Methodology Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            {eligibilityCriteriaData.work_methodology_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="work_methodology_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Work Methodology Marking <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="work_methodology_marking"
                  placeholder="work_methodology_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.work_methodology_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      work_methodology_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="presentation_required"
                className="font-weight500 font-size-subheading"
              >
                Presentation Required <span className="required">*</span>
              </label>
              <select
                id="presentation_required"
                name="presentation_required"
                value={eligibilityCriteriaData.presentation_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    presentation_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Presentation Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {eligibilityCriteriaData.presentation_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="presentation_required_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Presentation Required Marking{" "}
                  <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="presentation_required_marking"
                  placeholder="presentation_required_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.presentation_required_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      presentation_required_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            {eligibilityCriteriaData.presentation_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="presentation_type"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Presentation Type <span className="required">*</span>
                </label>
                <br />
                <select
                  id="presentation_type"
                  name="presentation_type"
                  className={`form-input input-form  form-group-selection `}
                  value={eligibilityCriteriaData.presentation_type}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      presentation_type: e.target.value,
                    }))
                  }
                >
                  <option value="null">Select Presentation Type</option>
                  <option value="Online">Online</option>
                  <option value="physical">Physical</option>
                  <option value="both">Both</option>
                </select>
              </div>
            )}
            <p className="error-message font-size-text">
              {" "}
              {isSubmittedeligiblity &&
                Object.keys(errorseligiblity).length > 0 && (
                  <h6 className="text-center">
                    {"Error in: " +
                      Object.keys(errorseligiblity)
                        .map((field) => {
                          // Convert field names to readable format
                          const formatted = field
                            .replace(/_/g, " ") // replace underscores with spaces
                            .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letters
                          return `${formatted}`; // include the actual error message
                        })
                        .join(", ")}
                  </h6>
                )}
            </p>

            <button
              onClick={handleEligibilityCriteriaUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      case "partners":
        return (
          <section
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div className="flex-column form-group-selectt ">
              <label
                htmlFor="lead_partner"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Lead Partner<span className="required">*</span>
              </label>
              <br />
              {finalizePartnersData.lead_qualify ? (
                <input
                  type="text"
                  name="lead_partner"
                  placeholder="lead partner"
                  value={finalizePartnersData.lead_partner}
                  disabled={finalizePartnersData.lead_qualify}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      lead_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              ) : (
                <select
                  id="lead_partner"
                  name="lead_partner"
                  value={finalizePartnersData.lead_partner}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      lead_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form  form-group-selection`}
                >
                  {Partners.map((partner) => (
                    <option value={partner.key}>{partner.value}</option>
                  ))}
                </select>
              )}
            </div>
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="lead_partner_share"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Lead Partner Share %<span className="required">*</span>
              </label>
              <br />
              <input
                type="number"
                name="lead_partner_share"
                placeholder="lead partner share"
                value={finalizePartnersData.lead_partner_share}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    lead_partner_share: e.target.value,
                  }))
                }
                className={`form-input input-form`}
              />
              {finalizePartnersData.partner_share_sum > 100 && (
                <label style={{ color: "red" }}>
                  Sum of all partner should not be more than 100
                </label>
              )}
              {finalizePartnersData.partner_share_sum < 100 && (
                <label style={{ color: "red" }}>
                  Sum of all lead partner should not be less than 100
                </label>
              )}
            </div>
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="jv_partner_name"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Jv Partner<span className="required">*</span>
              </label>
              <br />
              {finalizePartnersData.jv_qualify ? (
                <input
                  type="text"
                  name="jv_partner_name"
                  placeholder="Jv Partner"
                  value={finalizePartnersData.jv_partner_name}
                  disabled={finalizePartnersData.jv_qualify}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      jv_partner_name: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              ) : (
                <select
                  id="jv_partner_name"
                  name="jv_partner_name"
                  value={finalizePartnersData.jv_partner_name}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      jv_partner_name: e.target.value,
                    }))
                  }
                  className={`form-input input-form  form-group-selection`}
                >
                  {Partners.map((partner) => (
                    <option value={partner.key}>{partner.value}</option>
                  ))}
                </select>
              )}
            </div>

            {finalizePartnersData.jv_partner_name != "Not Required" && (
              <>
                {" "}
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="jv_partner_share"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Jv Partner Share %<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="number"
                    name="jv_partner_share"
                    placeholder="Jv Partner Share"
                    value={finalizePartnersData.jv_partner_share}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        jv_partner_share: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
                {finalizePartnersData.partner_share_sum > 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all partner should not be more than 100
                  </label>
                )}
                {finalizePartnersData.partner_share_sum < 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all lead partner should not be less than 100
                  </label>
                )}
              </>
            )}
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="assosiate_partner"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Assosiate Partner<span className="required">*</span>
              </label>
              <br />
              {finalizePartnersData.associate_qualify ? (
                <input
                  type="text"
                  name="assosiate_partner"
                  placeholder="Assosiate Partner"
                  value={finalizePartnersData.assosiate_partner}
                  disabled={finalizePartnersData.associate_qualify}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      assosiate_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              ) : (
                <select
                  id="assosiate_partner"
                  name="assosiate_partner"
                  value={finalizePartnersData.assosiate_partner}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      assosiate_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form  form-group-selection`}
                >
                  {Partners.map((partner) => (
                    <option value={partner.key}>{partner.value}</option>
                  ))}
                </select>
              )}
            </div>
            {finalizePartnersData.assosiate_partner != "Not Required" && (
              <>
                {" "}
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="associate_partner_share"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Associate Partner Share %<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="number"
                    name="associate_partner_share"
                    placeholder="Associate Partner Share"
                    value={finalizePartnersData.associate_partner_share}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        associate_partner_share: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
                {finalizePartnersData.partner_share_sum > 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all partner should not be more than 100
                  </label>
                )}
                {finalizePartnersData.partner_share_sum < 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all lead partner should not be less than 100
                  </label>
                )}
              </>
            )}

            <div className="dropdown-wrapper flex justify-center ">
              <label
                htmlFor="bid_prepare_by"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Bid Prepare By<span className="required">*</span>
              </label>
              <br />
              <select
                id="bid_prepare_by"
                name="bid_prepare_by"
                value={finalizePartnersData.bid_prepare_by}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    bid_prepare_by: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
              >
                <option value="">Select</option>
                <option
                  value={
                    finalizePartnersData.lead_partner
                      ? finalizePartnersData.lead_partner
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.lead_partner ||
                    finalizePartnersData.lead_partner != "null"
                    ? finalizePartnersData.lead_partner
                    : ""}
                </option>
                <option
                  value={
                    finalizePartnersData.jv_partner_name
                      ? finalizePartnersData.jv_partner_name
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.jv_partner_name ||
                    finalizePartnersData.jv_partner_name != "null"
                    ? finalizePartnersData.jv_partner_name
                    : ""}
                </option>
                <option
                  value={
                    finalizePartnersData.assosiate_partner
                      ? finalizePartnersData.assosiate_partner
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.assosiate_partner ||
                    finalizePartnersData.assosiate_partner != "null"
                    ? finalizePartnersData.assosiate_partner
                    : ""}
                </option>
              </select>
            </div>
            <div className="dropdown-wrapper flex justify-center ">
              <label className="form-labels font-weight500 font-size-subheading">
                Bid Prepare By Remarks
              </label>
              <br />
              <textarea
                name="bid_prepare_by_remarks"
                placeholder="Remarks for bid prepared by"
                value={finalizePartnersData.bid_prepare_by_remarks}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    bid_prepare_by_remarks: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
              />
            </div>

            <div className="dropdown-wrapper flex justify-center ">
              <label
                htmlFor="bg_prepare_by"
                className="form-labels  font-weight500    font-size-subheading"
              >
                BG Prepare By<span className="required">*</span>
              </label>
              <br />
              <select
                id="bg_prepare_by"
                name="bg_prepare_by"
                value={finalizePartnersData.bg_prepare_by}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    bg_prepare_by: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
              >
                <option value="">Select</option>
                <option
                  value={
                    finalizePartnersData.lead_partner
                      ? finalizePartnersData.lead_partner
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.lead_partner ||
                    finalizePartnersData.lead_partner != "null"
                    ? finalizePartnersData.lead_partner
                    : ""}
                </option>
                <option
                  value={
                    finalizePartnersData.jv_partner_name
                      ? finalizePartnersData.jv_partner_name
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.jv_partner_name ||
                    finalizePartnersData.jv_partner_name != "null"
                    ? finalizePartnersData.jv_partner_name
                    : ""}
                </option>
                <option
                  value={
                    finalizePartnersData.assosiate_partner
                      ? finalizePartnersData.assosiate_partner
                      : ""
                  }
                >
                  {" "}
                  {finalizePartnersData.assosiate_partner ||
                    finalizePartnersData.assosiate_partner != "null"
                    ? finalizePartnersData.assosiate_partner
                    : ""}
                </option>
              </select>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="team_required"
                className="font-weight500 font-size-subheading"
              >
                Team Required <span className="required">*</span>
              </label>
              <select
                id="team_required"
                name="team_required"
                value={finalizePartnersData.team_required}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    team_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Team Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {finalizePartnersData.team_required && (
              <>
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="team_prepare_by"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Team Prepare By<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="team_prepare_by"
                    name="team_prepare_by"
                    value={finalizePartnersData.team_prepare_by}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        team_prepare_by: e.target.value,
                      }))
                    }
                    className={`form-input input-form  form-group-selection`}
                  >
                    <option value="">Select</option>
                    <option
                      value={
                        finalizePartnersData.lead_partner
                          ? finalizePartnersData.lead_partner
                          : ""
                      }
                    >
                      {finalizePartnersData.lead_partner}
                    </option>
                    <option
                      value={
                        finalizePartnersData.jv_partner_name
                          ? finalizePartnersData.jv_partner_name
                          : ""
                      }
                    >
                      {" "}
                      {finalizePartnersData.jv_partner_name}
                    </option>
                    <option
                      value={
                        finalizePartnersData.assosiate_partner
                          ? finalizePartnersData.assosiate_partner
                          : ""
                      }
                    >
                      {" "}
                      {finalizePartnersData.assosiate_partner}
                    </option>
                  </select>
                </div>
                <div className="flex-column">
                  <label className="form-labels">
                    Team Prepare By Remarks <span className="required">*</span>
                  </label>
                  <textarea
                    name="team_prepare_by_remarks"
                    placeholder="Remarks for Team prepared by"
                    value={finalizePartnersData.team_prepare_by_remarks}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        team_prepare_by_remarks: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>{" "}
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="team_requirements_details"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Team Requirements Details<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="team_requirements_details"
                    placeholder="Team Requirements Deatils"
                    value={finalizePartnersData.team_requirements_details}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        team_requirements_details: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
              </>
            )}
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="tender_submission_type"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Tender Submission Type<span className="required">*</span>
              </label>
              <br />
              <select
                id="tender_submission_type"
                name="tender_submission_type"
                value={finalizePartnersData.tender_submission_type}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    tender_submission_type: e.target.value,
                  }))
                }
                className={`form-input input-form  form-group-selection`}
              >
                <option value="null">Select Tender Submission Type</option>
                <option value="Online">Online</option>
                <option value="physical">Physical</option>
                <option value="both">Both</option>
              </select>
            </div>
            <br />
            <p className="error-message font-size-text">
              {isSubmittedpartner && Object.keys(errorspartner).length > 0 && (
                <h6 className="text-center">
                  {"Error in: " +
                    Object.keys(errorspartner)
                      .map((field) => {
                        if (field === "partner_share_sum") {
                          return errorspartner[field]; // show the actual message directly
                        }
                        const formatted = field
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase());
                        return formatted;
                      })
                      .join(", ")}
                </h6>
              )}
            </p>
            <button
              onClick={handleFinalizePartnerUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      case "documents":
        return (
          <section>
            {roleemp != "CertificationAccessCvTeamHead" &&
              roleemp != "CertificationAccessCvTeam" && (
                <>
                  <div className="dropdown-wrapper flex-column justify-center ">
                    <label
                      htmlFor="checklist"
                      className="font-weight500 font-size-subheading"
                    >
                      Checklist <span className="required">*</span>
                    </label>
                    <select
                      id="checklist"
                      name="checklist"
                      value={tenderDocumentsData.checklist}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          checklist:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null,
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Checklist</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                  <div className="dropdown-wrapper flex-column justify-center ">
                    <label
                      htmlFor="all_docs_done"
                      className="font-weight500 font-size-subheading"
                    >
                      All Docs Done <span className="required">*</span>
                    </label>
                    <select
                      id="all_docs_done"
                      name="all_docs_done"
                      value={tenderDocumentsData.all_docs_done}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          all_docs_done:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null,
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">All Docs Done</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>

                  <div className="flex-column form-group-selectt">
                    <label
                      htmlFor="tech_score"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Total Technical Score <span className="required">*</span>
                    </label>
                    <br />
                    <input
                      type="text"
                      name="tech_score"
                      placeholder="tech Score"
                      value={tenderDocumentsData.tech_score}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          tech_score: e.target.value,
                        }))
                      }
                      className={`form-input input-form`}
                    />
                  </div>
                </>
              )}
            {(roleemp === "CertificationAccessCvTeamHead" ||
              roleemp === "CertificationAccessCvTeam" ||
              roleemp === "CertificationAccess" ||
              roleemp === "CertificateAccessBd" ||
              roleemp === "certificaionadminaccess") && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="cv_score"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    CV Score <span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="cv_score"
                    placeholder="CV Score"
                    value={tenderDocumentsData.cv_score}
                    onChange={(e) =>
                      setTenderDocumentsData((prev) => ({
                        ...prev,
                        cv_score: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
              )}
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Tech Proposal (File name should be max 400 character)
              </label>

              {tenderDocumentsData?.tech_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.tech_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleTechFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddTechDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!techDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: techDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: techDocs?.length ? "#fafafd" : "none",
                }}
              >
                {techDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== techDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleTechRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!techDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Financial Proposal (File name should be max 400
                character)
              </label>

              {tenderDocumentsData?.financial_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.financial_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleFinancialFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddFinancialDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!finacialDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: finacialDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: finacialDocs?.length ? "#fafafd" : "none",
                }}
              >
                {finacialDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== finacialDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleFinancialRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!finacialDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload CV's (File name should be max 400 character)
              </label>

              {tenderDocumentsData?.cvs_files?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.cvs_files.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleCvsFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddCvDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!cvsDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: cvsDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: cvsDocs?.length ? "#fafafd" : "none",
                }}
              >
                {cvsDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== cvsDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleCvsRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!cvsDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="all_cvs_done"
                className="font-weight500 font-size-subheading"
              >
                All Cvs Done
              </label>
              <select
                id="all_cvs_done"
                name="all_cvs_done"
                value={tenderDocumentsData.all_cvs_done}
                onChange={(e) =>
                  setTenderDocumentsData((prev) => ({
                    ...prev,
                    all_cvs_done:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">All Cvs Done</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Bid Acknowledgemnet (File name should be max 400
                character)
              </label>

              {tenderDocumentsData?.bid_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.bid_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleBidsFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddBidDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!BidDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: BidDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: BidDocs?.length ? "#fafafd" : "none",
                }}
              >
                {BidDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== BidDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleBidsRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!BidDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            {roleemp != "CertificationAccessCvTeamHead" &&
              roleemp != "CertificationAccessCvTeam" && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <label style={{ fontSize: "16px", fontWeight: 500 }}>
                    Bidder
                  </label>

                  <table
                    className="table-css table-border"
                    style={{ borderRadius: "15px" }}
                  >
                    <thead className="table-heading">
                      <tr className="custom-table-head-tr">
                        <th
                          className="table-heading-text text-center table-border"
                          style={{ padding: "8px 10px" }}
                        >
                          S.No
                        </th>
                        <th
                          className="table-heading-text text-center table-border"
                          style={{ padding: "8px 10px" }}
                        >
                          Bidder Name
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {tenderDocumentsData?.bidders?.map((bidder, index) => (
                        <tr>
                          <td
                            className="text-center table-border"
                            style={{ fontSize: "14px" }}
                          >
                            {index + 1}
                          </td>
                          <td
                            className="text-center table-border"
                            style={{ fontSize: "14px" }}
                          >
                            {bidder.bidder_name}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="flex-column form-group-selectt">
                    <label
                      htmlFor="bidder_name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Bidder Name<span className="required">*</span>
                    </label>
                    <br />
                    <input
                      type="text"
                      name="bidder_name"
                      placeholder="bidder_name"
                      value={tenderDocumentsData.bidder_name.value}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          bidder_name: {
                            ...prev.bidder_name,
                            value: e.target.value,
                          },
                        }))
                      }
                      className={`form-input input-form`}
                    />
                  </div>

                  <button
                    className="upload-svg"
                    style={{
                      display: "flex",
                      gap: "10px",
                      width: "fit-content",
                      marginLeft: "auto",
                    }}
                    disabled={
                      tenderDocumentsData.bidder_name.loading ||
                      tenderDocumentsData.bidder_name.value === ""
                    }
                    onClick={handleBidderSubmit}
                  >
                    <AddwithWhiteCircle />
                    Add
                  </button>
                </div>
              )}

            <p className="error-message font-size-text">
              {isSubmitteddoc && Object.keys(errorsdoc).length > 0 && (
                <h6 className="text-center">
                  {"Error in: " +
                    Object.keys(errorsdoc)
                      .map((field) => {
                        // Convert field names to readable format
                        const formatted = field
                          .replace(/_/g, " ") // replace underscores with spaces
                          .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letters
                        return `${formatted}`; // include the actual error message
                      })
                      .join(", ")}
                </h6>
              )}
            </p>

            <button
              onClick={handleTenderDocumentUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        dialogClassName="edit-tender-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Move Tender To Tab</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Move To Stage Dropdown */}
          <div
            className="dropdown-wrapper flex-column justify-center"
            style={{ marginBottom: "20px" }}
          >
            <label
              htmlFor="move_to_stage"
              className="form-label font-weight500 font-size-subheading"
            >
              Move To Stage<span className="required">*</span>
            </label>
            <select
              id="move_to_stage"
              name="move_to_stage"
              value={selectedStage}
              onChange={handleStageChange}
              className="form-input font-size-subheading"
            >
              <option value="">Select Stage to Move</option>
              <option value="wishlist">WishList</option>
              <option value="target">Target Tender</option>
              <option value="final">Final Tender</option>
            </select>
          </div>

          {/* Dynamic Tabs */}
          <div
            style={{
              display: "flex",
              borderBottom: "1px solid #e0e0e0",
              marginBottom: 20,
              gap: 16,
            }}
            role="tablist"
          >
            {filteredTabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                type="button"
                style={{
                  padding: "10px 20px",
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: 16,
                  color: "#495057",
                  background: "none",
                  border: "none",
                  borderBottom: "2px solid transparent",
                  outline: "none",
                  transition: "color 0.18s, border-bottom 0.18s",
                  ...(activeTab === tab.key
                    ? {
                      color: "#0d6efd",
                      borderBottom: "2px solid #0d6efd",
                      fontWeight: 700,
                    }
                    : {}),
                }}
                tabIndex={0}
                aria-selected={activeTab === tab.key}
                role="tab"
                aria-controls={`tab-panel-${tab.key}`}
                id={`tab-${tab.key}`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div
            id={`tab-panel-${activeTab}`}
            role="tabpanel"
            aria-labelledby={`tab-${activeTab}`}
            style={{
              background: "#fafbfc",
              borderRadius: 8,
              padding: 20,
              minHeight: 180,
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            }}
          >
            {renderTabContent(activeTab)}
          </div>
        </Modal.Body>
        {/* <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}
      </Modal>
    </>
  );
};

// ─── All other sub-components (TenderViewBgModal, UpdateBidDetails, Addtocart,
// AssignTeamOnly, TenderReject, TenderCancel, Tenderspecial, Tenderdiscuss,
// UploadSiteProject, StatusBadge, getTenderStatus, StatsCard,
// CorrigendumModal, CorrigendumModalScreening, TenderViewModal,
// TenderViewAddDocumentModal, TenderAddPresentationfiles,
// TenderViewModalPresnatation, TenderViewAddSingleNoteModal,
// TenderViewSingleNote, TenderViewNotes, TenderViewAddNotes,
// TenderViewAddBidders, EditTenderInfo, EditTenderInfoTab)
// are imported from the original file as-is. They are not reproduced here
// to avoid bloat — they must remain exactly as in the original Bid.jsx.
// The Bid() default export below is the only thing redesigned.

// ─── Helper ───────────────────────────────────────────────────────────────────
function getDaysLeftNumber(dateStr) {
  if (!dateStr) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const target = new Date(dateStr); target.setHours(0, 0, 0, 0);
  return Math.ceil((target - today) / (1000 * 60 * 60 * 24));
}

function getDaysLeftedNumber(dateStr) {
  if (!dateStr) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const target = new Date(dateStr); target.setHours(0, 0, 0, 0);
  return Math.ceil((target - today) / (1000 * 60 * 60 * 24));
}

function DaysBadge({ days, toggleState }) {
  if ([5, 11, 12].includes(toggleState)) return null;
  if (days === null) return null;
  if (days < 0) return <span className="bg-days-badge bg-days-badge--expired">{Math.abs(days)}d Exp</span>;
  if (days <= 3) return <span className="bg-days-badge bg-days-badge--urgent">{days}d</span>;
  if (days <= 10) return <span className="bg-days-badge bg-days-badge--warn">{days}d</span>;
  return <span className="bg-days-badge bg-days-badge--ok">{days}d</span>;
}

// helper (top of Bid component, or file-level)
const isRecentlyExpired = (t) => {
  const d = getDaysLeftNumber(t?.corrigendum_date || t?.submission_date);
  return d !== null && d < 0 && d >= -3 && !t?.is_submitted;
};



function SectorBadge({ sector }) {
  if (!sector) return null;
  return <span className="bg-sector-badge">{sector}</span>;
}

// Reads a "yes" value from custom_fields by name/key (case/space/underscore-insensitive)
const isCustomFlagYes = (tender, label) => {
  const norm = (s) => String(s ?? "").toLowerCase().replace(/[^a-z]/g, "");
  const target = norm(label);
  const f = (tender?.custom_fields || []).find(
    (cf) => norm(cf.key) === target || norm(cf.name) === target
  );
  if (!f) return false;
  const v = String(f.value).toLowerCase();
  return f.value === true || v === "true" || v === "yes";
};

// Moved out of the Internal ID cell
function ConstructionCostFlag({ tender }) {
  const isHighway =
    tender?.sector === "Highway" ||
    (tender?.sector === "Other" && tender?.other_sector_type === "Highway");
  if (!isHighway) return null;

  const val = parseFloat(tender?.construction_fees);
  const base = {
    display: "block", fontSize: 9, fontWeight: 700, borderRadius: 3,
    padding: "1px 4px", marginTop: 2, whiteSpace: "nowrap", width: "fit-content",
  };

  if (!tender?.construction_fees || isNaN(val))
    return <span style={{ ...base, fontWeight: 600, color: "#888", background: "#f0f0f0" }}>No Const. Value</span>;
  if (val >= 1000)
    return <span style={{ ...base, color: "#7c2d12", background: "#fef2f2", border: "1px solid #fca5a5" }}>≥1000cr</span>;
  if (val >= 500)
    return <span style={{ ...base, color: "#92400e", background: "#fffbeb", border: "1px solid #fcd34d" }}>≥500cr</span>;
  return <span style={{ ...base, color: "#1e40af", background: "#eff6ff", border: "1px solid #93c5fd" }}>&lt;500cr</span>;
}

// ─── Expanded Row Panel ───────────────────────────────────────────────────────
function ExpandedTenderRow({
  i, toggleState, getBidData, filters,
  openCorrigendumModal, openCorrigendumModalScreening,
  handleShow, handleOpenBackModal, handleOpenEditModal, handleOpenEditModalTab,
  roleemp, toggleCvDone, toggleDocumentDone,
  bgData, scrollToTender, setScrollToTender, handleScrollToTender,
  editingId, setEditingId, tenderFeeMap, setTenderFeeMap,
  navigate, setToggleState,
  getDaysLeftNumber,
  Addtocart,
  TenderRejectComponent,
  TenderCancelComponent,
  TenderViewAddDocumentModal,
  TenderViewAddSingleNoteModal,
  StatusBadge,
  Tenderdiscuss,
  wishListData,
  setWishListData,
  AssignTeamOnly,
  showEditModalTab,
  handleCloseEditModalTab,
  filteredData,
  editTenderId,
  editTenderData,
  showModal,
  amendedTenderIds,
}) {
  const [activeTab, setActiveTab] = useState("basic");
  const [showResultModal, setShowResultModal] = useState(false); // State for modal visibility
  const [auditLogs, setAuditLogs] = useState([]);
  const [auditLoading, setAuditLoading] = useState(false);

  const fetchAuditLogs = async () => {
    setAuditLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/auditlog/?tab_id=${toggleState}`, {
        params: { tender: i?.id },
      });
      const data = res.data;
      const list = Array.isArray(data) ? data : (data?.results || []);
      setAuditLogs(list);
    } catch (err) {
      console.error("Error fetching audit logs:", err);
      setAuditLogs([]);
    } finally {
      setAuditLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "amendments") {
      fetchAuditLogs();
    }
  }, [activeTab, i?.id, toggleState]); // ← add toggleState so it refetches when switching tab 5 ⇄ 9

  // Build per-log field-diff rows, handling update_field being null
  // (happens on CREATE, and sometimes on UPDATE when previous_value is {})
  const buildFieldRows = (log) => {
    const prevObj = log.previous_value || {};
    const newObj = log.new_value || {};
    const prevIsEmpty = Object.keys(prevObj).length === 0;

    let fields =
      Array.isArray(log.update_field) && log.update_field.length > 0
        ? log.update_field
        : Object.keys(newObj);

    if (prevIsEmpty) {
      // Nothing to diff against — treat as initial values (CREATE-style)
      return fields.map((f) => ({ field: f, prev: undefined, next: newObj[f] }));
    }

    // If we fell back to all keys of new_value (update_field was null),
    // only keep the ones that actually changed
    if (!Array.isArray(log.update_field) || log.update_field.length === 0) {
      fields = fields.filter(
        (f) => JSON.stringify(newObj[f]) !== JSON.stringify(prevObj[f])
      );
    }

    return fields.map((f) => ({ field: f, prev: prevObj[f], next: newObj[f] }));
  };

  const formatAuditVal = (v) => {
    if (v === null || v === undefined || v === "") return "—";
    if (typeof v === "boolean") return v ? "Yes" : "No";
    if (typeof v === "object") return JSON.stringify(v);
    return String(v);
  };


  const [notesData, setNotesData] = useState(i?.notes_tender || []);
  const [notesLoading, setNotesLoading] = useState(false);

  const qualificationStatusLabel = (() => {
    if (!i?.qualification_status) return null;
    if (i.qualification_status === "qualified") return "Qualified";
    if (i.qualification_status === "do_not_qualified") return "Do Not Qualified";
    return i.qualification_status;
  })();

  const ifQualifiedLabel = (() => {
    if (i?.qualification_status !== "qualified") return null;
    if (!i?.if_qualified) return null;
    const map = {
      solo_only: "Solo Only",
      jv_only: "JV Only",
      lead_only: "Lead Only",
      associate_only: "Associate Only",
      sent_to_partner: "Sent To Partner",
    };
    return map[i.if_qualified] || i.if_qualified;
  })();


  const fetchNotes = async () => {
    setNotesLoading(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/notesfilterbytender/${i?.id}/`
      );
      const apiNotes = res?.data || [];
      const existingNotes = i?.notes_tender || [];

      // Merge: avoid duplicates by id
      const existingIds = new Set(existingNotes.map((n) => n.id));
      const uniqueApiNotes = apiNotes.filter((n) => !existingIds.has(n.id));
      setNotesData([...existingNotes, ...uniqueApiNotes]);
    } catch (err) {
      console.error("Error fetching notes:", err);
      // Fallback to existing notes only
      setNotesData(i?.notes_tender || []);
    } finally {
      setNotesLoading(false);
    }
  };

  // Fetch on mount so count shows immediately
  useEffect(() => {
    if (activeTab === "notes") {
      fetchNotes();
    }
  }, [activeTab, i?.id]);

  // Tabs with count badge
  const tabs = [
    { id: "basic", label: "Basic Details" },
    ...(toggleState >= 3 ? [{ id: "eligibility", label: "Eligibility" }] : []),
    ...(toggleState >= 4 ? [{ id: "partners", label: "Partners" }] : []),
    ...([5, 6, 11, 12].includes(toggleState) ? [{ id: "bidinfo", label: "Bid Info" }] : []),
    { id: "docs", label: "Documents" },
    { id: "notes", label: "Notes" },
    ...([5, 9].includes(toggleState) ? [{ id: "amendments", label: "Amendment History" }] : []),
  ];

  // Tab buttons rendering
  {
    tabs.map((tab) => (
      <button
        key={tab.id}
        className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
        onClick={() => setActiveTab(tab.id)}
      >
        {tab.label}
        {tab.id === "notes" && notesData.length > 0 && (
          <span
            style={{
              marginLeft: 6,
              background: "#2576bc",
              color: "#fff",
              borderRadius: "10px",
              padding: "1px 7px",
              fontSize: "11px",
              fontWeight: 600,
              lineHeight: "1.6",
              display: "inline-block",
              verticalAlign: "middle",
            }}
          >
            {notesData.length}
          </span>
        )}
      </button>
    ))
  }
  const ViewAllBidDetails = () => {
    navigate(
      `/${window.location?.pathname?.split("/")[1] || "certificaionadminaccess"}/tenderDetails/`,
      { state: { project: i.id, data: i } }
    );
  };

  const allowedRoles = ["certificaionadminaccess", "CertificationAccess", "CertificationAccessDocumentTeamHead", "CertificationAccessCvTeamHead", "CertificationAccessBd", "BdDashboardPrebid", "ScreeningTeam"];
  const hasAccess = allowedRoles.includes(roleemp);
  const date = i?.corrigendum_date || i?.submission_date;
  const daysLeft = getDaysLeftNumber(date);

  return (
    <>
      <tr className="bg-expand-row">
        <td colSpan={10}>
          {/* inner tab bar */}
          <div className="bg-exp-tabbar">
            {tabs.map((t) => (
              <button
                key={t.id}
                className={`bg-exp-tab ${activeTab === t.id ? "bg-exp-tab--active" : ""}`}
                onClick={() => setActiveTab(t.id)}
              >
                <span className="bg-exp-tab-dot-wrap">
                  {t.label}
                  {t.id === "amendments" &&
                    [5, 9].includes(toggleState) &&
                    amendedTenderIds?.has(i.id) && (
                      <span className="amend-blink-dot" title="This tender has amendment history" />
                    )}
                </span>
              </button>
            ))}
          </div>

          {/* tab body */}
          <div className="bg-exp-body">

            {/* BASIC DETAILS */}
            {activeTab === "basic" && (
              <div className="bg-detail-grid">
                <div className="bg-field"><span className="bg-field-label">Published Date</span><span className="bg-field-value">{formatDateDDMMYYYYmonth(i?.publish_date) || "N/A"}</span></div>
                <div className="bg-field">
                  <span className="bg-field-label">
                    {[1, 2, 3].includes(toggleState)
                      ? "Screening Date"
                      : toggleState === 4
                        ? "FinalList Moved Date"
                        : toggleState === 5
                          ? "SubmitList Moved Date"
                          : toggleState === 9
                            ? "Bid In Progress Moving Date"
                            : "Submission"}
                  </span>

                  <span
                    className="bg-field-value"
                    title={
                      [1, 2, 3].includes(toggleState) && i?.created_at
                        ? formatDateDDMMYYYYmonth(i.created_at)
                        : toggleState === 4 && i?.date_cc
                          ? formatDateDDMMYYYYmonth(i.date_cc)
                          : toggleState === 5 && i?.date_ee
                            ? formatDateDDMMYYYYmonth(i.date_ee)
                            : toggleState === 9 && i?.date_ff
                              ? formatDateDDMMYYYYmonth(i.date_ff)
                              : i?.corrigendum_date
                                ? formatDateDDMMYYYYmonth(i.corrigendum_date)
                                : i?.submission_date
                                  ? formatDateDDMMYYYYmonth(i.submission_date)
                                  : "—"
                    }
                    style={{ color: "#5b21b6", fontWeight: 600 }}
                  >
                    {[1, 2, 3].includes(toggleState) && i?.created_at
                      ? formatDateDDMMYYYYmonth(i.created_at)
                      : toggleState === 4 && i?.date_cc
                        ? formatDateDDMMYYYYmonth(i.date_cc)
                        : toggleState === 5 && i?.date_ee
                          ? formatDateDDMMYYYYmonth(i.date_ee)
                          : toggleState === 9 && i?.date_ff
                            ? formatDateDDMMYYYYmonth(i.date_ff)
                            : i?.corrigendum_date
                              ? formatDateDDMMYYYYmonth(i.corrigendum_date)
                              : i?.submission_date
                                ? formatDateDDMMYYYYmonth(i.submission_date)
                                : "—"}
                  </span>
                </div>
                {(() => {
                  const corrigendum = i?.correigendum_types
                    ?.filter(
                      (ct) =>
                        ct.corrigendum_type === "date" ||
                        (ct.corrigendum_type === "both" &&
                          ct.other_name === "corrigendum_date"),
                    )
                    ?.sort(
                      (a, b) =>
                        new Date(b.created_at) - new Date(a.created_at),
                    )?.[0];

                  return corrigendum ? (
                    <div className="bg-field">
                      <span className="bg-field-label">Corrigendum Date</span>
                      <span
                        className="bg-field-value"
                        style={{ color: "#5b21b6", fontWeight: 700 }}
                      >
                        {formatDateDDMMYYYYmonth(corrigendum.other_value)}
                      </span>
                    </div>
                  ) : null;
                })()}
                <div className="bg-field"><span className="bg-field-label">Sector</span><span className="bg-field-value">{i?.sector === "Other" ? i?.other_sector_type : i?.sector || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Tender Type</span><span className="bg-field-value">{i?.tender_type || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Client</span><span className="bg-field-value">{i?.client?.replace(/[-_]/g, " ").trim().toUpperCase() || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">State</span><span className="bg-field-value">{i?.state || "N/A"}</span></div>
                <div className="bg-field">
                  <span className="bg-field-label">Lane</span>
                  <span className="bg-field-value">
                    {i?.lane === "rfp_not_uploaded"
                      ? "Not Available"
                      : i?.lane === "intimident_lane"
                        ? "Single Lane"
                        : i?.lane
                          ? `${i.lane} Lane`
                          : "N/A"}
                  </span>
                </div>
                <div className="bg-field"><span className="bg-field-label">Length</span><span className="bg-field-value">{i?.length ? `${i.length} km` : "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">RFP Uploaded</span><span className="bg-field-value">{i?.rfp_doc?.length ? <span className="bg-check--yes">✓ Yes</span> : <span className="bg-check--no">✗ No</span>}</span></div>
                <div className="bg-field"><span className="bg-field-label">Consultancy Cost</span><span className="bg-field-value">{i?.consultancy_fees ? `₹${Number(i.consultancy_fees).toFixed(2)} cr` : "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Construction Cost</span><span className="bg-field-value">{i?.construction_fees ? `₹${Math.round(i.construction_fees)} cr` : "N/A"}</span></div>

                {i?.cost_of_rfp && (
                  <div className="bg-field">
                    <span className="bg-field-label">RFP Cost</span>
                    <span className="bg-field-value">
                      ₹{Number(i.cost_of_rfp).toLocaleString("en-IN")}
                    </span>
                  </div>
                )}
                {i?.infracon_id_cost && (
                  <div className="bg-field">
                    <span className="bg-field-label">Infracon ID Cost</span>
                    <span className="bg-field-value">
                      ₹{Number(i.infracon_id_cost).toLocaleString("en-IN")}
                    </span>
                  </div>
                )}
                {/* <div className="bg-field"><span className="bg-field-label">GST</span><span className="bg-field-value">{i?.GST_consultancy || "N/A"}</span></div> */}
                <div className="bg-field">
                  <span className="bg-field-label">Days Left</span>
                  <span className="bg-field-value">
                    <DaysBadge days={daysLeft} toggleState={toggleState} />
                  </span>
                </div>
                <div className="bg-field"><span className="bg-field-label">Regional Office</span><span className="bg-field-value">{i?.ro || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">EMD Required</span><span className="bg-field-value">{i?.is_emd_required == null ? "—" : i.is_emd_required ? "Yes" : "No"}</span></div>
                {i?.is_emd_required && <>
                  <div className="bg-field"><span className="bg-field-label">Exempted EMD</span><span className="bg-field-value">{i?.exmpted_emd == null ? "—" : i.exmpted_emd ? "Yes" : "No"}</span></div>
                  <div className="bg-field"><span className="bg-field-label">EMD Amount</span><span className="bg-field-value">{i?.emd_amount || "N/A"}</span></div>
                  <div className="bg-field"><span className="bg-field-label">EMD Type</span><span className="bg-field-value">{(() => { const multi = (i.emd_type_multi || []).map(k => k.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())); const single = i.emd_type ? [i.emd_type.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())] : []; return [...multi, ...single].join(", ") || "N/A"; })()}</span></div>
                </>}
                {i?.is_discussed != null && (
                  <div className="bg-field">
                    <span className="bg-field-label">Discussed</span>
                    <span className="bg-field-value">
                      {i.is_discussed ? <span className="bg-check--yes">✓ Yes</span> : <span className="bg-check--no">✗ No</span>}
                    </span>
                  </div>
                )}
                {qualificationStatusLabel && (
                  <div className="bg-field">
                    <span className="bg-field-label">Qualification Status</span>
                    <span
                      className="bg-field-value"
                      style={{
                        color: i.qualification_status === "do_not_qualified" ? "#b42318" : "#1a7f37",
                        fontWeight: 600,
                      }}
                    >
                      {qualificationStatusLabel}
                    </span>
                  </div>
                )}
                {ifQualifiedLabel && (
                  <div className="bg-field">
                    <span className="bg-field-label">If Qualified</span>
                    <span className="bg-field-value" style={{ color: "#1a7f37", fontWeight: 600 }}>
                      {ifQualifiedLabel}
                    </span>
                  </div>
                )}
                {i?.qualification_remarks && (
                  <div className="bg-field bg-field">
                    <span className="bg-field-label">Qualification Remarks</span>
                    <span className="bg-field-value">{i.qualification_remarks}</span>
                  </div>
                )}
                {i?.is_cancelled && i?.reason_remark_cancellation && (
                  <div className="bg-field bg-field--full">
                    <span className="bg-field-label">Cancellation Reason</span>
                    <span className="bg-field-value">{i.reason_remark_cancellation}</span>
                  </div>
                )}
                {i?.is_cancelled && i?.cancellation_proof && (
                  <div className="bg-field">
                    <span className="bg-field-label">Cancellation Proof</span>
                    <span className="bg-field-value">
                      <a href={i.cancellation_proof} target="_blank" rel="noopener noreferrer" className="bg-doc-btn">View</a>
                    </span>
                  </div>
                )}
                {i?.custom_fields?.filter((f) => f.value !== null && f.value !== "").map((f) => (
                  <div className="bg-field" key={f.key}>
                    <span className="bg-field-label">{f.name}</span>
                    <span className="bg-field-value">{formatCustomValue(f)}</span>
                  </div>
                ))}
                {i?.remarks && <div className="bg-field bg-field--full"><span className="bg-field-label">Remarks</span><span className="bg-field-value">{i.remarks}</span></div>}
                {toggleState === 4 && i?.date_cc && <div className="bg-field"><span className="bg-field-label">FinalList Moved</span><span className="bg-field-value">{formatDateIndian(i.date_cc)}</span></div>}
                {toggleState === 5 && i?.date_ee && <div className="bg-field"><span className="bg-field-label">Submitted On</span><span className="bg-field-value">{formatDateIndian(i.date_ee)}</span></div>}
                {toggleState === 9 && i?.date_ff && <div className="bg-field"><span className="bg-field-label">Bid Prep Started</span><span className="bg-field-value">{formatDateIndian(i.date_ff)}</span></div>}
                {(toggleState === 9 || toggleState === 5) && i?.main_tl_summary?.[0]?.name && (
                  <div className="bg-field"><span className="bg-field-label">CV Team TL</span><span className="bg-field-value" style={{ color: "#1a7f37", fontWeight: 600 }}>{i.main_tl_summary[0].name}</span></div>
                )}
                <div className="bg-detail-actions">
                  <button className="bg-exp-btn bg-exp-btn--primary" onClick={ViewAllBidDetails}>👁 View Full Details</button>
                  {toggleState !== 5 && toggleState !== 6 && !["BdDashboardPrebid"].includes(roleemp) && (
                    <button className="bg-exp-btn" onClick={() => openCorrigendumModal && openCorrigendumModal(i)}>📅 Edit Date</button>
                  )}
                </div>
              </div>
            )}

            {/* ELIGIBILITY */}
            {activeTab === "eligibility" && (
              <div className="bg-detail-grid">
                <div className="bg-field"><span className="bg-field-label">Company Name</span><span className="bg-field-value">{i?.company_name?.toUpperCase() || "N/A"}</span></div>
                {i.company_name === "joint" && <>
                  <div className="bg-field"><span className="bg-field-label">Company Dist JV</span><span className="bg-field-value">{i?.company_dist_jv?.toUpperCase() || "N/A"}</span></div>
                  <div className="bg-field"><span className="bg-field-label">Company Dist Lead</span><span className="bg-field-value">{i?.company_dist_lead?.toUpperCase() || "N/A"}</span></div>
                </>}
                <div className="bg-field"><span className="bg-field-label">Total Tech Score</span><span className="bg-field-value">{i?.tech_score || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Company Score</span><span className="bg-field-value">{i?.company_score || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Sole Qualify</span><span className="bg-field-value">{i?.soil_quality ? "Yes" : "No"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Participating As</span><span className="bg-field-value">{i?.participating_as || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">JV Allowed</span><span className="bg-field-value">{i?.is_jv_allowed ? "Yes" : "No"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Consortium Allowed</span><span className="bg-field-value">{i?.is_jv_consorium_association_allowed ? "Yes" : "No"}</span></div>
                {i?.is_jv_consorium_association_allowed && <div className="bg-field"><span className="bg-field-label">Terms of JV</span><span className="bg-field-value">{i?.terms_of_jv || "N/A"}</span></div>}
                <div className="bg-field"><span className="bg-field-label">Site Appraisal Marking</span><span className="bg-field-value">{i?.site_apprisate_marking || "No"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Work Methodology Marking</span><span className="bg-field-value">{i?.work_methodology_marking || "No"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Presentation Marking</span><span className="bg-field-value">{i?.presentation_required_marking || "No"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Presentation Type</span><span className="bg-field-value">{i?.presentation_type || "No"}</span></div>
                <div className="bg-field bg-field--full"><span className="bg-field-label">Eligibility Criteria</span><span className="bg-field-value">{i?.eligibity_criteria ? (i.eligibity_criteria === "Special" ? i.eligibity_criteria_special : i.eligibity_criteria) : "N/A"}</span></div>
                <div className="bg-detail-actions">
                  <button
                    className="bg-exp-btn bg-exp-btn--primary"
                    onClick={() => handleOpenEditModal && handleOpenEditModal(i?.id, i, 'eligibility')}
                  >
                    ✏️ Edit Eligibility
                  </button>
                </div>
              </div>
            )}

            {/* PARTNERS */}
            {activeTab === "partners" && (
              <div className="bg-detail-grid">
                <div className="bg-field"><span className="bg-field-label">Lead Partner</span><span className="bg-field-value">{i?.lead_partner || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Lead Partner Share</span><span className="bg-field-value">{i?.lead_partner_share ? `${i.lead_partner_share}%` : "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">JV Partner</span><span className="bg-field-value">{i?.jv_partner_name || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">JV Partner Share</span><span className="bg-field-value">{i?.jv_partner_share ? `${i.jv_partner_share}%` : "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Associate Partner</span><span className="bg-field-value">{i?.assosiate_partner === "Other" ? i?.custom_assosiate_partner : i?.assosiate_partner || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Associate Share</span><span className="bg-field-value">{i?.associate_partner_share ? `${i.associate_partner_share}%` : "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Bid Prepare By</span><span className="bg-field-value">{i?.bid_prepare_by?.replace(/_/g, " ").toUpperCase() || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">BG Prepare By</span><span className="bg-field-value">{i?.bg_prepare_by?.replace(/_/g, " ").toUpperCase() || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Team Required</span><span className="bg-field-value">{i?.team_required ? "Yes" : "No"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Tender Submission Type</span><span className="bg-field-value">{i?.tender_submission_type || "N/A"}</span></div>
                {i?.team_required && <>
                  <div className="bg-field"><span className="bg-field-label">Team Prepare By</span><span className="bg-field-value">{i?.team_prepare_by || "N/A"}</span></div>
                  <div className="bg-field"><span className="bg-field-label">Team Req. Details</span><span className="bg-field-value">{i?.team_requirements_details || "N/A"}</span></div>
                </>}
                <div className="bg-detail-actions">
                  <button
                    className="bg-exp-btn bg-exp-btn--primary"
                    onClick={() => handleOpenEditModal && handleOpenEditModal(i?.id, i, 'partners')}
                  >
                    ✏️ Edit Partners
                  </button>
                </div>
              </div>
            )}

            {/* BID INFO */}
            {activeTab === "bidinfo" && (
              <div className="bg-detail-grid">
                <div className="bg-field"><span className="bg-field-label">CV Score</span><span className="bg-field-value">{i?.cv_score || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Checklist</span><span className="bg-field-value">{i?.checklist ? "Yes" : "No"}</span></div>
                <div className="bg-field"><span className="bg-field-label">All Docs Done</span><span className="bg-field-value">{i?.all_docs_done ? "Yes" : "No"}</span></div>
                <div className="bg-field"><span className="bg-field-label">All CVs Done</span><span className="bg-field-value">{i?.all_cvs_done ? "Yes" : "No"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Lead Partner</span><span className="bg-field-value">{i?.lead_partner || "N/A"}</span></div>
                <div className="bg-field"><span className="bg-field-label">Are We L1</span><span className="bg-field-value">{i?.are_we_l1 != null ? (i.are_we_l1 ? "Yes" : "No") : "N/A"}</span></div>
                {i?.tender_fee && <div className="bg-field"><span className="bg-field-label">Bidded Amount</span><span className="bg-field-value">{i.tender_fee}</span></div>}
              </div>
            )}

            {/* DOCUMENTS */}
            {activeTab === "docs" && (
              <div className="bg-docs-panel">
                {i?.correigendum_doc?.length > 0 && (
                  <div className="bg-doc-group">
                    <div className="bg-doc-group-header"><span>Corrigendum Docs</span><span className="bg-doc-count">{i.correigendum_doc.length}</span></div>
                    {i.correigendum_doc.map((doc, idx) => (
                      <div className="bg-doc-row" key={idx}><span className="bg-doc-sno">{idx + 1}</span><span className="bg-doc-name" title={doc?.document_name}>{doc?.document_name}</span><div>{doc?.document ? <a href={doc.document} target="_blank" rel="noopener noreferrer" className="bg-doc-btn">View</a> : <span className="bg-doc-nofile">No file</span>}</div></div>
                    ))}
                  </div>
                )}
                {i?.rfp_doc?.length > 0 && (
                  <div className="bg-doc-group">
                    <div className="bg-doc-group-header"><span>RFP Documents</span><span className="bg-doc-count">{i.rfp_doc.length}</span></div>
                    {i.rfp_doc.map((doc, idx) => (
                      <div className="bg-doc-row" key={idx}><span className="bg-doc-sno">{idx + 1}</span><span className="bg-doc-name" title={doc?.document_name}>{doc?.document_name}</span><div>{doc?.document ? <a href={doc.document} target="_blank" rel="noopener noreferrer" className="bg-doc-btn">View</a> : <span className="bg-doc-nofile">No file</span>}</div></div>
                    ))}
                  </div>
                )}
                {[5, 11].includes(toggleState) && i?.tech_doc?.length > 0 && (
                  <div className="bg-doc-group">
                    <div className="bg-doc-group-header"><span>Technical Docs</span><span className="bg-doc-count">{i.tech_doc.length}</span></div>
                    {i.tech_doc.map((doc, idx) => (<div className="bg-doc-row" key={idx}><span className="bg-doc-sno">{idx + 1}</span><span className="bg-doc-name">{doc?.document_name}</span><div>{doc?.document ? <a href={doc.document} target="_blank" rel="noopener noreferrer" className="bg-doc-btn">View</a> : <span className="bg-doc-nofile">No file</span>}</div></div>))}
                  </div>
                )}
                {[5, 11].includes(toggleState) && i?.financial_doc?.length > 0 && (
                  <div className="bg-doc-group">
                    <div className="bg-doc-group-header"><span>Financial Docs</span><span className="bg-doc-count">{i.financial_doc.length}</span></div>
                    {i.financial_doc.map((doc, idx) => (<div className="bg-doc-row" key={idx}><span className="bg-doc-sno">{idx + 1}</span><span className="bg-doc-name">{doc?.document_name}</span><div>{doc?.document ? <a href={doc.document} target="_blank" rel="noopener noreferrer" className="bg-doc-btn">View</a> : <span className="bg-doc-nofile">No file</span>}</div></div>))}
                  </div>
                )}
                {[5, 9].includes(toggleState) && i?.cv_doc?.length > 0 && (
                  <div className="bg-doc-group">
                    <div className="bg-doc-group-header"><span>CV Documents</span><span className="bg-doc-count">{i.cv_doc.length}</span></div>
                    {i.cv_doc.map((doc, idx) => (<div className="bg-doc-row" key={idx}><span className="bg-doc-sno">{idx + 1}</span><span className="bg-doc-name">{doc?.document_name}</span><div>{doc?.document ? <a href={doc.document} target="_blank" rel="noopener noreferrer" className="bg-doc-btn">View</a> : <span className="bg-doc-nofile">No file</span>}</div></div>))}
                  </div>
                )}
                {i?.bid_doc?.length > 0 && (
                  <div className="bg-doc-group">
                    <div className="bg-doc-group-header"><span>Bid Docs</span><span className="bg-doc-count">{i.bid_doc.length}</span></div>
                    {i.bid_doc.map((doc, idx) => (<div className="bg-doc-row" key={idx}><span className="bg-doc-sno">{idx + 1}</span><span className="bg-doc-name">{doc?.document_name}</span><div>{doc?.document ? <a href={doc.document} target="_blank" rel="noopener noreferrer" className="bg-doc-btn">View</a> : <span className="bg-doc-nofile">No file</span>}</div></div>))}
                  </div>
                )}
                {!i?.rfp_doc?.length && !i?.tech_doc?.length && !i?.financial_doc?.length && !i?.cv_doc?.length && !i?.bid_doc?.length && !i?.correigendum_doc?.length && (
                  <p className="bg-empty-msg">No documents attached to this tender.</p>
                )}
              </div>
            )}

            {/* NOTES */}
            {/* // Notes tab content — uses API data (notesData) instead of i.notes_tender */}
            {activeTab === "notes" && (
              <div>
                {notesLoading ? (
                  <p className="bg-empty-msg">Loading notes...</p>
                ) : notesData.length > 0 ? (
                  <table className="bg-notes-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Title</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {notesData.map((note, idx) => (
                        <tr key={note?.id || idx}>
                          <td>{idx + 1}</td>
                          <td>{note?.description?.title || "No Title"}</td>
                          <td className="bg-notes-detail">
                            {note?.description?.detail || "No Details"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p className="bg-empty-msg">No notes available.</p>
                )}
              </div>
            )}
            {activeTab === "amendments" && (
              <div className="bg-docs-panel">
                {auditLoading ? (
                  <p className="bg-empty-msg">Loading amendment history...</p>
                ) : auditLogs?.length > 0 ? (
                  <table className="bg-notes-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Field</th>
                        <th>Previous Value</th>
                        <th>New Value</th>
                        <th>Updated By</th>
                        <th>Updated At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {auditLogs
                        .slice()
                        .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
                        .flatMap((log, logIdx) => {
                          const rows = buildFieldRows(log);
                          if (rows.length === 0) {
                            return [
                              <tr key={`${log.id}-empty`}>
                                <td>{logIdx + 1}</td>
                                <td colSpan={2} style={{ fontStyle: "italic", color: "#888" }}>
                                  {log.action === "CREATE" ? "Record created" : "No field changes recorded"}
                                </td>
                                <td>—</td>
                                <td>{log.updated_by || "—"}</td>
                                <td>{formatDateDDMMYYYYmonth(log.updated_at)}</td>
                              </tr>,
                            ];
                          }
                          return rows.map((r, rIdx) => (
                            <tr key={`${log.id}-${r.field}`}>
                              <td>{rIdx === 0 ? logIdx + 1 : ""}</td>
                              <td style={{ fontWeight: 600 }}>
                                {r.field.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                              </td>
                              <td style={{ color: "#b42318" }}>{formatAuditVal(r.prev)}</td>
                              <td style={{ color: "#1a7f37" }}>{formatAuditVal(r.next)}</td>
                              <td>{rIdx === 0 ? (log.updated_by || "—") : ""}</td>
                              <td>{rIdx === 0 ? formatDateDDMMYYYYmonth(log.updated_at) : ""}</td>
                            </tr>
                          ));
                        })}
                    </tbody>
                  </table>
                ) : (
                  <p className="bg-empty-msg">No amendment history available.</p>
                )}
              </div>
            )}
          </div>

          {/* footer action bar */}
          <div className="bg-exp-footer">
            {/* Next step button logic */}
            {(toggleState === 1 || toggleState === 2 || toggleState === 3 || toggleState === 4) && !["BdDashboardPrebid"].includes(roleemp) && (
              <span className="bg-status-pill">
                {i?.is_submitted ? "Submitted" : i?.is_bid_prepare_in_progress ? "In Pipeline" : i?.is_finalize ? "Finalized" : i?.is_in_targetlist ? "In Target" : i?.is_in_bidlist ? "In WishList" : "New"}
              </span>
            )}
            {toggleState !== 1 && toggleState !== 6 && (
              <button className="bg-exp-btn" onClick={() => handleOpenBackModal && handleOpenBackModal(i, i?.id)}>← Previous</button>
            )}

            {toggleState === 9 && i?.is_submitted && <span className="bg-status-pill">Submitted ✓</span>}
            {toggleState === 11 && i?.is_in_tech_tab && <span className="bg-status-pill">Tech Open ✓</span>}
            {toggleState === 11 && i?.is_in_financial_tab && <span className="bg-status-pill">Financial Open ✓</span>}

            {toggleState === 1 && (
              i.is_submitted ? (
                <p className="newly-added mb-0" style={{ width: "82px" }}>Submitted</p>
              ) : i.is_bid_prepare_in_progress ? (
                <p className="newly-added mb-0" style={{ width: "82px" }}>In Bid Prepare In progress</p>
              ) : i.is_finalize ? (
                <p className="newly-added mb-0" style={{ width: "82px" }}>In-Finalize</p>
              ) : i.is_in_targetlist ? (
                <span className="newly-added mb-0" style={{ width: "82px" }}>In-Target</span>
              ) : i.is_in_bidlist ? (
                <p className="newly-added mb-0" style={{ width: "82px" }}>In BidList</p>
              ) : (
                Addtocart && <Addtocart
                  i={i}
                  getBid={getBidData}
                  toggleState={toggleState}
                  filters={filters}
                  setToggleState={setToggleState}
                  getDaysLeftNumber={getDaysLeftNumber}
                />
              )
            )}

            {toggleState === 2 && (
              i.is_submitted ? (
                <p className="newly-added mb-0" style={{ width: "82px" }}>Submitted</p>
              ) : i.is_bid_prepare_in_progress ? (
                <p className="newly-added mb-0" style={{ width: "82px" }}>In Bid Prepare In progress</p>
              ) : i.is_finalize ? (
                <p className="newly-added mb-0" style={{ width: "82px" }}>In Finalize</p>
              ) : (
                Addtocart && <Addtocart
                  i={i}
                  getBid={getBidData}
                  toggleState={toggleState}
                  filters={filters}
                  setToggleState={setToggleState}
                  getDaysLeftNumber={getDaysLeftNumber}
                />
              )
            )}

            {toggleState === 3 && (
              i.is_finalize ? (
                <p className="newly-added mb-0" style={{ padding: "" }}>In Finalize</p>
              ) : (
                Addtocart && <Addtocart
                  i={i}
                  getBid={getBidData}
                  toggleState={toggleState}
                  filters={filters}
                  setToggleState={setToggleState}
                  getDaysLeftNumber={getDaysLeftNumber}
                />
              )
            )}

            {toggleState === 4 && (
              i.is_bid_prepare_in_progress ? (
                <p className="newly-added mb-0" style={{ padding: "" }}>In Bid Prepare Progress</p>
              ) : (
                Addtocart && <Addtocart
                  i={i}
                  getBid={getBidData}
                  toggleState={toggleState}
                  filters={filters}
                  setToggleState={setToggleState}
                  getDaysLeftNumber={getDaysLeftNumber}
                />
              )
            )}

            {toggleState === 9 && !["CertificationAccessCvTeamHead", "CertificationAccessCvTeam"].includes(roleemp) && (
              i.is_submitted ? (
                <p className="newly-added mb-0" style={{ padding: "" }}>Submitted</p>
              ) : (
                Addtocart && <Addtocart
                  i={i}
                  getBid={getBidData}
                  toggleState={toggleState}
                  filters={filters}
                  setToggleState={setToggleState}
                  getDaysLeftNumber={getDaysLeftNumber}
                  bgData={bgData}
                />
              )
            )}

            {toggleState === 5 && i?.is_in_tech_tab && (
              <span className="newly-added mb-0">Tech Open ✓</span>
            )}
            {toggleState === 5 && i?.is_in_financial_tab && (
              <span className="newly-added mb-0">Financial Open ✓</span>
            )}
            {/* "Next →" to Financial Open only while it's Tech-only */}
            {toggleState === 5 && i.is_submitted && i?.is_in_tech_tab && !i?.is_in_financial_tab && (
              <Addtocart
                i={i}
                getBid={getBidData}
                toggleState={11}
                filters={filters}
                setToggleState={setToggleState}
                getDaysLeftNumber={getDaysLeftNumber}
                bgData={bgData}
              />
            )}
            {!["BdDashboardPrebid"].includes(roleemp) && (
              <>
                {toggleState !== 1 && toggleState !== 6 && toggleState !== 5 && (
                  <StatusBadge
                    Tenderstatus={getTenderStatus(
                      toggleState,
                      i,
                    )}
                  />
                )}

                {/* Eligibility/Partners/Docs buttons */}
                {toggleState !== 1 && toggleState !== 4 && (
                  <button
                    title={
                      toggleState === 3
                        ? "Finalize Partners"
                        : toggleState === 9
                          ? "Attach Tender Documents"
                          : "Eligibility Criteria"
                    }
                    onClick={() => handleShow(i.id, i)}
                  >
                    {toggleState === 3 ? (
                      <button className="bg-exp-btn bg-exp-btn--primary">
                        👥 Partners
                      </button>
                    ) : [5, 9].includes(toggleState) ? (
                      <button className="bg-exp-btn bg-exp-btn--primary">
                        📁 Docs
                      </button>
                    ) : (
                      <button className="bg-exp-btn bg-exp-btn--primary">
                        🛡️ Eligibility
                      </button>
                    )}
                  </button>
                )}

                {/* NEW: Tender Result Button - shows only for toggleState 5, 11, 12 */}
                {[5, 11].includes(toggleState) && (
                  <button
                    className="bg-exp-btn bg-exp-btn--primary"
                    onClick={() => setShowResultModal(true)}
                    style={{ background: "#28a745", borderColor: "#28a745" }}
                  >
                    📊 Tender Result
                  </button>
                )}
                {toggleState === 9 &&
                  ![
                    "certificaionadminaccess",
                    "CertificationAccessBd",
                    "CertificationAccessCvTeam",
                    "CertificationAccessDocumentTeam",
                    "CertificationAccessDocumentTeamHead",
                  ].includes(roleemp) && (
                    <AssignTeamOnly
                      i={i}
                      getBid={getBidData}
                      toggleState={toggleState}
                      filters={filters}
                      setToggleState={setToggleState}
                      getDaysLeftNumber={getDaysLeftNumber}
                    />
                  )}
                {toggleState > 2 && ![
                  "CertificationAccessCvTeamHead",
                  "CertificationAccessCvTeam",
                  "CertificationAccessDocumentTeam",
                  "CertificationAccessDocumentTeamHead",
                ].includes(roleemp) && (
                    <button
                      className="bg-exp-btn"
                      onClick={() => handleOpenEditModalTab && handleOpenEditModalTab(i?.id)}
                      title="Move to Any Tab"
                      style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M8 7l4-4 4 4M8 17l4 4 4-4" />
                        <path d="M12 3v18" />
                        <path d="M17 8l4 4-4 4M7 8l-4 4 4 4" />
                      </svg>
                      Move Tab
                    </button>
                  )}
                {/* <EditTenderInfoTab
                  showEditModal={showEditModalTab}
                  handleCloseEditModal={handleCloseEditModalTab}
                  toggleState={toggleState}
                  tenders={filteredData}
                  tenderId={editTenderId}
                  getBidData={getBidData}
                  editTenderData={editTenderData}
                  showModal={showModal}
                  filters={filters}
                  roleemp={roleemp}
                /> */}
              </>
            )}

            <TenderViewAddDocumentModal
              tenderID={i?.id}
              getBidData={getBidData}
              toogleState={toggleState}
              filters={filters}
              i={i}
            />
            <TenderViewAddSingleNoteModal
              i={i}
              tenderID={i?.id}
              getBidData={getBidData}
              filters={filters}
            />

            {!i?.is_submitted && !i?.is_rejected && (
              <TenderRejectComponent
                i={i}
                getBidData={getBidData}
                filters={filters}
                bgData={bgData}
                toggleState={toggleState}
              />
            )}
            {!i?.is_cancelled && (
              <TenderCancelComponent
                i={i}
                getBidData={getBidData}
                filters={filters}
                bgData={bgData}
              />
            )}
            <Tenderdiscuss i={i}
              getBidData={getBidData}
              filters={filters} />

            {i?.is_rejected && (
              <span className="bg-rejection-label">Rejected: {i?.rejected_reason === "other" ? i?.rejected_reason_other : i?.rejected_reason}</span>
            )}

          </div>

          {/* extra strips */}
          {(i?.mark_as_document || i?.mark_as_cv) && (
            <div className="bg-status-badges-strip">
              {i.mark_as_document && <span className="bg-badge bg-badge--doc">📋 Document Done</span>}
              {i.mark_as_cv && <span className="bg-badge bg-badge--cv">📄 CV Done</span>}
            </div>
          )}
          {i?.is_residual_bid_capacity && (
            <div className="bg-residual-label"><span className="bg-residual-dot" /> Residual Bid Capacity</div>
          )}
        </td>
      </tr>

      {/* Tender Result Modal */}
      {showResultModal && (
        <div className="trs-modal-overlay" onClick={() => setShowResultModal(false)}>
          <div className="trs-modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="trs-modal-header">
              <h3>Tender Result - {i?.tender_no || i?.tender_id}</h3>
              <button
                className="trs-modal-close"
                onClick={() => setShowResultModal(false)}
              >
                ×
              </button>
            </div>
            <div className="trs-modal-body">
              <TenderResultSection
                tenderId={i.id}
                tenderIdCode={i?.tender_id}
                wishListData={wishListData}
                setWishListData={setWishListData}
                roleemp={roleemp}
              />
            </div>
          </div>
        </div>
      )}

      {/* Modal Styles */}
      <style>{`
        .trs-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.6);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(4px);
        }
        
        .trs-modal-container {
          background: #fff;
          border-radius: 12px;
          width: 90%;
          max-width: 1400px;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
          animation: modalSlideIn 0.2s ease-out;
        }
        
        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .trs-modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 24px;
          border-bottom: 1px solid #e0e0e0;
          background: #f8f9fa;
          border-radius: 12px 12px 0 0;
        }
        
        .trs-modal-header h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #2576bc;
        }
        
        .trs-modal-close {
          background: none;
          border: none;
          font-size: 28px;
          cursor: pointer;
          color: #666;
          padding: 0;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          transition: all 0.2s;
        }
        
        .trs-modal-close:hover {
          background: #e0e0e0;
          color: #333;
        }
        
        .trs-modal-body {
          padding: 24px;
          overflow-y: auto;
          flex: 1;
        }
      `}</style>
      <EditTenderInfoTab
        showEditModal={showEditModalTab}
        handleCloseEditModal={handleCloseEditModalTab}
        toggleState={toggleState}
        tenders={filteredData}
        tenderId={editTenderId}
        getBidData={getBidData}
        editTenderData={editTenderData}
        showModal={showModal}
        filters={filters}
        roleemp={roleemp}
      />
    </>
  );
}

// ─── TAB CONFIG ───────────────────────────────────────────────────────────────
const TAB_CONFIG = [
  { id: 1, label: "New Tenders", countKey: "new_tenders" },
  { id: 2, label: "Wish Listed", countKey: "wishlist_tenders" },
  { id: 3, label: "Target", countKey: "target_tenders" },
  { id: 4, label: "Final", countKey: "final_tenders" },
  { id: 9, label: "Bid Pipeline", countKey: "bid_preparation_pipeline" },
  { id: 5, label: "Submitted", countKey: "submitted_tenders" },
  // { id: 11, label: "Tender Result", countKey: null }, // merged Tech Open (11) + Financial Open (12)
  { id: 7, label: "Closed/Expired", countKey: null },
  { id: 10, label: "Presentation", countKey: "presentation_required_tender" },
];

const HIDDEN_FOR_ROLES = {
  CertificationAccessCvTeamHead: [1, 2, 3, 4],
  CertificationAccessCvTeam: [1, 2, 3, 4],
  CertificationAccessDocumentTeam: [1, 2, 3, 4],
  CertificationAccessDocumentTeamHead: [1, 2, 3, 4],
  BdDashboardPrebid: [1, 2, 3, 4, 5, 11, 7], // was [...11, 12...]
  CertificationAccessBd: [11],               // was [11, 12]
};
const FunnelIcon = ({ active }) => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill={active ? "currentColor" : "none"}
    stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 4h18l-7 8.5V19l-4 2v-8.5L3 4z" />
  </svg>
);

const ColumnFilter = ({ options = [], selected = [], onApply }) => {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(selected);
  const [query, setQuery] = useState("");
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const btnRef = useRef(null);
  const menuRef = useRef(null);

  const opts = useMemo(
    () => options.map((o) => (typeof o === "string" ? { value: o, label: o } : o)),
    [options]
  );
  const visible = opts.filter((o) =>
    String(o.label).toLowerCase().includes(query.trim().toLowerCase())
  );
  const allVisibleSelected = visible.length > 0 && visible.every((o) => pending.includes(o.value));

  const openMenu = () => {
    const r = btnRef.current.getBoundingClientRect();
    setPos({ top: r.bottom + 4, left: Math.max(8, Math.min(r.left, window.innerWidth - 248)) });
    setPending(selected);
    setQuery("");
    setOpen(true);
  };

  useEffect(() => {
    if (!open) return;
    const close = () => setOpen(false);
    const onDown = (e) => {
      if (menuRef.current?.contains(e.target) || btnRef.current?.contains(e.target)) return;
      close();
    };
    const onScroll = (e) => { if (!menuRef.current?.contains(e.target)) close(); };
    document.addEventListener("mousedown", onDown);
    window.addEventListener("scroll", onScroll, true);
    window.addEventListener("resize", close);
    return () => {
      document.removeEventListener("mousedown", onDown);
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("resize", close);
    };
  }, [open]);

  const toggleOne = (v) =>
    setPending((p) => (p.includes(v) ? p.filter((x) => x !== v) : [...p, v]));

  const toggleAll = () =>
    setPending((p) =>
      allVisibleSelected
        ? p.filter((v) => !visible.some((o) => o.value === v))
        : [...new Set([...p, ...visible.map((o) => o.value)])]
    );

  const apply = () => { onApply(pending); setOpen(false); };

  return (
    <>
      <button
        ref={btnRef}
        type="button"
        title="Filter"
        aria-label="Filter column"
        className={`bg-th-filter-btn ${selected.length ? "bg-th-filter-btn--active" : ""}`}
        onClick={(e) => { e.stopPropagation(); open ? setOpen(false) : openMenu(); }}
      >
        <FunnelIcon active={selected.length > 0} />
      </button>

      {open && createPortal(
        <div ref={menuRef} className="bg-colf-menu" style={{ top: pos.top, left: pos.left }}>
          <input
            className="bg-colf-search"
            placeholder="Search…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            autoFocus
          />
          <label className={`ms-filter-item ms-filter-item--all ${allVisibleSelected ? "ms-filter-item--checked" : ""}`}>
            <input
              type="checkbox"
              checked={allVisibleSelected}
              ref={(el) => { if (el) el.indeterminate = !allVisibleSelected && visible.some((o) => pending.includes(o.value)); }}
              onChange={toggleAll}
            />
            <span style={{ flex: 1, fontWeight: 600 }}>Select All</span>
            <span className="ms-filter-item-count">{pending.length}/{opts.length}</span>
          </label>
          <div className="bg-colf-list">
            {visible.length === 0 && <div className="bg-colf-empty">No matches</div>}
            {visible.map((o) => {
              const checked = pending.includes(o.value);
              return (
                <label key={o.value} className={`ms-filter-item ${checked ? "ms-filter-item--checked" : ""}`}>
                  <input type="checkbox" checked={checked} onChange={() => toggleOne(o.value)} />
                  <span style={{ flex: 1 }}>{o.label}</span>
                  {o.count != null && <span className="ms-filter-item-count">{o.count}</span>}
                </label>
              );
            })}
          </div>
          <div className="ms-filter-menu-footer">
            <button type="button" className="ms-filter-btn ms-filter-btn--cancel"
              style={{ marginRight: "auto" }} onClick={() => setPending([])}>Clear</button>
            <button type="button" className="ms-filter-btn ms-filter-btn--cancel" onClick={() => setOpen(false)}>Cancel</button>
            <button type="button" className="ms-filter-btn ms-filter-btn--ok" onClick={apply}>OK</button>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};
// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
const Bid = () => {
  // ── All original state from Bid ──────────────────────────────────────────

  // const [tabSectorCounts, setTabSectorCounts] = useState({});// Highway
  const [specialStructureCounts, setSpecialStructureCounts] = useState({});   // NEW
  const [techUploadProgress, setTechUploadProgress] = useState({}); // { [fileName]: percent }
  const [techUploadStatusText, setTechUploadStatusText] = useState("");
  const [techUploading, setTechUploading] = useState(false);
  const [financialUploading, setFinancialUploading] = useState(false);
  const [cvsUploading, setCvsUploading] = useState(false);
  const [bidUploading, setBidUploading] = useState(false);
  const [techUploadError, setTechUploadError] = useState("");
  const [financialUploadError, setFinancialUploadError] = useState("");
  const [cvsUploadError, setCvsUploadError] = useState("");
  const [bidUploadError, setBidUploadError] = useState("");

  const [financialUploadSuccess, setFinancialUploadSuccess] = useState("");
  const [cvsUploadSuccess, setCvsUploadSuccess] = useState("");
  const [bidUploadSuccess, setBidUploadSuccess] = useState("");

  const [corriendumModal, setCorriendumModal] = useState(false);
  const [corriendumModalScreening, setCorriendumModalScreening] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [tabCounts, setTabCounts] = useState({});
  const [allTendersForDownload, setAllTendersForDownload] = useState([]);
  const PAGE_SIZE = 20;
  const [scoreError, setScoreError] = useState("");
  const [BidDocs, setBidDocs] = useState([]);
  const [cvsDocs, setCvsDocs] = useState([]);
  const [finacialDocs, setFinancialDocs] = useState([]);
  const [editInitialTab, setEditInitialTab] = useState(null);
  const [consultancyCostFilter, setConsultancyCostFilter] = useState([]);   // Railway
  const [constructionCostRange, setConstructionCostRange] = useState([]);   // Highway
  const [lengthRange, setLengthRange] = useState([]);

  const [tabSectorCounts, setTabSectorCounts] = useState({});// Highway
  const [customFilters, setCustomFilters] = useState({});
  const customFiltersKey = JSON.stringify(customFilters); // stable dep, avoids new-object refetch churn
  const [cfDefs, setCfDefs] = useState([]);
  useEffect(() => { fetchCustomFieldDefs().then(setCfDefs).catch(() => { }); }, []);

  const setCustomFilter = (key, val) => {
    setCustomFilters((p) => {
      const n = { ...p };
      if (val === undefined) delete n[key]; else n[key] = val;
      return n;
    });
    setCurrentPage(1);
  };

  const toggleCustomOption = (key, v) => {
    setCustomFilters((p) => {
      const cur = p[key] || [];
      const next = cur.includes(v) ? cur.filter((x) => x !== v) : [...cur, v];
      const n = { ...p };
      if (next.length) n[key] = next; else delete n[key];
      return n;
    });
    setCurrentPage(1);
  };

  const setCustomRange = (key, bound, raw) => {
    setCustomFilters((p) => {
      const range = { ...(p[key] || {}) };
      if (raw === "") delete range[bound]; else range[bound] = Number(raw);
      const n = { ...p };
      if (Object.keys(range).length) n[key] = range; else delete n[key];
      return n;
    });
    setCurrentPage(1);
  };

  // const [tenderResultSubTab, setTenderResultSubTab] = useState("tech"); // "tech" | "financial"


  // The visible tab id stays 11 (merged "Tender Result"); the backend still expects
  // the original ids (11 = Tech Open, 12 = Financial Open) to filter correctly.


  const expiredCacheRef = useRef({ key: "", promise: null });

  const getExpiredList = () => {
    const key = JSON.stringify([
      filters, selectedFromDate, selectedToDate, dateRange,
      consultancyCostFilter, constructionCostRange, lengthRange, customFiltersKey,
    ]);
    if (expiredCacheRef.current.key === key && expiredCacheRef.current.promise) {
      return expiredCacheRef.current.promise;            // reuse in-flight / finished request
    }
    const promise = fetchTendersForTab(7, true).catch((e) => {
      expiredCacheRef.current = { key: "", promise: null };  // allow retry on failure
      throw e;
    });
    expiredCacheRef.current = { key, promise };
    return promise;
  };

  const [techDocs, setTechDocs] = useState([]);
  const [amendedTenderIds, setAmendedTenderIds] = useState(new Set());

  const fetchAmendedTenderIds = async () => {
    try {
      let allLogs = [];
      let url = `${BASE_URL}/siteproject/auditlog/?tab_id=${toggleState}`;
      while (url) {
        const res = await axios.get(url);
        const data = res.data;
        const list = Array.isArray(data) ? data : (data?.results || []);
        allLogs = allLogs.concat(list);
        url = !Array.isArray(data) && data?.next ? data.next : null;
      }
      const ids = new Set(allLogs.map((log) => log.tender).filter(Boolean));
      setAmendedTenderIds(ids);
    } catch (err) {
      console.error("Error fetching audit logs for amendment dots:", err);
    }
  };

  const handleCvsRemove = (index) => {
    setCvsDocs((prev) => prev.filter((_, i) => i !== index));
  };
  const handleBidsRemove = (index) => {
    setBidDocs((prev) => prev.filter((_, i) => i !== index));

  };
  const validateForm = () => {
    const newErrors = {};
    let requiredFields = [];
    if (toggleState === 2) {
      requiredFields = [
        wishListData.is_jv_allowed === null ? "is_jv_allowed" : null,
        "tech_score",
        "company_score",
        "company_name",
        "eligibity_criteria",
        wishListData.eligibity_criteria != "" &&
          wishListData.eligibity_criteria === "Special"
          ? "eligibity_criteria_special"
          : null,
        wishListData.soil_quality === null ? "soil_quality" : null,
        wishListData.participating_as === null ? "participating_as" : null,
        wishListData.is_jv_consorium_association_allowed === null
          ? "jv_consorium_association_allowed"
          : null,
        wishListData.site_apprisate_required === null
          ? "site_apprisate_required"
          : null,
        wishListData.site_apprisate_required !== null
          ? "site_apprisate_marking"
          : null,
        wishListData.work_methodology_required === null
          ? "work_methodology_required"
          : null,
        wishListData.work_methodology_required != null &&
          wishListData.work_methodology_required
          ? "work_methodology_marking"
          : null,
        wishListData.presentation_required === null
          ? "presentation_required"
          : null,
        wishListData.presentation_required !== null &&
          wishListData.presentation_required
          ? "presentation_required_marking"
          : null,
        wishListData.presentation_required !== null &&
          wishListData.presentation_required
          ? "presentation_type"
          : null,
      ].filter(Boolean);
    } else if (toggleState === 3) {
      requiredFields = [
        wishListData.tender_submission_type === null
          ? "tender_submission_type"
          : null,
        wishListData.bid_prepare_by === null ? "bid_prepare_by" : null,
        wishListData.bg_prepare_by === null ? "bg_prepare_by" : null,
        "lead_partner_share",

        // Show ONLY when both conditions match
        wishListData.jv_partner_name !== "Not Required"
          ? "jv_partner_share"
          : null,

        wishListData.assosiate_partner !== "Not Required"
          ? "associate_partner_share"
          : null,
        wishListData.team_required === null ? "team_required" : null,
        wishListData.team_required !== null && wishListData.team_required
          ? "team_prepare_by"
          : null,
        wishListData.team_required !== null && wishListData.team_required
          ? "team_prepare_by_remarks"
          : null,
        wishListData.team_required !== null && wishListData.team_required
          ? "team_requirements_details"
          : null,
      ].filter(Boolean);

      const partnerShareSum =
        (parseInt(wishListData.lead_partner_share) || 0) +
        (wishListData.jv_partner_name !== "Not Required"
          ? parseInt(wishListData.jv_partner_share) || 0
          : 0) +
        (wishListData.assosiate_partner !== "Not Required"
          ? parseInt(wishListData.associate_partner_share) || 0
          : 0);

      if (partnerShareSum !== 100) {
        newErrors["partner_share_sum"] =
          partnerShareSum > 100
            ? "Sum of all partner shares must not be more than 100"
            : "Sum of all partner shares must not be less than 100";
      }
    } else if (toggleState === 9) {
      if (
        roleemp === "CertificationAccessCvTeamHead" ||
        roleemp === "CertificationAccessCvTeam"
      ) {
        requiredFields = [
          "tech_score",
          "cv_score",
          wishListData.all_cvs_done === null ? "all_cvs_done" : null,
        ].filter(Boolean);
      } else if (
        roleemp === "certificateadminaccess" ||
        roleemp === "CertificationAccess"
      ) {
        requiredFields = [
          "tech_score",
          "cv_score",
          wishListData.all_cvs_done === null ? "all_cvs_done" : null,
          wishListData.checklist === null ? "checklist" : null,
          wishListData.all_docs_done === null ? "all_docs_done" : null,
        ].filter(Boolean);
      } else {
        requiredFields = [
          wishListData.checklist === null ? "checklist" : null,
          wishListData.all_docs_done === null ? "all_docs_done" : null,
        ].filter(Boolean);
      }
      // requiredFields = [

      //     wishListData.checklist === null ? "checklist" : null,
      //     wishListData.team_required === null ? "team_required" : null,
      //     wishListData.team_required !== null && wishListData.team_required ? "team_prepare_by" : null,
      //     wishListData.team_required !== null && wishListData.team_required ? "team_prepare_by_remarks" : null,
      //     wishListData.team_required !== null && wishListData.team_required ? "team_requirements_details" : null,
      //     wishListData.is_emd_required === null ? "is_emd_required" : null,
      //     wishListData.is_emd_required != null && wishListData.is_emd_required ? "emd_amount" : null,
      //     wishListData.is_emd_required != null && wishListData.is_emd_required ? "emd_unit" : null,
      //
      //     wishListData.is_emd_required != null && wishListData.is_emd_required ? "exmpted_emd" : null,

      //     wishListData.is_emd_required != null && wishListData.is_emd_required ? "emd_type" : null,
      //     wishListData.is_emd_required != null && wishListData.is_emd_required ? "emd_submission_type" : null,
      //     "tech_score",
      //     "cv_score",
      //     wishListData.all_docs_done === null ? "all_docs_done" : null,
      //     wishListData.all_cvs_done === null ? "all_cvs_done" : null,
      // ].filter(Boolean);
    } else if (toggleState === 5) {

      requiredFields = [
        wishListData.tech_open === null ? "tech_open" : null,
        wishListData.tech_responsive === null && wishListData.tech_open
          ? "tech_responsive"
          : null,
        wishListData.financial_status === null && wishListData.tech_responsive
          ? "financial_status"
          : null,
        wishListData.are_we_l1 === null ? "are_we_l1" : null,
      ].filter(Boolean);
    }

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          wishListData,
        );
    };

    requiredFields.forEach((field) => {
      if (!wishListData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });
    // if (wishListData.tech_open != null) {
    //     const participant = wishListData.participant_name || {
    //         value: "",
    //         score: "",
    //     };
    //     if (!participant.value?.trim() || !participant.score?.toString().trim()) {
    //         newErrors["participant_name"] =
    //             "At least one participant (name & score) is required!";
    //     }
    // }
    // if (wishListData.financial_status != null) {
    //     const participant = wishListData.financial_participant_name || {
    //         value: "",
    //         score: "",
    //     };
    //     if (!participant.value?.trim() || !participant.score?.toString().trim()) {
    //         newErrors["participant_name"] =
    //             "At least one participant (name & score) is required!";
    //     }
    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmitEligibilityCretria = async (e, filters) => {
    e.preventDefault();
    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait...");
      let data = {
        ...wishListData,
        submission_date: formatISTWithOffset(wishListData.submission_date),
      };
      if (
        !Partners.some(
          (partner) => partner.key === wishListData.lead_partner,
        ) ||
        wishListData.lead_partner === "Other"
      ) {
        data = { ...data, lead_partner: data.custom_lead_partner };
      }
      if (
        !EmdType.some((emd) => emd.key === wishListData.emd_type) ||
        wishListData.emd_type === "Other"
      ) {
        data = { ...data, emd_type: data.custom_emd_type };
      }
      if (
        !Partners.some(
          (partner) => partner.key === wishListData.jv_partner_name,
        ) ||
        wishListData.jv_partner_name === "Other"
      ) {
        data = { ...data, jv_partner_name: data.custom_jv_partner };
      }
      if (
        !Partners.some(
          (partner) => partner.key === wishListData.assosiate_partner,
        ) ||
        wishListData.assosiate_partner === "Other"
      ) {
        data = { ...data, assosiate_partner: data.custom_assosiate_partner };
      }

      if (wishListData.lead_partner === "Not Required") {
        data.lead_partner_share = 0;
      }

      if (wishListData.jv_partner_name === "Not Required") {
        data.jv_partner_share = 0;
      }

      if (wishListData.assosiate_partner === "Not Required") {
        data.associate_partner_share = 0;
      }
      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          const getJsonData = (data) => {
            if (data instanceof FormData) {
              return Object.fromEntries(data.entries());
            }
            return data; // already JSON
          };

          await saveAudit({
            tenderId: tenderId,
            updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
            tableName: "Tenderforbd",
            oldData: {},
            newData: getJsonData(wishListData),
            action: "CREATE",
            tab_id: toggleState,
          });
          if (toggleState === 5) {
            const matchedBg = bgData?.find(
              (bg) => bg.tender_id === tenderIdscroll,
            );

            if (matchedBg) {
              await axios.put(
                `${BASE_URL}/siteproject/bgdetailsforbdput/${matchedBg.id}/`,
                {
                  tech_open: wishListData.tech_open,
                  are_we_l1: wishListData.are_we_l1,
                  is_matured: matchedBg.is_submitted ? true : "",
                  result_open: new Date().toISOString().split("T")[0],
                },
                { headers: { "Content-Type": "application/json" } },
              );
            }
          }
          setShowMoadl(false);
          sessionStorage.setItem("scrollTenderId", tenderIdscroll);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const handleBidsFileChange = (e) => {
    if (e.target.files && e.target.files.length) {
      const newFiles = Array.from(e.target.files);
      setBidDocs(newFiles);
      uploadBidDocs(newFiles);

    }
  };

  const uploadBidDocs = async (files) => {
    setBidUploading(true);
    setBidUploadError("");
    setBidUploadSuccess("");
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("bid_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(`${BASE_URL}/siteproject/bulkbbid/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = files.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "BidTenderDocument",
          oldData: {},
          newData: { rfp_documents: rfpFilesJson },
          action: "CREATE",
        });

        // uploadBidDocs, after saveAudit:
        setBidUploadSuccess(`${files.length > 1 ? "Files" : "File"} uploaded successfully.`);
        setWishListData((prev) => ({
          ...prev,
          bidder_doc: [...(prev.bidder_doc || []), ...rfpFilesJson],
        }));
        setBidDocs([]);
        getBidData();
      }
    } catch (uploadErr) {
      setBidUploadError(
        uploadErr?.response?.status === 413
          ? "Upload failed: file too large for the server to accept."
          : uploadErr?.response?.data?.message || "Upload failed. Please try again."
      );
      setBidDocs([]);
    } finally {
      setBidUploading(false);
    }
  };
  const handleAddBidDoc = async (e) => {
    e.preventDefault();
    setBidUploading(true);
    setBidUploadError("");
    try {
      const formData = new FormData();

      BidDocs.forEach((file) => {
        formData.append("bid_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkbbid/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = BidDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "BidTenderDocument",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
        });
        setBidDocs([]);
        getBidData();
      }
    } catch (uploadErr) {
      setBidUploadError(
        uploadErr?.response?.status === 413
          ? "Upload failed: file too large for the server to accept."
          : uploadErr?.response?.data?.message || "Upload failed. Please try again."
      );
      setBidDocs([]);
    } finally {
      setBidUploading(false);

    }
  };
  const handleFinancialRemove = (index) => {
    setFinancialDocs((prev) => prev.filter((_, i) => i !== index));
  };
  const handleCvsFileChange = (e) => {
    if (e.target.files && e.target.files.length) {
      const newFiles = Array.from(e.target.files);
      setCvsDocs(newFiles);
      uploadCvsDocs(newFiles);
    }
  };

  const uploadCvsDocs = async (files) => {
    setCvsUploading(true);
    setCvsUploadError("");
    setCvsUploadSuccess("");
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("cv_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(`${BASE_URL}/siteproject/bulkcv/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = files.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "Cv",
          oldData: {},
          newData: { rfp_documents: rfpFilesJson },
          action: "CREATE",
        });

        // uploadCvsDocs, after saveAudit:
        setCvsUploadSuccess(`${files.length > 1 ? "Files" : "File"} uploaded successfully.`);
        setWishListData((prev) => ({
          ...prev,
          cvs_files: [...(prev.cvs_files || []), ...rfpFilesJson],
        }));
        setCvsDocs([]);
        getBidData();
      }
    } catch (uploadErr) {
      setCvsUploadError(
        uploadErr?.response?.status === 413
          ? "Upload failed: file too large for the server to accept."
          : uploadErr?.response?.data?.message || "Upload failed. Please try again."
      );
    } finally {
      setCvsUploading(false);
    }
  };

  const handleAddCvDoc = async (e) => {
    e.preventDefault();
    setCvsUploading(true);
    setCvsUploadError("");
    try {
      const formData = new FormData();

      cvsDocs.forEach((file) => {
        formData.append("cv_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkcv/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = cvsDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "Cv",
          oldData: {},
          newData: {
            rfp_documents: rfpFilesJson, // ✅ clean JSON for audit
          },
          action: "CREATE",
        });
        setCvsDocs([]);
        getBidData();
      }
    } catch (uploadErr) {
      setCvsUploadError(
        uploadErr?.response?.status === 413
          ? "Upload failed: file too large for the server to accept."
          : uploadErr?.response?.data?.message || "Upload failed. Please try again."
      );
      setCvsDocs([]);
    } finally {
      setCvsUploading(false);

    }
  };

  const handleTechFileChange = (e) => {
    if (e.target.files && e.target.files.length) {
      const newFiles = Array.from(e.target.files);
      setTechDocs(newFiles);
      uploadTechDocs(newFiles);
    }
  };
  const handleTechRemove = (index) => {
    setTechDocs((prev) => prev.filter((_, i) => i !== index));
  };
  const handleFinancialFileChange = (e) => {
    if (e.target.files && e.target.files.length) {
      const newFiles = Array.from(e.target.files);
      setFinancialDocs(newFiles);
      uploadFinancialDocs(newFiles);
    }
  };
  const uploadFinancialDocs = async (files) => {
    setFinancialUploading(true);
    setFinancialUploadError("");
    setFinancialUploadSuccess("");
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("financial_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(`${BASE_URL}/siteproject/bulkfinancial/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = files.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId: tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "FinancialDocument",
          oldData: {},
          newData: { rfp_documents: rfpFilesJson },
          action: "CREATE",
        });

        // uploadFinancialDocs, after saveAudit:
        setFinancialUploadSuccess(`${files.length > 1 ? "Files" : "File"} uploaded successfully.`);
        setWishListData((prev) => ({
          ...prev,
          financial_doc: [...(prev.financial_doc || []), ...rfpFilesJson],
        }));
        setFinancialDocs([]);
        getBidData();
      }
    } catch (uploadErr) {
      setFinancialUploadError(
        uploadErr?.response?.status === 413
          ? "Upload failed: file too large for the server to accept."
          : uploadErr?.response?.data?.message || "Upload failed. Please try again."
      );
    } finally {
      setFinancialUploading(false);
    }
  };

  const handleAddTechDoc = async (e) => {
    e.preventDefault();
    setTechUploading(true);
    setTechUploadError("");
    try {
      const formData = new FormData();
      techDocs.forEach((file) => {
        formData.append("tech_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(`${BASE_URL}/siteproject/bulk-presigned-urls/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadRes.status === 200 || uploadRes.status === 201) {
        const rfpFilesJson = techDocs.map((file) => ({
          document_name: file.name,
          file_type: file.type,
          file_size: file.size,
        }));

        await saveAudit({
          tenderId,
          updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
          tableName: "TechDocumentBd",
          oldData: {},
          newData: { rfp_documents: rfpFilesJson },
          action: "CREATE",
        });

        setTechDocs([]);
        getBidData();
      }
    } catch (uploadErr) {
      console.error(uploadErr);
      const status = uploadErr?.response?.status;
      setTechUploadError(
        status === 413
          ? "Upload failed: file too large for the server to accept."
          : uploadErr?.response?.data?.message || "Upload failed. Please try again."
      );
      // keep techDocs so the user doesn't have to re-pick the file
    } finally {
      setTechUploading(false);
    }
  };


  // const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB
  // const MAX_PARALLEL_CHUNKS = 4;      // ek saath 4 chunks upload honge

  // const uploadFileInChunks = async (file, onProgress) => {
  //   const fileId = `${Date.now()}_${Math.random().toString(36).slice(2)}_${file.name.replace(/[^\w.\-]/g, "_")}`;
  //   const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
  //   let completedChunks = 0;

  //   const uploadChunk = async (chunkIndex) => {
  //     const start = chunkIndex * CHUNK_SIZE;
  //     const end = Math.min(start + CHUNK_SIZE, file.size);
  //     const chunkBlob = file.slice(start, end);

  //     const chunkFormData = new FormData();
  //     chunkFormData.append("file", chunkBlob, file.name);
  //     chunkFormData.append("chunk_index", chunkIndex);
  //     chunkFormData.append("total_chunks", totalChunks);
  //     chunkFormData.append("file_id", fileId);
  //     chunkFormData.append("original_filename", file.name);

  //     await axios.post(
  //       `${BASE_URL}/siteproject/upload/chunk/`,
  //       chunkFormData,
  //       { headers: { "Content-Type": "multipart/form-data" } }
  //     );

  //     completedChunks += 1;
  //     onProgress(Math.round((completedChunks / totalChunks) * 100));
  //   };

  //   // Chunks ko batches me parallel upload karo (MAX_PARALLEL_CHUNKS ek saath)
  //   const chunkIndexes = Array.from({ length: totalChunks }, (_, i) => i);
  //   for (let i = 0; i < chunkIndexes.length; i += MAX_PARALLEL_CHUNKS) {
  //     const batch = chunkIndexes.slice(i, i + MAX_PARALLEL_CHUNKS);
  //     await Promise.all(batch.map((idx) => uploadChunk(idx)));
  //   }

  //   const completeRes = await axios.post(
  //     `${BASE_URL}/siteproject/upload/complete/`,
  //     { file_id: fileId },
  //     { headers: { "Content-Type": "application/json" } }
  //   );

  //   return completeRes.data;
  // };

  // ── Tech doc upload: presigned URL + confirm flow ─────────────────────
  // const uploadTechDocs = async (files) => {
  //   setTechUploading(true);
  //   setTechUploadError("");
  //   setTechUploadStatusText("Uploading files...");
  //   setTechUploadProgress(
  //     files.reduce((acc, f) => ({ ...acc, [f.name]: 0 }), {})
  //   );
  //   try {
  //     const uploadedFiles = [];

  //     // Step 1: har file ko ALAG-ALAG bhejo (ek-ek karke), taaki har file ka apna progress dikhe
  //     for (const file of files) {
  //       const formData = new FormData();
  //       formData.append("files", file, file.name);

  //       const presignedRes = await axios.post(
  //         `${BASE_URL}/siteproject/tech-doc/bulk-presigned-urls/`,
  //         formData,
  //         {
  //           headers: { "Content-Type": "multipart/form-data" },
  //           onUploadProgress: (evt) => {
  //             if (!evt.total) return;
  //             const percent = Math.round((evt.loaded / evt.total) * 100);
  //             setTechUploadProgress((prev) => ({ ...prev, [file.name]: percent }));
  //           },
  //         }
  //       );

  //       const result = presignedRes?.data?.files?.[0];
  //       if (!result) {
  //         throw new Error(`Upload failed for ${file.name}: no file info returned by server.`);
  //       }
  //       uploadedFiles.push(result);
  //     }

  //     setTechUploadStatusText("Finalizing upload...");

  //     // Step 2: confirm against the tender using the returned file_path/file_name pairs
  //     const confirmPayload = {
  //       tech_tender: tenderId,
  //       files: uploadedFiles.map((f) => ({
  //         file_path: f.file_path,
  //         document_name: f.file_name,   // backend "file_name" bhejta hai
  //       })),
  //     };

  //     await axios.post(
  //       `${BASE_URL}/siteproject/tech-doc/bulk-confirm-upload/`,
  //       confirmPayload,
  //       { headers: { "Content-Type": "application/json" } }
  //     );

  //     const rfpFilesJson = files.map((file) => ({
  //       document_name: file.name,
  //       file_type: file.type,
  //       file_size: file.size,
  //     }));
  //     await saveAudit({
  //       tenderId,
  //       updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
  //       tableName: "TechDocumentBd",
  //       oldData: {},
  //       newData: { rfp_documents: rfpFilesJson },
  //       action: "CREATE",
  //     });

  //     setTechUploadStatusText("All files uploaded successfully.");
  //     setTechDocs([]);
  //     getBidData();
  //   } catch (uploadErr) {
  //     console.error("uploadTechDocs failed:", uploadErr);
  //     const status = uploadErr?.response?.status;
  //     setTechUploadError(
  //       status === 413
  //         ? "Upload failed: file too large for the server to accept."
  //         : uploadErr?.response?.data?.message || uploadErr?.message || "Upload failed. Please try again."
  //     );
  //     setTechUploadProgress((prev) => {
  //       const next = { ...prev };
  //       files.forEach((f) => { next[f.name] = -1; });
  //       return next;
  //     });
  //   } finally {
  //     setTechUploading(false);
  //     setTimeout(() => {
  //       setTechUploadProgress({});
  //       setTechUploadStatusText("");
  //     }, 3000);
  //   }
  // };

  const CHUNK_SIZE = 10 * 1024 * 1024; // 5MB — S3 multipart minimum part size

  const uploadFileInChunks = async (file, onProgress) => {
    const fileId = `${Date.now()}_${Math.random().toString(36).slice(2)}_${file.name.replace(/[^\w.\-]/g, "_")}`;
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunkBlob = file.slice(start, end);

      const chunkFormData = new FormData();
      chunkFormData.append("file", chunkBlob, file.name);
      chunkFormData.append("chunk_index", chunkIndex);
      chunkFormData.append("total_chunks", totalChunks);
      chunkFormData.append("file_id", fileId);
      chunkFormData.append("original_filename", file.name);

      await axios.post(
        `${BASE_URL}/siteproject/upload/chunk/`,
        chunkFormData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      const percent = Math.round(((chunkIndex + 1) / totalChunks) * 100);
      onProgress(percent);
    }

    // Sab chunks chale gaye — ab backend ko bolo assemble + S3 upload karo
    const completeRes = await axios.post(
      `${BASE_URL}/siteproject/upload/complete/`,
      { file_id: fileId },
      { headers: { "Content-Type": "application/json" } }
    );

    return completeRes.data; // { file_name, file_path, file_url }
  };

  const uploadTechDocs = async (files) => {
    setTechUploading(true);
    setTechUploadError("");
    setTechUploadStatusText("Uploading files...");
    setTechUploadProgress(
      files.reduce((acc, f) => ({ ...acc, [f.name]: 0 }), {})
    );

    try {
      // Step 1: har file ko chunk-by-chunk upload karo, S3 path/url wapas milega
      const uploadedFiles = [];
      for (const file of files) {
        setTechUploadStatusText(`Uploading ${file.name}...`);
        const result = await uploadFileInChunks(file, (percent) => {
          setTechUploadProgress((prev) => ({ ...prev, [file.name]: percent }));
        });
        uploadedFiles.push({
          file_path: result.file_url,
          document_name: file.name,
        });
      }

      if (uploadedFiles.length === 0) {
        throw new Error("Upload failed: no file info returned by server.");
      }

      setTechUploadStatusText("Finalizing upload...");

      // Step 2: confirm against the tender using the returned file_path/document_name pairs
      const confirmPayload = {
        tech_tender: tenderId,
        files: uploadedFiles,
      };
      await axios.post(
        `${BASE_URL}/siteproject/tech-doc/bulk-confirm-upload/`,
        confirmPayload,
        { headers: { "Content-Type": "application/json" } }
      );

      const rfpFilesJson = files.map((file) => ({
        document_name: file.name,
        file_type: file.type,
        file_size: file.size,
      }));
      await saveAudit({
        tenderId,
        updatedBy: sessionStorage.getItem("sitemanagement_emp_code"),
        tableName: "TechDocumentBd",
        oldData: {},
        newData: { rfp_documents: rfpFilesJson },
        action: "CREATE",
      });

      setWishListData((prev) => ({
        ...prev,
        tech_doc: [...(prev.tech_doc || []), ...rfpFilesJson],
      }));
      setTechUploadStatusText("All files uploaded successfully.");
      setTechDocs([]);
      getBidData();
    } catch (uploadErr) {
      console.error("uploadTechDocs failed:", uploadErr);
      const status = uploadErr?.response?.status;
      setTechUploadError(
        status === 413
          ? "Upload failed: file too large for the server to accept."
          : uploadErr?.response?.data?.message || uploadErr?.message || "Upload failed. Please try again."
      );
      setTechUploadProgress((prev) => {
        const next = { ...prev };
        files.forEach((f) => { next[f.name] = -1; });
        return next;
      });
    } finally {
      setTechUploading(false);
      setTimeout(() => {
        setTechUploadProgress({});
      }, 3000);
    }
  };

  const Partners = [{ key: "sapl", value: "SAPL" }, { key: "cipl", value: "CIPL" }, { key: "joint", value: "Joint" }, { key: "Other", value: "Other" }, { key: "Not Required", value: "Not Required" }];
  const EmdType = [{ key: "Bank_Gurantee", value: "Bank Gurantee" }, { key: "neft", value: "NEFT" }, { key: "demand_draft", value: "Demand Draft" }, { key: "suretybond", value: "Surety Bond" }, { key: "other", value: "Other" }];
  const CLIENT_FILTER_OPTIONS = [
    { value: "NHAI", label: "NHAI" }, { value: "MORTH", label: "MoRTH" }, { value: "NHIDCL", label: "NHIDCL" },
    { value: "BRO", label: "BRO" }, { value: "PWDS", label: "PWDs" }, { value: "MPRDCL", label: "MPRDCL" },
    { value: "MHRDCL", label: "MHRDCL" }, { value: "GJRDCL", label: "GJRDCL" }, { value: "SHAJ", label: "SHAJ" },
    { value: "HSIIDC", label: "HSIIDC" }, { value: "BHRDCL", label: "BHRDCL" }, { value: "UPEIDA", label: "UPEIDA" },
    { value: "UPHA&SP", label: "UPHA&SP" }, { value: "RITES", label: "RITES" }, { value: "HRBG", label: "HRBG" },
    { value: "APCRDA", label: "APCRDA" }, { value: "RCDB", label: "RCDB" }, { value: "BSIL", label: "BSIL" },
    { value: "BUIDCL", label: "BUIDCL" }, { value: "CMRL", label: "CMRL" }, { value: "DMRCL", label: "DMRCL" },
    { value: "EPIL", label: "EPIL" }, { value: "HRSI&IDCL", label: "HRSI&IDCL" }, { value: "H&UDCL", label: "H&UDCL" },
    { value: "J&KRRDA", label: "J&KRRDA" }, { value: "MHSIDC", label: "MHSIDC" }, { value: "MHMRCL", label: "MHMRCL" },
    { value: "RJSRD&CCL", label: "RJSRD&CCL" }, { value: "KARDCL", label: "KARDCL" }, { value: "TNRDL", label: "TNRDL" },
    { value: "APRDC", label: "APRDC" }, { value: "PBIDB", label: "PBIDB" }, { value: "R&BDT", label: "R&BDT" },
    { value: "RCDJ", label: "RCDJ" }, { value: "JHSRDC", label: "JHSRDC" }, { value: "HPPWD", label: "HPPWD" },
    { value: "UKPWD", label: "UKPWD" }, { value: "DSI&IDC", label: "DSI&IDC" }, { value: "GOAPWD", label: "GOAPWD" },
    { value: "HRRIDC", label: "HRRIDC" }, { value: "RIDFOD", label: "RIDFOD" }, { value: "RJSID&IC", label: "RJSID&IC" },
    { value: "KLRFB", label: "KLRFB" }, { value: "RSHA", label: "RSHA" }, { value: "BIDA", label: "BIDA" },
    { value: "MIDFC", label: "MIDFC" }, { value: "SOI", label: "SOI" }, { value: "JNPT", label: "JNPT" },
    { value: "BMRCL", label: "BMRCL" }, { value: "OBCCL", label: "OBCCL" },
    { value: "NationalHighwaysLogisticsManagementLimited", label: "National Highways Logistics Management Limited" },
    { value: "CENTRAL_RAILWAY", label: "Central Railway" }, { value: "EAST_CENTRAL_RAILWAY", label: "East Central Railway" },
    { value: "EASTERN_RAILWAY", label: "Eastern Railway" }, { value: "MINISTRY_OF_RAILWAYS", label: "Ministry of Railways" },
    { value: "MUMBAI_RAILWAY_VIKAS_CORPORATION", label: "Mumbai Railway Vikas Corporation" },
    { value: "NORTH_CENTRAL_RAILWAY", label: "North Central Railway" }, { value: "NORTH_EASTERN_RAILWAYS", label: "North Eastern Railways" },
    { value: "NORTHEST_FRONTIER_RAILWAYA", label: "Northest Frontier Railwaya" }, { value: "NORTHERN_RAILWAY", label: "Northern Railway" },
    { value: "RAILWAY_ENERGY_MANAGEMENT_COMPANY_LIMITED", label: "Railway Energy Management Company Limited" },
    { value: "SOUTH_CENTRAL_RAILWAY", label: "South Central Railway" }, { value: "SOUTH_EASTERN_RAILWAYS", label: "South Eastern Railways" },
    { value: "SOUTH_COAST_RAILWAY", label: "South Coast Railway" },
    { value: "SOUTHEST_FRONTIER_RAILWAY", label: "Southest Frontier Railway" }, { value: "SOUTHERN_RAILWAY", label: "Southern Railway" },
    { value: "EAST_COAST_RAILWAY", label: "EAST COAST RAILWAY" }, { value: "South_West_Central_Railway", label: "South West Central Railway" },
    { value: "West_Central_Railway ", label: "West Central Railway" }, { value: "South_Western_Railway", label: "South Western Railway" },
    { value: "Western_Railway", label: "Western Railway" }, { value: "North_Western_Railway", label: "North Western Railway" },
    { value: "South_East_Railway", label: "South East Railway" }, { value: "OTHER", label: "Other" },
  ];
  const ALL_PARTNERS = [
    { key: "Saptagon Asia Private Limited", value: "Saptagon Asia Private Limited" },
    { key: "Civilmantra Infracon Limited", value: "Civilmantra Infracon Limited" },
    { key: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED", value: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED" },
    { key: "ISAN CORPORATION", value: "ISAN CORPORATION" },
    { key: "MARC TECHNOCRATS LIMITED", value: "MARC TECHNOCRATS LIMITED" },
    { key: "ALOMNDS GLOBAL INFRASTRUCTURE", value: "ALOMNDS GLOBAL INFRASTRUCTURE" },
    { key: "VOYANTS SOLUTIONS PVT LTD", value: "VOYANTS SOLUTIONS PVT LTD" },
    { key: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED", value: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED" },
    { key: "MSV INTERNATIONAL", value: "MSV INTERNATIONAL" },
    { key: "YONGMA ENGINEERING CO LTD", value: "YONGMA ENGINEERING CO LTD" },
    { key: "TECH-4", value: "TECH-4" },
    { key: "AECOM INDIA PRIVATE LIMITED", value: "AECOM INDIA PRIVATE LIMITED" },
    { key: "SMEC INDIA PVT LTD", value: "SMEC INDIA PVT LTD" },
    { key: "SPECTRUM", value: "SPECTRUM" },
    { key: "INSTUTIUTE GIPROSTROYMOST", value: "INSTUTIUTE GIPROSTROYMOST" },
    { key: "RODIC CONSULTANT PRIVATE LIMITED", value: "RODIC CONSULTANT PRIVATE LIMITED" },
    { key: "CHAITANYA PROJECT CONSULTANCY LTD", value: "CHAITANYA PROJECT CONSULTANCY LTD" },
    { key: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)", value: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)" },
    { key: "TPF ENGINEERING PRIVATE LIMITED", value: "TPF ENGINEERING PRIVATE LIMITED" },
    { key: "INFRAPLUS CONSULTANCY PVT LTD", value: "INFRAPLUS CONSULTANCY PVT LTD" },
    { key: "RITES LIMITED", value: "RITES LIMITED" },
    { key: "TPF GETINSAEUROESTUDIOS SL", value: "TPF GETINSAEUROESTUDIOS SL" },
    { key: "SA INFRASTURCTURE CONSULTING PRIVATE", value: "SA INFRASTURCTURE CONSULTING PRIVATE" },
    { key: "CEG LIMITED", value: "CEG LIMITED" },
    { key: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD", value: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD" },
    { key: "Egis", value: "Egis" },
    { key: "OPEN SOLUTION", value: "OPEN SOLUTION" },
    { key: "SUMAD ENTERPRISE", value: "SUMAD ENTERPRISE" },
    { key: "Earl Techno Consultant Pvt. Ltd.", value: "Earl Techno Consultant Pvt. Ltd." },
    { key: "Pentagon", value: "Pentagon" },
    { key: "Ropes", value: "Ropes" },
    { key: "WPKK", value: "WPKK" },
    { key: "sapl", value: "SAPL" },
    { key: "cipl", value: "CIPL" },
    { key: "DESIGN LINE CONSULTANCY", value: "DESIGN LINE CONSULTANCY" },
    { key: "GIPRO", value: "GIPRO" },
    { key: "joint", value: "Joint" },
    { key: "Other", value: "Other" },
    { key: "Not Required", value: "Not Required" },
  ];
  const partnerFilterOptions = ALL_PARTNERS.map((p) => ({ value: p.key, label: p.value }));

  const handleHideUpdateModal = () => setCorriendumModal(false);
  const handleHideUpdateModalScreening = () => setCorriendumModalScreening(false);

  const [filters, setFilters] = useState({ searchText: "", searchId: "", companyProjectCode: "", organizationID: "", sector: [], state: [], city: "", ownership: "", department: "", closingDateFrom: "", closingDateTo: "", website: "", quantityType: ">=", quantityValue: "", tenderValueComparison: "=", valueFrom: "", valueTo: "", lakhFrom: "Lakh", lakhTo: "Lakh", gemType: "All", msmeExemption: false, aiSummary: false, startupExemption: false, boq: false, client: [], partner: [], tenderType: [], is_special_tender: "", is_today: "", is_discussed: "", tenderStatus: [], specialStructureType: [] });
  const [toggleCompany, setToggleCompany] = useState("null");
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
  const navigate = useNavigate();
  const [companySelected, setCompanySelected] = useState("");
  const [targetSector, setTargetSector] = useState("");
  const [targetTenderType, setTargetTenderType] = useState("");
  const [structureList, setstructureList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState(null);
  const [selectedNo, setNo] = useState("");
  const [selectedFromDate, setFromDate] = useState("null");
  const [selectedToDate, setToDate] = useState("null");
  const [structure, setStructure] = useState("null");
  const [sector, setSector] = useState("null");
  const [service, setService] = useState("null");
  const [selectedProject, setSelectedProject] = useState("null");
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowMoadl] = useState(false);
  const [trackRecordList, setTrackRecordList] = useState([]);
  const [buffer, setBuffering] = useState(true);
  const [projectList, setProjectList] = useState([]);
  const [bidData, SetBidData] = useState([]);
  const [allTendersData, setAllTendersData] = useState([]);
  const [tenderFee, setTenderFee] = useState("");
  const roleemp = sessionStorage.getItem("sitemanagement_role");
  const latestRequestRef = useRef(0);

  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [dateRange, setDateRange] = useState("");
  const [selectedTL, setSelectedTL] = useState("");
  const [activeTLData, setActiveTLData] = useState(null);
  const [tlData, SetTlData] = useState([]);
  const [memberData, SetMemberData] = useState([]);
  const [tlSummaryData, setTlSummaryData] = useState([]);
  const [memberSummaryData, setMemberSummaryData] = useState([]);
  const [selectedMember, setSelectedMember] = useState("");
  const [tlMemberLoading, setTlMemberLoading] = useState(false);
  const [istlSelected, SetistlSelected] = useState(false);
  const [isrequested, Setisrequested] = useState(false);
  const [isClosed, SetisClosed] = useState(false);
  const [submissionDateFilter, setSubmissionDateFilter] = useState("");
  const [pipelineMovedRange, setPipelineMovedRange] = useState("");
  const [expiryDateFilter, setExpiryDateFilter] = useState(1);
  const [newDateFilter, setNewDateFilter] = useState(0);
  const [tenderId, setTenderId] = useState("");
  const [tenderIdscroll, SetTenderIdscroll] = useState("");
  const [wishListData, setWishListData] = useState({ jv_partner_type: "null", soil_quality: "", participating_as: "", soil_type: "null", lead_partner: "", lead_partner_share: 0, jv_partner_name: "", jv_partner_share: 0, assosiate_partner: "", associate_partner_share: 0, bg_requried: "", bg_amount: "", bg_type: "", tendersubmission: "", bg_submission: "", submission_date: "", company_score: "", company_type: "", tech_score: "", site_apprisate_required: "", work_methodology_required: "", work_methodology_marking: "", presentation_required: "", presentation_required_marking: "", presentation_type: "", client: "", technical_status: "", financial_status: "", responsive_status: "", are_we_l1: "", leading_parenter: "", bg_sharing: "", bidder_name: { value: "", loading: false }, bidders: [], bg_pending: false, tech_open: "", tech_responsive: "", participant_name: { value: "", score: "", loading: false }, participants: [], financial_participant_name: { value: "", score: "", loading: false }, financial_participants: [], checklist: "", all_docs_done: "", all_cvs_done: "", cvs_files: [], tech_doc: [], financial_doc: [], bid_doc: [], bidder_doc: [], is_jv_allowed: "", is_jv_consorium_association_allowed: "", terms_of_jv: "", partner_share_sum: 0, cv_score: 0, company_name: "", company_dist_lead: "", site_apprisate_marking: "", eligibity_criteria: "", eligibity_criteria_special: "", associate_qualify: false, tender_submission_type: "", custom_lead_partner: "", custom_emd_type: "", custom_jv_partner: "", custom_assosiate_partner: "", bid_prepare_by: "null", bg_prepare_by: "null", bid_prepare_by_remarks: "", team_prepare_by: "null", team_prepare_by_remarks: "", team_required: "", team_requirements_details: "", recipient_details: "", company_dist_jv: "" });
  const [errors, setErrors] = useState();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [stats, setStats] = useState([]);
  const [activeCard, setActiveCard] = useState(null);
  const [toggleState, setToggleState] = useState(
    roleemp === "CertificationAccessCvTeamHead" ||
      roleemp === "CertificationAccessCvTeam" ||
      roleemp === "CertificationAccessDocumentTeam" || roleemp === "CertificationAccessDocumentTeamHead"
      ? 9

      : roleemp === "BdDashboardPrebid"
        ? 10
        : 1,
  );
  const [recentExpiredCount, setRecentExpiredCount] = useState(null);

  const apiTabId = toggleState;

  const [closedExpiredSubTab, setClosedExpiredSubTab] = useState("expired");
  const [showEditModal, setShowEditModal] = useState(false);
  const [showEditModalTab, setShowEditModalTab] = useState(false);
  const [editTenderId, setEditTenderId] = useState(null);
  const [editTenderData, setEditTenderData] = useState([]);
  const [showBackModal, setShowBackModal] = useState(false);
  const [backTenderId, setBackTenderId] = useState(null);
  const [backTenderolddata, setBackTenderOldData] = useState({});
  const [bgData, setBgData] = useState([]);
  const [employeelistassigned, SetEmployeelistassigned] = useState([]);
  const [employeelistassignedto, SetEmployeelistassignedto] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isemployeeSelected, SetisemployeeSelected] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [tenderFeeMap, setTenderFeeMap] = useState({});
  const [scrollToTender, setScrollToTender] = useState(null);
  const [apiData, setApiData] = useState([]);
  const [docsModal, setDocsModal] = useState(false);
  const [corrigendumDocs, setCorrigendumDocs] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [tenderDocsModal, setTenderDocsModal] = useState(false);
  const [tenderDocuments, setTenderDocuments] = useState({ tech: [], financial: [], cvs: [], rpf: [], bidDocs: [] });
  const [isclear, Setisclear] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  // ── Grid-specific UI state ───────────────────────────────────────────────
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedRows, setSelectedRows] = useState({});
  const [showWorkLog, setShowWorkLog] = useState(false);
  const [workLogTender, setWorkLogTender] = useState(null);
  const [workLogProjectId, setWorkLogProjectId] = useState("");
  const [showViewWorkLog, setShowViewWorkLog] = useState(false);
  const [viewWorkLogTender, setViewWorkLogTender] = useState(null);
  const [ddProjects, setDdProjects] = useState([]);
  const [gridSearchTerm, setGridSearchTerm] = useState("");
  const [gridSectorFilter, setGridSectorFilter] = useState("");
  const [gridTypeFilter, setGridTypeFilter] = useState("");
  const [statsOpen, setStatsOpen] = useState(false);
  const [statstoggleOpen, setStatstoggleOpen] = useState(false);

  const MERGED_FETCH_SIZE = 1000;

  // Tender Result = tab 11 (Tech Open) + tab 12 (Financial Open), merged and paginated client-side
  const fetchMergedTabs = async (tabIds, fetchOne, listKey) => {
    const responses = await Promise.all(
      tabIds.map((t) => fetchOne(t, 1, MERGED_FETCH_SIZE))
    );

    const seen = new Set();
    const list = responses
      .flatMap((r) => r?.[listKey] ?? [])
      .filter((t) => {
        if (seen.has(t.id)) return false;
        seen.add(t.id);
        return true;
      });

    if (sortBy) {
      list.sort((a, b) => {
        const av = new Date(a?.[sortBy] || 0).getTime();
        const bv = new Date(b?.[sortBy] || 0).getTime();
        return sortOrder === "asc" ? av - bv : bv - av;
      });
    }

    const start = (currentPage - 1) * PAGE_SIZE;
    return {
      ...responses[0],
      [listKey]: list.slice(start, start + PAGE_SIZE),
      total_records: list.length,
      total_pages: Math.max(1, Math.ceil(list.length / PAGE_SIZE)),
      current_page: currentPage,
    };
  };

  const buildAssignedUrl = (emp_code, filters, tab_id, page, pageSize) =>
    `${BASE_URL}/siteproject/tendersassigned3/${emp_code}/null/${toParam(filters?.state)}/${filters?.searchText || "null"}/${toParam(filters?.sector)}/${selectedFromDate || "null"}/${selectedToDate || "null"}/${toParam(filters?.tenderType)}/${filters?.searchId || "null"}/${filters?.is_special_tender || "null"}/${filters?.is_today || "null"}/${filters?.is_discussed || "null"}/${filters?.is_discussed_by || "null"}/${toParam(filters?.tenderStatus)}/?tab_id=${tab_id}&page=${page}&page_size=${pageSize}` +
    `${sortBy ? `&sort_by=${sortBy}&sort_order=${sortOrder}` : ""}` +
    `${toggleState === 9 && dateRange ? `&submission_date_range=${dateRange}` : ""}` +
    `${toggleState === 9 && pipelineMovedRange ? `&date_ff_range=${pipelineMovedRange}` : ""}` +
    `${toggleState !== 9 && dateRange ? `&date_range=${dateRange}` : ""}` +
    buildSectorParams();

  // ── All original data-fetch methods ──────────────────────────────────────
  const getBidData = async (filters) => {
    const requestId = ++latestRequestRef.current;
    setBuffering(true);
    try {
      const empCode = sessionStorage.getItem("sitemanagement_emp_code");
      const buildApiUrl = (tab_id, page, pageSize) =>
        `${BASE_URL}/siteproject/tenderforBDfilter5/null` +
        `/${toParam(filters?.state)}` +
        `/${filters?.searchText || "null"}` +
        `/${toParam(filters?.sector)}` +
        `/${selectedFromDate || "null"}` +
        `/${selectedToDate || "null"}` +
        `/${toParam(filters?.tenderType)}` +
        `/${filters?.is_special_tender || "null"}` +
        `/${filters?.is_today || "null"}` +
        `/${filters?.is_discussed || "null"}` +
        `/${empCode}/${empCode}` +
        `/${toParam(filters?.tenderStatus)}` +
        `/?tender_id=${filters?.searchId || "null"}` +
        `&tab_id=${tab_id}&page=${page}&page_size=${pageSize}` +
        `${sortBy ? `&sort_by=${sortBy}&sort_order=${sortOrder}` : ""}` +
        `${tab_id === 9 && dateRange ? `&submission_date_range=${dateRange}` : ""}` +
        `${tab_id === 9 && pipelineMovedRange ? `&date_ff_range=${pipelineMovedRange}` : ""}` +
        `${tab_id !== 9 && dateRange ? `&date_range=${dateRange}` : ""}` +
        buildSectorParams();

      const allowedRoles = ["certificaionadminaccess", "CertificationAccess", "CertificationAccessBd", "BdDashboardPrebid", "ScreeningTeam"];
      if (toggleState === 8) {
        const all = await getExpiredList();
        if (requestId !== latestRequestRef.current) return;
        const list = all.filter(isRecentlyExpired);
        if (sortBy) {
          list.sort((a, b) => {
            const av = new Date(a?.[sortBy] || 0).getTime();
            const bv = new Date(b?.[sortBy] || 0).getTime();
            return sortOrder === "asc" ? av - bv : bv - av;
          });
        }
        const start = (currentPage - 1) * PAGE_SIZE;
        SetBidData(list.slice(start, start + PAGE_SIZE));
        setTotalCount(list.length);
        setTotalPages(Math.max(1, Math.ceil(list.length / PAGE_SIZE)));
        setRecentExpiredCount(list.length);
        return;
      }
      if (allowedRoles.includes(roleemp)) {
        const results =
          toggleState === 5
            ? await fetchMergedTabs([5, 11, 12], async (t, p, s) => (await axios.get(buildApiUrl(t, p, s))).data, "data")
            : (await axios.get(buildApiUrl(apiTabId, currentPage, PAGE_SIZE))).data;

        if (requestId !== latestRequestRef.current) return;


        SetBidData(results.data ?? []);
        SetTlData(results.tl_summary ?? []);
        SetMemberData(results.member_summary ?? []);
        setTlSummaryData(results.tl_summary ?? []);
        setMemberSummaryData(results.member_summary ?? []);
        setTotalCount(results.total_records ?? 0);
        setTotalPages(results.total_pages ?? 1);
        setCurrentPage(results.current_page ?? 1);

        setTabCounts({ new_tenders: results.new_tenders ?? 0, wishlist_tenders: results.wishlist_tenders ?? 0, target_tenders: results.target_tenders ?? 0, final_tenders: results.final_tenders ?? 0, submitted_tenders: results.submitted_tenders ?? 0, intechopen: results.intechopen ?? 0, infinacialopen: results.infinacialopen ?? 0, closed_tender: results.closed_tender ?? 0, expired_tender: results.expired_tender ?? 0, bid_preparation_pipeline: results.bid_preparation_pipeline ?? 0, presentation_required_tender: results.presentation_required ?? 0 });
        setSpecialStructureCounts(results.special_structure_type ?? {});
      } else if (roleemp === "CertificationAccessCvTeam" || roleemp === "CertificationAccessDocumentTeam") {
        await getEmployeeDatato(empCode, filters);
        if (requestId !== latestRequestRef.current) return;
      } else if (roleemp === "CertificationAccessDocumentTeamHead" || roleemp === "CertificationAccessCvTeamHead") {
        await getTlData(empCode, filters);
      }
    } catch (err) { console.error("Error fetching bid data:", err); }
    finally { if (requestId === latestRequestRef.current) setBuffering(false); }
  };

  // add this state near your other modal state


  // fetch fn: now returns the data directly instead of just setting state,
  // so the caller doesn't have to wait on a stale closure / batched setState
  const fetchTendersForTab = async (tabId, includeDateRange) => {
    const empCode = sessionStorage.getItem("sitemanagement_emp_code");
    let apiUrl =
      `${BASE_URL}/siteproject/tenderforBDfilter/null` +
      `/${toParam(filters?.state)}` +
      `/${toParam(filters?.searchText)}` +
      `/${toParam(filters?.sector)}` +
      `/${selectedFromDate || "null"}` +
      `/${selectedToDate || "null"}` +
      `/${toParam(filters?.tenderType)}` +
      `/${filters?.is_special_tender || "null"}` +
      `/${filters?.is_today || "null"}` +
      `/${filters?.is_discussed || "null"}` +
      `/${empCode}/${empCode}` +
      `/${toParam(filters?.tenderStatus)}` +
      `/?tender_id=${filters?.searchId || "null"}`;   // <-- no tab_id here, semicolon ends the statement

    // no tab_id => backend returns ALL tenders
    if (tabId !== null && tabId !== undefined) {
      apiUrl += `&tab_id=${tabId}`;
    }

    if (includeDateRange && dateRange) {
      apiUrl += tabId === 9
        ? `&submission_date_range=${dateRange}`
        : `&date_range=${dateRange}`;
    }
    if (includeDateRange && tabId === 9 && pipelineMovedRange) {
      apiUrl += `&date_ff_range=${pipelineMovedRange}`;
    }
    apiUrl += buildSectorParams();
    apiUrl += buildSectorParams();

    const res = await axios.get(apiUrl);
    const raw = res.data;
    const list = Array.isArray(raw)
      ? raw
      : Array.isArray(raw?.data)
        ? raw.data
        : Array.isArray(raw?.tenders)
          ? raw.tenders
          : Array.isArray(raw?.results)
            ? raw.results
            : [];
    return list;
  };
  const buildSectorParams = () => {
    let extra = "";
    if (filters.sector.includes("Railway") && consultancyCostFilter.length) {
      extra += `&consultancy_cost_range=${consultancyCostFilter.map(encodeURIComponent).join(",")}`;
    }
    if (filters.sector.includes("Highway")) {
      if (constructionCostRange.length) {
        extra += `&construction_cost_range=${constructionCostRange.map(encodeURIComponent).join(",")}`;
      }
      if (lengthRange.length) {
        extra += `&length_range=${lengthRange.map(encodeURIComponent).join(",")}`;
      }
    }
    if (filters.companyProjectCode) {
      extra += `&company_project_code_bd=${encodeURIComponent(filters.companyProjectCode)}`;
    }
    if (filters.specialStructureType?.length) {                                    // ← NEW
      extra += `&special_structure_type=${filters.specialStructureType.map(encodeURIComponent).join(",")}`;
    }
    if (filters.client?.length) {
      extra += `&client=${filters.client.map((v) => encodeURIComponent(String(v).replace(/ /g, ""))).join(",")}`;
    }
    if (filters.partner?.length) {
      extra += `&partner=${filters.partner.map((v) => encodeURIComponent(String(v).replace(/ /g, ""))).join(",")}`;
    }
    const cf = Object.fromEntries(
      Object.entries(customFilters).filter(([, v]) =>
        v !== undefined && v !== "" && !(Array.isArray(v) && !v.length))
    );
    if (Object.keys(cf).length) extra += `&custom_filters=${encodeURIComponent(JSON.stringify(cf))}`;
    return extra;
  };

  const handleDownloadConfirm = async (choice) => {
    setDownloadLoading(true);
    try {
      if (choice === "current") {
        let data;
        if (toggleState === 11) {
          const [tech, fin] = await Promise.all([fetchTendersForTab(11, true), fetchTendersForTab(12, true)]);
          const seen = new Set();
          data = [...tech, ...fin].filter((t) => {
            if (seen.has(t.id)) return false;
            seen.add(t.id);
            return true;
          });
        } else {
          data = await fetchTendersForTab(apiTabId, true);
        }
        setAllTendersForDownload(data);

        // Apply grid-level filters so the export matches the on-screen
        // "Showing X of Y" exactly.
        const gridFiltered = data.filter((t) => {
          if (gridSearchTerm) {
            const q = gridSearchTerm.toLowerCase();
            const matchesSearch =
              t.tender_id?.toLowerCase().includes(q) ||
              t.tender_name?.toLowerCase().includes(q);
            if (!matchesSearch) return false;
          }
          if (gridSectorFilter) {
            const sectorVal = t.sector === "Other" ? t.other_sector_type : t.sector;
            if (sectorVal !== gridSectorFilter) return false;
          }
          if (gridTypeFilter && t.tender_type !== gridTypeFilter) return false;
          return true;
        });

        downloadTenders(gridFiltered, apiTabId);
      } else if (choice === "all_single") {
        // hit tenderforBDfilter WITHOUT tab_id, no date_range
        const allData = await fetchTendersForTab(null, false);
        downloadAllTendersSingleSheet(allData);
      } else {
        // "All tenders" — fetch each tab pre-scoped in parallel instead of
        // relying on one combined response and slicing it client-side.
        const tabOrder = [1, 2, 3, 4, 9, 5, 11, 12, 6, 7, 10];
        const results = await Promise.all(
          tabOrder.map((tab) => fetchTendersForTab(tab, false))
        );
        const dataByTab = {};
        tabOrder.forEach((tab, idx) => { dataByTab[tab] = results[idx]; });
        downloadAllTenders(dataByTab);
      }
      setShowDownloadModal(false);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setDownloadLoading(false);
    }
  };

  // handleDownloadConfirm goes back to the simple version — no need to branch
  // on choice anymore since the fetch itself no longer cares about tab_id
  // const handleDownloadConfirm = async (choice) => {
  //   setDownloadLoading(true);
  //   try {
  //     const data = await fetchAllTendersForDownload(choice === "current");

  //     if (choice === "current") {
  //       const gridFiltered = data.filter((t) => {
  //         if (gridSearchTerm) {
  //           const q = gridSearchTerm.toLowerCase();
  //           const matchesSearch =
  //             t.tender_id?.toLowerCase().includes(q) ||
  //             t.tender_name?.toLowerCase().includes(q);
  //           if (!matchesSearch) return false;
  //         }
  //         if (gridSectorFilter) {
  //           const sectorVal = t.sector === "Other" ? t.other_sector_type : t.sector;
  //           if (sectorVal !== gridSectorFilter) return false;
  //         }
  //         if (gridTypeFilter && t.tender_type !== gridTypeFilter) return false;
  //         return true;
  //       });
  //       downloadTenders(gridFiltered, toggleState);
  //     } else {
  //       downloadAllTenders(data);
  //     }
  //     setShowDownloadModal(false);
  //   } catch (err) {
  //     handleErrorToast(err);
  //   } finally {
  //     setDownloadLoading(false);
  //   }
  // };

  // new: drives the modal's loading state and decides which export to run

  const getEmployeeDatato = async (emp_code, filters) => {
    try {
      const tab_id = apiTabId;
      const data =
        toggleState === 5
          ? await fetchMergedTabs([5, 11, 12], async (t, p, s) => (await axios.get(buildAssignedUrl(emp_code, filters, t, p, s))).data, "tenders")
          : (await axios.get(buildAssignedUrl(emp_code, filters, tab_id, currentPage, PAGE_SIZE))).data;
      // then replace every `results.data.` below with `data.`
      SetBidData(data.tenders);
      setTotalCount(data.total_records ?? 0);
      setTotalPages(data.total_pages ?? 1);
      setCurrentPage(data.current_page ?? 1);
      setTabCounts({ new_tenders: data.new_tenders ?? 0, wishlist_tenders: data.wishlist_tender ?? 0, target_tenders: data.target_tenders ?? 0, final_tenders: data.final_tenders ?? 0, submitted_tenders: data.submitted_tenders ?? 0, closed_tender: data.closed_tender ?? 0, expired_tender: data.expired_tender ?? 0, bid_preparation_pipeline: data.bid_preparation_pipeline ?? 0, presentation_required: data.presentation_required ?? 0 });
      setSpecialStructureCounts(data.special_structure_type ?? {});
      setBuffering(false);
    } catch (error) { console.error("Error fetching employee data:", error); }
  };

  const getTlData = async (emp_code, filters) => {
    try {
      // getEmployeeDatato
      const tab_id = apiTabId;
      const data =
        toggleState === 5
          ? await fetchMergedTabs([5, 11, 12], async (t, p, s) => (await axios.get(buildAssignedUrl(emp_code, filters, t, p, s))).data, "tenders")
          : (await axios.get(buildAssignedUrl(emp_code, filters, tab_id, currentPage, PAGE_SIZE))).data;
      // then replace every `results.data.` below with `data.`
      SetBidData(data.tenders ?? []);
      const rawTl = data.tl_summary ?? [];
      const rawMember = data.member_summary ?? [];
      SetTlData(rawTl); SetMemberData(rawMember); setTlSummaryData(rawTl); setMemberSummaryData(rawMember);
      setTotalCount(data.total_records ?? 0); setTotalPages(data.total_pages ?? 1); setCurrentPage(data.current_page ?? 1);
      setTabCounts({ new_tenders: data.new_tenders ?? 0, wishlist_tenders: data.wishlist_tender ?? 0, target_tenders: data.target_tenders ?? 0, final_tenders: data.final_tenders ?? 0, submitted_tenders: data.submitted_tenders ?? 0, closed_tender: data.closed_tender ?? 0, expired_tender: data.expired_tender ?? 0, bid_preparation_pipeline: data.bid_preparation_pipeline ?? 0, presentation_required: data.presentation_required ?? 0 });
      setBuffering(false);

    } catch (error) { console.error("Error fetching TL data:", error); }
  };

  const handleTLSelect = async (tlEmpCode) => {
    setSelectedTL(tlEmpCode); setSelectedMember(""); setCurrentPage(1);
    if (tlEmpCode) { const found = tlSummaryData.find(t => t.emp_code === tlEmpCode) || null; setActiveTLData(found); setSelectedEmployee(tlEmpCode); SetistlSelected(true); SetisemployeeSelected(false); await getTlData(tlEmpCode, filters); }
    else { setActiveTLData(null); setSelectedEmployee(null); SetistlSelected(false); const empCode = sessionStorage.getItem("sitemanagement_emp_code"); if (roleemp === "CertificationAccessDocumentTeamHead" || roleemp === "CertificationAccessCvTeamHead") { await getTlData(empCode, filters); } else { await getBidData(filters); } }
  };

  const handleMemberSelect = async (memberEmpCode) => {
    if (memberEmpCode === selectedMember) { setSelectedMember(""); setSelectedEmployee(selectedTL || null); SetisemployeeSelected(false); SetistlSelected(!!selectedTL); setCurrentPage(1); if (selectedTL) { await getTlData(selectedTL, filters); } else { await getBidData(filters); } return; }
    setSelectedMember(memberEmpCode); setSelectedEmployee(memberEmpCode); SetisemployeeSelected(true); SetistlSelected(false); setCurrentPage(1); await getEmployeeDatato(memberEmpCode, filters);
  };

  const handleClearTLMember = async () => {
    setSelectedTL(""); setActiveTLData(null); setSelectedMember(""); setSelectedEmployee(null); SetisemployeeSelected(false); SetistlSelected(false); setCurrentPage(1);
    const empCode = sessionStorage.getItem("sitemanagement_emp_code");
    if (roleemp === "CertificationAccessDocumentTeamHead" || roleemp === "CertificationAccessCvTeamHead") { await getTlData(empCode, filters); } else { await getBidData(filters); }
  };

  // const handleGetStats = async (tabId) => {
  //   try {
  //     const res = await axios.get(`${BASE_URL}/siteproject/tenderstatustabfilters/?tab_id=${tabId}`);
  //     const sectorData = res.data;
  //     const priorityOrder = ["HIGHWAY", "RAILWAY", "BUILDING"];

  //     // Prefer tab_sector_counts (bifurcated to the active tab) when present;
  //     // fall back to the global sector_counts otherwise.
  //     const sourceCounts =
  //       sectorData.tab_sector_counts && Object.keys(sectorData.tab_sector_counts).length > 0
  //         ? sectorData.tab_sector_counts
  //         : sectorData.sector_counts;

  //     const result = Object.entries(sourceCounts || {})
  //       .map(([sector, data]) => ({ sector, count: data.count, tender_type: data.tender_type }))
  //       .sort((a, b) => {
  //         if (a.sector === "OTHER") return 1;
  //         if (b.sector === "OTHER") return -1;
  //         const ia = priorityOrder.indexOf(a.sector);
  //         const ib = priorityOrder.indexOf(b.sector);
  //         if (ia !== -1 && ib !== -1) return ia - ib;
  //         if (ia !== -1) return -1;
  //         if (ib !== -1) return 1;
  //         return a.sector.localeCompare(b.sector);
  //       });

  //     setStats([
  //       ...result,
  //       { sector: "Special Tender", count: sectorData.special_tender, tender_type: {} },
  //       { sector: "Today Tender", count: sectorData.today_tender, tender_type: {} },
  //       { sector: "Discussion Tender", count: sectorData.is_discussed, tender_type: {} },
  //     ]);
  //   } catch (error) { }
  // };

  const handleGetStats = async (tabId) => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/tenderstatustabfilters/?tab_id=${tabId}`);
      const sectorData = res.data;
      const priorityOrder = ["HIGHWAY", "RAILWAY", "BUILDING"];

      // ✅ Stats cards ALWAYS reflect whole-data counts, not tab-bifurcated
      const wholeCounts = sectorData.sector_counts || {};

      const result = Object.entries(wholeCounts)
        .map(([sector, data]) => ({ sector, count: data.count, tender_type: data.tender_type }))
        .sort((a, b) => {
          if (a.sector === "OTHER") return 1;
          if (b.sector === "OTHER") return -1;
          const ia = priorityOrder.indexOf(a.sector);
          const ib = priorityOrder.indexOf(b.sector);
          if (ia !== -1 && ib !== -1) return ia - ib;
          if (ia !== -1) return -1;
          if (ib !== -1) return 1;
          return a.sector.localeCompare(b.sector);
        });

      setStats([
        ...result,
        { sector: "Special Tender", count: sectorData.special_tender, tender_type: {} },
        { sector: "Today Tender", count: sectorData.today_tender, tender_type: {} },
        { sector: "Discussion Tender", count: sectorData.is_discussed, tender_type: {} },
      ]);

      // ✅ Sector dropdown counts — bifurcated to whichever tab is currently active
      setTabSectorCounts(sectorData.tab_sector_counts || {});
      // setSpecialStructureCounts(sectorData.special_structure_type || {});   // NEW
    } catch (error) { }
  };
  const getEmployeeData = async () => {
    try {
      const empCode = sessionStorage.getItem("sitemanagement_role") === "certificateadminaccess" || sessionStorage.getItem("sitemanagement_role") === "CertificationAccess" ? "null" : sessionStorage.getItem("sitemanagement_emp_code");
      const extra = buildSectorParams();
      const response = await axios.get(
        `${BASE_URL}/siteproject/tendersfilter/${empCode}/null/${filters?.state ? "null" : filters?.state}/${filters?.searchText ? "null" : filters?.searchText}/${filters?.category ? "null" : filters?.category}/${selectedFromDate}/${selectedToDate}/${filters?.tenderType ? "null" : filters?.tenderType}/${filters?.searchId ? "null" : filters?.searchId}/${filters?.is_special_tender ? "null" : filters?.is_special_tender}/${filters?.is_today ? "null" : filters?.is_today}/${filters?.is_discussed ? "null" : filters?.is_discussed}/null/${filters?.tenderStatus ? "null" : filters?.tenderStatus}/` +
        (extra ? `?${extra.replace(/^&/, "")}` : "")
      );
      SetEmployeelistassigned(response.data.assigned_to_detail);
    } catch (error) { console.error("Error fetching employee data:", error); }
  };

  const getBgDetails = async () => {
    try { const response = await axios.get(`${BASE_URL}/siteproject/bgdetailsforbdpost/`); setBgData(response.data); } catch (err) { handleErrorToast(err); }
  };

  const fetchEmployees = async () => {
    try { const response = await axios.get(`${BASE_URL}/siteproject/employeebyfilterss/null/null/null/134b633a-89b3-4173-a51e-d030c5b562f5/null/null/d11b2d36-9a36-47df-98c4-4e23923c0abb/`); setApiData(response.data || []); } catch (error) { console.error("Error fetching employees:", error); }
  };

  const toggleCvDone = async (id, mark) => {
    try { await axios.put(`${BASE_URL}/siteproject/BidTenderUpdate/${id}/`, { mark_as_cv: !mark }); await getBidData(filters); toast.success("CV status updated"); } catch (error) { console.error("Error updating CV status:", error); }
  };

  const toggleDocumentDone = async (id, mark) => {
    try { await axios.put(`${BASE_URL}/siteproject/BidTenderUpdate/${id}/`, { mark_as_document: !mark }); await getBidData(filters); toast.success("Document status updated"); } catch (error) { console.error("Error updating Document status:", error); }
  };

  const handleScrollToTender = (tenderId) => {
    const element = document.querySelector(`[data-tender-id="${tenderId}"]`);
    if (element) { setTimeout(() => { element.scrollIntoView({ behavior: "smooth", block: "center" }); sessionStorage.removeItem("scrollTenderId"); SetTenderIdscroll(""); }, 2000); }
  };

  const handleShow = (id, i) => {
    setShowMoadl(true); setTenderId(id); SetTenderIdscroll(i?.tender_id); setEditTenderData(i); SetTenderIdscroll(i?.tender_id);
    const bid = bidData.find((bid) => bid.id === id);
    setWishListData({ jv_partner_type: bid?.jv_partner_type, soil_quality: bid?.soil_quality, participating_as: bid?.participating_as, lead_partner: bid?.lead_partner || "", lead_partner_share: bid?.lead_partner_share || 0, jv_partner_name: bid?.jv_partner_name || "", jv_partner_share: bid?.jv_partner_share || 0, assosiate_partner: bid?.assosiate_partner || "", associate_partner_share: bid?.associate_partner_share || 0, bg_requried: bid?.bg_requried, bg_amount: bid?.bg_amount || 0, bg_type: bid?.bg_type || "", tendersubmission: bid?.tendersubmission || "", bg_submission: bid?.bg_submission || "", submission_date: bid?.submission_date, company_score: bid?.company_score || "", company_type: bid?.company_type || "", tech_score: bid?.tech_score || "", site_apprisate_required: bid?.site_apprisate_required, site_apprisate_marking: bid?.site_apprisate_marking || "", work_methodology_required: bid?.work_methodology_required, work_methodology_marking: bid?.work_methodology_marking || "", presentation_required: bid?.presentation_required, presentation_required_marking: bid?.presentation_required_marking || "", presentation_type: bid?.presentation_type || "", client: bid?.client || "", technical_status: bid?.technical_status || "", financial_status: bid?.financial_status || "", responsive_status: bid?.responsive_status || "", are_we_l1: bid?.are_we_l1 || "", leading_parenter: bid?.leading_parenter, bg_sharing: bid?.bg_sharing || "", bidder_name: { value: "", loading: false }, bidders: bid?.tender_bidders || [], bg_pending: bid?.bg_pending, tech_open: bid?.tech_open || "", tech_responsive: bid?.tech_responsive || "", participant_name: { value: "", score: "", loading: false }, participants: bid?.tender_participants || [], financial_participant_name: { value: "", score: "", loading: false }, financial_participants: bid?.financial_participants || [], checklist: bid?.checklist || "", all_docs_done: bid?.all_docs_done || "", all_cvs_done: bid?.all_cvs_done || "", cvs_files: bid?.cv_doc || [], tech_doc: bid?.tech_doc || [], financial_doc: bid?.financial_doc || [], bid_doc: bid?.bid_doc || [], bidder_doc: bid?.bidder_doc || [], is_jv_allowed: bid?.is_jv_allowed, is_jv_consorium_association_allowed: bid?.is_jv_consorium_association_allowed, terms_of_jv: bid?.terms_of_jv || "", partner_share_sum: 0, cv_score: bid?.cv_score || 0, company_name: bid?.company_name || "", company_dist_lead: bid?.company_dist_lead, company_dist_jv: bid?.company_dist_jv, eligibity_criteria: bid?.eligibity_criteria || "", eligibity_criteria_special: bid?.eligibity_criteria_special || "", associate_qualify: bid?.associate_qualify, tender_submission_type: bid?.tender_submission_type || "", custom_lead_partner: bid?.lead_partner, custom_emd_type: bid?.custom_emd_type, custom_jv_partner_name: bid?.jv_partner_name, custom_assosiate_partner: bid?.assosiate_partner, bid_prepare_by: bid?.bid_prepare_by, bg_prepare_by: bid?.bg_prepare_by, bid_prepare_by_remarks: bid?.bid_prepare_by_remarks || "", team_prepare_by: bid?.team_prepare_by, team_prepare_by_remarks: bid?.team_prepare_by_remarks, team_required: bid?.team_required, team_requirements_details: bid?.team_requirements_details || "", recipient_details: bid?.recipient_details || "" });
  };

  const handleClose = () => { setShowMoadl(false); setEditTenderData(); setTenderId(""); setErrors(""); };


  const handleOpenEditModal = (id, tender, initialTab = null) => {
    setShowEditModal(true);
    setEditTenderId(id);
    setEditTenderData(tender);
    setEditInitialTab(initialTab);   // ← stores it in state
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditTenderId(null);
    setEditTenderData([]);
    setEditInitialTab(null);         // ← clears on close
  };
  // const handleOpenEditModal = (id, tender) => { setShowEditModal(true); setEditTenderId(id); setEditTenderData(tender); };
  const handleOpenEditModalTab = (id, tender) => { setShowEditModalTab(true); setEditTenderId(id); setEditTenderData(tender); };
  // const handleCloseEditModal = () => { setShowEditModal(false); setEditTenderId(null); setEditTenderData([]); };
  const handleCloseEditModalTab = () => { setShowEditModalTab(false); setEditTenderId(null); setEditTenderData([]); };
  const handleOpenBackModal = (i, id) => { setShowBackModal(true); setBackTenderId(id); setBackTenderOldData(i); };
  const handleCloseBackModal = () => { setShowBackModal(false); setBackTenderId(null); setBackTenderOldData({}); };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Processing...");
    let data = {};
    if (toggleState === 2) data = { is_in_bidlist: false };
    else if (toggleState === 3) data = { is_in_targetlist: false, date_aa: new Date().toISOString() };
    else if (toggleState === 4) data = { is_finalize: false, date_bb: new Date().toISOString(), tat_duration: null };
    else if (toggleState === 5)
      data = backTenderolddata?.is_in_financial_tab
        ? { is_in_financial_tab: false, is_in_tech_tab: true }
        : backTenderolddata?.is_in_tech_tab
          ? { is_in_tech_tab: false, is_submitted: true }
          : { is_submitted: false, date_ff: new Date().toISOString() };
    else if (toggleState === 9) data = { is_bid_prepare_in_progress: false, date_cc: new Date().toISOString() };
    // else if (toggleState === 11)
    //   data = backTenderolddata?.is_in_financial_tab
    //     ? { is_in_financial_tab: false, is_in_tech_tab: true }      // Financial Open → back to Tech Open
    //     : { is_in_tech_tab: false, is_submitted: true };            // Tech Open → back to Submitted
    try {
      const res = await axios.put(`${BASE_URL}/siteproject/BidTenderUpdate/${backTenderId}/`, data);
      if (res.status === 200) { getBidData(filters); setShowBackModal(false); toast.dismiss(loadingToastId); const getJsonData = (d) => { if (d instanceof FormData) return Object.fromEntries(d.entries()); return d; }; await saveAudit({ tenderId: backTenderId, updatedBy: sessionStorage.getItem("sitemanagement_emp_code"), tableName: "Tenderforbd", oldData: getJsonData(backTenderolddata), newData: getJsonData(data), action: "UPDATE" }); toast.success("Moved to previous stage"); }
    } catch (err) { handleErrorToast(err); }
    finally { toast.dismiss(loadingToastId); setBackTenderId(null); setBackTenderOldData({}); }
  };

  // filter application
  const applyFilters = () => {
    let fd = bidData;
    if (searchQuery !== "") { const lq = searchQuery.toLowerCase(); fd = fd.filter((d) => d?.name_of_work?.toString().toLowerCase().includes(lq)); }
    setFilteredData(fd);
  };
  const toParam = (val) => (Array.isArray(val) ? (val.length ? val.map(encodeURIComponent).join(",") : "null") : (val || "null"));

  const toggleMultiFilter = (name, value) => {
    setFilters((prev) => {
      const current = prev[name] || [];
      const next = current.includes(value) ? current.filter((v) => v !== value) : [...current, value];
      return { ...prev, [name]: next };
    });
    setCurrentPage(1);
  };
  const setMultiFilter = (name, values) => {
    setFilters((prev) => ({ ...prev, [name]: values }));
    setCurrentPage(1);
  };
  const toggleConsultancyCost = (value) => {
    setConsultancyCostFilter((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
    setConstructionCostRange([]);   // clear the mutually exclusive group
    setLengthRange([]);
    setCurrentPage(1);
  };

  const toggleConstructionCost = (value) => {
    setConstructionCostRange((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
    setConsultancyCostFilter([]);   // clear the mutually exclusive group
    setCurrentPage(1);
  };

  const toggleLengthRange = (value) => {
    setLengthRange((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
    setConsultancyCostFilter([]);   // clear the mutually exclusive group
    setCurrentPage(1);
  };

  const removeMultiFilterValue = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: (prev[name] || []).filter((v) => v !== value) }));
    setCurrentPage(1);
  };

  const clearAllMultiFilters = () => {
    setFilters((prev) => ({ ...prev, sector: [], state: [], tenderType: [], tenderStatus: [], specialStructureType: [], client: [], partner: [] }));
    setCurrentPage(1);
  };
  const handleChange = (e) => { const { name, value, type, checked } = e.target; setFilters({ ...filters, [name]: type === "checkbox" ? checked : value }); };
  const handleClear = () => {
    setFilters({
      searchText: "", organizationID: "", sector: [], state: [], city: "", ownership: "",
      department: "", closingDateFrom: "", closingDateTo: "", website: "", quantityType: ">=",
      quantityValue: "", tenderValueComparison: "=", valueFrom: "", valueTo: "", lakhFrom: "Lakh",
      lakhTo: "Lakh", gemType: "All", msmeExemption: false, aiSummary: false, startupExemption: false,
      boq: false, client: [], partner: [], searchId: "", companyProjectCode: "", is_special_tender: "",
      is_today: "", tenderStatus: [], is_discussed: "", specialStructureType: [],
    });
    Setisclear(true); setFromDate("null"); setToDate("null"); setActiveCard(null); setCustomFilters({});
    setConsultancyCostFilter([]); setConstructionCostRange([]); setLengthRange([]);
  };

  const handleStatClick = (sector) => setFilters((prev) => ({ ...prev, sector: sector ? [sector] : [] }));
  const handleFilterTenderType = (val) => setFilters((prev) => ({ ...prev, tenderType: val ? [val] : [] }));
  // const handleStatClick = (category) => setFilters((prev) => ({ ...prev, category }));
  const handleSpecialClick = () => setFilters((prev) => ({ ...prev, is_special_tender: true, is_today: false, is_discussed: false }));
  const handleTodayClick = () => setFilters((prev) => ({ ...prev, is_today: true, is_special_tender: false, is_discussed: false }));
  const handleDiscussClick = () => setFilters((prev) => ({ ...prev, is_discussed: true, is_special_tender: false, is_today: false }));
  // const handleFilterTenderType = (val) => setFilters((prev) => ({ ...prev, tenderType: val }));

  const openCorrigendumModal = (i) => { setCorriendumModal(true); setTenderId(i?.id); };
  const openCorrigendumModalScreening = (i) => { setCorriendumModalScreening(true); };

  // ── effects ────────────────────────────────────────────────────────────
  useEffect(() => { handleGetStats(apiTabId); }, [apiTabId]);
  // useEffect(() => { fetchAllTendersForDownload(); }, [filters, selectedFromDate, selectedToDate, dateRange]);
  useEffect(() => {
    setDateRange("");
    setSubmissionDateFilter("");
    setNewDateFilter(0);
    setPipelineMovedRange("");
    setCurrentPage(1);
  }, [toggleState]);
  useEffect(() => {
    const empCode = sessionStorage.getItem("sitemanagement_emp_code");
    if (roleemp === "CertificationAccessDocumentTeamHead" || roleemp === "CertificationAccessCvTeamHead") { getTlData(empCode, filters); }
    else if (roleemp === "CertificationAccessCvTeam" || roleemp === "CertificationAccessDocumentTeam") { getEmployeeDatato(empCode, filters); }
    else { getBidData(filters); }
  }, [filters, selectedFromDate, selectedToDate, toggleState, currentPage, sortBy, sortOrder, dateRange, consultancyCostFilter, constructionCostRange, lengthRange, customFiltersKey, pipelineMovedRange]);
  useEffect(() => { if (toggleState === 7 || toggleState === 6) { getBidData(filters); setCustomFilters({}); } }, [closedExpiredSubTab]);
  useEffect(() => { applyFilters(); }, [searchQuery, bidData]);
  useEffect(() => { if ([4, 9, 5, 11].includes(toggleState)) { getBgDetails(); } }, [toggleState]); // drop 12
  useEffect(() => { if (toggleState === 9 || toggleState === 5) { getEmployeeData(); } }, [toggleState, filters]);
  useEffect(() => { if (selectedEmployee != null && !istlSelected) { getEmployeeDatato(selectedEmployee, filters); } }, [selectedEmployee, filters, istlSelected]);
  useEffect(() => { if (selectedEmployee != null && istlSelected) { getTlData(selectedEmployee, filters); } }, [selectedEmployee, filters, istlSelected]);
  useEffect(() => { if (wishListData.lead_partner_share !== undefined) { const s = (parseInt(wishListData.lead_partner_share) || 0) + (parseInt(wishListData.associate_partner_share) || 0) + (parseInt(wishListData.jv_partner_share) || 0); setWishListData((p) => ({ ...p, partner_share_sum: s })); } }, [wishListData.lead_partner_share, wishListData.associate_partner_share, wishListData.jv_partner_share]);
  useEffect(() => { fetchEmployees(); }, []);
  useEffect(() => { const storedTenderId = sessionStorage.getItem("scrollTenderId"); if (storedTenderId) { handleScrollToTender(storedTenderId); } }, [bidData]);
  useEffect(() => {
    setConsultancyCostFilter([]);
    setConstructionCostRange([]);
    setLengthRange([]);
    setCurrentPage(1);
    setCustomFilters({});
  }, [filters.sector]);  // ← was filters.category
  useEffect(() => {
    if (toggleState === 5 || toggleState === 9) {
      fetchAmendedTenderIds();
    }
  }, [toggleState, currentPage, filters, dateRange]);
  useEffect(() => {
    if (!bidData?.length) {
      setNotesMap({});
      return;
    }
    let cancelled = false;

    const loadNotes = async () => {
      const entries = await Promise.all(
        bidData.map(async (t) => {
          try {
            const res = await axios.get(
              `${BASE_URL}/siteproject/notesfilterbytender/${t.id}/`
            );
            return [t.id, Array.isArray(res.data) ? res.data : []];
          } catch {
            return [t.id, t.notes_tender || []];
          }
        })
      );
      if (!cancelled) setNotesMap(Object.fromEntries(entries));
    };

    loadNotes();
    return () => { cancelled = true; };
  }, [bidData]);

  // ── Grid helpers ──────────────────────────────────────────────────────
  const toggleRow = (id) => setExpandedRows((p) => ({ ...p, [id]: !p[id] }));
  const toggleSelect = (id, checked) => setSelectedRows((p) => ({ ...p, [id]: checked }));
  const selectAll = (checked) => { const next = {}; filteredData.forEach((t) => (next[t.id] = checked)); setSelectedRows(next); };
  const selectedCount = Object.values(selectedRows).filter(Boolean).length;


  const [notesMap, setNotesMap] = useState({}); // { [tenderId]: notes[] }

  // ── Filter displayed data according to toggleState ────────────────────
  const displayData = useMemo(() => {
    let d = [...filteredData];
    // // Apply tab filters
    // d = d.filter((i) => {
    //   switch (toggleState) {
    //     case 1: return !i?.is_in_bidlist && !i?.is_in_targetlist && !i?.is_finalize && !i?.is_submitted && !i?.is_rejected && !i?.is_cancelled && (() => { const dl = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date); return dl >= 0; })();
    //     case 2: return i?.is_in_bidlist && !i?.is_in_targetlist && !i?.is_finalize && !i?.is_submitted && !i?.is_rejected && !i?.is_cancelled && (() => { const dl = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date); return dl >= 0; })();
    //     case 3: return i?.is_in_bidlist && i?.is_in_targetlist && !i?.is_finalize && !i?.is_submitted && !i?.is_rejected && !i?.is_cancelled && (() => { const dl = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date); return dl >= 0; })();
    //     case 4: return i?.is_in_bidlist && i?.is_in_targetlist && i?.is_finalize && !i.is_bid_prepare_in_progress && !i?.is_submitted && !i?.is_rejected && !i?.is_cancelled && (() => { const dl = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date); return dl >= 0; })();
    //     case 5: return i?.is_in_bidlist && i?.is_in_targetlist && i?.is_finalize && i?.is_bid_prepare_in_progress && i?.is_submitted && !i?.is_rejected && !i?.is_cancelled;
    //     case 11: return i?.is_in_bidlist && i?.is_in_targetlist && i?.is_finalize && i?.is_bid_prepare_in_progress && i?.is_submitted && i?.is_in_tech_tab === true && !i?.is_in_financial_tab && !i?.is_rejected && !i?.is_cancelled;
    //     case 12: return i?.is_in_bidlist && i?.is_in_targetlist && i?.is_finalize && i?.is_bid_prepare_in_progress && i?.is_submitted && i?.is_in_tech_tab && i?.is_in_financial_tab && !i?.is_rejected && !i?.is_cancelled;
    //     case 6: return i?.is_rejected || i?.is_cancelled;
    //     case 7: { const dl = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date); return dl < 0 && !i?.is_submitted; }
    //     case 9: return i?.is_in_bidlist && i?.is_in_targetlist && i?.is_finalize && i?.is_bid_prepare_in_progress && !i?.is_submitted && !i?.is_rejected && !i?.is_cancelled && (() => { const dl = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date); return dl >= 0; })();
    //     case 10: return i.is_in_bidlist && i.is_in_targetlist && (i.is_finalize || i.is_bid_prepare_in_progress || i.is_submitted) && !i.is_rejected && !i.is_cancelled && i.presentation_required && (() => { const dl = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date); return dl >= 0; })();
    //     default: return true;
    //   }
    // });
    // Grid inline filters
    if (gridSearchTerm) { const q = gridSearchTerm.toLowerCase(); d = d.filter((t) => t.tender_id?.toLowerCase().includes(q) || t.tender_name?.toLowerCase().includes(q)); }
    if (gridSectorFilter) d = d.filter((t) => (t.sector === "Other" ? t.other_sector_type : t.sector) === gridSectorFilter);
    if (gridTypeFilter) d = d.filter((t) => t.tender_type === gridTypeFilter);
    return d;
  }, [filteredData, toggleState, gridSearchTerm, gridSectorFilter, gridTypeFilter]);

  const uniqueSectors = useMemo(() => [...new Set(filteredData.map((t) => (t.sector === "Other" ? t.other_sector_type : t.sector)).filter(Boolean))], [filteredData]);
  const uniqueTypes = useMemo(() => [...new Set(filteredData.map((t) => t.tender_type).filter(Boolean))], [filteredData]);

  // ── Download helpers (unchanged logic) ───────────────────────────────
  const formatHeader = (key) => key.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());

  // corrigendum date (if updated) wins, else submission date
  const getEffectiveSubmissionDate = (item) => {
    if (item?.corrigendum_date) return item.corrigendum_date;

    const latestDateCorr = (item?.correigendum_types || [])
      .filter(
        (ct) =>
          (ct.corrigendum_type === "date" || ct.corrigendum_type === "both") &&
          ct.other_name === "corrigendum_date" &&
          ct.other_value,
      )
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

    return latestDateCorr?.other_value || item?.submission_date || null;
  };

  const sortBySubmissionAsc = (arr) =>
    [...arr].sort((a, b) => {
      const da = getEffectiveSubmissionDate(a);
      const db = getEffectiveSubmissionDate(b);
      if (!da && !db) return 0;
      if (!da) return 1;   // no date -> bottom
      if (!db) return -1;
      return new Date(da).getTime() - new Date(db).getTime();
    });
  const buildSheetData = (dataArray, tabId, skipStageFilter = false) => {
    const commonBasicFields = [
      "tender_id", "tender_name", "client", "tender_type", "lane", "length",
      "tat_duration", "submission_date", "publish_date", "state", "sector",
      "remarks", "is_emd_required", "exmpted_emd", "emd_amount", "emd_type",
      "emd_submission_type", "custom_emd_type"
      // ✅ corrigendum_date REMOVED — merged into submission_date column below
    ];
    const tab1Fields = ["consultancy_fees", "construction_fees", "created_at"];
    const tab3Fields = ["tech_score", "company_score", "eligibity_criteria", "eligibity_criteria_special", "is_jv_allowed", "is_jv_consorium_association_allowed", "terms_of_jv", "participating_as", "site_apprisate_marking", "work_methodology_marking", "presentation_required_marking", "presentation_type", "soil_quality"];
    const tab4Fields = ["company_name", "company_dist_jv", "company_dist_lead", "lead_partner", "lead_partner_share", "jv_partner_name", "jv_partner_share", "assosiate_partner", "custom_assosiate_partner", "associate_partner_share", "bid_prepare_by", "bid_prepare_by_remarks", "bg_prepare_by", "team_required", "team_prepare_by", "team_requirements_details", "team_prepare_by_remarks", "tender_submission_type", "recipient_details"];
    const tab5Fields = ["are_we_l1", "cv_score", "checklist", "all_docs_done", "all_cvs_done"];
    const tab6Fields = ["rejected_reason", "rejected_reason_other"];

    let fieldsToExport = [...commonBasicFields, ...tab1Fields];
    if (tabId >= 3) fieldsToExport.push(...tab3Fields);
    if (tabId >= 4) fieldsToExport.push(...tab4Fields);
    if (tabId >= 5) fieldsToExport.push(...tab5Fields);
    if (tabId === 6) fieldsToExport.push(...tab6Fields);
    fieldsToExport = [...new Set(fieldsToExport)];

    // ✅ Only format these via the generic path; submission_date handled manually below
    const dateFieldsToFormat = ["publish_date", "created_at"];

    const filtered = skipStageFilter ? dataArray : dataArray.filter((i) => {
      switch (tabId) {
        case 1: return !i?.is_in_bidlist && getDaysLeftNumber(i?.corrigendum_date || i?.submission_date) >= 0;
        case 2: return i?.is_in_bidlist && !i?.is_in_targetlist && getDaysLeftNumber(i?.corrigendum_date || i?.submission_date) >= 0;
        case 3: return i?.is_in_bidlist && i?.is_in_targetlist && !i?.is_finalize && getDaysLeftNumber(i?.corrigendum_date || i?.submission_date) >= 0;
        case 4: return i?.is_in_bidlist && i?.is_in_targetlist && i?.is_finalize && !i.is_bid_prepare_in_progress && getDaysLeftNumber(i?.corrigendum_date || i?.submission_date) >= 0;
        case 5: return i?.is_in_bidlist && i?.is_in_targetlist && i?.is_finalize && i?.is_bid_prepare_in_progress && i?.is_submitted && !i?.is_rejected && !i?.is_cancelled;
        case 6: return i?.is_rejected || i?.is_cancelled;
        case 7: { const dl = getDaysLeftNumber(i?.corrigendum_date || i?.submission_date); return dl < 0 && !i?.is_submitted; }
        case 9: return i?.is_in_bidlist && i?.is_in_targetlist && i?.is_finalize && i?.is_bid_prepare_in_progress && !i?.is_submitted && getDaysLeftNumber(i?.corrigendum_date || i?.submission_date) >= 0;
        case 10: return i?.is_in_bidlist && i?.is_in_targetlist && (i?.is_finalize || i?.is_bid_prepare_in_progress || i?.is_submitted) && !i?.is_rejected && !i?.is_cancelled && i?.presentation_required && getDaysLeftNumber(i?.corrigendum_date || i?.submission_date) >= 0;
        case 11: return i?.is_in_bidlist && i?.is_in_targetlist && i?.is_finalize && i?.is_bid_prepare_in_progress && i?.is_submitted && i?.is_in_tech_tab === true && !i?.is_in_financial_tab && !i?.is_rejected && !i?.is_cancelled;
        case 12: return i?.is_in_bidlist && i?.is_in_targetlist && i?.is_finalize && i?.is_bid_prepare_in_progress && i?.is_submitted && i?.is_in_tech_tab && i?.is_in_financial_tab && !i?.is_rejected && !i?.is_cancelled;
        default: return true;
      }
    });

    // ✅ Use for...of — no continue inside .map() which causes silent crash
    const sortedRows = sortBySubmissionAsc(filtered);

    // ✅ Use for...of — no continue inside .map() which causes silent crash
    const finalData = sortedRows.map((item) => {
      const row = {};
      for (const key of fieldsToExport) {
        if (key === "submission_date") {
          // ✅ Merged column: corrigendum_date wins if present, else submission_date
          const raw = getEffectiveSubmissionDate(item);
          row["Submission Date"] = raw ? formatDateDDMMYYYYmonth(raw) : "_";
        } else {
          let value = item[key];
          if (dateFieldsToFormat.includes(key) && value != null && value !== "")
            value = formatDateDDMMYYYYmonth(value);
          if (typeof value === "boolean") value = value ? "Yes" : "No";
          if (value === null || value === undefined || value === "") value = "_";
          row[formatHeader(key)] = value;
        }
      }
      (item.custom_fields || []).forEach((f) => { row[f.name] = formatCustomValue(f); });
      return row;
    });

    return { finalData, fieldsToExport, rows: sortedRows }; // ✅ always returns
  };

  const appendSheet = (workbook, dataArray, tabId, sheetName, categoryLabel = null, skipStageFilter = false) => {
    const { finalData, fieldsToExport } = buildSheetData(dataArray, tabId, skipStageFilter);
    if (finalData.length === 0) return false;
    const exportData = categoryLabel ? finalData.map((row) => ({ Category: categoryLabel, ...row })) : finalData;
    const sheet = XLSX.utils.json_to_sheet(exportData);
    const maxWidth = 50; const columnWidths = {};
    exportData.forEach((row) => { Object.keys(row).forEach((key) => { const cellValue = String(row[key] || ""); columnWidths[key] = Math.min(maxWidth, Math.max(columnWidths[key] || 0, cellValue.length, key.length)); }); });
    const allKeys = categoryLabel ? ["Category", ...fieldsToExport.map((k) => formatHeader(k))] : fieldsToExport.map((k) => formatHeader(k));
    sheet["!cols"] = allKeys.map((key) => ({ wch: columnWidths[key] || 15 }));
    XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
    return true;
  };

  const downloadTenders = (bidData, toggleState) => {
    if (bidData.length === 0) { toast.info("No data available for this section"); return; }
    const fileNameMap = {
      1: "New Tenders.xlsx", 2: "Wishlisted Tenders.xlsx", 3: "Target Tenders.xlsx",
      4: "Finalized Tenders.xlsx", 5: "Submitted Tenders.xlsx", 6: "Rejected-Cancelled Tenders.xlsx",
      7: "Expired Tenders.xlsx", 9: "Bid Preparation Pipeline.xlsx", 10: "Presentation Required Tenders.xlsx",
      11: "Tender Result Tenders.xlsx",
    };
    const fileName = fileNameMap[toggleState] || "Tenders.xlsx";
    const workbook = XLSX.utils.book_new();
    const added = appendSheet(workbook, bidData, toggleState, "Sheet1", null, true); // already tab-scoped
    if (!added) { toast.info("No data available for this section"); return; }
    XLSX.writeFile(workbook, fileName);
  };

  const downloadAllTenders = (dataByTab) => {
    const tabOrder = [1, 2, 3, 4, 9, 5, 11, 12, 6, 7, 10];
    const tabConfig = {
      1: { sheetName: "New Tenders", category: "New Tender" },
      2: { sheetName: "Wishlisted", category: "Wishlisted" },
      3: { sheetName: "Target", category: "Target" },
      4: { sheetName: "Finalized", category: "Finalized" },
      9: { sheetName: "Bid Prep Pipeline", category: "Bid Prep Pipeline" },
      5: { sheetName: "Submitted", category: "Submitted" },
      11: { sheetName: "Tender Result", category: "Tender Result" },
      12: { sheetName: "Financial Open", category: "Financial Open" },
      6: { sheetName: "Rejected", category: "Rejected" },
      7: { sheetName: "Expired", category: "Expired" },
      10: { sheetName: "Presentation Required", category: "Presentation Required" },
    };
    const workbook = XLSX.utils.book_new();
    let anyAdded = false;
    tabOrder.forEach((tab) => {
      const { sheetName, category } = tabConfig[tab];
      const added = appendSheet(workbook, dataByTab[tab] || [], tab, sheetName, category, true); // already tab-scoped
      if (added) anyAdded = true;
    });
    if (!anyAdded) { toast.info("No data available to download"); return; }
    XLSX.writeFile(workbook, "All Tenders.xlsx");
  };

  // Which tab/stage does a tender currently sit in?
  const getTenderStage = (i) => {
    if (i?.is_rejected) return "Rejected";
    if (i?.is_cancelled) return "Cancelled";
    if (i?.is_submitted) {
      if (i?.is_in_financial_tab) return "Financial Open";
      if (i?.is_in_tech_tab) return "Tech Open";
      return "Submitted";
    }
    const dl = getDaysLeftNumber(i?.corrigendum_date || i?.submission_date);
    if (dl !== null && dl < 0) return "Expired";
    if (i?.is_bid_prepare_in_progress) return "Bid Pipeline";
    if (i?.is_finalize) return "Final";
    if (i?.is_in_targetlist) return "Target";
    if (i?.is_in_bidlist) return "Wish Listed";
    return "New";
  };

  const downloadAllTendersSingleSheet = (allData) => {
    if (!allData || allData.length === 0) {
      toast.info("No data available to download");
      return;
    }

    // tabId 6 => widest field set (basic + eligibility + partners + bid info + rejection)
    // skipStageFilter = true => no per-tab filtering, keep every tender
    const { finalData, rows } = buildSheetData(allData, 6, true);

    // rows is the same sorted order as finalData
    const exportData = finalData.map((row, idx) => ({
      Stage: getTenderStage(rows[idx]),
      ...row,
    }));

    const sheet = XLSX.utils.json_to_sheet(exportData);

    const maxWidth = 50;
    const widths = {};
    exportData.forEach((row) => {
      Object.keys(row).forEach((k) => {
        widths[k] = Math.min(
          maxWidth,
          Math.max(widths[k] || 0, String(row[k] ?? "").length, k.length)
        );
      });
    });
    sheet["!cols"] = Object.keys(exportData[0]).map((k) => ({ wch: widths[k] || 15 }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, "All Tenders");
    XLSX.writeFile(workbook, "All Tenders.xlsx");
  };

  // ── Stats card component (inline, unchanged logic) ──────────────────
  const StatsCard = ({ stat, index }) => {
    const isOpen = activeCard === index;
    const toggleOpen = () => {
      if (isOpen) { setActiveCard(null); handleStatClick(""); handleFilterTenderType(""); }
      else {
        setActiveCard(index); handleFilterTenderType("");
        if (stat.sector !== "Special Tender" && stat.sector !== "Today Tender" && stat.sector !== "Discussion Tender") { handleStatClick(stat.sector.charAt(0).toUpperCase() + stat.sector.slice(1).toLowerCase()); }
        else if (stat.sector === "Special Tender") { handleSpecialClick(true); }
        else if (stat.sector === "Discussion Tender") { handleDiscussClick(true); }
        else if (stat.sector === "Today Tender") { handleTodayClick(true); }
      }
    };
    return (
      <div className={`bg-stat-card ${isOpen ? "bg-stat-card--active" : ""}`} onClick={toggleOpen}>
        <div className="bg-stat-card-header">
          <span className="bg-stat-card-name">{stat.sector}</span>
          <span className="bg-stat-card-arrow">▼</span>
        </div>
        <div className="bg-stat-card-count">{stat.count}</div>
        <div className="bg-stat-card-types">
          {Object.entries(stat.tender_type || {}).map(([type, count]) => (
            <div key={type} className="bg-stat-type-chip" onClick={(e) => { e.stopPropagation(); handleFilterTenderType(type); }}>
              <span>{type}</span><span style={{ fontWeight: 700 }}>{count}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const MultiSelectDropdown = ({ label, options, selected = [], onToggle, onApply, width = 190 }) => {
    const [open, setOpen] = useState(false);
    const [pending, setPending] = useState(selected);
    const ref = useRef(null);

    // keep pending in sync with parent selection whenever dropdown opens
    useEffect(() => {
      if (open) setPending(selected);
    }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
      const handleClickOutside = (e) => {
        if (ref.current && !ref.current.contains(e.target)) {
          setPending(selected); // discard unsaved changes if closed by outside click
          setOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [selected]);
    // useEffect(() => {
    //   if (![6, 7, 8].includes(toggleState) || toggleState === 8) return;
    //   fetchTendersForTab(7, true)
    //     .then((all) => setRecentExpiredCount(all.filter(isRecentlyExpired).length))
    //     .catch(() => { });
    // }, [toggleState, filters, dateRange]);

    const togglePending = (value) => {
      setPending((prev) =>
        prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
      );
    };

    const allValues = options.map((opt) => (typeof opt === "string" ? opt : opt.value));
    const allSelected = allValues.length > 0 && allValues.every((v) => pending.includes(v));
    const someSelected = pending.length > 0 && !allSelected;
    const toggleSelectAll = () => setPending(allSelected ? [] : [...allValues]);

    const handleApply = () => {
      const toAdd = pending.filter((v) => !selected.includes(v));
      const toRemove = selected.filter((v) => !pending.includes(v));
      [...toAdd, ...toRemove].forEach((v) => onToggle(v));
      setOpen(false);
    };

    const handleCancel = () => {
      setPending(selected);
      setOpen(false);
    };

    return (
      <div className="ms-filter-wrap" ref={ref} style={{ width }}>
        <button
          type="button"
          className={`bg-filter-select ms-filter-trigger ${selected.length ? "ms-filter-trigger--active" : ""}`}
          onClick={() => setOpen((o) => !o)}
        >
          <span className="ms-filter-trigger-label">
            {label}
            {selected.length > 0 && <span className="ms-filter-trigger-count">{selected.length}</span>}
          </span>
          <span className="ms-filter-trigger-arrow">{open ? "▲" : "▼"}</span>
        </button>

        {open && (
          <div className="ms-filter-menu">
            <label
              className={`ms-filter-item ms-filter-item--all ${allSelected ? "ms-filter-item--checked" : ""}`}
              onClick={(e) => e.stopPropagation()}
            >
              <input
                type="checkbox"
                checked={allSelected}
                ref={(el) => { if (el) el.indeterminate = someSelected; }}
                onChange={toggleSelectAll}
              />
              <span style={{ flex: 1, fontWeight: 600 }}>Select All</span>
              <span className="ms-filter-item-count">{pending.length}/{allValues.length}</span>
            </label>
            <div className="ms-filter-menu-list">
              {options.map((opt) => {
                const value = typeof opt === "string" ? opt : opt.value;
                const optLabel = typeof opt === "string" ? opt : opt.label;
                const optCount = typeof opt === "string" ? null : opt.count;
                const checked = pending.includes(value);
                return (
                  <label
                    key={value}
                    className={`ms-filter-item ${checked ? "ms-filter-item--checked" : ""}`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => togglePending(value)}
                    />
                    <span style={{ flex: 1 }}>{optLabel}</span>
                    {optCount !== null && optCount !== undefined && (
                      <span className="ms-filter-item-count">{optCount}</span>
                    )}
                  </label>
                );
              })}
            </div>
            <div className="ms-filter-menu-footer">
              <button type="button" className="ms-filter-btn ms-filter-btn--cancel" onClick={handleCancel}>
                Cancel
              </button>
              <button type="button" className="ms-filter-btn ms-filter-btn--ok" onClick={handleApply}>
                OK
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const ActiveMultiChips = ({
    filters,
    onRemove,
    onClearAll,
    consultancyCostFilter,
    onRemoveConsultancyCost,
    constructionCostRange,
    onRemoveConstructionCost,
    lengthRange,
    onRemoveLengthRange,
  }) => {
    const groups = [
      { key: "sector", label: "Sector" },
      { key: "state", label: "State" },
      { key: "client", label: "Client" },
      { key: "partner", label: "Partner" },
      { key: "tenderType", label: "Type" },
      { key: "tenderStatus", label: "Status" },
      { key: "specialStructureType", label: "Special Structure" },   // ← NEW
    ];
    const chips = [];
    groups.forEach((g) => (filters[g.key] || []).forEach((v) => chips.push({ group: g.key, groupLabel: g.label, value: v, extra: false })));

    // extra (non-`filters`) multiselects
    (consultancyCostFilter || []).forEach((v) => chips.push({ group: "consultancyCost", groupLabel: "Consultancy Cost", value: v, extra: true }));
    (constructionCostRange || []).forEach((v) => chips.push({ group: "constructionCost", groupLabel: "Construction Cost", value: v, extra: true }));
    (lengthRange || []).forEach((v) => chips.push({ group: "lengthRange", groupLabel: "Length", value: v, extra: true }));

    if (chips.length === 0) return null;

    const chipDisplay = (group, value) => {
      if (group === "client") return CLIENT_FILTER_OPTIONS.find((c) => c.value === value)?.label ?? value.replace(/_/g, " ");
      if (group === "partner") return ALL_PARTNERS.find((p) => p.key === value)?.value ?? value.replace(/_/g, " ");
      return value.replace(/_/g, " ");
    };

    const handleRemove = (chip) => {
      if (!chip.extra) { onRemove(chip.group, chip.value); return; }
      if (chip.group === "consultancyCost") onRemoveConsultancyCost(chip.value);
      else if (chip.group === "constructionCost") onRemoveConstructionCost(chip.value);
      else if (chip.group === "lengthRange") onRemoveLengthRange(chip.value);
    };

    return (
      <div className="ms-chips-bar">
        {chips.map((c) => (
          <span key={`${c.group}-${c.value}`} className="ms-chip">
            <span className="ms-chip-group">{c.groupLabel}:</span> {chipDisplay(c.group, c.value)}
            <button type="button" className="ms-chip-x" onClick={() => handleRemove(c)} aria-label={`Remove ${c.value}`}>✕</button>
          </span>
        ))}
        <button type="button" className="ms-chip-clearall" onClick={onClearAll}>Clear All ✕</button>
      </div>
    );
  };

  // ── Visible tabs based on role ─────────────────────────────────────
  const visibleTabs = TAB_CONFIG.filter((tab) => {
    const hidden = HIDDEN_FOR_ROLES[roleemp] || [];
    return !hidden.includes(tab.id);
  });
  const consultancyCostOptions = [
    { value: "lt_10", label: "<10cr" },
    { value: "10_50", label: "10-50cr" },
    { value: "gt_50", label: ">50cr" },
  ];
  const constructionCostOptions = [
    { value: "lt_500", label: "<500cr" },
    { value: "500_1000", label: "500-1000cr" },
    { value: "gt_1000", label: ">1000cr" },
  ];
  const lengthRangeOptions = [
    { value: "upto_30", label: "Upto 30kms" },
    { value: "30_60", label: "30-60kms" },
    { value: "gt_60", label: ">60kms" },
  ];

  const specialStructureTypeOptions = [
    { value: "tunnel", label: "Tunnel" },
    { value: "major_bridge", label: "Major Bridge" },
    { value: "cable_stayed", label: "Cable Stayed" },
    { value: "elevated", label: "Elevated" },
    { value: "hilly", label: "Hilly" },
    { value: "slope_protection", label: "Slope Protection" },
    { value: "new_segment", label: "New Segment" },
  ];
  const tenderTypeOptions = [
    { value: "Feasibility", label: "Feasibility" }, { value: "DPR", label: "DPR" },
    { value: "FesibilityCumDPR", label: "Feasibility Cum DPR" },
    { value: "Authority_Engineer", label: "Authority Engineer" },
    { value: "Independent_Engineer", label: "Independent Engineer" },
    { value: "PMC", label: "PMC" }, { value: "Supervision", label: "Supervision" },
    { value: "eoi", label: "EOI" }, { value: "Empanelment", label: "Empanelment" },
    { value: "O&M", label: "O&M" }, { value: "Survey", label: "Survey" },
    { value: "Other", label: "Other" }, { value: "PSSA", label: "PSSA" }, { value: "GC", label: "GC" },
  ];
  const tenderStatusOptions = [
    { value: "Cancelled", label: "Cancelled" }, { value: "Rejected", label: "Rejected" }, { value: "Expired", label: "Expired" },
  ];

  const resolveDdProjectId = (tender, projects = []) =>
    projectIdOf(findProjectForTender(tender, projects));

  const openWorkLog = (tender) => {
    if (!tender) return;
    const cachedId = resolveDdProjectId(tender, ddProjects) || tender.id || "";
    setWorkLogTender(tender);
    setWorkLogProjectId(cachedId);
    setShowWorkLog(true);
    fetchProjectsListSimple()
      .then((list) => {
        const projects = Array.isArray(list) ? list : [];
        setDdProjects(projects);
        setWorkLogProjectId(resolveDdProjectId(tender, projects) || cachedId);
      })
      .catch(() => { });
  };

  const openViewWorkLog = (tender) => {
    if (!tender) return;
    setViewWorkLogTender(tender);
    setShowViewWorkLog(true);
    if (ddProjects.length) return;
    fetchProjectsListSimple()
      .then((list) => setDdProjects(Array.isArray(list) ? list : []))
      .catch(() => { });
  };

  const handleSaveTenderWorkLog = async (date, rows) => {
    const tenderId = workLogTender?.id ? String(workLogTender.id) : "";
    const logs = (Array.isArray(rows) ? rows : []).map((row) => ({
      ...row,
      date,
      startTime: row.startTime || row.start_time,
      endTime: row.endTime || row.end_time,
      projectId: tenderId || row.projectId || row.project,
      project: tenderId || row.project || row.projectId,
      // subActivityId: row.subActivityId || row.subactivity,
      // workType: row.workType || row.work_type,
      status: row.status || "WORKED",
    }));
    await saveDailyWorkLog(logs);
    setShowWorkLog(false);
    setWorkLogTender(null);
    setWorkLogProjectId("");
  };

  useEffect(() => {
    let cancelled = false;
    fetchProjectsListSimple()
      .then((list) => {
        if (!cancelled) setDdProjects(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (!cancelled) setDdProjects([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const categories = ["Highway", "Railway", "Water", "Metro", "Urban Infrastructure Buildings"];
  const states = ["Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir", "Jharkhand", "Karnataka", "Kerala", "Ladakh", "Lakshadweep", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"];
  const sectorOptionsWithCounts = useMemo(() => {
    return categories.map((cat) => ({
      value: cat,
      label: cat,
      count: tabSectorCounts?.[cat.toUpperCase()]?.count ?? 0,
    }));
  }, [tabSectorCounts]);

  const specialStructureOptionsWithCounts = useMemo(() => {
    return specialStructureTypeOptions.map((opt) => ({
      ...opt,
      count: specialStructureCounts?.[opt.value] ?? 0,
    }));
  }, [specialStructureCounts]);
  // ── RENDER ─────────────────────────────────────────────────────────
  return (
    <>
      <style>{EMD_MULTISELECT_STYLES}</style>
      <style>{TL_MEMBER_STYLES}</style>
      <style>{BLINK_DOT_STYLES}</style>
      <style>{RESULT_BADGE_STYLES}</style>
      {/* ══ Outer wrapper ══════════════════════════════════════════════ */}
      <div className="attendance-history-cont">
        <div className="bg-root">

          {/* ── Top bar ────────────────────────────────────────────── */}
          <div className="bg-topbar">
            <span className="bg-topbar-brand">📋 Tenders</span>

            <button className={`bg-stats-toggle-btn ${statstoggleOpen ? "bg-stats-toggle-btn--open" : ""}`} onClick={() => setStatstoggleOpen(!statstoggleOpen)}>
              📊 Stats {statstoggleOpen ? "▲" : "▼"}
            </button>

            <div className="bg-topbar-actions">
              {toggleState === 1 && (
                <AddBidDetails getBidData={getBidData} handleGetStats={handleGetStats} filters={filters} />
              )}
              {/* Upload */}
              <UploadSiteProject getBidData={getBidData} filters={filters} />
              {/* Download */}
              <button className="bg-icon-btn" onClick={() => setShowDownloadModal(true)}>
                <DownloadIcon /> Download
              </button>

              {showDownloadModal && (
                <DownloadModal
                  onClose={() => { if (!downloadLoading) setShowDownloadModal(false); }}
                  onDownload={handleDownloadConfirm}
                  loading={downloadLoading}
                />
              )}
            </div>
          </div>

          {/* ── Stats panel ────────────────────────────────────────── */}
          <div className={`bg-stats-panel ${statstoggleOpen ? "bg-stats-panel--open" : ""}`}>
            <div className="bg-stats-scroll">
              {stats?.map((stat, index) => (
                <StatsCard key={`${stat.sector}-${index}`} stat={stat} index={index} />
              ))}
            </div>
          </div>

          {/* ── Tab bar ────────────────────────────────────────────── */}
          <div className="bg-tabbar">
            {visibleTabs.map((tab) => {
              const count =
                tab.id === 11
                  ? (tabCounts.intechopen ?? 0) + (tabCounts.infinacialopen ?? 0)
                  : tab.id === 7
                    ? (tabCounts.expired_tender ?? 0) + (tabCounts.closed_tender ?? 0)
                    : (tab.countKey ? (tabCounts[tab.countKey] ?? 0) : 0);
              return (
                <button
                  key={tab.id}
                  className={`bg-tab ${(toggleState === tab.id || (tab.id === 7 && [6, 7, 8].includes(toggleState))) ? "bg-tab--active" : ""}`}
                  onClick={() => {
                    setToggleState(tab.id === 7 ? 7 : tab.id);

                    setCompanySelected("");
                    setCurrentPage(1);
                  }}
                >
                  {tab.label}
                  <span className="bg-tab-count">{count}</span>
                </button>
              );
            })}
          </div>

          {/* ── Sub-tab for Closed/Expired ─────────────────────────── */}
          {[6, 7, 8].includes(toggleState) && (
            <div className="bg-subtab-bar">
              <button className={`bg-subtab ${toggleState === 8 ? "bg-subtab--active" : ""}`}
                onClick={() => { setClosedExpiredSubTab("recent"); setToggleState(8); }}>
                Expired ≤ 3 Days ({recentExpiredCount ?? "-"})
              </button>
              <button className={`bg-subtab ${toggleState === 7 ? "bg-subtab--active" : ""}`}
                onClick={() => { setClosedExpiredSubTab("expired"); setToggleState(7); }}>
                Expired ({tabCounts.expired_tender ?? 0})
              </button>

              <button className={`bg-subtab ${toggleState === 6 ? "bg-subtab--active" : ""}`}
                onClick={() => { setClosedExpiredSubTab("closed"); setToggleState(6); }}>
                Closed ({tabCounts.closed_tender ?? 0})
              </button>
            </div>
          )}
          {/* {toggleState === 11 && (
            <div className="bg-subtab-bar">
              <button
                className={`bg-subtab ${tenderResultSubTab === "tech" ? "bg-subtab--active" : ""}`}
                onClick={() => { setTenderResultSubTab("tech"); setCurrentPage(1); }}
              >
                Tech Open ({tabCounts.intechopen ?? 0})
              </button>
              <button
                className={`bg-subtab ${tenderResultSubTab === "financial" ? "bg-subtab--active" : ""}`}
                onClick={() => { setTenderResultSubTab("financial"); setCurrentPage(1); }}
              >
                Financial Open ({tabCounts.infinacialopen ?? 0})
              </button>
            </div>
          )} */}

          {/* ── TL Summary (Tab 9) ──────────────────────────────────── */}
          {toggleState === 9 && (
            <div className="bg-tl-section">
              <div className="bg-tl-filter-row">
                {!["CertificationAccessCvTeamHead", "CertificationAccessCvTeam", "CertificationAccessDocumentTeam", "CertificationAccessDocumentTeamHead"].includes(roleemp) && (
                  <select className="bg-tl-select" value={selectedTL} onChange={(e) => handleTLSelect(e.target.value)}>
                    <option value="">— Select Team Lead —</option>
                    {tlSummaryData.map((tl, i) => (<option key={i} value={tl.emp_code}>{tl.emp_code} — {tl.name || "Unknown"} ({tl.tender_total ?? 0})</option>))}
                  </select>
                )}
                {selectedTL && memberSummaryData?.length > 0 && (
                  <select className="bg-tl-select" value={selectedMember} onChange={(e) => handleMemberSelect(e.target.value)}>
                    <option value="">— Show all members —</option>
                    {memberSummaryData.map((m, i) => (<option key={i} value={m.emp_code}>{m.emp_code} — {m.name} ({m.tender_total ?? 0})</option>))}
                  </select>
                )}
                {(selectedTL || selectedMember) && (
                  <button className="bg-tl-clear-btn" onClick={handleClearTLMember}>✕ Clear</button>
                )}
                {/* sort controls */}
                <select className="bg-tl-select" value={submissionDateFilter} onChange={(e) => { setSubmissionDateFilter(e.target.value); setDateRange(e.target.value); setCurrentPage(1); }} style={{ minWidth: 140 }}>
                  {[{ key: "", label: "All Tenders" }, { key: "1", label: "Next 1 Day" }, { key: "3", label: "Next 3 Days" }, { key: "7", label: "Next 7 Days" }, { key: "15", label: "Next 15 Days" }].map(c => (<option key={c.key} value={c.key}>{c.label}</option>))}
                </select>
                <select className="bg-tl-select" value={sortBy} onChange={(e) => { setSortBy(e.target.value); setCurrentPage(1); }} style={{ minWidth: 150 }}>
                  <option value="">— Sort By —</option><option value="updated_at">Updated Date</option>
                  {/* <option value="corrigendum_date">Corrigendum Date</option>  */}
                  <option value="submission_date">Submission Date</option>
                </select>
                <select className="bg-tl-select" value={sortOrder} onChange={(e) => { setSortOrder(e.target.value); setCurrentPage(1); }} style={{ minWidth: 120 }}>
                  <option value="desc">Descending</option><option value="asc">Ascending</option>
                </select>
              </div>
              {selectedTL && activeTLData && (
                <div className="bg-tl-banner" style={{ marginTop: 8 }}>
                  <div className="bg-tl-avatar">{activeTLData.name?.charAt(0)?.toUpperCase()}</div>
                  <div><p className="bg-tl-name">{activeTLData.emp_code} — {activeTLData.name}</p><p className="bg-tl-role">Team Lead</p></div>
                  <span className="bg-tl-badge">{activeTLData.tender_total} tenders</span>
                </div>
              )}
              {!["CertificationAccessCvTeam", "CertificationAccessDocumentTeam"].includes(roleemp) && memberSummaryData?.length > 0 && (
                <div className="member-chips-row" style={{ marginTop: 8 }}>
                  {memberSummaryData.map((member, i) => {
                    const isActive = selectedMember === member.emp_code;
                    return (
                      <div key={i} className={`member-chip ${isActive ? "member-chip-active" : ""}`} onClick={() => handleMemberSelect(member.emp_code)}>
                        <div className="member-chip-avatar">{member.name?.charAt(0)?.toUpperCase()}</div>
                        <span>{member.emp_code} — {member.name}</span>
                        <span className="member-chip-count">{member.tender_total ?? 0}</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}



          {/* ── Sort controls for tab 1 ─────────────────────────────── */}
          {/* ── Filter/sort bar: Special Structure (tabs 1–4) + date/sort (tab 1 only) ── */}
          {[1, 2, 3, 4].includes(toggleState) && (
            <div style={{ display: "flex", gap: 6, padding: "6px 12px", background: "#f6f8fa", borderBottom: "1px solid #d0d7de", flexWrap: "wrap", alignItems: "center" }}>
              <MultiSelectDropdown
                label="Special Structure"
                options={specialStructureOptionsWithCounts}
                selected={filters.specialStructureType}
                onToggle={(v) => toggleMultiFilter("specialStructureType", v)}
                width={190}
              />

              {toggleState === 1 && (
                <>
                  <select value={newDateFilter} onChange={(e) => { setNewDateFilter(e.target.value); setDateRange(e.target.value); setCurrentPage(1); }} className="bg-filter-select" style={{ minWidth: 130 }}>
                    {[{ k: "", l: "All Tenders" }, { k: "1", l: "Last 1 Day" }, { k: "3", l: "Last 3 Days" }, { k: "7", l: "Last 7 Days" }, { k: "15", l: "Last 15 Days" }, { k: "30", l: "Last 30 Days" }].map(c => (<option key={c.k} value={c.k}>{c.l}</option>))}
                  </select>
                  <span style={{ fontSize: 11, color: "#57606a", fontWeight: 600 }}>Sort:</span>
                  <select value={sortBy} onChange={(e) => { setSortBy(e.target.value); setCurrentPage(1); }} className="bg-filter-select">
                    <option value="">— Sort By —</option><option value="updated_at">Updated Date</option>
                    <option value="submission_date">Submission Date</option>
                  </select>
                  <select value={sortOrder} onChange={(e) => { setSortOrder(e.target.value); setCurrentPage(1); }} className="bg-filter-select">
                    <option value="desc">Descending</option><option value="asc">Ascending</option>
                  </select>
                </>
              )}
            </div>
          )}

          {/* ── Filter bar (global) ─────────────────────────────────── */}
          <div className="bg-filterbar">
            <input className="bg-filter-input" placeholder="Search tender name…" value={filters.searchText} name="searchText" onChange={handleChange} />
            <input className="bg-filter-input" placeholder="Search by Internal ID…" value={filters.companyProjectCode} name="companyProjectCode" onChange={handleChange} style={{ width: 180 }} />
            <input className="bg-filter-input" placeholder="Search by Tender ID…" value={filters.searchId} name="searchId" onChange={handleChange} style={{ width: 160 }} />
            {toggleState === 9 && (
              <select
                className="bg-tl-select"
                value={pipelineMovedRange}
                onChange={(e) => { setPipelineMovedRange(e.target.value); setCurrentPage(1); }}
                style={{ minWidth: 170 }}
              >
                {[
                  { key: "", label: "Moved: Any Time" },
                  { key: "today", label: "Moved: Today" },
                  { key: "1", label: "Moved: Last 1 Day" },
                  { key: "2", label: "Moved: Last 2 Days" },
                  { key: "3", label: "Moved: Last 3 Days" },
                  { key: "5", label: "Moved: Last 5 Days" },
                  { key: "7", label: "Moved: Last 7 Days" },
                  { key: "15", label: "Moved: Last 15 Days" },
                  { key: "30", label: "Moved: Last 30 Days" },
                ].map((c) => (<option key={c.key} value={c.key}>{c.label}</option>))}
              </select>
            )}
            <div className="bg-filter-date-wrap">
              <span className="bg-filter-date-label">Date:</span>
              <DateRangePicker startDate={selectedFromDate} endDate={selectedToDate} placeHolder1="DD/MM/YYYY" placeHolder2="DD/MM/YYYY" onChange={(start, end) => { setFromDate(start); setToDate(end); }} className="custom-range-picker" />
            </div>

            <MultiSelectDropdown label="Sector" options={sectorOptionsWithCounts} selected={filters.sector} onToggle={(v) => toggleMultiFilter("sector", v)} />

            {filters.sector.includes("Railway") &&
              constructionCostRange.length === 0 &&
              lengthRange.length === 0 && (
                <MultiSelectDropdown
                  label="Consultancy Cost"
                  options={consultancyCostOptions}
                  selected={consultancyCostFilter}
                  onToggle={toggleConsultancyCost}
                  width={170}
                />
              )}

            {filters.sector.includes("Highway") &&
              consultancyCostFilter.length === 0 && (
                <>
                  <MultiSelectDropdown
                    label="Construction Cost"
                    options={constructionCostOptions}
                    selected={constructionCostRange}
                    onToggle={toggleConstructionCost}
                    width={170}
                  />
                  <MultiSelectDropdown
                    label="Length"
                    options={lengthRangeOptions}
                    selected={lengthRange}
                    onToggle={toggleLengthRange}
                    width={150}
                  />
                </>
              )}
            <MultiSelectDropdown label="State" options={states} selected={filters.state} onToggle={(v) => toggleMultiFilter("state", v)} />
            <MultiSelectDropdown label="Client" options={CLIENT_FILTER_OPTIONS} selected={filters.client} onToggle={(v) => toggleMultiFilter("client", v)} width={200} />
            <MultiSelectDropdown label="Partner" options={partnerFilterOptions} selected={filters.partner} onToggle={(v) => toggleMultiFilter("partner", v)} width={260} />
            {cfDefs
              .filter((f) => !filters.sector.length || fieldAppliesTo(f, null) || filters.sector.some((s) => f.applies_to_sectors?.includes(s)))
              .map((f) => {
                if (f.field_type === "boolean")
                  return (
                    <select key={f.key} className="bg-filter-select"
                      value={customFilters[f.key] === undefined ? "" : String(customFilters[f.key])}
                      onChange={(e) => setCustomFilter(f.key, e.target.value === "" ? undefined : e.target.value === "true")}>
                      <option value="">{f.name}: Any</option><option value="true">{f.name}: Yes</option><option value="false">{f.name}: No</option>
                    </select>
                  );
                if (f.field_type === "dropdown")
                  return (
                    <MultiSelectDropdown key={f.key} label={f.name} options={f.options}
                      selected={customFilters[f.key] || []} onToggle={(v) => toggleCustomOption(f.key, v)} />
                  );
                if (["integer", "decimal"].includes(f.field_type))
                  return (
                    <span key={f.key} style={{ display: "inline-flex", gap: 4, alignItems: "center" }}>
                      <input type="number" className="bg-filter-input" style={{ width: 80 }} placeholder={`${f.name} ≥`}
                        value={customFilters[f.key]?.gte ?? ""} onChange={(e) => setCustomRange(f.key, "gte", e.target.value)} />
                      <input type="number" className="bg-filter-input" style={{ width: 80 }} placeholder="≤"
                        value={customFilters[f.key]?.lte ?? ""} onChange={(e) => setCustomRange(f.key, "lte", e.target.value)} />
                    </span>
                  );
                return null;
              })}
            <MultiSelectDropdown label="Type" options={tenderTypeOptions} selected={filters.tenderType} onToggle={(v) => toggleMultiFilter("tenderType", v)} />
            {/* <MultiSelectDropdown label="Status" options={tenderStatusOptions} selected={filters.tenderStatus} onToggle={(v) => toggleMultiFilter("tenderStatus", v)} /> */}

            {/* Grid inline filters (client-side, unrelated single-value state) */}
            <select className="bg-filter-select" value={gridSectorFilter} onChange={(e) => setGridSectorFilter(e.target.value)}>
              <option value="">Grid: All Sectors</option>{uniqueSectors.map(s => (<option key={s}>{s}</option>))}
            </select>
            <select className="bg-filter-select" value={gridTypeFilter} onChange={(e) => setGridTypeFilter(e.target.value)}>
              <option value="">Grid: All Types</option>{uniqueTypes.map(t => (<option key={t}>{t}</option>))}
            </select>

            {/* <div className="bg-filter-actions">
              <button className="bg-filter-btn bg-filter-btn--search" onClick={() => getBidData(filters)}>Search</button>
              <button className="bg-filter-btn bg-filter-btn--clear" onClick={handleClear}>Clear</button>
            </div> */}
            <span className="bg-filter-count">Showing {displayData.length} of {totalCount}</span>
          </div>
          <ActiveMultiChips
            filters={filters}
            onRemove={removeMultiFilterValue}
            onClearAll={() => {
              clearAllMultiFilters();
              setConsultancyCostFilter([]);
              setConstructionCostRange([]);
              setLengthRange([]);
            }}
            consultancyCostFilter={consultancyCostFilter}
            onRemoveConsultancyCost={toggleConsultancyCost}
            constructionCostRange={constructionCostRange}
            onRemoveConstructionCost={toggleConstructionCost}
            lengthRange={lengthRange}
            onRemoveLengthRange={toggleLengthRange}
          />

          {/* ── Table ──────────────────────────────────────────────── */}
          <div className="bg-table-scroll">
            <table className="bg-table">
              <colgroup>
                <col style={{ width: 40 }} />   {/* checkbox */}
                <col style={{ width: 50 }} />   {/* # */}
                <col style={{ width: 150 }} />  {/* internal id */}
                <col style={{ width: 400 }} />  {/* tender name */}
                <col style={{ width: 110 }} />  {/* sector */}
                <col style={{ width: 120 }} />  {/* type */}
                <col style={{ width: 120 }} />  {/* client */}
                <col style={{ width: 120 }} />  {/* state */}
                <col style={{ width: 160 }} />  {/* notes: increase as needed */}
                <col style={{ width: 200 }} />  {/* actions */}
              </colgroup>
              <thead>
                <tr>
                  <th className="bg-th bg-th--center">
                    <input type="checkbox" className="bg-chk" onChange={(e) => selectAll(e.target.checked)} aria-label="Select all" />
                  </th>
                  <th className="bg-th">#</th>
                  <th className="bg-th">Internal ID</th>
                  <th className="bg-th">Tender Name</th>
                  <th className="bg-th">
                    <div className="bg-th-inner"><span>Sector</span>
                      <ColumnFilter options={sectorOptionsWithCounts} selected={filters.sector} onApply={(v) => setMultiFilter("sector", v)} />
                    </div>
                  </th>
                  <th className="bg-th">
                    <div className="bg-th-inner"><span>Type</span>
                      <ColumnFilter options={tenderTypeOptions} selected={filters.tenderType} onApply={(v) => setMultiFilter("tenderType", v)} />
                    </div>
                  </th>
                  <th className="bg-th">
                    <div className="bg-th-inner"><span>Client</span>
                      <ColumnFilter options={CLIENT_FILTER_OPTIONS} selected={filters.client} onApply={(v) => setMultiFilter("client", v)} />
                    </div>
                  </th>
                  <th className="bg-th">
                    <div className="bg-th-inner"><span>State</span>
                      <ColumnFilter options={states} selected={filters.state} onApply={(v) => setMultiFilter("state", v)} />
                    </div>
                  </th>
                  <th className="bg-th">Notes</th>
                  {/* <th className="bg-th bg-th--right">Length</th> */}
                  {/* <th className="bg-th">
                    {[1, 2, 3].includes(toggleState)
                      ? "Screening Date"
                      : toggleState === 4
                        ? "FinalList Moved Date"
                        : toggleState === 5
                          ? "SubmitList Moved Date"
                          : toggleState === 9
                            ? "Bid In Progress Moving Date"
                            : "Submission"}
                  </th> */}
                  {/* <th className="bg-th">Days Left</th> */}
                  {/* <th className="bg-th bg-th--center">EMD</th> */}
                  {/* <th className="bg-th bg-th--center">Lane</th> */}
                  <th className="bg-th" style={{ textAlign: "center" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {buffer && (
                  <tr className="bg-loader-row"><td colSpan={15}><AimantraLoading /></td></tr>
                )}
                {!buffer && displayData.length === 0 && (
                  <tr><td colSpan={15} className="bg-empty-row">📭 No tenders found. Try adjusting your filters.</td></tr>
                )}
                {!buffer && displayData.map((i, index) => {
                  const isExpanded = !!expandedRows[i.id];
                  const isSelected = !!selectedRows[i.id];
                  const date = i?.corrigendum_date || i?.submission_date;
                  const daysLeft = getDaysLeftNumber(date);
                  const sectorDisplay = i?.sector === "Other" ? i?.other_sector_type : i?.sector;
                  const isDiscussed = i?.is_discussed;
                  const isResidual = i?.is_residual_bid_capacity;

                  return (
                    <React.Fragment key={i.id}>
                      <tr
                        className={[
                          "bg-rows",
                          index % 2 === 1 ? "bg-rows--even" : "",
                          isSelected ? "bg-rows--selected" : "",
                          isResidual ? "bg-rows--residual" : "",
                          isDiscussed ? "bg-rows--discussed" : "",
                          isExpanded ? "bg-rows--expanded" : "",
                          toggleState === 5 && (i?.is_in_tech_tab || i?.is_in_financial_tab) ? "bg-rows--tech-open" : "",
                        ].filter(Boolean).join(" ")}
                        data-tender-id={i.tender_id}
                        onClick={(e) => {
                          if (e.target.tagName === "BUTTON" || e.target.closest("button") || e.target.tagName === "INPUT" || e.target.tagName === "A") return;
                          toggleRow(i.id);
                        }}
                      >
                        {/* Checkbox */}
                        <td className="bg-td bg-td--check" onClick={(e) => e.stopPropagation()}>
                          <input type="checkbox" className="bg-chk" checked={isSelected} onChange={(e) => toggleSelect(i.id, e.target.checked)} aria-label={`Select ${i.tender_id}`} />
                        </td>

                        {/* Index */}
                        <td className="bg-td bg-td--small" style={{ color: "#57606a" }}>
                          {(currentPage - 1) * PAGE_SIZE + index + 1}
                        </td>

                        {/* Internal ID */}
                        <td className="bg-td bg-td--id" title={i?.company_project_code_bd}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              flexWrap: "wrap",
                            }}
                          >
                            {/* Internal ID */}
                            <span
                              style={{
                                fontWeight: 600,
                                color: "#0056b3",
                              }}
                            >
                              {i?.company_project_code_bd || "N/A"}
                            </span>

                            {/* Corr */}
                            {i?.corrigendum_date && (
                              <span className="bg-corr-badge" title="Corrigendum">
                                Corr
                              </span>
                            )}

                            {/* Special */}
                            {i?.is_special_tender && (
                              <span className="bg-special-badge" title="Special Tender">
                                ⭐ SP
                              </span>
                            )}

                            {/* Discussed */}
                            {i?.is_discussed && (
                              <span title="Discussed">💬</span>
                            )}

                            {/* Residual */}
                            {i?.is_residual_bid_capacity && (
                              <span
                                className="bg-residual-flag"
                                title="Residual"
                              >
                                R
                              </span>
                            )}

                            {/* Document */}
                            {toggleState === 9 && i?.mark_as_document && (
                              <span
                                title="Doc Done"
                                style={{ color: "#185fa5" }}
                              >
                                📋
                              </span>
                            )}

                            {/* CV */}
                            {toggleState === 9 && i?.mark_as_cv && (
                              <span
                                title="CV Done"
                                style={{ color: "#1a7f37" }}
                              >
                                📄
                              </span>
                            )}
                            {[5, 9].includes(toggleState) && amendedTenderIds.has(i.id) && (
                              <span className="amend-blink-dot" title="This tender has amendment history" />
                            )}
                            {[5, 11].includes(toggleState) && i?.is_in_tech_tab && (
                              <span className="bg-result-badge bg-result-badge--tech">Tech Open</span>
                            )}
                            {[5, 11].includes(toggleState) && i?.is_in_financial_tab && (
                              <span className="bg-result-badge bg-result-badge--tech">Financial Open</span>
                            )}
                            {/* Construction Cost Badge - Highway only */}
                            {(i?.sector === "Highway" || (i?.sector === "Other" && i?.other_sector_type === "Highway")) && (() => {
                              const val = parseFloat(i?.construction_fees);
                              if (!i?.construction_fees || isNaN(val)) return (
                                <span style={{
                                  display: "block", fontSize: 9, fontWeight: 600, color: "#888",
                                  background: "#f0f0f0", borderRadius: 3, padding: "1px 4px",
                                  marginTop: 2, whiteSpace: "nowrap"
                                }}>No Const. Value</span>
                              );
                              if (val >= 1000) return (
                                <span style={{
                                  display: "block", fontSize: 9, fontWeight: 700, color: "#7c2d12",
                                  background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: 3,
                                  padding: "1px 4px", marginTop: 2, whiteSpace: "nowrap"
                                }}>≥1000cr</span>
                              );
                              if (val >= 500) return (
                                <span style={{
                                  display: "block", fontSize: 9, fontWeight: 700, color: "#92400e",
                                  background: "#fffbeb", border: "1px solid #fcd34d", borderRadius: 3,
                                  padding: "1px 4px", marginTop: 2, whiteSpace: "nowrap"
                                }}>≥500cr</span>
                              );
                              return (
                                <span style={{
                                  display: "block", fontSize: 9, fontWeight: 700, color: "#1e40af",
                                  background: "#eff6ff", border: "1px solid #93c5fd", borderRadius: 3,
                                  padding: "1px 4px", marginTop: 2, whiteSpace: "nowrap"
                                }}>&lt;500cr</span>
                              );
                            })()}
                          </div>
                        </td>

                        {/* Name */}
                        {/* Name (with Tender ID stacked on top) */}

                        <td
                          className="bg-td bg-td--name"
                          title={`${i?.tender_id || ""} — ${i?.tender_name || ""}`}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 4,
                            }}
                          >
                            {/* Tender ID, submission date and consultancy fees */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flexWrap: "wrap",
                                columnGap: 10,
                                rowGap: 4,
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: 600,
                                  color: "#0056b3",
                                  fontSize: 11,
                                }}
                              >
                                {i?.tender_id || "N/A"}
                              </span>

                              {/* Submission date */}
                              <span
                                style={{
                                  color: "#5b21b6",
                                  fontWeight: 600,
                                  fontSize: 11,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {(() => {
                                  const dateCorrigendum = i?.correigendum_types
                                    ?.filter(
                                      (ct) =>
                                        ct.corrigendum_type === "date" ||
                                        (ct.corrigendum_type === "both" &&
                                          ct.other_name === "corrigendum_date"),
                                    )
                                    ?.sort(
                                      (a, b) =>
                                        new Date(b.created_at).getTime() -
                                        new Date(a.created_at).getTime(),
                                    )[0];

                                  return dateCorrigendum
                                    ? formatDateDDMMYYYYmonth(dateCorrigendum.other_value)
                                    : i?.submission_date
                                      ? formatDateDDMMYYYYmonth(i.submission_date)
                                      : "—";
                                })()}
                              </span>

                              {/* Consultancy fees */}
                              {/* <span
                                style={{
                                  fontSize: 11,
                                  fontWeight: 500,
                                  color: "#1A1A2E",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {i?.consultancy_fees
                                  ? `₹${Number(i.consultancy_fees).toFixed(1)}cr`
                                  : ""}
                              </span> */}
                            </div>

                            {/* Tender name */}
                            <span>{i?.tender_name || "Unnamed Tender"}</span>
                          </div>
                        </td>


                        {/* Sector */}
                        <td className="bg-td">
                          {sectorDisplay && <SectorBadge sector={sectorDisplay} />}
                          {isCustomFlagYes(i, "Fixed cost") && (
                            <span className="bg-flag bg-flag--fixed" title="Fixed Cost">💰 Fixed Cost</span>
                          )}
                          {isCustomFlagYes(i, "Rating") && (
                            <span className="bg-flag bg-flag--rating" title="Rating">⭐ Rating</span>
                          )}
                        </td>

                        {/* Type */}
                        <td className="bg-td bg-td--small">
                          {i?.tender_type?.replace(/_/g, " ") || "—"}
                          {i?.consultancy_fees && (
                            <span className="bg-flag bg-flag--cost" title="Consultancy Cost">
                              ₹{Number(i.consultancy_fees).toFixed(1)}cr
                            </span>
                          )}
                          {i?.construction_fees && (
                            <span className="bg-flag bg-flag--cost" title="Construction Cost">
                              ₹{Number(i.construction_fees).toFixed(1)}cr
                            </span>
                          )}
                        </td>

                        {/* Client */}
                        <td className="bg-td bg-td--small" title={i?.client}>{i?.client?.replace(/[-_]/g, " ").trim().toUpperCase() || "—"}</td>

                        {/* State */}
                        <td className="bg-td bg-td--small">{i?.state || "—"}</td>


                        <td className="bg-td bg-td--small">
                          {(notesMap[i.id] || []).length > 0 ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 8,
                              }}
                            >
                              {notesMap[i.id].map((note, idx) => (
                                <div
                                  key={note?.id || idx}
                                  title={note?.description?.detail || "No Details"}
                                  style={{
                                    cursor: "help",
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: 6,
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: 600,
                                      color: "#0056b3",
                                      flexShrink: 0,
                                    }}
                                  >
                                    {idx + 1}.
                                  </span>

                                  <span
                                    style={{
                                      fontWeight: 600,
                                      color: "#0056b3",
                                    }}
                                  >
                                    {note?.description?.title || "No Title"}
                                  </span>
                                </div>
                              ))}
                            </div>
                          ) : (
                            "—"
                          )}
                        </td>



                        {/* Length */}
                        {/* <td className="bg-td bg-td--right bg-td--small">{i?.length ? `${i.length} km` : "—"}</td> */}

                        {/* <td
                          className="bg-td bg-td--small"
                          title={
                            [1, 2, 3].includes(toggleState) && i?.created_at
                              ? formatDateDDMMYYYYmonth(i.created_at)
                              : toggleState === 4 && i?.date_cc
                                ? formatDateDDMMYYYYmonth(i.date_cc)
                                : toggleState === 5 && i?.date_ee
                                  ? formatDateDDMMYYYYmonth(i.date_ee)
                                  : toggleState === 9 && i?.date_ff
                                    ? formatDateDDMMYYYYmonth(i.date_ff)
                                    : i?.corrigendum_date
                                      ? formatDateDDMMYYYYmonth(i.corrigendum_date)
                                      : i?.submission_date
                                        ? formatDateDDMMYYYYmonth(i.submission_date)
                                        : "—"
                          }
                        >
                          {[1, 2, 3].includes(toggleState) && i?.created_at ? (
                            <span style={{ color: "#5b21b6", fontWeight: 600 }}>
                              {formatDateDDMMYYYYmonth(i.created_at)}
                            </span>
                          ) : toggleState === 4 && i?.date_cc ? (
                            <span style={{ color: "#5b21b6", fontWeight: 600 }}>
                              {formatDateDDMMYYYYmonth(i.date_cc)}
                            </span>
                          ) : toggleState === 5 && i?.date_ee ? (
                            <span style={{ color: "#5b21b6", fontWeight: 600 }}>
                              {formatDateDDMMYYYYmonth(i.date_ee)}
                            </span>
                          ) : toggleState === 9 && i?.date_ff ? (
                            <span style={{ color: "#5b21b6", fontWeight: 600 }}>
                              {formatDateDDMMYYYYmonth(i.date_ff)}
                            </span>
                          ) : i?.corrigendum_date ? (
                            <span style={{ color: "#5b21b6", fontWeight: 600 }}>
                              {formatDateDDMMYYYYmonth(i.corrigendum_date)}
                            </span>
                          ) : i?.submission_date ? (
                            formatDateDDMMYYYYmonth(i.submission_date)
                          ) : (
                            "—"
                          )}
                        </td> */}
                        {/* Days left */}
                        {/* <td className="bg-td"><DaysBadge days={daysLeft} toggleState={toggleState} /></td> */}

                        {/* EMD */}
                        {/* <td className="bg-td bg-td--center">
                          {i?.is_emd_required == null ? "—" : i.is_emd_required ? <span className="bg-check--yes">✓</span> : <span className="bg-check--no">✗</span>}
                        </td> */}

                        {/* Flags */}
                        {/* <td className="bg-td bg-td--center" style={{ fontSize: 13, letterSpacing: 2 }}>
                          {i?.is_discussed && <span title="Discussed">💬</span>}
                          {i?.is_residual_bid_capacity && <span className="bg-residual-flag" title="Residual">R</span>}
                          {toggleState === 9 && i?.mark_as_document && <span title="Doc Done" style={{ color: "#185fa5" }}>📋</span>}
                          {toggleState === 9 && i?.mark_as_cv && <span title="CV Done" style={{ color: "#1a7f37" }}>📄</span>}
                        </td> */}
                        {/* <td className="bg-td bg-td--right bg-td--small">{i?.lane || "—"}</td> */}

                        {/* Actions */}
                        <td className="bg-td" onClick={(e) => e.stopPropagation()}>
                          <div className="bg-rows-actions">
                            <button
                              type="button"
                              className="bg-action-btn"
                              title="Add Worklog"
                              onClick={() => openWorkLog(i)}
                            >
                              ⏱ Worklog
                            </button>
                            <button
                              type="button"
                              className="bg-action-btn"
                              title="View Worklogs"
                              onClick={() => openViewWorkLog(i)}
                            >
                              👁 View
                            </button>
                            {/* Mark as Document (tab 9) */}
                            {!["CertificationAccessCvTeam"].includes(roleemp) && toggleState === 9 && (
                              <button className={`bg-action-btn ${i?.mark_as_document ? "bg-action-btn--active" : ""}`} title="Mark as Document" onClick={() => toggleDocumentDone(i.id, i.mark_as_document)}>📋</button>
                            )}
                            {/* Mark as CV (tab 9) */}
                            {!["CertificationAccessDocumentTeam"].includes(roleemp) && toggleState === 9 && (
                              <button className={`bg-action-btn ${i?.mark_as_cv ? "bg-action-btn--active" : ""}`} title="Mark as CV" onClick={() => toggleCvDone(i.id, i.mark_as_cv)}>📄</button>
                            )}
                            {/* Edit date */}
                            {toggleState !== 5 && toggleState !== 6 && !["BdDashboardPrebid"].includes(roleemp) && (
                              <button className="bg-action-btn" title="Edit Submission Date" onClick={() => openCorrigendumModal(i)}>📅</button>
                            )}
                            {/* Edit tender info */}
                            {![
                              // "CertificationAccessBd",
                              // "certificaionadminaccess",
                              // "CertificationAccess"
                              "CertificationAccessCvTeamHead",
                              "CertificationAccessCvTeam",
                              "CertificationAccessDocumentTeam",
                              "CertificationAccessDocumentTeamHead",
                              "BdDashboardPrebid",
                            ].includes(roleemp) && (
                                <UpdateBidDetails
                                  usedWhere="downward"
                                  i={i}
                                  getBidData={getBidData}
                                  toggleState={toggleState}
                                  filters={filters}
                                  onUpdateSuccess={handleScrollToTender}
                                  setScrollToTender={setScrollToTender}
                                  scrollToTender={scrollToTender}
                                />
                              )}
                            {/* Expand */}
                            {/* <button className="bg-action-btn bg-action-btn--expand" title={isExpanded ? "Collapse" : "Expand"} onClick={() => toggleRow(i.id)} aria-expanded={isExpanded}>
                              {isExpanded ? "▲" : "▼"}
                            </button> */}
                          </div>
                        </td>
                      </tr>

                      {/* Expanded panel */}
                      {isExpanded && (
                        <ExpandedTenderRow
                          i={i}
                          toggleState={toggleState}
                          // tenderResultSubTab={tenderResultSubTab}
                          amendedTenderIds={amendedTenderIds}
                          getBidData={getBidData}
                          filters={filters}
                          openCorrigendumModal={openCorrigendumModal}
                          openCorrigendumModalScreening={openCorrigendumModalScreening}
                          handleShow={handleShow}
                          handleOpenBackModal={handleOpenBackModal}
                          handleOpenEditModal={handleOpenEditModal}
                          handleOpenEditModalTab={handleOpenEditModalTab}  // Make sure this is passed
                          roleemp={roleemp}
                          toggleCvDone={toggleCvDone}
                          toggleDocumentDone={toggleDocumentDone}
                          bgData={bgData}
                          scrollToTender={scrollToTender}
                          setScrollToTender={setScrollToTender}
                          handleScrollToTender={handleScrollToTender}
                          editingId={editingId}
                          setEditingId={setEditingId}
                          tenderFeeMap={tenderFeeMap}
                          setTenderFeeMap={setTenderFeeMap}
                          navigate={navigate}
                          setToggleState={setToggleState}
                          getDaysLeftNumber={getDaysLeftNumber}
                          Addtocart={Addtocart}
                          TenderRejectComponent={TenderReject}
                          TenderCancelComponent={TenderCancel}
                          TenderViewAddDocumentModal={TenderViewAddDocumentModal}
                          TenderViewAddSingleNoteModal={TenderViewAddSingleNoteModal}
                          StatusBadge={StatusBadge}
                          Tenderdiscuss={Tenderdiscuss}
                          wishListData={wishListData}
                          setWishListData={setWishListData}
                          AssignTeamOnly={AssignTeamOnly}
                          EditTenderInfoTab={EditTenderInfoTab}
                          showEditModalTab={showEditModalTab}           // Pass these
                          handleCloseEditModalTab={handleCloseEditModalTab}
                          filteredData={filteredData}
                          editTenderId={editTenderId}
                          editTenderData={editTenderData}
                          showModal={showModal}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* ── Status bar ─────────────────────────────────────────── */}


          {/* ── Pagination ─────────────────────────────────────────── */}
          <div className="bg-pagination-wrap">
            <div className="bg-statusbar">
              <span><strong>{totalCount}</strong> total tenders</span>
              <span className="bg-statusbar-sep">|</span>
              <span><strong>{displayData.length}</strong> shown</span>
              <span className="bg-statusbar-sep">|</span>
              <span><strong>{selectedCount}</strong> selected</span>
              <span className="bg-statusbar-sep">|</span>
              <span>Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong></span>
            </div>
            <Pagination currentPage={currentPage} totalPages={totalPages} totalCount={totalCount} pageSize={PAGE_SIZE} onPageChange={(page) => setCurrentPage(page)} />
          </div>

        </div>{/* bg-root */}
      </div>{/* attendance-history-cont */}

      {/* ══ All original modals (rendered outside grid, unchanged) ═══════ */}
      <CorrigendumModal
        corriendumModal={corriendumModal}
        setCorriendumModal={setCorriendumModal}
        handleHideUpdateModal={handleHideUpdateModal}
        tenderId={tenderId}
        getBidData={getBidData}
        toggleState={toggleState}
        tenders={filteredData}
        filters={filters}
        onUpdateSuccess={handleScrollToTender}
        setScrollToTender={setScrollToTender}
        scrollToTender={scrollToTender}
        bgData={bgData}
      />
      <CorrigendumModalScreening
        corriendumModal={corriendumModalScreening}
        setCorriendumModal={setCorriendumModalScreening}
        handleHideUpdateModal={handleHideUpdateModalScreening}
        tenderId={tenderId}
        getBidData={getBidData}
        toggleState={toggleState}
        tenders={filteredData}
        filters={filters}
        onUpdateSuccess={handleScrollToTender}
        setScrollToTender={setScrollToTender}
        scrollToTender={scrollToTender}
      />
      <EditTenderInfo
        showEditModal={showEditModal}
        handleCloseEditModal={handleCloseEditModal}
        toggleState={toggleState}
        tenders={filteredData}
        tenderId={editTenderId}
        getBidData={getBidData}
        editTenderData={editTenderData}
        showModal={showModal}
        filters={filters}
        roleemp={roleemp}
        bgData={bgData}
        initialTab={editInitialTab}
      />
      <EditTenderInfoTab
        showEditModal={showEditModalTab}
        handleCloseEditModal={handleCloseEditModalTab}
        toggleState={toggleState}
        tenders={filteredData}
        tenderId={editTenderId}
        getBidData={getBidData}
        editTenderData={editTenderData}
        showModal={showModal}
        filters={filters}
        roleemp={roleemp}
      />

      {/* Back modal */}
      <Modal show={showBackModal} onHide={handleCloseBackModal} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton><Modal.Title>Move back tender to previous stage</Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want To Move This Tender Back ?
            <div className="button-models">
              <button className="model-button font-weight500 model-button-cancel" onClick={handleCloseBackModal}>Cancel</button>
              <button onClick={handleFormSubmit} className="model-button font-weight500 model-button-delete">Confirm</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Eligibility / Partner / Doc modal (showModal) */}
      <Modal
        show={showModal}
        onHide={handleClose}
        dialogClassName="request-leaves"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>
            {toggleState === 2
              ? "Eligibility Cretria"
              : toggleState === 3
                ? "Finalize Partners"
                : [5, 9].includes(toggleState)
                  ? "Tender Documents"
                  : "Tender Result"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form className="register-form">
            <div style={{ display: "flex", flexDirection: "column" }}>

              {/* ══════════════════════════════════════
            toggleState === 2 : Eligibility Criteria
        ══════════════════════════════════════ */}
              {toggleState === 2 && (
                <>
                  <div className="dropdown-wrapper flex-column justify-center">
                    <label
                      htmlFor="eligibity_criteria"
                      className="form-label font-weight500 font-size-subheading"
                    >
                      Eligibilty Criteria<span className="required">*</span>
                    </label>
                    <select
                      name="eligibity_criteria"
                      placeholder="Please write a eligibility creteria."
                      value={wishListData.eligibity_criteria}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          eligibity_criteria: e.target.value,
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Eligibilty Criteria</option>
                      <option value="Normal">Normal</option>
                      <option value="Special">Special</option>
                    </select>
                  </div>

                  {wishListData.eligibity_criteria === "Special" && (
                    <div className="dropdown-wrapper flex-column justify-center">
                      <label className="form-labels">
                        Eligibility Criteria Special
                        <span className="required">*</span>
                      </label>
                      <textarea
                        name="eligibity_criteria_special Eligibity Criteria"
                        placeholder="Please write Special Eligibilty Criteria"
                        value={wishListData.eligibity_criteria_special}
                        className="form-input input-form"
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            eligibity_criteria_special: e.target.value,
                          }))
                        }
                      />
                    </div>
                  )}
                </>
              )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center">
                  <label
                    htmlFor="is_jv_allowed"
                    className="form-label font-weight500 font-size-subheading"
                  >
                    Is JV allowed<span className="required">*</span>
                  </label>
                  <select
                    id="is_jv_allowed"
                    name="is_jv_allowed"
                    value={wishListData.is_jv_allowed}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        is_jv_allowed:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Is Jv Allowed</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center">
                  <label
                    htmlFor="is_jv_consorium_association_allowed"
                    className="form-label font-weight500 font-size-subheading"
                  >
                    Is Consorium/Association allowed
                    <span className="required">*</span>
                  </label>
                  <select
                    id="is_jv_consorium_association_allowed"
                    name="is_jv_consorium_association_allowed"
                    value={wishListData.is_jv_consorium_association_allowed}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        is_jv_consorium_association_allowed:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Is Consorium/Association allowed</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}

              {toggleState === 2 && wishListData.is_jv_consorium_association_allowed && (
                <div className="flex-column">
                  <label className="form-labels">Terms of JV</label>
                  <textarea
                    name="terms_of_jv"
                    placeholder="terms"
                    value={wishListData.terms_of_jv}
                    className="form-input input-form"
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        terms_of_jv: e.target.value,
                      }))
                    }
                  />
                </div>
              )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center">
                  <label
                    htmlFor="company_name"
                    className="font-weight500 font-size-subheading"
                  >
                    Company Name<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="company_name"
                    name="company_name"
                    value={wishListData.company_name}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        company_name: e.target.value,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Select Company Name</option>
                    <option value="sapl">SAPL</option>
                    <option value="cipl">CIPL</option>
                  </select>
                </div>
              )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center">
                  <label
                    htmlFor="soil_quality"
                    className="font-weight500 font-size-subheading"
                  >
                    Sole Qualify<span className="required">*</span>
                  </label>
                  <select
                    id="soil_quality"
                    name="soil_quality"
                    value={wishListData.soil_quality}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        soil_quality:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Sole Qualify</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center">
                  <label
                    htmlFor="participating_as"
                    className="font-weight500 font-size-subheading"
                  >
                    Participating As<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="participating_as"
                    name="participating_as"
                    value={wishListData.participating_as}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        participating_as: e.target.value,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Select Participating As</option>
                    <option value="lead">Lead</option>
                    <option value="jv">JV</option>
                    <option value="associate">Associate</option>
                    {wishListData.soil_quality ? (
                      <option value="sole">Sole</option>
                    ) : (
                      ""
                    )}
                  </select>
                </div>
              )}

              <div
                className="joint-columns"
                style={{ display: "flex", gap: "20px", marginTop: "10px" }}
              >
                {toggleState === 2 && (
                  <div className="flex-column form-group-selectt widths50">
                    <label
                      htmlFor="tech_score"
                      className="form-labels font-weight500 font-size-subheading"
                    >
                      Total Tech Score<span className="required">*</span>
                    </label>
                    <br />
                    <input
                      type="text"
                      name="tech_score"
                      placeholder="tech Score"
                      value={wishListData.tech_score}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          tech_score: e.target.value,
                        }))
                      }
                      className="form-input input-form"
                      style={{ width: "80%" }}
                    />
                  </div>
                )}

                {toggleState === 2 && (
                  <div className="flex-column form-group-selectt widths50">
                    <label
                      htmlFor="company_score"
                      className="form-labels font-weight500 font-size-subheading"
                    >
                      {wishListData.company_name === null ||
                        wishListData.company_name === ""
                        ? "Our Company"
                        : wishListData.company_name?.toUpperCase()}{" "}
                      Technical Score<span className="required">*</span>
                    </label>
                    <br />
                    <input
                      type="text"
                      name="company_score"
                      placeholder="Technical Score"
                      value={wishListData.company_score}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (Number(value) > Number(wishListData.tech_score)) {
                          setScoreError(
                            "Company score should not be greater than Total Tech Score"
                          );
                        } else {
                          setScoreError("");
                          setWishListData((prev) => ({
                            ...prev,
                            company_score: value,
                          }));
                        }
                      }}
                      className="form-input input-form"
                      style={{ width: "80%" }}
                    />
                    {scoreError && (
                      <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                        {scoreError}
                      </p>
                    )}
                  </div>
                )}
              </div>

              {/* ══════════════════════════════════════
            toggleState === 3 : Finalize Partners
        ══════════════════════════════════════ */}
              {toggleState === 3 && (
                <div className="dropdown-wrapper flex justify-center">
                  <label
                    htmlFor="lead_partner"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    {wishListData.participating_as === "sole"
                      ? "Sole Partner "
                      : "Lead Partner"}{" "}
                    <span className="required">*</span>
                  </label>
                  <br />
                  {wishListData.lead_qualify ? (
                    <input
                      type="text"
                      name="lead_partner"
                      placeholder="lead partner"
                      value={wishListData.lead_partner}
                      disabled={true}
                      className="form-input input-form"
                    />
                  ) : (
                    <>
                      <select
                        id="lead_partner"
                        name="lead_partner"
                        value={
                          wishListData.lead_partner === ""
                            ? "null"
                            : wishListData.lead_partner
                        }
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            lead_partner: e.target.value,
                          }))
                        }
                        className="form-input font-size-subheading"
                      >
                        <option value="">Select lead partner</option>
                        {Partners.map((partner) => (
                          <option key={partner.key} value={partner.key}>
                            {partner.value}
                          </option>
                        ))}
                      </select>

                      {(!Partners.some(
                        (partner) => partner.key === wishListData.lead_partner
                      ) ||
                        wishListData.lead_partner === "Other") &&
                        wishListData.lead_partner !== "null" && (
                          <input
                            type="text"
                            name="lead_partner"
                            placeholder="Enter custom lead partner"
                            value={wishListData.custom_lead_partner}
                            onChange={(e) =>
                              setWishListData((prev) => ({
                                ...prev,
                                custom_lead_partner: e.target.value,
                              }))
                            }
                            className="form-input font-size-subheading"
                          />
                        )}
                    </>
                  )}
                </div>
              )}

              {toggleState === 3 && (
                <div className="dropdown-wrapper flex justify-center">
                  <label
                    htmlFor="lead_partner_share"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    {wishListData.participating_as === "sole"
                      ? "Sole Partner "
                      : "Lead Partner"}{" "}
                    %<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="number"
                    name="lead_partner_share"
                    placeholder="lead partner share"
                    value={wishListData.lead_partner_share}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        lead_partner_share: e.target.value,
                      }))
                    }
                    className="form-input font-size-subheading"
                    onWheel={(e) => e.target.blur()}
                  />
                  {wishListData.partner_share_sum > 100 && (
                    <label style={{ color: "red" }}>
                      Sum of all partner should not be more than 100
                    </label>
                  )}
                  {wishListData.partner_share_sum < 100 && (
                    <label style={{ color: "red" }}>
                      Sum of all lead partner should not be less than 100
                    </label>
                  )}
                </div>
              )}

              {toggleState === 3 && wishListData.participating_as !== "sole" && (
                <div className="dropdown-wrapper flex justify-center">
                  <label
                    htmlFor="jv_partner_name"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Jv Partner<span className="required">*</span>
                  </label>
                  <br />
                  {wishListData.jv_qualify ? (
                    <input
                      type="text"
                      name="jv_partner_name"
                      placeholder="Jv Partner"
                      value={wishListData.jv_partner_name}
                      disabled={wishListData.jv_qualify}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          jv_partner_name: e.target.value,
                        }))
                      }
                      className="form-input font-size-subheading"
                    />
                  ) : (
                    <>
                      <select
                        id="jv_partner_name"
                        name="jv_partner_name"
                        value={wishListData.jv_partner_name}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            jv_partner_name: e.target.value,
                          }))
                        }
                        className="form-input font-size-subheading"
                      >
                        <option value="">Select JV partner</option>
                        {Partners.map((partner) => (
                          <option key={partner.key} value={partner.key}>
                            {partner.value}
                          </option>
                        ))}
                      </select>
                      {(!Partners.some(
                        (partner) => partner.key === wishListData.jv_partner_name
                      ) ||
                        wishListData.jv_partner_name === "Other") &&
                        wishListData.jv_partner_name !== "null" && (
                          <input
                            type="text"
                            name="jv_partner_name"
                            placeholder="Enter custom jv partner"
                            value={wishListData.custom_jv_partner}
                            onChange={(e) =>
                              setWishListData((prev) => ({
                                ...prev,
                                custom_jv_partner: e.target.value,
                              }))
                            }
                            className="form-input input-form"
                          />
                        )}
                    </>
                  )}
                </div>
              )}

              {toggleState === 3 &&
                wishListData.jv_partner_name !== "Not Required" && (
                  <>
                    <div className="dropdown-wrapper flex justify-center">
                      <label
                        htmlFor="jv_partner_share"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Jv Partner Share %<span className="required">*</span>
                      </label>
                      <br />
                      <input
                        type="number"
                        name="jv_partner_share"
                        placeholder="Jv Partner Share"
                        value={wishListData.jv_partner_share}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            jv_partner_share: e.target.value,
                          }))
                        }
                        className="form-input font-size-subheading"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    {wishListData.partner_share_sum > 100 && (
                      <label style={{ color: "red" }}>
                        Sum of all partner should not be more than 100
                      </label>
                    )}
                    {wishListData.partner_share_sum < 100 && (
                      <label style={{ color: "red" }}>
                        Sum of all lead partner should not be less than 100
                      </label>
                    )}
                  </>
                )}

              {toggleState === 3 && wishListData.participating_as !== "sole" && (
                <div className="dropdown-wrapper flex justify-center">
                  <label
                    htmlFor="assosiate_partner"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Assosiate Partner<span className="required">*</span>
                  </label>
                  <br />
                  {wishListData.associate_qualify ? (
                    <>
                      <select
                        id="assosiate_partner"
                        name="assosiate_partner"
                        value={wishListData.assosiate_partner}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            assosiate_partner: e.target.value,
                          }))
                        }
                        className="form-input font-size-subheading"
                      >
                        <option value="">Select associate partner</option>
                        {Partners.map((partner) => (
                          <option key={partner.key} value={partner.key}>
                            {partner.value}
                          </option>
                        ))}
                      </select>
                      {(!Partners.some(
                        (partner) => partner.key === wishListData.assosiate_partner
                      ) ||
                        wishListData.assosiate_partner === "Other") &&
                        wishListData.assosiate_partner !== "null" && (
                          <input
                            type="text"
                            name="assosiate_partner"
                            placeholder="Enter custom assosiate partner"
                            value={wishListData.custom_assosiate_partner}
                            onChange={(e) =>
                              setWishListData((prev) => ({
                                ...prev,
                                custom_assosiate_partner: e.target.value,
                              }))
                            }
                            className="form-input font-size-subheading"
                          />
                        )}
                    </>
                  ) : (
                    <>
                      <select
                        id="assosiate_partner"
                        name="assosiate_partner"
                        value={wishListData.assosiate_partner}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            assosiate_partner: e.target.value,
                          }))
                        }
                        className="form-input font-size-subheading"
                      >
                        <option value="">Select associate partner</option>
                        {Partners.map((partner) => (
                          <option key={partner.key} value={partner.key}>
                            {partner.value}
                          </option>
                        ))}
                      </select>
                      {(!Partners.some(
                        (partner) => partner.key === wishListData.assosiate_partner
                      ) ||
                        wishListData.assosiate_partner === "Other") &&
                        wishListData.assosiate_partner !== "null" && (
                          <input
                            type="text"
                            name="assosiate_partner"
                            placeholder="Enter custom assosiate partner"
                            value={wishListData.custom_assosiate_partner}
                            onChange={(e) =>
                              setWishListData((prev) => ({
                                ...prev,
                                custom_assosiate_partner: e.target.value,
                              }))
                            }
                            className="form-input font-size-subheading"
                          />
                        )}
                    </>
                  )}
                </div>
              )}

              {toggleState === 3 &&
                wishListData.assosiate_partner !== "Not Required" && (
                  <>
                    <div className="dropdown-wrapper flex justify-center">
                      <label
                        htmlFor="associate_partner_share"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Associate Partner Share %
                        <span className="required">*</span>
                      </label>
                      <br />
                      <input
                        type="number"
                        name="associate_partner_share"
                        placeholder="Associate Partner Share"
                        value={wishListData.associate_partner_share}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            associate_partner_share: e.target.value,
                          }))
                        }
                        className="form-input font-size-subheading"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    {wishListData.partner_share_sum > 100 && (
                      <label style={{ color: "red" }}>
                        Sum of all partner should not be more than 100
                      </label>
                    )}
                    {wishListData.partner_share_sum < 100 && (
                      <label style={{ color: "red" }}>
                        Sum of all lead partner should not be less than 100
                      </label>
                    )}
                  </>
                )}

              {toggleState === 3 && (
                <>
                  <div className="dropdown-wrapper flex justify-center">
                    <label
                      htmlFor="bid_prepare_by"
                      className="form-labels font-weight500 font-size-subheading"
                    >
                      Bid Prepare By<span className="required">*</span>
                    </label>
                    <br />
                    <select
                      id="bid_prepare_by"
                      name="bid_prepare_by"
                      value={wishListData.bid_prepare_by}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          bid_prepare_by: e.target.value,
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Select</option>
                      <option
                        value={wishListData.lead_partner ? wishListData.lead_partner : ""}
                      >
                        {wishListData.lead_partner || wishListData.lead_partner !== "null"
                          ? wishListData.lead_partner
                          : ""}
                      </option>
                      <option
                        value={
                          wishListData.jv_partner_name ? wishListData.jv_partner_name : ""
                        }
                      >
                        {wishListData.jv_partner_name ||
                          wishListData.jv_partner_name !== "null"
                          ? wishListData.jv_partner_name
                          : ""}
                      </option>
                      <option
                        value={
                          wishListData.assosiate_partner
                            ? wishListData.assosiate_partner
                            : ""
                        }
                      >
                        {wishListData.assosiate_partner ||
                          wishListData.assosiate_partner !== "null"
                          ? wishListData.assosiate_partner
                          : ""}
                      </option>
                    </select>
                  </div>

                  <div className="dropdown-wrapper flex justify-center">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Bid Prepare By Remarks
                    </label>
                    <textarea
                      name="bid_prepare_by_remarks"
                      placeholder="Remarks for bid prepared by"
                      value={wishListData.bid_prepare_by_remarks}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          bid_prepare_by_remarks: e.target.value,
                        }))
                      }
                      className="form-input font-size-subheading"
                    />
                  </div>

                  <div className="dropdown-wrapper flex justify-center">
                    <label
                      htmlFor="bg_prepare_by"
                      className="form-labels font-weight500 font-size-subheading"
                    >
                      BG Prepare By<span className="required">*</span>
                    </label>
                    <br />
                    <select
                      id="bg_prepare_by"
                      name="bg_prepare_by"
                      value={wishListData.bg_prepare_by}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          bg_prepare_by: e.target.value,
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Select</option>
                      <option
                        value={wishListData.lead_partner ? wishListData.lead_partner : ""}
                      >
                        {wishListData.lead_partner || wishListData.lead_partner !== "null"
                          ? wishListData.lead_partner
                          : ""}
                      </option>
                      <option
                        value={
                          wishListData.jv_partner_name ? wishListData.jv_partner_name : ""
                        }
                      >
                        {wishListData.jv_partner_name ||
                          wishListData.jv_partner_name !== "null"
                          ? wishListData.jv_partner_name
                          : ""}
                      </option>
                      <option
                        value={
                          wishListData.assosiate_partner
                            ? wishListData.assosiate_partner
                            : ""
                        }
                      >
                        {wishListData.assosiate_partner ||
                          wishListData.assosiate_partner !== "null"
                          ? wishListData.assosiate_partner
                          : ""}
                      </option>
                    </select>
                  </div>
                </>
              )}

              {toggleState === 3 && (
                <>
                  <div className="dropdown-wrapper flex justify-center">
                    <label
                      htmlFor="team_required"
                      className="form-labels font-weight500 font-size-subheading"
                    >
                      Team Required<span className="required">*</span>
                    </label>
                    <br />
                    <select
                      id="team_required"
                      name="team_required"
                      value={wishListData.team_required}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          team_required:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null,
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Select Team Required</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>

                  {wishListData.team_required && (
                    <>
                      <div className="flex-column form-group-selectt">
                        <label
                          htmlFor="team_prepare_by"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          Team Prepare By<span className="required">*</span>
                        </label>
                        <br />
                        <select
                          id="team_prepare_by"
                          name="team_prepare_by"
                          value={wishListData.team_prepare_by}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              team_prepare_by: e.target.value,
                            }))
                          }
                          className="form-input input-form form-group-selection"
                        >
                          <option value="">Select</option>
                          <option
                            value={
                              wishListData.lead_partner ? wishListData.lead_partner : ""
                            }
                          >
                            {wishListData.lead_partner}
                          </option>
                          <option
                            value={
                              wishListData.jv_partner_name
                                ? wishListData.jv_partner_name
                                : ""
                            }
                          >
                            {wishListData.jv_partner_name}
                          </option>
                          <option
                            value={
                              wishListData.assosiate_partner
                                ? wishListData.assosiate_partner
                                : ""
                            }
                          >
                            {wishListData.assosiate_partner}
                          </option>
                        </select>
                      </div>

                      <div className="flex-column">
                        <label className="form-labels">
                          Team Prepare By Remarks <span className="required">*</span>
                        </label>
                        <textarea
                          name="team_prepare_by_remarks"
                          placeholder="Remarks for Team prepared by"
                          value={wishListData.team_prepare_by_remarks}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              team_prepare_by_remarks: e.target.value,
                            }))
                          }
                          className="form-input input-form"
                        />
                      </div>

                      <div className="flex-column">
                        <label className="form-labels">
                          Team Requirements Details
                          <span className="required">*</span>
                        </label>
                        <textarea
                          name="team_requirements_details"
                          placeholder="Team Requirements Details"
                          value={wishListData.team_requirements_details}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              team_requirements_details: e.target.value,
                            }))
                          }
                          className="form-input input-form"
                        />
                      </div>
                    </>
                  )}
                </>
              )}

              {toggleState === 3 && wishListData.tendersubmission === "HardCopy" && (
                <div className="flex-column">
                  <label className="form-labels">
                    Submission Date <span className="required">*</span>
                  </label>
                  <input
                    type="datetime-local"
                    name="submission_date"
                    min={new Date().toISOString().slice(0, 16)}
                    value={wishListData?.submission_date}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        submission_date: e.target.value,
                      }))
                    }
                    className="form-input input-form"
                  />
                </div>
              )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center">
                  <label
                    htmlFor="site_apprisate_required"
                    className="font-weight500 font-size-subheading"
                  >
                    Site Appriciate Required <span className="required">*</span>
                  </label>
                  <select
                    id="site_apprisate_required"
                    name="site_apprisate_required"
                    value={wishListData.site_apprisate_required}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        site_apprisate_required:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Site Appriciate Required</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}

              {toggleState === 2 && wishListData.site_apprisate_required && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="site_apprisate_marking"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Site Appreciate Marking<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="site_apprisate_marking"
                    placeholder="site_apprisate_marking"
                    value={wishListData.site_apprisate_marking}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        site_apprisate_marking: e.target.value,
                      }))
                    }
                    className="form-input input-form"
                  />
                </div>
              )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center">
                  <label
                    htmlFor="work_methodology_required"
                    className="font-weight500 font-size-subheading"
                  >
                    Work methodology required <span className="required">*</span>
                  </label>
                  <select
                    id="work_methodology_required"
                    name="work_methodology_required"
                    value={wishListData.work_methodology_required}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        work_methodology_required:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Work Methodology Marking</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}

              {toggleState === 2 && wishListData.work_methodology_required && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="work_methodology_marking"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Work Methodology Marking<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="work_methodology_marking"
                    placeholder="work_methodology_marking"
                    value={wishListData.work_methodology_marking}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        work_methodology_marking: e.target.value,
                      }))
                    }
                    className="form-input input-form"
                  />
                </div>
              )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center">
                  <label
                    htmlFor="presentation_required"
                    className="font-weight500 font-size-subheading"
                  >
                    Presentation Required<span className="required">*</span>
                  </label>
                  <select
                    id="presentation_required"
                    name="presentation_required"
                    value={wishListData.presentation_required}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        presentation_required:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Presentation Required</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}

              {toggleState === 2 && wishListData.presentation_required && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="presentation_required_marking"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Presentation Required Marking
                    <span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="presentation_required_marking"
                    placeholder="presentation_required_marking"
                    value={wishListData.presentation_required_marking}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        presentation_required_marking: e.target.value,
                      }))
                    }
                    className="form-input input-form"
                  />
                </div>
              )}

              {toggleState === 2 && wishListData.presentation_required && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="presentation_type"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Presentation Type<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="presentation_type"
                    name="presentation_type"
                    value={wishListData.presentation_type}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        presentation_type: e.target.value,
                      }))
                    }
                    className="form-input input-form form-group-selection"
                  >
                    <option value="">Select Presentation Type</option>
                    <option value="Online">Online</option>
                    <option value="physical">Physical</option>
                    <option value="both">Both</option>
                  </select>
                </div>
              )}

              {toggleState === 3 && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="tender_submission_type"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Tender Submission Type<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="tender_submission_type"
                    name="tender_submission_type"
                    value={wishListData.tender_submission_type}
                    className="form-input input-form form-group-selection"
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        tender_submission_type: e.target.value,
                      }))
                    }
                  >
                    <option value="null">Select Tender Submission Type</option>
                    <option value="Online">Online</option>
                    <option value="physical">Physical</option>
                    <option value="both">Both</option>
                  </select>
                </div>
              )}

              {/* ══════════════════════════════════════
            toggleState === 9 : Tender Documents
        ══════════════════════════════════════ */}
              {[5, 9].includes(toggleState) && (
                <>
                  {roleemp !== "CertificationAccessCvTeamHead" &&
                    roleemp !== "CertificationAccessCvTeam" && (
                      <div className="dropdown-wrapper flex justify-center">
                        <label
                          htmlFor="checklist"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          Checklist<span className="required">*</span>
                        </label>
                        <br />
                        <select
                          id="checklist"
                          name="checklist"
                          value={wishListData.checklist}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              checklist:
                                e.target.value === "true"
                                  ? true
                                  : e.target.value === "false"
                                    ? false
                                    : null,
                            }))
                          }
                          className="form-input font-size-subheading"
                        >
                          <option value="">All Checklist done</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                    )}

                  {roleemp !== "CertificationAccessCvTeamHead" &&
                    roleemp !== "CertificationAccessCvTeam" && (
                      <div className="dropdown-wrapper flex justify-center">
                        <label
                          htmlFor="all_docs_done"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          All Docs done<span className="required">*</span>
                        </label>
                        <br />
                        <select
                          id="all_docs_done"
                          name="all_docs_done"
                          value={wishListData.all_docs_done}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              all_docs_done:
                                e.target.value === "true"
                                  ? true
                                  : e.target.value === "false"
                                    ? false
                                    : null,
                            }))
                          }
                          className="form-input font-size-subheading"
                        >
                          <option value="">All Docs done</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                    )}

                  {roleemp !== "CertificationAccessCvTeamHead" &&
                    roleemp !== "CertificationAccessCvTeam" && (
                      <div className="flex-column form-group-selectt">
                        <label
                          htmlFor="tech_score"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          Total Technical Score<span className="required">*</span>
                        </label>
                        <br />
                        <input
                          type="text"
                          name="tech_score"
                          placeholder="tech Score"
                          value={wishListData.tech_score}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              tech_score: e.target.value,
                            }))
                          }
                          className="form-input input-form"
                        />
                      </div>
                    )}

                  {(roleemp === "CertificationAccessCvTeamHead" ||
                    roleemp === "CertificationAccessCvTeam" ||
                    roleemp === "CertificationAccess" ||
                    roleemp === "CertificateAccessBd" ||
                    roleemp === "certificaionadminaccess") && (
                      <div className="flex-column form-group-selectt">
                        <label
                          htmlFor="cv_score"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          CV Score<span className="required">*</span>
                        </label>
                        <br />
                        <input
                          type="text"
                          name="cv_score"
                          placeholder="CV Score"
                          value={wishListData.cv_score}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              cv_score: e.target.value,
                            }))
                          }
                          className="form-input input-form"
                        />
                      </div>
                    )}

                  {roleemp !== "CertificationAccessCvTeamHead" &&
                    roleemp !== "CertificationAccessCvTeam" && (
                      <div
                        style={{
                          width: "100%",
                          maxWidth: 480,
                          margin: "0 auto",
                          background: "#fff",
                          borderRadius: 8,
                          boxShadow: "0 2px 12px #eee",
                          padding: 32,
                          marginTop: 24,
                        }}
                      >
                        <label
                          className="form-labels font-weight500 font-size-subheading"
                          style={{ marginBottom: 12, display: "block", fontSize: 18, fontWeight: 600 }}
                        >
                          Upload Tech Proposal (File name should be max 400 character)
                        </label>
                        {wishListData?.tech_doc?.length > 0 && (
                          <div style={{ marginBottom: 18 }}>
                            {wishListData.tech_doc.map((cv) => (
                              <div key={cv.document_name} style={{ marginBottom: 6 }}>
                                <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                                  {cv.document_name}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}

                        <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
                          <input
                            type="file"
                            multiple
                            onChange={handleTechFileChange}
                            style={{ flex: 1, minWidth: 0 }}
                            className="form-control"
                            disabled={techUploading}
                          />
                          {techUploading && (
                            <span style={{ marginLeft: 12, fontSize: 13, color: "#6c63ff", fontWeight: 600, whiteSpace: "nowrap" }}>
                              ⏳ Uploading...
                            </span>
                          )}
                        </div>

                        {techUploadStatusText && (
                          <p style={{ fontSize: 12, color: "#6c63ff", fontWeight: 600, marginBottom: 8 }}>
                            {techUploadStatusText}
                          </p>
                        )}

                        {/* Per-file progress bars */}
                        {Object.keys(techUploadProgress).length > 0 && (
                          <div style={{ marginBottom: 16 }}>
                            {Object.entries(techUploadProgress).map(([name, percent]) => (
                              <div key={name} style={{ marginBottom: 8 }}>
                                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 2 }}>
                                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "70%" }}>
                                    {name}
                                  </span>
                                  <span style={{ color: percent === -1 ? "#dc2626" : percent === 100 ? "#16a34a" : "#6c63ff", fontWeight: 600 }}>
                                    {percent === -1 ? "Failed ✗" : `${percent}%`}
                                  </span>
                                </div>
                                <div style={{ height: 6, background: "#eee", borderRadius: 3, overflow: "hidden" }}>
                                  <div
                                    style={{
                                      height: "100%",
                                      width: `${percent === -1 ? 100 : percent}%`,
                                      background: percent === -1 ? "#dc2626" : percent === 100 ? "#16a34a" : "#6c63ff",
                                      transition: "width 0.2s ease",
                                    }}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                        {techUploadError && (
                          <p style={{ color: "#dc2626", fontSize: 13, fontWeight: 600, marginTop: 4, marginBottom: 12 }}>
                            ⚠ {techUploadError}
                          </p>
                        )}



                        <span style={{ fontSize: 11, color: "#888", marginTop: 4, display: "block" }}>
                          Files upload automatically once selected.
                        </span>

                        {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24 }}>
                          <input
                            type="file"
                            multiple
                            onChange={handleTechFileChange}
                            style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                            className="form-control"
                          />

                          <button
                            onClick={handleAddTechDoc}
                            style={{
                              padding: "8px 20px",
                              backgroundColor: techUploading ? "#a89cf7" : "#6c63ff",
                              color: "#fff",
                              border: "none",
                              borderRadius: 4,
                              fontWeight: 600,
                              fontSize: 15,
                              cursor: techUploading || !techDocs.length ? "not-allowed" : "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              minWidth: 80,
                              justifyContent: "center",
                            }}
                            disabled={!techDocs.length || techUploading}
                          >
                            {techUploading ? (
                              <>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5"
                                  style={{ animation: "spin 1s linear infinite" }}>
                                  <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                                </svg>
                                Uploading...
                              </>
                            ) : "Add"}
                          </button>

                        </div>
                        {techUploadError && (
                          <p style={{ color: "#dc2626", fontSize: 13, fontWeight: 600, marginTop: 4, marginBottom: 12 }}>
                            ⚠ {techUploadError}
                          </p>
                        )}
                        <span style={{ fontSize: 11, color: "#888", marginTop: 4, display: "block" }}>
                          ↑ Select files, then click <strong>Add</strong> to upload
                        </span> */}
                        <ul style={{ listStyle: "none", padding: 0, margin: 0, width: "100%", maxHeight: 180, overflowY: "auto", border: techDocs?.length ? "1px solid #ececec" : "none", borderRadius: 6, background: techDocs?.length ? "#fafafd" : "none" }}>
                          {techDocs?.map((file, index) => (
                            <li key={file.name + index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 8px", borderBottom: index !== techDocs.length - 1 ? "1px solid #ececec" : "none" }}>
                              <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                <svg width="18" height="18" fill="#6c63ff" style={{ marginRight: 8, verticalAlign: "middle" }}><rect width="18" height="18" rx="3" /></svg>
                                {file.name}
                              </span>
                              <button onClick={() => handleTechRemove(index)} style={{ marginLeft: 16, padding: "4px 12px", backgroundColor: "#ff4e4e", color: "#fff", border: "none", borderRadius: 4, fontWeight: 500, cursor: "pointer", fontSize: 14 }}>Remove</button>
                            </li>
                          ))}
                          {!techDocs?.length && (
                            <li style={{ color: "#999", textAlign: "center", padding: 20 }}>No files uploaded</li>
                          )}
                        </ul>
                      </div>
                    )}

                  {((roleemp !== "CertificationAccessCvTeamHead" &&
                    roleemp !== "CertificationAccessCvTeam") ||
                    roleemp === "CertificationAccess" ||
                    roleemp === "CertificateAccessBd" ||
                    roleemp === "certificaionadminaccess") && (
                      <div style={{ width: "100%", maxWidth: 480, margin: "0 auto", background: "#fff", borderRadius: 8, boxShadow: "0 2px 12px #eee", padding: 32, marginTop: 24 }}>
                        <label className="form-labels font-weight500 font-size-subheading" style={{ marginBottom: 12, display: "block", fontSize: 18, fontWeight: 600 }}>
                          Upload Financial Proposal (File name should be max 400 character)
                        </label>
                        {wishListData?.financial_doc?.length > 0 && (
                          <div style={{ marginBottom: 18 }}>
                            {wishListData.financial_doc.map((cv) => (
                              <div key={cv.document_name} style={{ marginBottom: 6 }}>
                                <label style={{ color: "#6c63ff", fontWeight: 500 }}>{cv.document_name}</label>
                              </div>
                            ))}
                          </div>
                        )}
                        <div style={{ display: "flex", alignItems: "center", marginBottom: 24 }}>
                          <input
                            type="file"
                            multiple
                            onChange={handleFinancialFileChange}
                            style={{ flex: 1, minWidth: 0 }}
                            className="form-control"
                            disabled={financialUploading}
                          />
                          {financialUploading && (
                            <span style={{ marginLeft: 12, fontSize: 13, color: "#6c63ff", fontWeight: 600 }}>
                              Uploading...
                            </span>
                          )}
                        </div>
                        {financialUploadError && (
                          <p style={{ color: "#dc2626", fontSize: 13, fontWeight: 600, marginTop: 4, marginBottom: 12 }}>
                            ⚠ {financialUploadError}
                          </p>
                        )}
                        {financialUploadSuccess && (                       // NEW
                          <p style={{ color: "#16a34a", fontSize: 13, fontWeight: 600, marginTop: 4, marginBottom: 12 }}>
                            ✓ {financialUploadSuccess}
                          </p>
                        )}
                        <span style={{ fontSize: 11, color: "#888", marginTop: 4, display: "block" }}>
                          Files upload automatically once selected.
                        </span>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0, width: "100%", maxHeight: 180, overflowY: "auto", border: finacialDocs?.length ? "1px solid #ececec" : "none", borderRadius: 6, background: finacialDocs?.length ? "#fafafd" : "none" }}>
                          {finacialDocs?.map((file, index) => (
                            <li key={file.name + index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 8px", borderBottom: index !== finacialDocs.length - 1 ? "1px solid #ececec" : "none" }}>
                              <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                <svg width="18" height="18" fill="#6c63ff" style={{ marginRight: 8, verticalAlign: "middle" }}><rect width="18" height="18" rx="3" /></svg>
                                {file.name}
                              </span>
                              <button onClick={() => handleFinancialRemove(index)} style={{ marginLeft: 16, padding: "4px 12px", backgroundColor: "#ff4e4e", color: "#fff", border: "none", borderRadius: 4, fontWeight: 500, cursor: "pointer", fontSize: 14 }}>Remove</button>
                            </li>
                          ))}
                          {!finacialDocs?.length && (
                            <li style={{ color: "#999", textAlign: "center", padding: 20 }}>No files uploaded</li>
                          )}
                        </ul>
                      </div>
                    )}

                  {(roleemp === "CertificationAccessCvTeamHead" ||
                    roleemp === "CertificationAccessCvTeam" ||
                    roleemp === "CertificationAccess" ||
                    roleemp === "CertificateAccessBd" ||
                    roleemp === "certificaionadminaccess") && (
                      <div style={{ width: "100%", maxWidth: 480, margin: "0 auto", background: "#fff", borderRadius: 8, boxShadow: "0 2px 12px #eee", padding: 32, marginTop: 24 }}>
                        <label className="form-labels font-weight500 font-size-subheading" style={{ marginBottom: 12, display: "block", fontSize: 18, fontWeight: 600 }}>
                          Upload CV's (File name should be max 400 character)
                        </label>
                        {wishListData?.cvs_files?.length > 0 && (
                          <div style={{ marginBottom: 18 }}>
                            {wishListData.cvs_files.map((cv) => (
                              <div key={cv.document_name} style={{ marginBottom: 6 }}>
                                <label style={{ color: "#6c63ff", fontWeight: 500 }}>{cv.document_name}</label>
                              </div>
                            ))}
                          </div>
                        )}
                        <div style={{ display: "flex", alignItems: "center", marginBottom: 24 }}>
                          <input
                            type="file"
                            multiple
                            onChange={handleCvsFileChange}
                            style={{ flex: 1, minWidth: 0 }}
                            className="form-control"
                            disabled={cvsUploading}
                          />
                          {cvsUploading && (
                            <span style={{ marginLeft: 12, fontSize: 13, color: "#6c63ff", fontWeight: 600 }}>
                              Uploading...
                            </span>
                          )}
                        </div>
                        {cvsUploadError && (
                          <p style={{ color: "#dc2626", fontSize: 13, fontWeight: 600, marginTop: 4, marginBottom: 12 }}>
                            ⚠ {cvsUploadError}
                          </p>
                        )}
                        {cvsUploadSuccess && (                             // NEW
                          <p style={{ color: "#16a34a", fontSize: 13, fontWeight: 600, marginTop: 4, marginBottom: 12 }}>
                            ✓ {cvsUploadSuccess}
                          </p>
                        )}
                        <span style={{ fontSize: 11, color: "#888", marginTop: 4, display: "block" }}>
                          Files upload automatically once selected.
                        </span>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0, width: "100%", maxHeight: 180, overflowY: "auto", border: cvsDocs?.length ? "1px solid #ececec" : "none", borderRadius: 6, background: cvsDocs?.length ? "#fafafd" : "none" }}>
                          {cvsDocs?.map((file, index) => (
                            <li key={file.name + index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 8px", borderBottom: index !== cvsDocs.length - 1 ? "1px solid #ececec" : "none" }}>
                              <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                <svg width="18" height="18" fill="#6c63ff" style={{ marginRight: 8, verticalAlign: "middle" }}><rect width="18" height="18" rx="3" /></svg>
                                {file.name}
                              </span>
                              <button onClick={() => handleCvsRemove(index)} style={{ marginLeft: 16, padding: "4px 12px", backgroundColor: "#ff4e4e", color: "#fff", border: "none", borderRadius: 4, fontWeight: 500, cursor: "pointer", fontSize: 14 }}>Remove</button>
                            </li>
                          ))}
                          {!cvsDocs?.length && (
                            <li style={{ color: "#999", textAlign: "center", padding: 20 }}>No files uploaded</li>
                          )}
                        </ul>
                      </div>
                    )}

                  {(roleemp === "CertificationAccessCvTeamHead" ||
                    roleemp === "CertificationAccessCvTeam" ||
                    roleemp === "CertificationAccess" ||
                    roleemp === "CertificateAccessBd" ||
                    roleemp === "certificaionadminaccess") && (
                      <div className="flex-column form-group-selectt">
                        <label
                          htmlFor="all_cvs_done"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          All CV's Done<span className="required">*</span>
                        </label>
                        <br />
                        <select
                          id="all_cvs_done"
                          name="all_cvs_done"
                          value={wishListData.all_cvs_done}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              all_cvs_done:
                                e.target.value === "true"
                                  ? true
                                  : e.target.value === "false"
                                    ? false
                                    : null,
                            }))
                          }
                          className="form-input input-form form-group-selection"
                        >
                          <option value="">All Cv's done</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                    )}

                  {roleemp !== "CertificationAccessCvTeamHead" &&
                    roleemp !== "CertificationAccessCvTeam" && (
                      <div style={{ width: "100%", maxWidth: 480, margin: "0 auto", background: "#fff", borderRadius: 8, boxShadow: "0 2px 12px #eee", padding: 32, marginTop: 24 }}>
                        <label className="form-labels font-weight500 font-size-subheading" style={{ marginBottom: 12, display: "block", fontSize: 18, fontWeight: 600 }}>
                          Upload Bid Acknowledgemnet
                        </label>
                        {wishListData?.bid_doc?.length > 0 && (
                          <div style={{ marginBottom: 18 }}>
                            {wishListData.bid_doc.map((cv) => (
                              <div key={cv.document_name} style={{ marginBottom: 6 }}>
                                <label style={{ color: "#6c63ff", fontWeight: 500 }}>{cv.document_name}</label>
                              </div>
                            ))}
                          </div>
                        )}
                        <div style={{ display: "flex", alignItems: "center", marginBottom: 24 }}>
                          <input
                            type="file"
                            multiple
                            onChange={handleBidsFileChange}
                            style={{ flex: 1, minWidth: 0 }}
                            className="form-control"
                            disabled={bidUploading}
                          />
                          {bidUploading && (
                            <span style={{ marginLeft: 12, fontSize: 13, color: "#6c63ff", fontWeight: 600 }}>
                              Uploading...
                            </span>
                          )}
                        </div>
                        {bidUploadError && (
                          <p style={{ color: "#dc2626", fontSize: 13, fontWeight: 600, marginTop: 4, marginBottom: 12 }}>
                            ⚠ {bidUploadError}
                          </p>
                        )}
                        {bidUploadSuccess && (                             // NEW
                          <p style={{ color: "#16a34a", fontSize: 13, fontWeight: 600, marginTop: 4, marginBottom: 12 }}>
                            ✓ {bidUploadSuccess}
                          </p>
                        )}
                        <span style={{ fontSize: 11, color: "#888", marginTop: 4, display: "block" }}>
                          Files upload automatically once selected.
                        </span>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0, width: "100%", maxHeight: 180, overflowY: "auto", border: BidDocs?.length ? "1px solid #ececec" : "none", borderRadius: 6, background: BidDocs?.length ? "#fafafd" : "none" }}>
                          {BidDocs?.map((file, index) => (
                            <li key={file.name + index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 8px", borderBottom: index !== cvsDocs.length - 1 ? "1px solid #ececec" : "none" }}>
                              <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                <svg width="18" height="18" fill="#6c63ff" style={{ marginRight: 8, verticalAlign: "middle" }}><rect width="18" height="18" rx="3" /></svg>
                                {file.name}
                              </span>
                              <button onClick={() => handleBidsRemove(index)} style={{ marginLeft: 16, padding: "4px 12px", backgroundColor: "#ff4e4e", color: "#fff", border: "none", borderRadius: 4, fontWeight: 500, cursor: "pointer", fontSize: 14 }}>Remove</button>
                            </li>
                          ))}
                          {!BidDocs?.length && (
                            <li style={{ color: "#999", textAlign: "center", padding: 20 }}>No files uploaded</li>
                          )}
                        </ul>
                      </div>
                    )}
                </>
              )}

              {/* ══════════════════════════════════════
            toggleState === 5 : Tender Result
            ── replaced with TenderResultSection ──
        ══════════════════════════════════════ */}


            </div>{/* end flex column */}

            <p className="error-message font-size-text">
              {isSubmitted && Object.keys(errors).length > 0 && (
                <h6 className="text-center">
                  {"Error in: " +
                    Object.keys(errors)
                      .map((field) => {
                        const formatted = field
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase());
                        return `${formatted}`;
                      })
                      .join(", ")}
                </h6>
              )}
            </p>

            <div className="button-models">
              <button
                type="submit"
                onClick={(e) => handleSubmitEligibilityCretria(e, filters)}
                className="model-button model-button-submit"
              >
                {toggleState === 1 ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </Modal.Body>

        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>

      {/* <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover /> */}
      <MultiWorkLogModal
        isOpen={showWorkLog}
        onClose={() => { setShowWorkLog(false); setWorkLogTender(null); setWorkLogProjectId(""); }}
        projects={ddProjects}
        defaultTender={workLogTender}
        defaultProjectId={workLogProjectId || workLogTender?.id}
        allowMultipleRows={false}
        onSave={handleSaveTenderWorkLog}
      />
      <ViewWorkLogModal
        isOpen={showViewWorkLog}
        onClose={() => { setShowViewWorkLog(false); setViewWorkLogTender(null); }}
        tender={viewWorkLogTender}
        projects={ddProjects}
      />
    </>
  );
};

export default Bid;
